(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire77dd"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire77dd"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("f9AIs", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b0842d51d9c0999a$export$71511d61b312f219; });

var $byJ7Q = parcelRequire("byJ7Q");

var $5xUMV = parcelRequire("5xUMV");

var $jUUb8 = parcelRequire("jUUb8");

var $f8lFf = parcelRequire("f8lFf");
function $b0842d51d9c0999a$export$71511d61b312f219(arr, i) {
    return (0, $byJ7Q._)(arr) || (0, $5xUMV._)(arr, i) || (0, $f8lFf._)(arr, i) || (0, $jUUb8._)();
}

});
parcelRegister("byJ7Q", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $86a5dfb33a848ddc$export$71511d61b312f219; });
function $86a5dfb33a848ddc$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("5xUMV", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $409c15c2c71fb6b6$export$71511d61b312f219; });
function $409c15c2c71fb6b6$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("jUUb8", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e7fed334ed9e06d0$export$71511d61b312f219; });
function $e7fed334ed9e06d0$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("f8lFf", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $02d7e0a711145bb5$export$71511d61b312f219; });

var $h3oB6 = parcelRequire("h3oB6");
function $02d7e0a711145bb5$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $h3oB6._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $h3oB6._)(o, minLen);
}

});
parcelRegister("h3oB6", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c6a5cc06c93a0628$export$71511d61b312f219; });
function $c6a5cc06c93a0628$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});



parcelRegister("45FY7", function(module, exports) {
"use strict";

module.exports = (parcelRequire("7lPrl"));

});
parcelRegister("7lPrl", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $55a26582b34904d0$export$ffb0004e005737fa; }, function (v) { return $55a26582b34904d0$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $55a26582b34904d0$export$34b9dba7ce09269b; }, function (v) { return $55a26582b34904d0$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $55a26582b34904d0$export$25062201e9e25d76; }, function (v) { return $55a26582b34904d0$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $55a26582b34904d0$export$ffb0004e005737fa;
var $55a26582b34904d0$export$34b9dba7ce09269b;
var $55a26582b34904d0$export$25062201e9e25d76;
"use strict";

var $4Bt61 = parcelRequire("4Bt61");
var $55a26582b34904d0$var$k = Symbol.for("react.element"), $55a26582b34904d0$var$l = Symbol.for("react.fragment"), $55a26582b34904d0$var$m = Object.prototype.hasOwnProperty, $55a26582b34904d0$var$n = $4Bt61.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $55a26582b34904d0$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $55a26582b34904d0$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$55a26582b34904d0$var$m.call(a, b) && !$55a26582b34904d0$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $55a26582b34904d0$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $55a26582b34904d0$var$n.current
    };
}
$55a26582b34904d0$export$ffb0004e005737fa = $55a26582b34904d0$var$l;
$55a26582b34904d0$export$34b9dba7ce09269b = $55a26582b34904d0$var$q;
$55a26582b34904d0$export$25062201e9e25d76 = $55a26582b34904d0$var$q;

});
parcelRegister("4Bt61", function(module, exports) {
"use strict";

module.exports = (parcelRequire("5FcLn"));

});
parcelRegister("5FcLn", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $41faae90f070a008$export$dca3b0875bd9a954; }, function (v) { return $41faae90f070a008$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $41faae90f070a008$export$16fa2f45be04daa8; }, function (v) { return $41faae90f070a008$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $41faae90f070a008$export$ffb0004e005737fa; }, function (v) { return $41faae90f070a008$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $41faae90f070a008$export$e2c29f18771995cb; }, function (v) { return $41faae90f070a008$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $41faae90f070a008$export$221d75b3f55bb0bd; }, function (v) { return $41faae90f070a008$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $41faae90f070a008$export$5f8d39834fd61797; }, function (v) { return $41faae90f070a008$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $41faae90f070a008$export$74bf444e3cd11ea5; }, function (v) { return $41faae90f070a008$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $41faae90f070a008$export$ae55be85d98224ed; }, function (v) { return $41faae90f070a008$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $41faae90f070a008$export$e530037191fcd5d7; }, function (v) { return $41faae90f070a008$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $41faae90f070a008$export$fd42f52fd3ae1109; }, function (v) { return $41faae90f070a008$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $41faae90f070a008$export$c8a8987d4410bf2d; }, function (v) { return $41faae90f070a008$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $41faae90f070a008$export$d38cd72104c1f0e9; }, function (v) { return $41faae90f070a008$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $41faae90f070a008$export$7d1e3a5e95ceca43; }, function (v) { return $41faae90f070a008$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $41faae90f070a008$export$257a8862b851cb5b; }, function (v) { return $41faae90f070a008$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $41faae90f070a008$export$a8257692ac88316c; }, function (v) { return $41faae90f070a008$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $41faae90f070a008$export$488013bae63b21da; }, function (v) { return $41faae90f070a008$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $41faae90f070a008$export$7c73462e0d25e514; }, function (v) { return $41faae90f070a008$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $41faae90f070a008$export$7568632d0d33d16d; }, function (v) { return $41faae90f070a008$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $41faae90f070a008$export$88948ce120ea2619; }, function (v) { return $41faae90f070a008$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $41faae90f070a008$export$35808ee640e87ca7; }, function (v) { return $41faae90f070a008$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $41faae90f070a008$export$fae74005e78b1a27; }, function (v) { return $41faae90f070a008$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $41faae90f070a008$export$dc8fbce3eb94dc1e; }, function (v) { return $41faae90f070a008$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $41faae90f070a008$export$6a7bc4e911dc01cf; }, function (v) { return $41faae90f070a008$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $41faae90f070a008$export$6d9c69b0de29b591; }, function (v) { return $41faae90f070a008$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $41faae90f070a008$export$f680877a34711e37; }, function (v) { return $41faae90f070a008$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $41faae90f070a008$export$d5a552a76deda3c2; }, function (v) { return $41faae90f070a008$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $41faae90f070a008$export$aaabe4eda9ed9969; }, function (v) { return $41faae90f070a008$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $41faae90f070a008$export$e5c5a5f917a5871c; }, function (v) { return $41faae90f070a008$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $41faae90f070a008$export$1538c33de8887b59; }, function (v) { return $41faae90f070a008$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $41faae90f070a008$export$13e3392192263954; }, function (v) { return $41faae90f070a008$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $41faae90f070a008$export$b8f5890fc79d6aca; }, function (v) { return $41faae90f070a008$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $41faae90f070a008$export$60241385465d0a34; }, function (v) { return $41faae90f070a008$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $41faae90f070a008$export$306c0aa65ff9ec16; }, function (v) { return $41faae90f070a008$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $41faae90f070a008$export$7b286972b8d8ccbf; }, function (v) { return $41faae90f070a008$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $41faae90f070a008$export$83d89fbfd8236492; }, function (v) { return $41faae90f070a008$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $6zqIC = parcelRequire("6zqIC");
var $41faae90f070a008$export$dca3b0875bd9a954;
var $41faae90f070a008$export$16fa2f45be04daa8;
var $41faae90f070a008$export$ffb0004e005737fa;
var $41faae90f070a008$export$e2c29f18771995cb;
var $41faae90f070a008$export$221d75b3f55bb0bd;
var $41faae90f070a008$export$5f8d39834fd61797;
var $41faae90f070a008$export$74bf444e3cd11ea5;
var $41faae90f070a008$export$ae55be85d98224ed;
var $41faae90f070a008$export$e530037191fcd5d7;
var $41faae90f070a008$export$fd42f52fd3ae1109;
var $41faae90f070a008$export$c8a8987d4410bf2d;
var $41faae90f070a008$export$d38cd72104c1f0e9;
var $41faae90f070a008$export$7d1e3a5e95ceca43;
var $41faae90f070a008$export$257a8862b851cb5b;
var $41faae90f070a008$export$a8257692ac88316c;
var $41faae90f070a008$export$488013bae63b21da;
var $41faae90f070a008$export$7c73462e0d25e514;
var $41faae90f070a008$export$7568632d0d33d16d;
var $41faae90f070a008$export$88948ce120ea2619;
var $41faae90f070a008$export$35808ee640e87ca7;
var $41faae90f070a008$export$fae74005e78b1a27;
var $41faae90f070a008$export$dc8fbce3eb94dc1e;
var $41faae90f070a008$export$6a7bc4e911dc01cf;
var $41faae90f070a008$export$6d9c69b0de29b591;
var $41faae90f070a008$export$f680877a34711e37;
var $41faae90f070a008$export$d5a552a76deda3c2;
var $41faae90f070a008$export$aaabe4eda9ed9969;
var $41faae90f070a008$export$e5c5a5f917a5871c;
var $41faae90f070a008$export$1538c33de8887b59;
var $41faae90f070a008$export$13e3392192263954;
var $41faae90f070a008$export$b8f5890fc79d6aca;
var $41faae90f070a008$export$60241385465d0a34;
var $41faae90f070a008$export$306c0aa65ff9ec16;
var $41faae90f070a008$export$7b286972b8d8ccbf;
var $41faae90f070a008$export$83d89fbfd8236492;
"use strict";
var $41faae90f070a008$var$l = Symbol.for("react.element"), $41faae90f070a008$var$n = Symbol.for("react.portal"), $41faae90f070a008$var$p = Symbol.for("react.fragment"), $41faae90f070a008$var$q = Symbol.for("react.strict_mode"), $41faae90f070a008$var$r = Symbol.for("react.profiler"), $41faae90f070a008$var$t = Symbol.for("react.provider"), $41faae90f070a008$var$u = Symbol.for("react.context"), $41faae90f070a008$var$v = Symbol.for("react.forward_ref"), $41faae90f070a008$var$w = Symbol.for("react.suspense"), $41faae90f070a008$var$x = Symbol.for("react.memo"), $41faae90f070a008$var$y = Symbol.for("react.lazy"), $41faae90f070a008$var$z = Symbol.iterator;
function $41faae90f070a008$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $41faae90f070a008$var$z && a[$41faae90f070a008$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $41faae90f070a008$var$B = {
    isMounted: function isMounted() {
        return !1;
    },
    enqueueForceUpdate: function enqueueForceUpdate() {},
    enqueueReplaceState: function enqueueReplaceState() {},
    enqueueSetState: function enqueueSetState() {}
}, $41faae90f070a008$var$C = Object.assign, $41faae90f070a008$var$D = {};
function $41faae90f070a008$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $41faae90f070a008$var$D;
    this.updater = e || $41faae90f070a008$var$B;
}
$41faae90f070a008$var$E.prototype.isReactComponent = {};
$41faae90f070a008$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$41faae90f070a008$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $41faae90f070a008$var$F() {}
$41faae90f070a008$var$F.prototype = $41faae90f070a008$var$E.prototype;
function $41faae90f070a008$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $41faae90f070a008$var$D;
    this.updater = e || $41faae90f070a008$var$B;
}
var $41faae90f070a008$var$H = $41faae90f070a008$var$G.prototype = new $41faae90f070a008$var$F;
$41faae90f070a008$var$H.constructor = $41faae90f070a008$var$G;
$41faae90f070a008$var$C($41faae90f070a008$var$H, $41faae90f070a008$var$E.prototype);
$41faae90f070a008$var$H.isPureReactComponent = !0;
var $41faae90f070a008$var$I = Array.isArray, $41faae90f070a008$var$J = Object.prototype.hasOwnProperty, $41faae90f070a008$var$K = {
    current: null
}, $41faae90f070a008$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $41faae90f070a008$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$41faae90f070a008$var$J.call(b, d) && !$41faae90f070a008$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $41faae90f070a008$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $41faae90f070a008$var$K.current
    };
}
function $41faae90f070a008$var$N(a, b) {
    return {
        $$typeof: $41faae90f070a008$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $41faae90f070a008$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $41faae90f070a008$var$l;
}
function $41faae90f070a008$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $41faae90f070a008$var$P = /\/+/g;
function $41faae90f070a008$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $41faae90f070a008$var$escape("" + a.key) : b.toString(36);
}
function $41faae90f070a008$var$R(a, b, e, d, c) {
    var k = typeof a === "undefined" ? "undefined" : (0, $6zqIC._)(a);
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $41faae90f070a008$var$l:
                case $41faae90f070a008$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $41faae90f070a008$var$Q(h, 0) : d, $41faae90f070a008$var$I(c) ? (e = "", null != a && (e = a.replace($41faae90f070a008$var$P, "$&/") + "/"), $41faae90f070a008$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($41faae90f070a008$var$O(c) && (c = $41faae90f070a008$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($41faae90f070a008$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($41faae90f070a008$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $41faae90f070a008$var$Q(k, g);
        h += $41faae90f070a008$var$R(k, b, e, f, c);
    }
    else if (f = $41faae90f070a008$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $41faae90f070a008$var$Q(k, g++), h += $41faae90f070a008$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $41faae90f070a008$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $41faae90f070a008$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $41faae90f070a008$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $41faae90f070a008$var$U = {
    current: null
}, $41faae90f070a008$var$V = {
    transition: null
}, $41faae90f070a008$var$W = {
    ReactCurrentDispatcher: $41faae90f070a008$var$U,
    ReactCurrentBatchConfig: $41faae90f070a008$var$V,
    ReactCurrentOwner: $41faae90f070a008$var$K
};
$41faae90f070a008$export$dca3b0875bd9a954 = {
    map: $41faae90f070a008$var$S,
    forEach: function forEach(a, b, e) {
        $41faae90f070a008$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function count(a) {
        var b = 0;
        $41faae90f070a008$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function toArray(a) {
        return $41faae90f070a008$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function only(a) {
        if (!$41faae90f070a008$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$41faae90f070a008$export$16fa2f45be04daa8 = $41faae90f070a008$var$E;
$41faae90f070a008$export$ffb0004e005737fa = $41faae90f070a008$var$p;
$41faae90f070a008$export$e2c29f18771995cb = $41faae90f070a008$var$r;
$41faae90f070a008$export$221d75b3f55bb0bd = $41faae90f070a008$var$G;
$41faae90f070a008$export$5f8d39834fd61797 = $41faae90f070a008$var$q;
$41faae90f070a008$export$74bf444e3cd11ea5 = $41faae90f070a008$var$w;
$41faae90f070a008$export$ae55be85d98224ed = $41faae90f070a008$var$W;
$41faae90f070a008$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $41faae90f070a008$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $41faae90f070a008$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$41faae90f070a008$var$J.call(b, f) && !$41faae90f070a008$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $41faae90f070a008$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$41faae90f070a008$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $41faae90f070a008$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $41faae90f070a008$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$41faae90f070a008$export$c8a8987d4410bf2d = $41faae90f070a008$var$M;
$41faae90f070a008$export$d38cd72104c1f0e9 = function(a) {
    var b = $41faae90f070a008$var$M.bind(null, a);
    b.type = a;
    return b;
};
$41faae90f070a008$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$41faae90f070a008$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $41faae90f070a008$var$v,
        render: a
    };
};
$41faae90f070a008$export$a8257692ac88316c = $41faae90f070a008$var$O;
$41faae90f070a008$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $41faae90f070a008$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $41faae90f070a008$var$T
    };
};
$41faae90f070a008$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $41faae90f070a008$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$41faae90f070a008$export$7568632d0d33d16d = function(a) {
    var b = $41faae90f070a008$var$V.transition;
    $41faae90f070a008$var$V.transition = {};
    try {
        a();
    } finally{
        $41faae90f070a008$var$V.transition = b;
    }
};
$41faae90f070a008$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$41faae90f070a008$export$35808ee640e87ca7 = function(a, b) {
    return $41faae90f070a008$var$U.current.useCallback(a, b);
};
$41faae90f070a008$export$fae74005e78b1a27 = function(a) {
    return $41faae90f070a008$var$U.current.useContext(a);
};
$41faae90f070a008$export$dc8fbce3eb94dc1e = function() {};
$41faae90f070a008$export$6a7bc4e911dc01cf = function(a) {
    return $41faae90f070a008$var$U.current.useDeferredValue(a);
};
$41faae90f070a008$export$6d9c69b0de29b591 = function(a, b) {
    return $41faae90f070a008$var$U.current.useEffect(a, b);
};
$41faae90f070a008$export$f680877a34711e37 = function() {
    return $41faae90f070a008$var$U.current.useId();
};
$41faae90f070a008$export$d5a552a76deda3c2 = function(a, b, e) {
    return $41faae90f070a008$var$U.current.useImperativeHandle(a, b, e);
};
$41faae90f070a008$export$aaabe4eda9ed9969 = function(a, b) {
    return $41faae90f070a008$var$U.current.useInsertionEffect(a, b);
};
$41faae90f070a008$export$e5c5a5f917a5871c = function(a, b) {
    return $41faae90f070a008$var$U.current.useLayoutEffect(a, b);
};
$41faae90f070a008$export$1538c33de8887b59 = function(a, b) {
    return $41faae90f070a008$var$U.current.useMemo(a, b);
};
$41faae90f070a008$export$13e3392192263954 = function(a, b, e) {
    return $41faae90f070a008$var$U.current.useReducer(a, b, e);
};
$41faae90f070a008$export$b8f5890fc79d6aca = function(a) {
    return $41faae90f070a008$var$U.current.useRef(a);
};
$41faae90f070a008$export$60241385465d0a34 = function(a) {
    return $41faae90f070a008$var$U.current.useState(a);
};
$41faae90f070a008$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $41faae90f070a008$var$U.current.useSyncExternalStore(a, b, e);
};
$41faae90f070a008$export$7b286972b8d8ccbf = function() {
    return $41faae90f070a008$var$U.current.useTransition();
};
$41faae90f070a008$export$83d89fbfd8236492 = "18.2.0";

});
parcelRegister("6zqIC", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $4c8abcbf1af2a7b7$export$71511d61b312f219; });
function $4c8abcbf1af2a7b7$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});





parcelRegister("4OQVW", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $3824e46e58e663a3$export$ae55be85d98224ed; }, function (v) { return $3824e46e58e663a3$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $3824e46e58e663a3$export$d39a5bbd09211389; }, function (v) { return $3824e46e58e663a3$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $3824e46e58e663a3$export$882461b6382ed46c; }, function (v) { return $3824e46e58e663a3$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $3824e46e58e663a3$export$466bfc07425424d5; }, function (v) { return $3824e46e58e663a3$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $3824e46e58e663a3$export$cd75ccfd720a3cd4; }, function (v) { return $3824e46e58e663a3$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $3824e46e58e663a3$export$fa8d919ba61d84db; }, function (v) { return $3824e46e58e663a3$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $3824e46e58e663a3$export$757ceba2d55c277e; }, function (v) { return $3824e46e58e663a3$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $3824e46e58e663a3$export$b3890eb0ae9dca99; }, function (v) { return $3824e46e58e663a3$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $3824e46e58e663a3$export$502457920280e6be; }, function (v) { return $3824e46e58e663a3$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $3824e46e58e663a3$export$c78a37762a8d58e1; }, function (v) { return $3824e46e58e663a3$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $3824e46e58e663a3$export$dc54d992c10e8a18; }, function (v) { return $3824e46e58e663a3$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $3824e46e58e663a3$export$83d89fbfd8236492; }, function (v) { return $3824e46e58e663a3$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 
var $6zqIC = parcelRequire("6zqIC");
var $3824e46e58e663a3$export$ae55be85d98224ed;
var $3824e46e58e663a3$export$d39a5bbd09211389;
var $3824e46e58e663a3$export$882461b6382ed46c;
var $3824e46e58e663a3$export$466bfc07425424d5;
var $3824e46e58e663a3$export$cd75ccfd720a3cd4;
var $3824e46e58e663a3$export$fa8d919ba61d84db;
var $3824e46e58e663a3$export$757ceba2d55c277e;
var $3824e46e58e663a3$export$b3890eb0ae9dca99;
var $3824e46e58e663a3$export$502457920280e6be;
var $3824e46e58e663a3$export$c78a37762a8d58e1;
var $3824e46e58e663a3$export$dc54d992c10e8a18;
var $3824e46e58e663a3$export$83d89fbfd8236492;
"use strict";

var $4Bt61 = parcelRequire("4Bt61");

var $bv0px = parcelRequire("bv0px");
function $3824e46e58e663a3$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $3824e46e58e663a3$var$da = new Set, $3824e46e58e663a3$var$ea = {};
function $3824e46e58e663a3$var$fa(a, b) {
    $3824e46e58e663a3$var$ha(a, b);
    $3824e46e58e663a3$var$ha(a + "Capture", b);
}
function $3824e46e58e663a3$var$ha(a, b) {
    $3824e46e58e663a3$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$3824e46e58e663a3$var$da.add(b[a]);
}
var $3824e46e58e663a3$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $3824e46e58e663a3$var$ja = Object.prototype.hasOwnProperty, $3824e46e58e663a3$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $3824e46e58e663a3$var$la = {}, $3824e46e58e663a3$var$ma = {};
function $3824e46e58e663a3$var$oa(a) {
    if ($3824e46e58e663a3$var$ja.call($3824e46e58e663a3$var$ma, a)) return !0;
    if ($3824e46e58e663a3$var$ja.call($3824e46e58e663a3$var$la, a)) return !1;
    if ($3824e46e58e663a3$var$ka.test(a)) return $3824e46e58e663a3$var$ma[a] = !0;
    $3824e46e58e663a3$var$la[a] = !0;
    return !1;
}
function $3824e46e58e663a3$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b === "undefined" ? "undefined" : (0, $6zqIC._)(b)){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $3824e46e58e663a3$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $3824e46e58e663a3$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $3824e46e58e663a3$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $3824e46e58e663a3$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $3824e46e58e663a3$var$z[a] = new $3824e46e58e663a3$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $3824e46e58e663a3$var$z[b] = new $3824e46e58e663a3$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $3824e46e58e663a3$var$z[a] = new $3824e46e58e663a3$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $3824e46e58e663a3$var$z[a] = new $3824e46e58e663a3$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $3824e46e58e663a3$var$z[a] = new $3824e46e58e663a3$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $3824e46e58e663a3$var$z[a] = new $3824e46e58e663a3$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $3824e46e58e663a3$var$z[a] = new $3824e46e58e663a3$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $3824e46e58e663a3$var$z[a] = new $3824e46e58e663a3$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $3824e46e58e663a3$var$z[a] = new $3824e46e58e663a3$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $3824e46e58e663a3$var$ra = /[\-:]([a-z])/g;
function $3824e46e58e663a3$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($3824e46e58e663a3$var$ra, $3824e46e58e663a3$var$sa);
    $3824e46e58e663a3$var$z[b] = new $3824e46e58e663a3$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($3824e46e58e663a3$var$ra, $3824e46e58e663a3$var$sa);
    $3824e46e58e663a3$var$z[b] = new $3824e46e58e663a3$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($3824e46e58e663a3$var$ra, $3824e46e58e663a3$var$sa);
    $3824e46e58e663a3$var$z[b] = new $3824e46e58e663a3$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $3824e46e58e663a3$var$z[a] = new $3824e46e58e663a3$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$3824e46e58e663a3$var$z.xlinkHref = new $3824e46e58e663a3$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $3824e46e58e663a3$var$z[a] = new $3824e46e58e663a3$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $3824e46e58e663a3$var$ta(a, b, c, d) {
    var e = $3824e46e58e663a3$var$z.hasOwnProperty(b) ? $3824e46e58e663a3$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $3824e46e58e663a3$var$qa(b, c, e, d) && (c = null), d || null === e ? $3824e46e58e663a3$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $3824e46e58e663a3$var$ua = $4Bt61.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $3824e46e58e663a3$var$va = Symbol.for("react.element"), $3824e46e58e663a3$var$wa = Symbol.for("react.portal"), $3824e46e58e663a3$var$ya = Symbol.for("react.fragment"), $3824e46e58e663a3$var$za = Symbol.for("react.strict_mode"), $3824e46e58e663a3$var$Aa = Symbol.for("react.profiler"), $3824e46e58e663a3$var$Ba = Symbol.for("react.provider"), $3824e46e58e663a3$var$Ca = Symbol.for("react.context"), $3824e46e58e663a3$var$Da = Symbol.for("react.forward_ref"), $3824e46e58e663a3$var$Ea = Symbol.for("react.suspense"), $3824e46e58e663a3$var$Fa = Symbol.for("react.suspense_list"), $3824e46e58e663a3$var$Ga = Symbol.for("react.memo"), $3824e46e58e663a3$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $3824e46e58e663a3$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $3824e46e58e663a3$var$Ja = Symbol.iterator;
function $3824e46e58e663a3$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $3824e46e58e663a3$var$Ja && a[$3824e46e58e663a3$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $3824e46e58e663a3$var$A = Object.assign, $3824e46e58e663a3$var$La;
function $3824e46e58e663a3$var$Ma(a) {
    if (void 0 === $3824e46e58e663a3$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $3824e46e58e663a3$var$La = b && b[1] || "";
    }
    return "\n" + $3824e46e58e663a3$var$La + a;
}
var $3824e46e58e663a3$var$Na = !1;
function $3824e46e58e663a3$var$Oa(a, b) {
    if (!a || $3824e46e58e663a3$var$Na) return "";
    $3824e46e58e663a3$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function b() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function set() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $3824e46e58e663a3$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $3824e46e58e663a3$var$Ma(a) : "";
}
function $3824e46e58e663a3$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $3824e46e58e663a3$var$Ma(a.type);
        case 16:
            return $3824e46e58e663a3$var$Ma("Lazy");
        case 13:
            return $3824e46e58e663a3$var$Ma("Suspense");
        case 19:
            return $3824e46e58e663a3$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $3824e46e58e663a3$var$Oa(a.type, !1), a;
        case 11:
            return a = $3824e46e58e663a3$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $3824e46e58e663a3$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $3824e46e58e663a3$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $3824e46e58e663a3$var$ya:
            return "Fragment";
        case $3824e46e58e663a3$var$wa:
            return "Portal";
        case $3824e46e58e663a3$var$Aa:
            return "Profiler";
        case $3824e46e58e663a3$var$za:
            return "StrictMode";
        case $3824e46e58e663a3$var$Ea:
            return "Suspense";
        case $3824e46e58e663a3$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $3824e46e58e663a3$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $3824e46e58e663a3$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $3824e46e58e663a3$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $3824e46e58e663a3$var$Ga:
            return b = a.displayName || null, null !== b ? b : $3824e46e58e663a3$var$Qa(a.type) || "Memo";
        case $3824e46e58e663a3$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $3824e46e58e663a3$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $3824e46e58e663a3$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $3824e46e58e663a3$var$Qa(b);
        case 8:
            return b === $3824e46e58e663a3$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $3824e46e58e663a3$var$Sa(a) {
    switch(typeof a === "undefined" ? "undefined" : (0, $6zqIC._)(a)){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $3824e46e58e663a3$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $3824e46e58e663a3$var$Ua(a) {
    var b = $3824e46e58e663a3$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function get() {
                return e.call(this);
            },
            set: function set(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function getValue() {
                return d;
            },
            setValue: function setValue(a) {
                d = "" + a;
            },
            stopTracking: function stopTracking() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $3824e46e58e663a3$var$Va(a) {
    a._valueTracker || (a._valueTracker = $3824e46e58e663a3$var$Ua(a));
}
function $3824e46e58e663a3$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $3824e46e58e663a3$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $3824e46e58e663a3$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $3824e46e58e663a3$var$Ya(a, b) {
    var c = b.checked;
    return $3824e46e58e663a3$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $3824e46e58e663a3$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $3824e46e58e663a3$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $3824e46e58e663a3$var$ab(a, b) {
    b = b.checked;
    null != b && $3824e46e58e663a3$var$ta(a, "checked", b, !1);
}
function $3824e46e58e663a3$var$bb(a, b) {
    $3824e46e58e663a3$var$ab(a, b);
    var c = $3824e46e58e663a3$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $3824e46e58e663a3$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $3824e46e58e663a3$var$cb(a, b.type, $3824e46e58e663a3$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $3824e46e58e663a3$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $3824e46e58e663a3$var$cb(a, b, c) {
    if ("number" !== b || $3824e46e58e663a3$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $3824e46e58e663a3$var$eb = Array.isArray;
function $3824e46e58e663a3$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $3824e46e58e663a3$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $3824e46e58e663a3$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($3824e46e58e663a3$var$p(91));
    return $3824e46e58e663a3$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $3824e46e58e663a3$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($3824e46e58e663a3$var$p(92));
            if ($3824e46e58e663a3$var$eb(c)) {
                if (1 < c.length) throw Error($3824e46e58e663a3$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $3824e46e58e663a3$var$Sa(c)
    };
}
function $3824e46e58e663a3$var$ib(a, b) {
    var c = $3824e46e58e663a3$var$Sa(b.value), d = $3824e46e58e663a3$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $3824e46e58e663a3$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $3824e46e58e663a3$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $3824e46e58e663a3$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $3824e46e58e663a3$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $3824e46e58e663a3$var$mb, $3824e46e58e663a3$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $3824e46e58e663a3$var$mb = $3824e46e58e663a3$var$mb || document.createElement("div");
        $3824e46e58e663a3$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $3824e46e58e663a3$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $3824e46e58e663a3$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $3824e46e58e663a3$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $3824e46e58e663a3$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($3824e46e58e663a3$var$pb).forEach(function(a) {
    $3824e46e58e663a3$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $3824e46e58e663a3$var$pb[b] = $3824e46e58e663a3$var$pb[a];
    });
});
function $3824e46e58e663a3$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $3824e46e58e663a3$var$pb.hasOwnProperty(a) && $3824e46e58e663a3$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $3824e46e58e663a3$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $3824e46e58e663a3$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $3824e46e58e663a3$var$tb = $3824e46e58e663a3$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $3824e46e58e663a3$var$ub(a, b) {
    if (b) {
        if ($3824e46e58e663a3$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($3824e46e58e663a3$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($3824e46e58e663a3$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($3824e46e58e663a3$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($3824e46e58e663a3$var$p(62));
    }
}
function $3824e46e58e663a3$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $3824e46e58e663a3$var$wb = null;
function $3824e46e58e663a3$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $3824e46e58e663a3$var$yb = null, $3824e46e58e663a3$var$zb = null, $3824e46e58e663a3$var$Ab = null;
function $3824e46e58e663a3$var$Bb(a) {
    if (a = $3824e46e58e663a3$var$Cb(a)) {
        if ("function" !== typeof $3824e46e58e663a3$var$yb) throw Error($3824e46e58e663a3$var$p(280));
        var b = a.stateNode;
        b && (b = $3824e46e58e663a3$var$Db(b), $3824e46e58e663a3$var$yb(a.stateNode, a.type, b));
    }
}
function $3824e46e58e663a3$var$Eb(a) {
    $3824e46e58e663a3$var$zb ? $3824e46e58e663a3$var$Ab ? $3824e46e58e663a3$var$Ab.push(a) : $3824e46e58e663a3$var$Ab = [
        a
    ] : $3824e46e58e663a3$var$zb = a;
}
function $3824e46e58e663a3$var$Fb() {
    if ($3824e46e58e663a3$var$zb) {
        var a = $3824e46e58e663a3$var$zb, b = $3824e46e58e663a3$var$Ab;
        $3824e46e58e663a3$var$Ab = $3824e46e58e663a3$var$zb = null;
        $3824e46e58e663a3$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$3824e46e58e663a3$var$Bb(b[a]);
    }
}
function $3824e46e58e663a3$var$Gb(a, b) {
    return a(b);
}
function $3824e46e58e663a3$var$Hb() {}
var $3824e46e58e663a3$var$Ib = !1;
function $3824e46e58e663a3$var$Jb(a, b, c) {
    if ($3824e46e58e663a3$var$Ib) return a(b, c);
    $3824e46e58e663a3$var$Ib = !0;
    try {
        return $3824e46e58e663a3$var$Gb(a, b, c);
    } finally{
        if ($3824e46e58e663a3$var$Ib = !1, null !== $3824e46e58e663a3$var$zb || null !== $3824e46e58e663a3$var$Ab) $3824e46e58e663a3$var$Hb(), $3824e46e58e663a3$var$Fb();
    }
}
function $3824e46e58e663a3$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $3824e46e58e663a3$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($3824e46e58e663a3$var$p(231, b, typeof c === "undefined" ? "undefined" : (0, $6zqIC._)(c)));
    return c;
}
var $3824e46e58e663a3$var$Lb = !1;
if ($3824e46e58e663a3$var$ia) try {
    var $3824e46e58e663a3$var$Mb = {};
    Object.defineProperty($3824e46e58e663a3$var$Mb, "passive", {
        get: function get() {
            $3824e46e58e663a3$var$Lb = !0;
        }
    });
    window.addEventListener("test", $3824e46e58e663a3$var$Mb, $3824e46e58e663a3$var$Mb);
    window.removeEventListener("test", $3824e46e58e663a3$var$Mb, $3824e46e58e663a3$var$Mb);
} catch (a) {
    $3824e46e58e663a3$var$Lb = !1;
}
function $3824e46e58e663a3$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $3824e46e58e663a3$var$Ob = !1, $3824e46e58e663a3$var$Pb = null, $3824e46e58e663a3$var$Qb = !1, $3824e46e58e663a3$var$Rb = null, $3824e46e58e663a3$var$Sb = {
    onError: function onError(a) {
        $3824e46e58e663a3$var$Ob = !0;
        $3824e46e58e663a3$var$Pb = a;
    }
};
function $3824e46e58e663a3$var$Tb(a, b, c, d, e, f, g, h, k) {
    $3824e46e58e663a3$var$Ob = !1;
    $3824e46e58e663a3$var$Pb = null;
    $3824e46e58e663a3$var$Nb.apply($3824e46e58e663a3$var$Sb, arguments);
}
function $3824e46e58e663a3$var$Ub(a, b, c, d, e, f, g, h, k) {
    $3824e46e58e663a3$var$Tb.apply(this, arguments);
    if ($3824e46e58e663a3$var$Ob) {
        if ($3824e46e58e663a3$var$Ob) {
            var l = $3824e46e58e663a3$var$Pb;
            $3824e46e58e663a3$var$Ob = !1;
            $3824e46e58e663a3$var$Pb = null;
        } else throw Error($3824e46e58e663a3$var$p(198));
        $3824e46e58e663a3$var$Qb || ($3824e46e58e663a3$var$Qb = !0, $3824e46e58e663a3$var$Rb = l);
    }
}
function $3824e46e58e663a3$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $3824e46e58e663a3$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $3824e46e58e663a3$var$Xb(a) {
    if ($3824e46e58e663a3$var$Vb(a) !== a) throw Error($3824e46e58e663a3$var$p(188));
}
function $3824e46e58e663a3$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $3824e46e58e663a3$var$Vb(a);
        if (null === b) throw Error($3824e46e58e663a3$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $3824e46e58e663a3$var$Xb(e), a;
                if (f === d) return $3824e46e58e663a3$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($3824e46e58e663a3$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($3824e46e58e663a3$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($3824e46e58e663a3$var$p(190));
    }
    if (3 !== c.tag) throw Error($3824e46e58e663a3$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $3824e46e58e663a3$var$Zb(a) {
    a = $3824e46e58e663a3$var$Yb(a);
    return null !== a ? $3824e46e58e663a3$var$$b(a) : null;
}
function $3824e46e58e663a3$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $3824e46e58e663a3$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $3824e46e58e663a3$var$ac = $bv0px.unstable_scheduleCallback, $3824e46e58e663a3$var$bc = $bv0px.unstable_cancelCallback, $3824e46e58e663a3$var$cc = $bv0px.unstable_shouldYield, $3824e46e58e663a3$var$dc = $bv0px.unstable_requestPaint, $3824e46e58e663a3$var$B = $bv0px.unstable_now, $3824e46e58e663a3$var$ec = $bv0px.unstable_getCurrentPriorityLevel, $3824e46e58e663a3$var$fc = $bv0px.unstable_ImmediatePriority, $3824e46e58e663a3$var$gc = $bv0px.unstable_UserBlockingPriority, $3824e46e58e663a3$var$hc = $bv0px.unstable_NormalPriority, $3824e46e58e663a3$var$ic = $bv0px.unstable_LowPriority, $3824e46e58e663a3$var$jc = $bv0px.unstable_IdlePriority, $3824e46e58e663a3$var$kc = null, $3824e46e58e663a3$var$lc = null;
function $3824e46e58e663a3$var$mc(a) {
    if ($3824e46e58e663a3$var$lc && "function" === typeof $3824e46e58e663a3$var$lc.onCommitFiberRoot) try {
        $3824e46e58e663a3$var$lc.onCommitFiberRoot($3824e46e58e663a3$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $3824e46e58e663a3$var$oc = Math.clz32 ? Math.clz32 : $3824e46e58e663a3$var$nc, $3824e46e58e663a3$var$pc = Math.log, $3824e46e58e663a3$var$qc = Math.LN2;
function $3824e46e58e663a3$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($3824e46e58e663a3$var$pc(a) / $3824e46e58e663a3$var$qc | 0) | 0;
}
var $3824e46e58e663a3$var$rc = 64, $3824e46e58e663a3$var$sc = 4194304;
function $3824e46e58e663a3$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $3824e46e58e663a3$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $3824e46e58e663a3$var$tc(h) : (f &= g, 0 !== f && (d = $3824e46e58e663a3$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $3824e46e58e663a3$var$tc(g) : 0 !== f && (d = $3824e46e58e663a3$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $3824e46e58e663a3$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $3824e46e58e663a3$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $3824e46e58e663a3$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $3824e46e58e663a3$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $3824e46e58e663a3$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $3824e46e58e663a3$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $3824e46e58e663a3$var$yc() {
    var a = $3824e46e58e663a3$var$rc;
    $3824e46e58e663a3$var$rc <<= 1;
    0 === ($3824e46e58e663a3$var$rc & 4194240) && ($3824e46e58e663a3$var$rc = 64);
    return a;
}
function $3824e46e58e663a3$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $3824e46e58e663a3$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $3824e46e58e663a3$var$oc(b);
    a[b] = c;
}
function $3824e46e58e663a3$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $3824e46e58e663a3$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $3824e46e58e663a3$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $3824e46e58e663a3$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $3824e46e58e663a3$var$C = 0;
function $3824e46e58e663a3$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $3824e46e58e663a3$var$Ec, $3824e46e58e663a3$var$Fc, $3824e46e58e663a3$var$Gc, $3824e46e58e663a3$var$Hc, $3824e46e58e663a3$var$Ic, $3824e46e58e663a3$var$Jc = !1, $3824e46e58e663a3$var$Kc = [], $3824e46e58e663a3$var$Lc = null, $3824e46e58e663a3$var$Mc = null, $3824e46e58e663a3$var$Nc = null, $3824e46e58e663a3$var$Oc = new Map, $3824e46e58e663a3$var$Pc = new Map, $3824e46e58e663a3$var$Qc = [], $3824e46e58e663a3$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $3824e46e58e663a3$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $3824e46e58e663a3$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $3824e46e58e663a3$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $3824e46e58e663a3$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $3824e46e58e663a3$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $3824e46e58e663a3$var$Pc.delete(b.pointerId);
    }
}
function $3824e46e58e663a3$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $3824e46e58e663a3$var$Cb(b), null !== b && $3824e46e58e663a3$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $3824e46e58e663a3$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $3824e46e58e663a3$var$Lc = $3824e46e58e663a3$var$Tc($3824e46e58e663a3$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $3824e46e58e663a3$var$Mc = $3824e46e58e663a3$var$Tc($3824e46e58e663a3$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $3824e46e58e663a3$var$Nc = $3824e46e58e663a3$var$Tc($3824e46e58e663a3$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $3824e46e58e663a3$var$Oc.set(f, $3824e46e58e663a3$var$Tc($3824e46e58e663a3$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $3824e46e58e663a3$var$Pc.set(f, $3824e46e58e663a3$var$Tc($3824e46e58e663a3$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $3824e46e58e663a3$var$Vc(a) {
    var b = $3824e46e58e663a3$var$Wc(a.target);
    if (null !== b) {
        var c = $3824e46e58e663a3$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $3824e46e58e663a3$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $3824e46e58e663a3$var$Ic(a.priority, function() {
                        $3824e46e58e663a3$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $3824e46e58e663a3$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $3824e46e58e663a3$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $3824e46e58e663a3$var$wb = d;
            c.target.dispatchEvent(d);
            $3824e46e58e663a3$var$wb = null;
        } else return b = $3824e46e58e663a3$var$Cb(c), null !== b && $3824e46e58e663a3$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $3824e46e58e663a3$var$Zc(a, b, c) {
    $3824e46e58e663a3$var$Xc(a) && c.delete(b);
}
function $3824e46e58e663a3$var$$c() {
    $3824e46e58e663a3$var$Jc = !1;
    null !== $3824e46e58e663a3$var$Lc && $3824e46e58e663a3$var$Xc($3824e46e58e663a3$var$Lc) && ($3824e46e58e663a3$var$Lc = null);
    null !== $3824e46e58e663a3$var$Mc && $3824e46e58e663a3$var$Xc($3824e46e58e663a3$var$Mc) && ($3824e46e58e663a3$var$Mc = null);
    null !== $3824e46e58e663a3$var$Nc && $3824e46e58e663a3$var$Xc($3824e46e58e663a3$var$Nc) && ($3824e46e58e663a3$var$Nc = null);
    $3824e46e58e663a3$var$Oc.forEach($3824e46e58e663a3$var$Zc);
    $3824e46e58e663a3$var$Pc.forEach($3824e46e58e663a3$var$Zc);
}
function $3824e46e58e663a3$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $3824e46e58e663a3$var$Jc || ($3824e46e58e663a3$var$Jc = !0, $bv0px.unstable_scheduleCallback($bv0px.unstable_NormalPriority, $3824e46e58e663a3$var$$c)));
}
function $3824e46e58e663a3$var$bd(a) {
    function b(b) {
        return $3824e46e58e663a3$var$ad(b, a);
    }
    if (0 < $3824e46e58e663a3$var$Kc.length) {
        $3824e46e58e663a3$var$ad($3824e46e58e663a3$var$Kc[0], a);
        for(var c = 1; c < $3824e46e58e663a3$var$Kc.length; c++){
            var d = $3824e46e58e663a3$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $3824e46e58e663a3$var$Lc && $3824e46e58e663a3$var$ad($3824e46e58e663a3$var$Lc, a);
    null !== $3824e46e58e663a3$var$Mc && $3824e46e58e663a3$var$ad($3824e46e58e663a3$var$Mc, a);
    null !== $3824e46e58e663a3$var$Nc && $3824e46e58e663a3$var$ad($3824e46e58e663a3$var$Nc, a);
    $3824e46e58e663a3$var$Oc.forEach(b);
    $3824e46e58e663a3$var$Pc.forEach(b);
    for(c = 0; c < $3824e46e58e663a3$var$Qc.length; c++)d = $3824e46e58e663a3$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $3824e46e58e663a3$var$Qc.length && (c = $3824e46e58e663a3$var$Qc[0], null === c.blockedOn);)$3824e46e58e663a3$var$Vc(c), null === c.blockedOn && $3824e46e58e663a3$var$Qc.shift();
}
var $3824e46e58e663a3$var$cd = $3824e46e58e663a3$var$ua.ReactCurrentBatchConfig, $3824e46e58e663a3$var$dd = !0;
function $3824e46e58e663a3$var$ed(a, b, c, d) {
    var e = $3824e46e58e663a3$var$C, f = $3824e46e58e663a3$var$cd.transition;
    $3824e46e58e663a3$var$cd.transition = null;
    try {
        $3824e46e58e663a3$var$C = 1, $3824e46e58e663a3$var$fd(a, b, c, d);
    } finally{
        $3824e46e58e663a3$var$C = e, $3824e46e58e663a3$var$cd.transition = f;
    }
}
function $3824e46e58e663a3$var$gd(a, b, c, d) {
    var e = $3824e46e58e663a3$var$C, f = $3824e46e58e663a3$var$cd.transition;
    $3824e46e58e663a3$var$cd.transition = null;
    try {
        $3824e46e58e663a3$var$C = 4, $3824e46e58e663a3$var$fd(a, b, c, d);
    } finally{
        $3824e46e58e663a3$var$C = e, $3824e46e58e663a3$var$cd.transition = f;
    }
}
function $3824e46e58e663a3$var$fd(a, b, c, d) {
    if ($3824e46e58e663a3$var$dd) {
        var e = $3824e46e58e663a3$var$Yc(a, b, c, d);
        if (null === e) $3824e46e58e663a3$var$hd(a, b, d, $3824e46e58e663a3$var$id, c), $3824e46e58e663a3$var$Sc(a, d);
        else if ($3824e46e58e663a3$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($3824e46e58e663a3$var$Sc(a, d), b & 4 && -1 < $3824e46e58e663a3$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $3824e46e58e663a3$var$Cb(e);
                null !== f && $3824e46e58e663a3$var$Ec(f);
                f = $3824e46e58e663a3$var$Yc(a, b, c, d);
                null === f && $3824e46e58e663a3$var$hd(a, b, d, $3824e46e58e663a3$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $3824e46e58e663a3$var$hd(a, b, d, null, c);
    }
}
var $3824e46e58e663a3$var$id = null;
function $3824e46e58e663a3$var$Yc(a, b, c, d) {
    $3824e46e58e663a3$var$id = null;
    a = $3824e46e58e663a3$var$xb(d);
    a = $3824e46e58e663a3$var$Wc(a);
    if (null !== a) {
        if (b = $3824e46e58e663a3$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $3824e46e58e663a3$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $3824e46e58e663a3$var$id = a;
    return null;
}
function $3824e46e58e663a3$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($3824e46e58e663a3$var$ec()){
                case $3824e46e58e663a3$var$fc:
                    return 1;
                case $3824e46e58e663a3$var$gc:
                    return 4;
                case $3824e46e58e663a3$var$hc:
                case $3824e46e58e663a3$var$ic:
                    return 16;
                case $3824e46e58e663a3$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $3824e46e58e663a3$var$kd = null, $3824e46e58e663a3$var$ld = null, $3824e46e58e663a3$var$md = null;
function $3824e46e58e663a3$var$nd() {
    if ($3824e46e58e663a3$var$md) return $3824e46e58e663a3$var$md;
    var a, b = $3824e46e58e663a3$var$ld, c = b.length, d, e = "value" in $3824e46e58e663a3$var$kd ? $3824e46e58e663a3$var$kd.value : $3824e46e58e663a3$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $3824e46e58e663a3$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $3824e46e58e663a3$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $3824e46e58e663a3$var$pd() {
    return !0;
}
function $3824e46e58e663a3$var$qd() {
    return !1;
}
function $3824e46e58e663a3$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $3824e46e58e663a3$var$pd : $3824e46e58e663a3$var$qd;
        this.isPropagationStopped = $3824e46e58e663a3$var$qd;
        return this;
    }
    $3824e46e58e663a3$var$A(b.prototype, {
        preventDefault: function preventDefault() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== (0, $6zqIC._)(a.returnValue) && (a.returnValue = !1), this.isDefaultPrevented = $3824e46e58e663a3$var$pd);
        },
        stopPropagation: function stopPropagation() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== (0, $6zqIC._)(a.cancelBubble) && (a.cancelBubble = !0), this.isPropagationStopped = $3824e46e58e663a3$var$pd);
        },
        persist: function persist() {},
        isPersistent: $3824e46e58e663a3$var$pd
    });
    return b;
}
var $3824e46e58e663a3$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function timeStamp(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $3824e46e58e663a3$var$td = $3824e46e58e663a3$var$rd($3824e46e58e663a3$var$sd), $3824e46e58e663a3$var$ud = $3824e46e58e663a3$var$A({}, $3824e46e58e663a3$var$sd, {
    view: 0,
    detail: 0
}), $3824e46e58e663a3$var$vd = $3824e46e58e663a3$var$rd($3824e46e58e663a3$var$ud), $3824e46e58e663a3$var$wd, $3824e46e58e663a3$var$xd, $3824e46e58e663a3$var$yd, $3824e46e58e663a3$var$Ad = $3824e46e58e663a3$var$A({}, $3824e46e58e663a3$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $3824e46e58e663a3$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function relatedTarget(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function movementX(a) {
        if ("movementX" in a) return a.movementX;
        a !== $3824e46e58e663a3$var$yd && ($3824e46e58e663a3$var$yd && "mousemove" === a.type ? ($3824e46e58e663a3$var$wd = a.screenX - $3824e46e58e663a3$var$yd.screenX, $3824e46e58e663a3$var$xd = a.screenY - $3824e46e58e663a3$var$yd.screenY) : $3824e46e58e663a3$var$xd = $3824e46e58e663a3$var$wd = 0, $3824e46e58e663a3$var$yd = a);
        return $3824e46e58e663a3$var$wd;
    },
    movementY: function movementY(a) {
        return "movementY" in a ? a.movementY : $3824e46e58e663a3$var$xd;
    }
}), $3824e46e58e663a3$var$Bd = $3824e46e58e663a3$var$rd($3824e46e58e663a3$var$Ad), $3824e46e58e663a3$var$Cd = $3824e46e58e663a3$var$A({}, $3824e46e58e663a3$var$Ad, {
    dataTransfer: 0
}), $3824e46e58e663a3$var$Dd = $3824e46e58e663a3$var$rd($3824e46e58e663a3$var$Cd), $3824e46e58e663a3$var$Ed = $3824e46e58e663a3$var$A({}, $3824e46e58e663a3$var$ud, {
    relatedTarget: 0
}), $3824e46e58e663a3$var$Fd = $3824e46e58e663a3$var$rd($3824e46e58e663a3$var$Ed), $3824e46e58e663a3$var$Gd = $3824e46e58e663a3$var$A({}, $3824e46e58e663a3$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $3824e46e58e663a3$var$Hd = $3824e46e58e663a3$var$rd($3824e46e58e663a3$var$Gd), $3824e46e58e663a3$var$Id = $3824e46e58e663a3$var$A({}, $3824e46e58e663a3$var$sd, {
    clipboardData: function clipboardData(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $3824e46e58e663a3$var$Jd = $3824e46e58e663a3$var$rd($3824e46e58e663a3$var$Id), $3824e46e58e663a3$var$Kd = $3824e46e58e663a3$var$A({}, $3824e46e58e663a3$var$sd, {
    data: 0
}), $3824e46e58e663a3$var$Ld = $3824e46e58e663a3$var$rd($3824e46e58e663a3$var$Kd), $3824e46e58e663a3$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $3824e46e58e663a3$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $3824e46e58e663a3$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $3824e46e58e663a3$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $3824e46e58e663a3$var$Od[a]) ? !!b[a] : !1;
}
function $3824e46e58e663a3$var$zd() {
    return $3824e46e58e663a3$var$Pd;
}
var $3824e46e58e663a3$var$Qd = $3824e46e58e663a3$var$A({}, $3824e46e58e663a3$var$ud, {
    key: function key(a) {
        if (a.key) {
            var b = $3824e46e58e663a3$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $3824e46e58e663a3$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $3824e46e58e663a3$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $3824e46e58e663a3$var$zd,
    charCode: function charCode(a) {
        return "keypress" === a.type ? $3824e46e58e663a3$var$od(a) : 0;
    },
    keyCode: function keyCode(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function which(a) {
        return "keypress" === a.type ? $3824e46e58e663a3$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $3824e46e58e663a3$var$Rd = $3824e46e58e663a3$var$rd($3824e46e58e663a3$var$Qd), $3824e46e58e663a3$var$Sd = $3824e46e58e663a3$var$A({}, $3824e46e58e663a3$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $3824e46e58e663a3$var$Td = $3824e46e58e663a3$var$rd($3824e46e58e663a3$var$Sd), $3824e46e58e663a3$var$Ud = $3824e46e58e663a3$var$A({}, $3824e46e58e663a3$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $3824e46e58e663a3$var$zd
}), $3824e46e58e663a3$var$Vd = $3824e46e58e663a3$var$rd($3824e46e58e663a3$var$Ud), $3824e46e58e663a3$var$Wd = $3824e46e58e663a3$var$A({}, $3824e46e58e663a3$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $3824e46e58e663a3$var$Xd = $3824e46e58e663a3$var$rd($3824e46e58e663a3$var$Wd), $3824e46e58e663a3$var$Yd = $3824e46e58e663a3$var$A({}, $3824e46e58e663a3$var$Ad, {
    deltaX: function deltaX(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function deltaY(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $3824e46e58e663a3$var$Zd = $3824e46e58e663a3$var$rd($3824e46e58e663a3$var$Yd), $3824e46e58e663a3$var$$d = [
    9,
    13,
    27,
    32
], $3824e46e58e663a3$var$ae = $3824e46e58e663a3$var$ia && "CompositionEvent" in window, $3824e46e58e663a3$var$be = null;
$3824e46e58e663a3$var$ia && "documentMode" in document && ($3824e46e58e663a3$var$be = document.documentMode);
var $3824e46e58e663a3$var$ce = $3824e46e58e663a3$var$ia && "TextEvent" in window && !$3824e46e58e663a3$var$be, $3824e46e58e663a3$var$de = $3824e46e58e663a3$var$ia && (!$3824e46e58e663a3$var$ae || $3824e46e58e663a3$var$be && 8 < $3824e46e58e663a3$var$be && 11 >= $3824e46e58e663a3$var$be), $3824e46e58e663a3$var$ee = String.fromCharCode(32), $3824e46e58e663a3$var$fe = !1;
function $3824e46e58e663a3$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $3824e46e58e663a3$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $3824e46e58e663a3$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $3824e46e58e663a3$var$ie = !1;
function $3824e46e58e663a3$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $3824e46e58e663a3$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $3824e46e58e663a3$var$fe = !0;
            return $3824e46e58e663a3$var$ee;
        case "textInput":
            return a = b.data, a === $3824e46e58e663a3$var$ee && $3824e46e58e663a3$var$fe ? null : a;
        default:
            return null;
    }
}
function $3824e46e58e663a3$var$ke(a, b) {
    if ($3824e46e58e663a3$var$ie) return "compositionend" === a || !$3824e46e58e663a3$var$ae && $3824e46e58e663a3$var$ge(a, b) ? (a = $3824e46e58e663a3$var$nd(), $3824e46e58e663a3$var$md = $3824e46e58e663a3$var$ld = $3824e46e58e663a3$var$kd = null, $3824e46e58e663a3$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $3824e46e58e663a3$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $3824e46e58e663a3$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $3824e46e58e663a3$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$3824e46e58e663a3$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $3824e46e58e663a3$var$ne(a, b, c, d) {
    $3824e46e58e663a3$var$Eb(d);
    b = $3824e46e58e663a3$var$oe(b, "onChange");
    0 < b.length && (c = new $3824e46e58e663a3$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $3824e46e58e663a3$var$pe = null, $3824e46e58e663a3$var$qe = null;
function $3824e46e58e663a3$var$re(a) {
    $3824e46e58e663a3$var$se(a, 0);
}
function $3824e46e58e663a3$var$te(a) {
    var b = $3824e46e58e663a3$var$ue(a);
    if ($3824e46e58e663a3$var$Wa(b)) return a;
}
function $3824e46e58e663a3$var$ve(a, b) {
    if ("change" === a) return b;
}
var $3824e46e58e663a3$var$we = !1;
if ($3824e46e58e663a3$var$ia) {
    var $3824e46e58e663a3$var$xe;
    if ($3824e46e58e663a3$var$ia) {
        var $3824e46e58e663a3$var$ye = "oninput" in document;
        if (!$3824e46e58e663a3$var$ye) {
            var $3824e46e58e663a3$var$ze = document.createElement("div");
            $3824e46e58e663a3$var$ze.setAttribute("oninput", "return;");
            $3824e46e58e663a3$var$ye = "function" === typeof $3824e46e58e663a3$var$ze.oninput;
        }
        $3824e46e58e663a3$var$xe = $3824e46e58e663a3$var$ye;
    } else $3824e46e58e663a3$var$xe = !1;
    $3824e46e58e663a3$var$we = $3824e46e58e663a3$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $3824e46e58e663a3$var$Ae() {
    $3824e46e58e663a3$var$pe && ($3824e46e58e663a3$var$pe.detachEvent("onpropertychange", $3824e46e58e663a3$var$Be), $3824e46e58e663a3$var$qe = $3824e46e58e663a3$var$pe = null);
}
function $3824e46e58e663a3$var$Be(a) {
    if ("value" === a.propertyName && $3824e46e58e663a3$var$te($3824e46e58e663a3$var$qe)) {
        var b = [];
        $3824e46e58e663a3$var$ne(b, $3824e46e58e663a3$var$qe, a, $3824e46e58e663a3$var$xb(a));
        $3824e46e58e663a3$var$Jb($3824e46e58e663a3$var$re, b);
    }
}
function $3824e46e58e663a3$var$Ce(a, b, c) {
    "focusin" === a ? ($3824e46e58e663a3$var$Ae(), $3824e46e58e663a3$var$pe = b, $3824e46e58e663a3$var$qe = c, $3824e46e58e663a3$var$pe.attachEvent("onpropertychange", $3824e46e58e663a3$var$Be)) : "focusout" === a && $3824e46e58e663a3$var$Ae();
}
function $3824e46e58e663a3$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $3824e46e58e663a3$var$te($3824e46e58e663a3$var$qe);
}
function $3824e46e58e663a3$var$Ee(a, b) {
    if ("click" === a) return $3824e46e58e663a3$var$te(b);
}
function $3824e46e58e663a3$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $3824e46e58e663a3$var$te(b);
}
function $3824e46e58e663a3$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $3824e46e58e663a3$var$He = "function" === typeof Object.is ? Object.is : $3824e46e58e663a3$var$Ge;
function $3824e46e58e663a3$var$Ie(a, b) {
    if ($3824e46e58e663a3$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$3824e46e58e663a3$var$ja.call(b, e) || !$3824e46e58e663a3$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $3824e46e58e663a3$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $3824e46e58e663a3$var$Ke(a, b) {
    var c = $3824e46e58e663a3$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $3824e46e58e663a3$var$Je(c);
    }
}
function $3824e46e58e663a3$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $3824e46e58e663a3$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $3824e46e58e663a3$var$Me() {
    for(var a = window, b = $3824e46e58e663a3$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $3824e46e58e663a3$var$Xa(a.document);
    }
    return b;
}
function $3824e46e58e663a3$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $3824e46e58e663a3$var$Oe(a) {
    var b = $3824e46e58e663a3$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $3824e46e58e663a3$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $3824e46e58e663a3$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $3824e46e58e663a3$var$Ke(c, f);
                var g = $3824e46e58e663a3$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $3824e46e58e663a3$var$Pe = $3824e46e58e663a3$var$ia && "documentMode" in document && 11 >= document.documentMode, $3824e46e58e663a3$var$Qe = null, $3824e46e58e663a3$var$Re = null, $3824e46e58e663a3$var$Se = null, $3824e46e58e663a3$var$Te = !1;
function $3824e46e58e663a3$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $3824e46e58e663a3$var$Te || null == $3824e46e58e663a3$var$Qe || $3824e46e58e663a3$var$Qe !== $3824e46e58e663a3$var$Xa(d) || (d = $3824e46e58e663a3$var$Qe, "selectionStart" in d && $3824e46e58e663a3$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $3824e46e58e663a3$var$Se && $3824e46e58e663a3$var$Ie($3824e46e58e663a3$var$Se, d) || ($3824e46e58e663a3$var$Se = d, d = $3824e46e58e663a3$var$oe($3824e46e58e663a3$var$Re, "onSelect"), 0 < d.length && (b = new $3824e46e58e663a3$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $3824e46e58e663a3$var$Qe)));
}
function $3824e46e58e663a3$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $3824e46e58e663a3$var$We = {
    animationend: $3824e46e58e663a3$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $3824e46e58e663a3$var$Ve("Animation", "AnimationIteration"),
    animationstart: $3824e46e58e663a3$var$Ve("Animation", "AnimationStart"),
    transitionend: $3824e46e58e663a3$var$Ve("Transition", "TransitionEnd")
}, $3824e46e58e663a3$var$Xe = {}, $3824e46e58e663a3$var$Ye = {};
$3824e46e58e663a3$var$ia && ($3824e46e58e663a3$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $3824e46e58e663a3$var$We.animationend.animation, delete $3824e46e58e663a3$var$We.animationiteration.animation, delete $3824e46e58e663a3$var$We.animationstart.animation), "TransitionEvent" in window || delete $3824e46e58e663a3$var$We.transitionend.transition);
function $3824e46e58e663a3$var$Ze(a) {
    if ($3824e46e58e663a3$var$Xe[a]) return $3824e46e58e663a3$var$Xe[a];
    if (!$3824e46e58e663a3$var$We[a]) return a;
    var b = $3824e46e58e663a3$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $3824e46e58e663a3$var$Ye) return $3824e46e58e663a3$var$Xe[a] = b[c];
    return a;
}
var $3824e46e58e663a3$var$$e = $3824e46e58e663a3$var$Ze("animationend"), $3824e46e58e663a3$var$af = $3824e46e58e663a3$var$Ze("animationiteration"), $3824e46e58e663a3$var$bf = $3824e46e58e663a3$var$Ze("animationstart"), $3824e46e58e663a3$var$cf = $3824e46e58e663a3$var$Ze("transitionend"), $3824e46e58e663a3$var$df = new Map, $3824e46e58e663a3$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $3824e46e58e663a3$var$ff(a, b) {
    $3824e46e58e663a3$var$df.set(a, b);
    $3824e46e58e663a3$var$fa(b, [
        a
    ]);
}
for(var $3824e46e58e663a3$var$gf = 0; $3824e46e58e663a3$var$gf < $3824e46e58e663a3$var$ef.length; $3824e46e58e663a3$var$gf++){
    var $3824e46e58e663a3$var$hf = $3824e46e58e663a3$var$ef[$3824e46e58e663a3$var$gf], $3824e46e58e663a3$var$jf = $3824e46e58e663a3$var$hf.toLowerCase(), $3824e46e58e663a3$var$kf = $3824e46e58e663a3$var$hf[0].toUpperCase() + $3824e46e58e663a3$var$hf.slice(1);
    $3824e46e58e663a3$var$ff($3824e46e58e663a3$var$jf, "on" + $3824e46e58e663a3$var$kf);
}
$3824e46e58e663a3$var$ff($3824e46e58e663a3$var$$e, "onAnimationEnd");
$3824e46e58e663a3$var$ff($3824e46e58e663a3$var$af, "onAnimationIteration");
$3824e46e58e663a3$var$ff($3824e46e58e663a3$var$bf, "onAnimationStart");
$3824e46e58e663a3$var$ff("dblclick", "onDoubleClick");
$3824e46e58e663a3$var$ff("focusin", "onFocus");
$3824e46e58e663a3$var$ff("focusout", "onBlur");
$3824e46e58e663a3$var$ff($3824e46e58e663a3$var$cf, "onTransitionEnd");
$3824e46e58e663a3$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$3824e46e58e663a3$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$3824e46e58e663a3$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$3824e46e58e663a3$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$3824e46e58e663a3$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$3824e46e58e663a3$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$3824e46e58e663a3$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$3824e46e58e663a3$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$3824e46e58e663a3$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$3824e46e58e663a3$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $3824e46e58e663a3$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $3824e46e58e663a3$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($3824e46e58e663a3$var$lf));
function $3824e46e58e663a3$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $3824e46e58e663a3$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $3824e46e58e663a3$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $3824e46e58e663a3$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $3824e46e58e663a3$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($3824e46e58e663a3$var$Qb) throw a = $3824e46e58e663a3$var$Rb, $3824e46e58e663a3$var$Qb = !1, $3824e46e58e663a3$var$Rb = null, a;
}
function $3824e46e58e663a3$var$D(a, b) {
    var c = b[$3824e46e58e663a3$var$of];
    void 0 === c && (c = b[$3824e46e58e663a3$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($3824e46e58e663a3$var$pf(b, a, 2, !1), c.add(d));
}
function $3824e46e58e663a3$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $3824e46e58e663a3$var$pf(c, a, d, b);
}
var $3824e46e58e663a3$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $3824e46e58e663a3$var$sf(a) {
    if (!a[$3824e46e58e663a3$var$rf]) {
        a[$3824e46e58e663a3$var$rf] = !0;
        $3824e46e58e663a3$var$da.forEach(function(b) {
            "selectionchange" !== b && ($3824e46e58e663a3$var$mf.has(b) || $3824e46e58e663a3$var$qf(b, !1, a), $3824e46e58e663a3$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$3824e46e58e663a3$var$rf] || (b[$3824e46e58e663a3$var$rf] = !0, $3824e46e58e663a3$var$qf("selectionchange", !1, b));
    }
}
function $3824e46e58e663a3$var$pf(a, b, c, d) {
    switch($3824e46e58e663a3$var$jd(b)){
        case 1:
            var e = $3824e46e58e663a3$var$ed;
            break;
        case 4:
            e = $3824e46e58e663a3$var$gd;
            break;
        default:
            e = $3824e46e58e663a3$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$3824e46e58e663a3$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $3824e46e58e663a3$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $3824e46e58e663a3$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $3824e46e58e663a3$var$Jb(function() {
        var _$d = f, _$e = $3824e46e58e663a3$var$xb(c), g = [];
        a: {
            var h = $3824e46e58e663a3$var$df.get(a);
            if (void 0 !== h) {
                var k = $3824e46e58e663a3$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $3824e46e58e663a3$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $3824e46e58e663a3$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $3824e46e58e663a3$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $3824e46e58e663a3$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $3824e46e58e663a3$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $3824e46e58e663a3$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $3824e46e58e663a3$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $3824e46e58e663a3$var$Vd;
                        break;
                    case $3824e46e58e663a3$var$$e:
                    case $3824e46e58e663a3$var$af:
                    case $3824e46e58e663a3$var$bf:
                        k = $3824e46e58e663a3$var$Hd;
                        break;
                    case $3824e46e58e663a3$var$cf:
                        k = $3824e46e58e663a3$var$Xd;
                        break;
                    case "scroll":
                        k = $3824e46e58e663a3$var$vd;
                        break;
                    case "wheel":
                        k = $3824e46e58e663a3$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $3824e46e58e663a3$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $3824e46e58e663a3$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = _$d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $3824e46e58e663a3$var$Kb(w, x), null != F && t.push($3824e46e58e663a3$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, _$e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $3824e46e58e663a3$var$wb && (n = c.relatedTarget || c.fromElement) && ($3824e46e58e663a3$var$Wc(n) || n[$3824e46e58e663a3$var$uf])) break a;
                if (k || h) {
                    h = _$e.window === _$e ? _$e : (h = _$e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = _$d, n = n ? $3824e46e58e663a3$var$Wc(n) : null, null !== n && (J = $3824e46e58e663a3$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = _$d;
                    if (k !== n) {
                        t = $3824e46e58e663a3$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $3824e46e58e663a3$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $3824e46e58e663a3$var$ue(k);
                        u = null == n ? h : $3824e46e58e663a3$var$ue(n);
                        h = new t(F, w + "leave", k, c, _$e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $3824e46e58e663a3$var$Wc(_$e) === _$d && (t = new t(x, w + "enter", n, c, _$e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $3824e46e58e663a3$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $3824e46e58e663a3$var$vf(F))u++;
                            for(; 0 < w - u;)t = $3824e46e58e663a3$var$vf(t), w--;
                            for(; 0 < u - w;)x = $3824e46e58e663a3$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $3824e46e58e663a3$var$vf(t);
                                x = $3824e46e58e663a3$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $3824e46e58e663a3$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $3824e46e58e663a3$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = _$d ? $3824e46e58e663a3$var$ue(_$d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $3824e46e58e663a3$var$ve;
                else if ($3824e46e58e663a3$var$me(h)) {
                    if ($3824e46e58e663a3$var$we) na = $3824e46e58e663a3$var$Fe;
                    else {
                        na = $3824e46e58e663a3$var$De;
                        var xa = $3824e46e58e663a3$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $3824e46e58e663a3$var$Ee);
                if (na && (na = na(a, _$d))) {
                    $3824e46e58e663a3$var$ne(g, na, c, _$e);
                    break a;
                }
                xa && xa(a, h, _$d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $3824e46e58e663a3$var$cb(h, "number", h.value);
            }
            xa = _$d ? $3824e46e58e663a3$var$ue(_$d) : window;
            switch(a){
                case "focusin":
                    if ($3824e46e58e663a3$var$me(xa) || "true" === xa.contentEditable) $3824e46e58e663a3$var$Qe = xa, $3824e46e58e663a3$var$Re = _$d, $3824e46e58e663a3$var$Se = null;
                    break;
                case "focusout":
                    $3824e46e58e663a3$var$Se = $3824e46e58e663a3$var$Re = $3824e46e58e663a3$var$Qe = null;
                    break;
                case "mousedown":
                    $3824e46e58e663a3$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $3824e46e58e663a3$var$Te = !1;
                    $3824e46e58e663a3$var$Ue(g, c, _$e);
                    break;
                case "selectionchange":
                    if ($3824e46e58e663a3$var$Pe) break;
                case "keydown":
                case "keyup":
                    $3824e46e58e663a3$var$Ue(g, c, _$e);
            }
            var $a;
            if ($3824e46e58e663a3$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $3824e46e58e663a3$var$ie ? $3824e46e58e663a3$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($3824e46e58e663a3$var$de && "ko" !== c.locale && ($3824e46e58e663a3$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $3824e46e58e663a3$var$ie && ($a = $3824e46e58e663a3$var$nd()) : ($3824e46e58e663a3$var$kd = _$e, $3824e46e58e663a3$var$ld = "value" in $3824e46e58e663a3$var$kd ? $3824e46e58e663a3$var$kd.value : $3824e46e58e663a3$var$kd.textContent, $3824e46e58e663a3$var$ie = !0)), xa = $3824e46e58e663a3$var$oe(_$d, ba), 0 < xa.length && (ba = new $3824e46e58e663a3$var$Ld(ba, a, null, c, _$e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $3824e46e58e663a3$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $3824e46e58e663a3$var$ce ? $3824e46e58e663a3$var$je(a, c) : $3824e46e58e663a3$var$ke(a, c)) _$d = $3824e46e58e663a3$var$oe(_$d, "onBeforeInput"), 0 < _$d.length && (_$e = new $3824e46e58e663a3$var$Ld("onBeforeInput", "beforeinput", null, c, _$e), g.push({
                event: _$e,
                listeners: _$d
            }), _$e.data = $a);
        }
        $3824e46e58e663a3$var$se(g, b);
    });
}
function $3824e46e58e663a3$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $3824e46e58e663a3$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $3824e46e58e663a3$var$Kb(a, c), null != f && d.unshift($3824e46e58e663a3$var$tf(a, f, e)), f = $3824e46e58e663a3$var$Kb(a, b), null != f && d.push($3824e46e58e663a3$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $3824e46e58e663a3$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $3824e46e58e663a3$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $3824e46e58e663a3$var$Kb(c, f), null != k && g.unshift($3824e46e58e663a3$var$tf(c, k, h))) : e || (k = $3824e46e58e663a3$var$Kb(c, f), null != k && g.push($3824e46e58e663a3$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $3824e46e58e663a3$var$xf = /\r\n?/g, $3824e46e58e663a3$var$yf = /\u0000|\uFFFD/g;
function $3824e46e58e663a3$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($3824e46e58e663a3$var$xf, "\n").replace($3824e46e58e663a3$var$yf, "");
}
function $3824e46e58e663a3$var$Af(a, b, c) {
    b = $3824e46e58e663a3$var$zf(b);
    if ($3824e46e58e663a3$var$zf(a) !== b && c) throw Error($3824e46e58e663a3$var$p(425));
}
function $3824e46e58e663a3$var$Bf() {}
var $3824e46e58e663a3$var$Cf = null, $3824e46e58e663a3$var$Df = null;
function $3824e46e58e663a3$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $3824e46e58e663a3$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $3824e46e58e663a3$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $3824e46e58e663a3$var$Hf = "function" === typeof Promise ? Promise : void 0, $3824e46e58e663a3$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $3824e46e58e663a3$var$Hf ? function Jf(a) {
    return $3824e46e58e663a3$var$Hf.resolve(null).then(a).catch($3824e46e58e663a3$var$If);
} : $3824e46e58e663a3$var$Ff;
function $3824e46e58e663a3$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $3824e46e58e663a3$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $3824e46e58e663a3$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $3824e46e58e663a3$var$bd(b);
}
function $3824e46e58e663a3$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $3824e46e58e663a3$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $3824e46e58e663a3$var$Nf = Math.random().toString(36).slice(2), $3824e46e58e663a3$var$Of = "__reactFiber$" + $3824e46e58e663a3$var$Nf, $3824e46e58e663a3$var$Pf = "__reactProps$" + $3824e46e58e663a3$var$Nf, $3824e46e58e663a3$var$uf = "__reactContainer$" + $3824e46e58e663a3$var$Nf, $3824e46e58e663a3$var$of = "__reactEvents$" + $3824e46e58e663a3$var$Nf, $3824e46e58e663a3$var$Qf = "__reactListeners$" + $3824e46e58e663a3$var$Nf, $3824e46e58e663a3$var$Rf = "__reactHandles$" + $3824e46e58e663a3$var$Nf;
function $3824e46e58e663a3$var$Wc(a) {
    var b = a[$3824e46e58e663a3$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$3824e46e58e663a3$var$uf] || c[$3824e46e58e663a3$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $3824e46e58e663a3$var$Mf(a); null !== a;){
                if (c = a[$3824e46e58e663a3$var$Of]) return c;
                a = $3824e46e58e663a3$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $3824e46e58e663a3$var$Cb(a) {
    a = a[$3824e46e58e663a3$var$Of] || a[$3824e46e58e663a3$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $3824e46e58e663a3$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($3824e46e58e663a3$var$p(33));
}
function $3824e46e58e663a3$var$Db(a) {
    return a[$3824e46e58e663a3$var$Pf] || null;
}
var $3824e46e58e663a3$var$Sf = [], $3824e46e58e663a3$var$Tf = -1;
function $3824e46e58e663a3$var$Uf(a) {
    return {
        current: a
    };
}
function $3824e46e58e663a3$var$E(a) {
    0 > $3824e46e58e663a3$var$Tf || (a.current = $3824e46e58e663a3$var$Sf[$3824e46e58e663a3$var$Tf], $3824e46e58e663a3$var$Sf[$3824e46e58e663a3$var$Tf] = null, $3824e46e58e663a3$var$Tf--);
}
function $3824e46e58e663a3$var$G(a, b) {
    $3824e46e58e663a3$var$Tf++;
    $3824e46e58e663a3$var$Sf[$3824e46e58e663a3$var$Tf] = a.current;
    a.current = b;
}
var $3824e46e58e663a3$var$Vf = {}, $3824e46e58e663a3$var$H = $3824e46e58e663a3$var$Uf($3824e46e58e663a3$var$Vf), $3824e46e58e663a3$var$Wf = $3824e46e58e663a3$var$Uf(!1), $3824e46e58e663a3$var$Xf = $3824e46e58e663a3$var$Vf;
function $3824e46e58e663a3$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $3824e46e58e663a3$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $3824e46e58e663a3$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $3824e46e58e663a3$var$$f() {
    $3824e46e58e663a3$var$E($3824e46e58e663a3$var$Wf);
    $3824e46e58e663a3$var$E($3824e46e58e663a3$var$H);
}
function $3824e46e58e663a3$var$ag(a, b, c) {
    if ($3824e46e58e663a3$var$H.current !== $3824e46e58e663a3$var$Vf) throw Error($3824e46e58e663a3$var$p(168));
    $3824e46e58e663a3$var$G($3824e46e58e663a3$var$H, b);
    $3824e46e58e663a3$var$G($3824e46e58e663a3$var$Wf, c);
}
function $3824e46e58e663a3$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($3824e46e58e663a3$var$p(108, $3824e46e58e663a3$var$Ra(a) || "Unknown", e));
    return $3824e46e58e663a3$var$A({}, c, d);
}
function $3824e46e58e663a3$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $3824e46e58e663a3$var$Vf;
    $3824e46e58e663a3$var$Xf = $3824e46e58e663a3$var$H.current;
    $3824e46e58e663a3$var$G($3824e46e58e663a3$var$H, a);
    $3824e46e58e663a3$var$G($3824e46e58e663a3$var$Wf, $3824e46e58e663a3$var$Wf.current);
    return !0;
}
function $3824e46e58e663a3$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($3824e46e58e663a3$var$p(169));
    c ? (a = $3824e46e58e663a3$var$bg(a, b, $3824e46e58e663a3$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $3824e46e58e663a3$var$E($3824e46e58e663a3$var$Wf), $3824e46e58e663a3$var$E($3824e46e58e663a3$var$H), $3824e46e58e663a3$var$G($3824e46e58e663a3$var$H, a)) : $3824e46e58e663a3$var$E($3824e46e58e663a3$var$Wf);
    $3824e46e58e663a3$var$G($3824e46e58e663a3$var$Wf, c);
}
var $3824e46e58e663a3$var$eg = null, $3824e46e58e663a3$var$fg = !1, $3824e46e58e663a3$var$gg = !1;
function $3824e46e58e663a3$var$hg(a) {
    null === $3824e46e58e663a3$var$eg ? $3824e46e58e663a3$var$eg = [
        a
    ] : $3824e46e58e663a3$var$eg.push(a);
}
function $3824e46e58e663a3$var$ig(a) {
    $3824e46e58e663a3$var$fg = !0;
    $3824e46e58e663a3$var$hg(a);
}
function $3824e46e58e663a3$var$jg() {
    if (!$3824e46e58e663a3$var$gg && null !== $3824e46e58e663a3$var$eg) {
        $3824e46e58e663a3$var$gg = !0;
        var a = 0, b = $3824e46e58e663a3$var$C;
        try {
            var c = $3824e46e58e663a3$var$eg;
            for($3824e46e58e663a3$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $3824e46e58e663a3$var$eg = null;
            $3824e46e58e663a3$var$fg = !1;
        } catch (e) {
            throw null !== $3824e46e58e663a3$var$eg && ($3824e46e58e663a3$var$eg = $3824e46e58e663a3$var$eg.slice(a + 1)), $3824e46e58e663a3$var$ac($3824e46e58e663a3$var$fc, $3824e46e58e663a3$var$jg), e;
        } finally{
            $3824e46e58e663a3$var$C = b, $3824e46e58e663a3$var$gg = !1;
        }
    }
    return null;
}
var $3824e46e58e663a3$var$kg = [], $3824e46e58e663a3$var$lg = 0, $3824e46e58e663a3$var$mg = null, $3824e46e58e663a3$var$ng = 0, $3824e46e58e663a3$var$og = [], $3824e46e58e663a3$var$pg = 0, $3824e46e58e663a3$var$qg = null, $3824e46e58e663a3$var$rg = 1, $3824e46e58e663a3$var$sg = "";
function $3824e46e58e663a3$var$tg(a, b) {
    $3824e46e58e663a3$var$kg[$3824e46e58e663a3$var$lg++] = $3824e46e58e663a3$var$ng;
    $3824e46e58e663a3$var$kg[$3824e46e58e663a3$var$lg++] = $3824e46e58e663a3$var$mg;
    $3824e46e58e663a3$var$mg = a;
    $3824e46e58e663a3$var$ng = b;
}
function $3824e46e58e663a3$var$ug(a, b, c) {
    $3824e46e58e663a3$var$og[$3824e46e58e663a3$var$pg++] = $3824e46e58e663a3$var$rg;
    $3824e46e58e663a3$var$og[$3824e46e58e663a3$var$pg++] = $3824e46e58e663a3$var$sg;
    $3824e46e58e663a3$var$og[$3824e46e58e663a3$var$pg++] = $3824e46e58e663a3$var$qg;
    $3824e46e58e663a3$var$qg = a;
    var d = $3824e46e58e663a3$var$rg;
    a = $3824e46e58e663a3$var$sg;
    var e = 32 - $3824e46e58e663a3$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $3824e46e58e663a3$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $3824e46e58e663a3$var$rg = 1 << 32 - $3824e46e58e663a3$var$oc(b) + e | c << e | d;
        $3824e46e58e663a3$var$sg = f + a;
    } else $3824e46e58e663a3$var$rg = 1 << f | c << e | d, $3824e46e58e663a3$var$sg = a;
}
function $3824e46e58e663a3$var$vg(a) {
    null !== a.return && ($3824e46e58e663a3$var$tg(a, 1), $3824e46e58e663a3$var$ug(a, 1, 0));
}
function $3824e46e58e663a3$var$wg(a) {
    for(; a === $3824e46e58e663a3$var$mg;)$3824e46e58e663a3$var$mg = $3824e46e58e663a3$var$kg[--$3824e46e58e663a3$var$lg], $3824e46e58e663a3$var$kg[$3824e46e58e663a3$var$lg] = null, $3824e46e58e663a3$var$ng = $3824e46e58e663a3$var$kg[--$3824e46e58e663a3$var$lg], $3824e46e58e663a3$var$kg[$3824e46e58e663a3$var$lg] = null;
    for(; a === $3824e46e58e663a3$var$qg;)$3824e46e58e663a3$var$qg = $3824e46e58e663a3$var$og[--$3824e46e58e663a3$var$pg], $3824e46e58e663a3$var$og[$3824e46e58e663a3$var$pg] = null, $3824e46e58e663a3$var$sg = $3824e46e58e663a3$var$og[--$3824e46e58e663a3$var$pg], $3824e46e58e663a3$var$og[$3824e46e58e663a3$var$pg] = null, $3824e46e58e663a3$var$rg = $3824e46e58e663a3$var$og[--$3824e46e58e663a3$var$pg], $3824e46e58e663a3$var$og[$3824e46e58e663a3$var$pg] = null;
}
var $3824e46e58e663a3$var$xg = null, $3824e46e58e663a3$var$yg = null, $3824e46e58e663a3$var$I = !1, $3824e46e58e663a3$var$zg = null;
function $3824e46e58e663a3$var$Ag(a, b) {
    var c = $3824e46e58e663a3$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $3824e46e58e663a3$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $3824e46e58e663a3$var$xg = a, $3824e46e58e663a3$var$yg = $3824e46e58e663a3$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $3824e46e58e663a3$var$xg = a, $3824e46e58e663a3$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $3824e46e58e663a3$var$qg ? {
                id: $3824e46e58e663a3$var$rg,
                overflow: $3824e46e58e663a3$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $3824e46e58e663a3$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $3824e46e58e663a3$var$xg = a, $3824e46e58e663a3$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $3824e46e58e663a3$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $3824e46e58e663a3$var$Eg(a) {
    if ($3824e46e58e663a3$var$I) {
        var b = $3824e46e58e663a3$var$yg;
        if (b) {
            var c = b;
            if (!$3824e46e58e663a3$var$Cg(a, b)) {
                if ($3824e46e58e663a3$var$Dg(a)) throw Error($3824e46e58e663a3$var$p(418));
                b = $3824e46e58e663a3$var$Lf(c.nextSibling);
                var d = $3824e46e58e663a3$var$xg;
                b && $3824e46e58e663a3$var$Cg(a, b) ? $3824e46e58e663a3$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $3824e46e58e663a3$var$I = !1, $3824e46e58e663a3$var$xg = a);
            }
        } else {
            if ($3824e46e58e663a3$var$Dg(a)) throw Error($3824e46e58e663a3$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $3824e46e58e663a3$var$I = !1;
            $3824e46e58e663a3$var$xg = a;
        }
    }
}
function $3824e46e58e663a3$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $3824e46e58e663a3$var$xg = a;
}
function $3824e46e58e663a3$var$Gg(a) {
    if (a !== $3824e46e58e663a3$var$xg) return !1;
    if (!$3824e46e58e663a3$var$I) return $3824e46e58e663a3$var$Fg(a), $3824e46e58e663a3$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$3824e46e58e663a3$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $3824e46e58e663a3$var$yg)) {
        if ($3824e46e58e663a3$var$Dg(a)) throw $3824e46e58e663a3$var$Hg(), Error($3824e46e58e663a3$var$p(418));
        for(; b;)$3824e46e58e663a3$var$Ag(a, b), b = $3824e46e58e663a3$var$Lf(b.nextSibling);
    }
    $3824e46e58e663a3$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($3824e46e58e663a3$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $3824e46e58e663a3$var$yg = $3824e46e58e663a3$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $3824e46e58e663a3$var$yg = null;
        }
    } else $3824e46e58e663a3$var$yg = $3824e46e58e663a3$var$xg ? $3824e46e58e663a3$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $3824e46e58e663a3$var$Hg() {
    for(var a = $3824e46e58e663a3$var$yg; a;)a = $3824e46e58e663a3$var$Lf(a.nextSibling);
}
function $3824e46e58e663a3$var$Ig() {
    $3824e46e58e663a3$var$yg = $3824e46e58e663a3$var$xg = null;
    $3824e46e58e663a3$var$I = !1;
}
function $3824e46e58e663a3$var$Jg(a) {
    null === $3824e46e58e663a3$var$zg ? $3824e46e58e663a3$var$zg = [
        a
    ] : $3824e46e58e663a3$var$zg.push(a);
}
var $3824e46e58e663a3$var$Kg = $3824e46e58e663a3$var$ua.ReactCurrentBatchConfig;
function $3824e46e58e663a3$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $3824e46e58e663a3$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $3824e46e58e663a3$var$Mg = $3824e46e58e663a3$var$Uf(null), $3824e46e58e663a3$var$Ng = null, $3824e46e58e663a3$var$Og = null, $3824e46e58e663a3$var$Pg = null;
function $3824e46e58e663a3$var$Qg() {
    $3824e46e58e663a3$var$Pg = $3824e46e58e663a3$var$Og = $3824e46e58e663a3$var$Ng = null;
}
function $3824e46e58e663a3$var$Rg(a) {
    var b = $3824e46e58e663a3$var$Mg.current;
    $3824e46e58e663a3$var$E($3824e46e58e663a3$var$Mg);
    a._currentValue = b;
}
function $3824e46e58e663a3$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $3824e46e58e663a3$var$Tg(a, b) {
    $3824e46e58e663a3$var$Ng = a;
    $3824e46e58e663a3$var$Pg = $3824e46e58e663a3$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($3824e46e58e663a3$var$Ug = !0), a.firstContext = null);
}
function $3824e46e58e663a3$var$Vg(a) {
    var b = a._currentValue;
    if ($3824e46e58e663a3$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $3824e46e58e663a3$var$Og) {
            if (null === $3824e46e58e663a3$var$Ng) throw Error($3824e46e58e663a3$var$p(308));
            $3824e46e58e663a3$var$Og = a;
            $3824e46e58e663a3$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $3824e46e58e663a3$var$Og = $3824e46e58e663a3$var$Og.next = a;
    }
    return b;
}
var $3824e46e58e663a3$var$Wg = null;
function $3824e46e58e663a3$var$Xg(a) {
    null === $3824e46e58e663a3$var$Wg ? $3824e46e58e663a3$var$Wg = [
        a
    ] : $3824e46e58e663a3$var$Wg.push(a);
}
function $3824e46e58e663a3$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $3824e46e58e663a3$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $3824e46e58e663a3$var$Zg(a, d);
}
function $3824e46e58e663a3$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $3824e46e58e663a3$var$$g = !1;
function $3824e46e58e663a3$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $3824e46e58e663a3$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $3824e46e58e663a3$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $3824e46e58e663a3$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($3824e46e58e663a3$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $3824e46e58e663a3$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $3824e46e58e663a3$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $3824e46e58e663a3$var$Zg(a, c);
}
function $3824e46e58e663a3$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $3824e46e58e663a3$var$Cc(a, c);
    }
}
function $3824e46e58e663a3$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $3824e46e58e663a3$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $3824e46e58e663a3$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $3824e46e58e663a3$var$A({}, q, r);
                            break a;
                        case 2:
                            $3824e46e58e663a3$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $3824e46e58e663a3$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $3824e46e58e663a3$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($3824e46e58e663a3$var$p(191, e));
            e.call(d);
        }
    }
}
var $3824e46e58e663a3$var$jh = (new $4Bt61.Component).refs;
function $3824e46e58e663a3$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $3824e46e58e663a3$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $3824e46e58e663a3$var$nh = {
    isMounted: function isMounted(a) {
        return (a = a._reactInternals) ? $3824e46e58e663a3$var$Vb(a) === a : !1;
    },
    enqueueSetState: function enqueueSetState(a, b, c) {
        a = a._reactInternals;
        var d = $3824e46e58e663a3$var$L(), e = $3824e46e58e663a3$var$lh(a), f = $3824e46e58e663a3$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $3824e46e58e663a3$var$dh(a, f, e);
        null !== b && ($3824e46e58e663a3$var$mh(b, a, e, d), $3824e46e58e663a3$var$eh(b, a, e));
    },
    enqueueReplaceState: function enqueueReplaceState(a, b, c) {
        a = a._reactInternals;
        var d = $3824e46e58e663a3$var$L(), e = $3824e46e58e663a3$var$lh(a), f = $3824e46e58e663a3$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $3824e46e58e663a3$var$dh(a, f, e);
        null !== b && ($3824e46e58e663a3$var$mh(b, a, e, d), $3824e46e58e663a3$var$eh(b, a, e));
    },
    enqueueForceUpdate: function enqueueForceUpdate(a, b) {
        a = a._reactInternals;
        var c = $3824e46e58e663a3$var$L(), d = $3824e46e58e663a3$var$lh(a), e = $3824e46e58e663a3$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $3824e46e58e663a3$var$dh(a, e, d);
        null !== b && ($3824e46e58e663a3$var$mh(b, a, d, c), $3824e46e58e663a3$var$eh(b, a, d));
    }
};
function $3824e46e58e663a3$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$3824e46e58e663a3$var$Ie(c, d) || !$3824e46e58e663a3$var$Ie(e, f) : !0;
}
function $3824e46e58e663a3$var$ph(a, b, c) {
    var d = !1, e = $3824e46e58e663a3$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $3824e46e58e663a3$var$Vg(f) : (e = $3824e46e58e663a3$var$Zf(b) ? $3824e46e58e663a3$var$Xf : $3824e46e58e663a3$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $3824e46e58e663a3$var$Yf(a, e) : $3824e46e58e663a3$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $3824e46e58e663a3$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $3824e46e58e663a3$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $3824e46e58e663a3$var$nh.enqueueReplaceState(b, b.state, null);
}
function $3824e46e58e663a3$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $3824e46e58e663a3$var$jh;
    $3824e46e58e663a3$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $3824e46e58e663a3$var$Vg(f) : (f = $3824e46e58e663a3$var$Zf(b) ? $3824e46e58e663a3$var$Xf : $3824e46e58e663a3$var$H.current, e.context = $3824e46e58e663a3$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($3824e46e58e663a3$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $3824e46e58e663a3$var$nh.enqueueReplaceState(e, e.state, null), $3824e46e58e663a3$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $3824e46e58e663a3$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($3824e46e58e663a3$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($3824e46e58e663a3$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function b(a) {
                var _$b = e.refs;
                _$b === $3824e46e58e663a3$var$jh && (_$b = e.refs = {});
                null === a ? delete _$b[f] : _$b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($3824e46e58e663a3$var$p(284));
        if (!c._owner) throw Error($3824e46e58e663a3$var$p(290, a));
    }
    return a;
}
function $3824e46e58e663a3$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($3824e46e58e663a3$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $3824e46e58e663a3$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $3824e46e58e663a3$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $3824e46e58e663a3$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $3824e46e58e663a3$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $3824e46e58e663a3$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $3824e46e58e663a3$var$Ha && $3824e46e58e663a3$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $3824e46e58e663a3$var$sh(a, b, c), d.return = a, d;
        d = $3824e46e58e663a3$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $3824e46e58e663a3$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $3824e46e58e663a3$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $3824e46e58e663a3$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $3824e46e58e663a3$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $3824e46e58e663a3$var$va:
                    return c = $3824e46e58e663a3$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $3824e46e58e663a3$var$sh(a, null, b), c.return = a, c;
                case $3824e46e58e663a3$var$wa:
                    return b = $3824e46e58e663a3$var$zh(b, a.mode, c), b.return = a, b;
                case $3824e46e58e663a3$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($3824e46e58e663a3$var$eb(b) || $3824e46e58e663a3$var$Ka(b)) return b = $3824e46e58e663a3$var$Ah(b, a.mode, c, null), b.return = a, b;
            $3824e46e58e663a3$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $3824e46e58e663a3$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $3824e46e58e663a3$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $3824e46e58e663a3$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($3824e46e58e663a3$var$eb(c) || $3824e46e58e663a3$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $3824e46e58e663a3$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $3824e46e58e663a3$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $3824e46e58e663a3$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $3824e46e58e663a3$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($3824e46e58e663a3$var$eb(d) || $3824e46e58e663a3$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $3824e46e58e663a3$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $3824e46e58e663a3$var$I && $3824e46e58e663a3$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $3824e46e58e663a3$var$I && $3824e46e58e663a3$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $3824e46e58e663a3$var$I && $3824e46e58e663a3$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $3824e46e58e663a3$var$Ka(h);
        if ("function" !== typeof l) throw Error($3824e46e58e663a3$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($3824e46e58e663a3$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $3824e46e58e663a3$var$I && $3824e46e58e663a3$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $3824e46e58e663a3$var$I && $3824e46e58e663a3$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $3824e46e58e663a3$var$I && $3824e46e58e663a3$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $3824e46e58e663a3$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $3824e46e58e663a3$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $3824e46e58e663a3$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $3824e46e58e663a3$var$Ha && $3824e46e58e663a3$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $3824e46e58e663a3$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $3824e46e58e663a3$var$ya ? (d = $3824e46e58e663a3$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $3824e46e58e663a3$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $3824e46e58e663a3$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $3824e46e58e663a3$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $3824e46e58e663a3$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $3824e46e58e663a3$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($3824e46e58e663a3$var$eb(f)) return n(a, d, f, h);
            if ($3824e46e58e663a3$var$Ka(f)) return t(a, d, f, h);
            $3824e46e58e663a3$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $3824e46e58e663a3$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $3824e46e58e663a3$var$Bh = $3824e46e58e663a3$var$vh(!0), $3824e46e58e663a3$var$Ch = $3824e46e58e663a3$var$vh(!1), $3824e46e58e663a3$var$Dh = {}, $3824e46e58e663a3$var$Eh = $3824e46e58e663a3$var$Uf($3824e46e58e663a3$var$Dh), $3824e46e58e663a3$var$Fh = $3824e46e58e663a3$var$Uf($3824e46e58e663a3$var$Dh), $3824e46e58e663a3$var$Gh = $3824e46e58e663a3$var$Uf($3824e46e58e663a3$var$Dh);
function $3824e46e58e663a3$var$Hh(a) {
    if (a === $3824e46e58e663a3$var$Dh) throw Error($3824e46e58e663a3$var$p(174));
    return a;
}
function $3824e46e58e663a3$var$Ih(a, b) {
    $3824e46e58e663a3$var$G($3824e46e58e663a3$var$Gh, b);
    $3824e46e58e663a3$var$G($3824e46e58e663a3$var$Fh, a);
    $3824e46e58e663a3$var$G($3824e46e58e663a3$var$Eh, $3824e46e58e663a3$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $3824e46e58e663a3$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $3824e46e58e663a3$var$lb(b, a);
    }
    $3824e46e58e663a3$var$E($3824e46e58e663a3$var$Eh);
    $3824e46e58e663a3$var$G($3824e46e58e663a3$var$Eh, b);
}
function $3824e46e58e663a3$var$Jh() {
    $3824e46e58e663a3$var$E($3824e46e58e663a3$var$Eh);
    $3824e46e58e663a3$var$E($3824e46e58e663a3$var$Fh);
    $3824e46e58e663a3$var$E($3824e46e58e663a3$var$Gh);
}
function $3824e46e58e663a3$var$Kh(a) {
    $3824e46e58e663a3$var$Hh($3824e46e58e663a3$var$Gh.current);
    var b = $3824e46e58e663a3$var$Hh($3824e46e58e663a3$var$Eh.current);
    var c = $3824e46e58e663a3$var$lb(b, a.type);
    b !== c && ($3824e46e58e663a3$var$G($3824e46e58e663a3$var$Fh, a), $3824e46e58e663a3$var$G($3824e46e58e663a3$var$Eh, c));
}
function $3824e46e58e663a3$var$Lh(a) {
    $3824e46e58e663a3$var$Fh.current === a && ($3824e46e58e663a3$var$E($3824e46e58e663a3$var$Eh), $3824e46e58e663a3$var$E($3824e46e58e663a3$var$Fh));
}
var $3824e46e58e663a3$var$M = $3824e46e58e663a3$var$Uf(0);
function $3824e46e58e663a3$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $3824e46e58e663a3$var$Nh = [];
function $3824e46e58e663a3$var$Oh() {
    for(var a = 0; a < $3824e46e58e663a3$var$Nh.length; a++)$3824e46e58e663a3$var$Nh[a]._workInProgressVersionPrimary = null;
    $3824e46e58e663a3$var$Nh.length = 0;
}
var $3824e46e58e663a3$var$Ph = $3824e46e58e663a3$var$ua.ReactCurrentDispatcher, $3824e46e58e663a3$var$Qh = $3824e46e58e663a3$var$ua.ReactCurrentBatchConfig, $3824e46e58e663a3$var$Rh = 0, $3824e46e58e663a3$var$N = null, $3824e46e58e663a3$var$O = null, $3824e46e58e663a3$var$P = null, $3824e46e58e663a3$var$Sh = !1, $3824e46e58e663a3$var$Th = !1, $3824e46e58e663a3$var$Uh = 0, $3824e46e58e663a3$var$Vh = 0;
function $3824e46e58e663a3$var$Q() {
    throw Error($3824e46e58e663a3$var$p(321));
}
function $3824e46e58e663a3$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$3824e46e58e663a3$var$He(a[c], b[c])) return !1;
    return !0;
}
function $3824e46e58e663a3$var$Xh(a, b, c, d, e, f) {
    $3824e46e58e663a3$var$Rh = f;
    $3824e46e58e663a3$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $3824e46e58e663a3$var$Ph.current = null === a || null === a.memoizedState ? $3824e46e58e663a3$var$Yh : $3824e46e58e663a3$var$Zh;
    a = c(d, e);
    if ($3824e46e58e663a3$var$Th) {
        f = 0;
        do {
            $3824e46e58e663a3$var$Th = !1;
            $3824e46e58e663a3$var$Uh = 0;
            if (25 <= f) throw Error($3824e46e58e663a3$var$p(301));
            f += 1;
            $3824e46e58e663a3$var$P = $3824e46e58e663a3$var$O = null;
            b.updateQueue = null;
            $3824e46e58e663a3$var$Ph.current = $3824e46e58e663a3$var$$h;
            a = c(d, e);
        }while ($3824e46e58e663a3$var$Th);
    }
    $3824e46e58e663a3$var$Ph.current = $3824e46e58e663a3$var$ai;
    b = null !== $3824e46e58e663a3$var$O && null !== $3824e46e58e663a3$var$O.next;
    $3824e46e58e663a3$var$Rh = 0;
    $3824e46e58e663a3$var$P = $3824e46e58e663a3$var$O = $3824e46e58e663a3$var$N = null;
    $3824e46e58e663a3$var$Sh = !1;
    if (b) throw Error($3824e46e58e663a3$var$p(300));
    return a;
}
function $3824e46e58e663a3$var$bi() {
    var a = 0 !== $3824e46e58e663a3$var$Uh;
    $3824e46e58e663a3$var$Uh = 0;
    return a;
}
function $3824e46e58e663a3$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $3824e46e58e663a3$var$P ? $3824e46e58e663a3$var$N.memoizedState = $3824e46e58e663a3$var$P = a : $3824e46e58e663a3$var$P = $3824e46e58e663a3$var$P.next = a;
    return $3824e46e58e663a3$var$P;
}
function $3824e46e58e663a3$var$di() {
    if (null === $3824e46e58e663a3$var$O) {
        var a = $3824e46e58e663a3$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $3824e46e58e663a3$var$O.next;
    var b = null === $3824e46e58e663a3$var$P ? $3824e46e58e663a3$var$N.memoizedState : $3824e46e58e663a3$var$P.next;
    if (null !== b) $3824e46e58e663a3$var$P = b, $3824e46e58e663a3$var$O = a;
    else {
        if (null === a) throw Error($3824e46e58e663a3$var$p(310));
        $3824e46e58e663a3$var$O = a;
        a = {
            memoizedState: $3824e46e58e663a3$var$O.memoizedState,
            baseState: $3824e46e58e663a3$var$O.baseState,
            baseQueue: $3824e46e58e663a3$var$O.baseQueue,
            queue: $3824e46e58e663a3$var$O.queue,
            next: null
        };
        null === $3824e46e58e663a3$var$P ? $3824e46e58e663a3$var$N.memoizedState = $3824e46e58e663a3$var$P = a : $3824e46e58e663a3$var$P = $3824e46e58e663a3$var$P.next = a;
    }
    return $3824e46e58e663a3$var$P;
}
function $3824e46e58e663a3$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $3824e46e58e663a3$var$fi(a) {
    var b = $3824e46e58e663a3$var$di(), c = b.queue;
    if (null === c) throw Error($3824e46e58e663a3$var$p(311));
    c.lastRenderedReducer = a;
    var d = $3824e46e58e663a3$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($3824e46e58e663a3$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $3824e46e58e663a3$var$N.lanes |= m;
                $3824e46e58e663a3$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $3824e46e58e663a3$var$He(d, b.memoizedState) || ($3824e46e58e663a3$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $3824e46e58e663a3$var$N.lanes |= f, $3824e46e58e663a3$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $3824e46e58e663a3$var$gi(a) {
    var b = $3824e46e58e663a3$var$di(), c = b.queue;
    if (null === c) throw Error($3824e46e58e663a3$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $3824e46e58e663a3$var$He(f, b.memoizedState) || ($3824e46e58e663a3$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $3824e46e58e663a3$var$hi() {}
function $3824e46e58e663a3$var$ii(a, b) {
    var c = $3824e46e58e663a3$var$N, d = $3824e46e58e663a3$var$di(), e = b(), f = !$3824e46e58e663a3$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $3824e46e58e663a3$var$Ug = !0);
    d = d.queue;
    $3824e46e58e663a3$var$ji($3824e46e58e663a3$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $3824e46e58e663a3$var$P && $3824e46e58e663a3$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $3824e46e58e663a3$var$li(9, $3824e46e58e663a3$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $3824e46e58e663a3$var$R) throw Error($3824e46e58e663a3$var$p(349));
        0 !== ($3824e46e58e663a3$var$Rh & 30) || $3824e46e58e663a3$var$ni(c, b, e);
    }
    return e;
}
function $3824e46e58e663a3$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $3824e46e58e663a3$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $3824e46e58e663a3$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $3824e46e58e663a3$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $3824e46e58e663a3$var$oi(b) && $3824e46e58e663a3$var$pi(a);
}
function $3824e46e58e663a3$var$ki(a, b, c) {
    return c(function() {
        $3824e46e58e663a3$var$oi(b) && $3824e46e58e663a3$var$pi(a);
    });
}
function $3824e46e58e663a3$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$3824e46e58e663a3$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $3824e46e58e663a3$var$pi(a) {
    var b = $3824e46e58e663a3$var$Zg(a, 1);
    null !== b && $3824e46e58e663a3$var$mh(b, a, 1, -1);
}
function $3824e46e58e663a3$var$qi(a) {
    var b = $3824e46e58e663a3$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $3824e46e58e663a3$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $3824e46e58e663a3$var$ri.bind(null, $3824e46e58e663a3$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $3824e46e58e663a3$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $3824e46e58e663a3$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $3824e46e58e663a3$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $3824e46e58e663a3$var$si() {
    return $3824e46e58e663a3$var$di().memoizedState;
}
function $3824e46e58e663a3$var$ti(a, b, c, d) {
    var e = $3824e46e58e663a3$var$ci();
    $3824e46e58e663a3$var$N.flags |= a;
    e.memoizedState = $3824e46e58e663a3$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $3824e46e58e663a3$var$ui(a, b, c, d) {
    var e = $3824e46e58e663a3$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $3824e46e58e663a3$var$O) {
        var g = $3824e46e58e663a3$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $3824e46e58e663a3$var$Wh(d, g.deps)) {
            e.memoizedState = $3824e46e58e663a3$var$li(b, c, f, d);
            return;
        }
    }
    $3824e46e58e663a3$var$N.flags |= a;
    e.memoizedState = $3824e46e58e663a3$var$li(1 | b, c, f, d);
}
function $3824e46e58e663a3$var$vi(a, b) {
    return $3824e46e58e663a3$var$ti(8390656, 8, a, b);
}
function $3824e46e58e663a3$var$ji(a, b) {
    return $3824e46e58e663a3$var$ui(2048, 8, a, b);
}
function $3824e46e58e663a3$var$wi(a, b) {
    return $3824e46e58e663a3$var$ui(4, 2, a, b);
}
function $3824e46e58e663a3$var$xi(a, b) {
    return $3824e46e58e663a3$var$ui(4, 4, a, b);
}
function $3824e46e58e663a3$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $3824e46e58e663a3$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $3824e46e58e663a3$var$ui(4, 4, $3824e46e58e663a3$var$yi.bind(null, b, a), c);
}
function $3824e46e58e663a3$var$Ai() {}
function $3824e46e58e663a3$var$Bi(a, b) {
    var c = $3824e46e58e663a3$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $3824e46e58e663a3$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $3824e46e58e663a3$var$Ci(a, b) {
    var c = $3824e46e58e663a3$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $3824e46e58e663a3$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $3824e46e58e663a3$var$Di(a, b, c) {
    if (0 === ($3824e46e58e663a3$var$Rh & 21)) return a.baseState && (a.baseState = !1, $3824e46e58e663a3$var$Ug = !0), a.memoizedState = c;
    $3824e46e58e663a3$var$He(c, b) || (c = $3824e46e58e663a3$var$yc(), $3824e46e58e663a3$var$N.lanes |= c, $3824e46e58e663a3$var$hh |= c, a.baseState = !0);
    return b;
}
function $3824e46e58e663a3$var$Ei(a, b) {
    var c = $3824e46e58e663a3$var$C;
    $3824e46e58e663a3$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $3824e46e58e663a3$var$Qh.transition;
    $3824e46e58e663a3$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $3824e46e58e663a3$var$C = c, $3824e46e58e663a3$var$Qh.transition = d;
    }
}
function $3824e46e58e663a3$var$Fi() {
    return $3824e46e58e663a3$var$di().memoizedState;
}
function $3824e46e58e663a3$var$Gi(a, b, c) {
    var d = $3824e46e58e663a3$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($3824e46e58e663a3$var$Hi(a)) $3824e46e58e663a3$var$Ii(b, c);
    else if (c = $3824e46e58e663a3$var$Yg(a, b, c, d), null !== c) {
        var e = $3824e46e58e663a3$var$L();
        $3824e46e58e663a3$var$mh(c, a, d, e);
        $3824e46e58e663a3$var$Ji(c, b, d);
    }
}
function $3824e46e58e663a3$var$ri(a, b, c) {
    var d = $3824e46e58e663a3$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($3824e46e58e663a3$var$Hi(a)) $3824e46e58e663a3$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($3824e46e58e663a3$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $3824e46e58e663a3$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $3824e46e58e663a3$var$Yg(a, b, e, d);
        null !== c && (e = $3824e46e58e663a3$var$L(), $3824e46e58e663a3$var$mh(c, a, d, e), $3824e46e58e663a3$var$Ji(c, b, d));
    }
}
function $3824e46e58e663a3$var$Hi(a) {
    var b = a.alternate;
    return a === $3824e46e58e663a3$var$N || null !== b && b === $3824e46e58e663a3$var$N;
}
function $3824e46e58e663a3$var$Ii(a, b) {
    $3824e46e58e663a3$var$Th = $3824e46e58e663a3$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $3824e46e58e663a3$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $3824e46e58e663a3$var$Cc(a, c);
    }
}
var $3824e46e58e663a3$var$ai = {
    readContext: $3824e46e58e663a3$var$Vg,
    useCallback: $3824e46e58e663a3$var$Q,
    useContext: $3824e46e58e663a3$var$Q,
    useEffect: $3824e46e58e663a3$var$Q,
    useImperativeHandle: $3824e46e58e663a3$var$Q,
    useInsertionEffect: $3824e46e58e663a3$var$Q,
    useLayoutEffect: $3824e46e58e663a3$var$Q,
    useMemo: $3824e46e58e663a3$var$Q,
    useReducer: $3824e46e58e663a3$var$Q,
    useRef: $3824e46e58e663a3$var$Q,
    useState: $3824e46e58e663a3$var$Q,
    useDebugValue: $3824e46e58e663a3$var$Q,
    useDeferredValue: $3824e46e58e663a3$var$Q,
    useTransition: $3824e46e58e663a3$var$Q,
    useMutableSource: $3824e46e58e663a3$var$Q,
    useSyncExternalStore: $3824e46e58e663a3$var$Q,
    useId: $3824e46e58e663a3$var$Q,
    unstable_isNewReconciler: !1
}, $3824e46e58e663a3$var$Yh = {
    readContext: $3824e46e58e663a3$var$Vg,
    useCallback: function useCallback(a, b) {
        $3824e46e58e663a3$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $3824e46e58e663a3$var$Vg,
    useEffect: $3824e46e58e663a3$var$vi,
    useImperativeHandle: function useImperativeHandle(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $3824e46e58e663a3$var$ti(4194308, 4, $3824e46e58e663a3$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function useLayoutEffect(a, b) {
        return $3824e46e58e663a3$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function useInsertionEffect(a, b) {
        return $3824e46e58e663a3$var$ti(4, 2, a, b);
    },
    useMemo: function useMemo(a, b) {
        var c = $3824e46e58e663a3$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function useReducer(a, b, c) {
        var d = $3824e46e58e663a3$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $3824e46e58e663a3$var$Gi.bind(null, $3824e46e58e663a3$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function useRef(a) {
        var b = $3824e46e58e663a3$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $3824e46e58e663a3$var$qi,
    useDebugValue: $3824e46e58e663a3$var$Ai,
    useDeferredValue: function useDeferredValue(a) {
        return $3824e46e58e663a3$var$ci().memoizedState = a;
    },
    useTransition: function useTransition() {
        var a = $3824e46e58e663a3$var$qi(!1), b = a[0];
        a = $3824e46e58e663a3$var$Ei.bind(null, a[1]);
        $3824e46e58e663a3$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function useMutableSource() {},
    useSyncExternalStore: function useSyncExternalStore(a, b, c) {
        var d = $3824e46e58e663a3$var$N, e = $3824e46e58e663a3$var$ci();
        if ($3824e46e58e663a3$var$I) {
            if (void 0 === c) throw Error($3824e46e58e663a3$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $3824e46e58e663a3$var$R) throw Error($3824e46e58e663a3$var$p(349));
            0 !== ($3824e46e58e663a3$var$Rh & 30) || $3824e46e58e663a3$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $3824e46e58e663a3$var$vi($3824e46e58e663a3$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $3824e46e58e663a3$var$li(9, $3824e46e58e663a3$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function useId() {
        var a = $3824e46e58e663a3$var$ci(), b = $3824e46e58e663a3$var$R.identifierPrefix;
        if ($3824e46e58e663a3$var$I) {
            var c = $3824e46e58e663a3$var$sg;
            var d = $3824e46e58e663a3$var$rg;
            c = (d & ~(1 << 32 - $3824e46e58e663a3$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $3824e46e58e663a3$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $3824e46e58e663a3$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $3824e46e58e663a3$var$Zh = {
    readContext: $3824e46e58e663a3$var$Vg,
    useCallback: $3824e46e58e663a3$var$Bi,
    useContext: $3824e46e58e663a3$var$Vg,
    useEffect: $3824e46e58e663a3$var$ji,
    useImperativeHandle: $3824e46e58e663a3$var$zi,
    useInsertionEffect: $3824e46e58e663a3$var$wi,
    useLayoutEffect: $3824e46e58e663a3$var$xi,
    useMemo: $3824e46e58e663a3$var$Ci,
    useReducer: $3824e46e58e663a3$var$fi,
    useRef: $3824e46e58e663a3$var$si,
    useState: function useState() {
        return $3824e46e58e663a3$var$fi($3824e46e58e663a3$var$ei);
    },
    useDebugValue: $3824e46e58e663a3$var$Ai,
    useDeferredValue: function useDeferredValue(a) {
        var b = $3824e46e58e663a3$var$di();
        return $3824e46e58e663a3$var$Di(b, $3824e46e58e663a3$var$O.memoizedState, a);
    },
    useTransition: function useTransition() {
        var a = $3824e46e58e663a3$var$fi($3824e46e58e663a3$var$ei)[0], b = $3824e46e58e663a3$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $3824e46e58e663a3$var$hi,
    useSyncExternalStore: $3824e46e58e663a3$var$ii,
    useId: $3824e46e58e663a3$var$Fi,
    unstable_isNewReconciler: !1
}, $3824e46e58e663a3$var$$h = {
    readContext: $3824e46e58e663a3$var$Vg,
    useCallback: $3824e46e58e663a3$var$Bi,
    useContext: $3824e46e58e663a3$var$Vg,
    useEffect: $3824e46e58e663a3$var$ji,
    useImperativeHandle: $3824e46e58e663a3$var$zi,
    useInsertionEffect: $3824e46e58e663a3$var$wi,
    useLayoutEffect: $3824e46e58e663a3$var$xi,
    useMemo: $3824e46e58e663a3$var$Ci,
    useReducer: $3824e46e58e663a3$var$gi,
    useRef: $3824e46e58e663a3$var$si,
    useState: function useState() {
        return $3824e46e58e663a3$var$gi($3824e46e58e663a3$var$ei);
    },
    useDebugValue: $3824e46e58e663a3$var$Ai,
    useDeferredValue: function useDeferredValue(a) {
        var b = $3824e46e58e663a3$var$di();
        return null === $3824e46e58e663a3$var$O ? b.memoizedState = a : $3824e46e58e663a3$var$Di(b, $3824e46e58e663a3$var$O.memoizedState, a);
    },
    useTransition: function useTransition() {
        var a = $3824e46e58e663a3$var$gi($3824e46e58e663a3$var$ei)[0], b = $3824e46e58e663a3$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $3824e46e58e663a3$var$hi,
    useSyncExternalStore: $3824e46e58e663a3$var$ii,
    useId: $3824e46e58e663a3$var$Fi,
    unstable_isNewReconciler: !1
};
function $3824e46e58e663a3$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $3824e46e58e663a3$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $3824e46e58e663a3$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $3824e46e58e663a3$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $3824e46e58e663a3$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $3824e46e58e663a3$var$Oi(a, b, c) {
    c = $3824e46e58e663a3$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $3824e46e58e663a3$var$Pi || ($3824e46e58e663a3$var$Pi = !0, $3824e46e58e663a3$var$Qi = d);
        $3824e46e58e663a3$var$Mi(a, b);
    };
    return c;
}
function $3824e46e58e663a3$var$Ri(a, b, c) {
    c = $3824e46e58e663a3$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $3824e46e58e663a3$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $3824e46e58e663a3$var$Mi(a, b);
        "function" !== typeof d && (null === $3824e46e58e663a3$var$Si ? $3824e46e58e663a3$var$Si = new Set([
            this
        ]) : $3824e46e58e663a3$var$Si.add(this));
        var _$c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== _$c ? _$c : ""
        });
    });
    return c;
}
function $3824e46e58e663a3$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $3824e46e58e663a3$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $3824e46e58e663a3$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $3824e46e58e663a3$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $3824e46e58e663a3$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $3824e46e58e663a3$var$ch(-1, 1), b.tag = 2, $3824e46e58e663a3$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $3824e46e58e663a3$var$Xi = $3824e46e58e663a3$var$ua.ReactCurrentOwner, $3824e46e58e663a3$var$Ug = !1;
function $3824e46e58e663a3$var$Yi(a, b, c, d) {
    b.child = null === a ? $3824e46e58e663a3$var$Ch(b, null, c, d) : $3824e46e58e663a3$var$Bh(b, a.child, c, d);
}
function $3824e46e58e663a3$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $3824e46e58e663a3$var$Tg(b, e);
    d = $3824e46e58e663a3$var$Xh(a, b, c, d, f, e);
    c = $3824e46e58e663a3$var$bi();
    if (null !== a && !$3824e46e58e663a3$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $3824e46e58e663a3$var$$i(a, b, e);
    $3824e46e58e663a3$var$I && c && $3824e46e58e663a3$var$vg(b);
    b.flags |= 1;
    $3824e46e58e663a3$var$Yi(a, b, d, e);
    return b.child;
}
function $3824e46e58e663a3$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$3824e46e58e663a3$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $3824e46e58e663a3$var$cj(a, b, f, d, e);
        a = $3824e46e58e663a3$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $3824e46e58e663a3$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $3824e46e58e663a3$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $3824e46e58e663a3$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $3824e46e58e663a3$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($3824e46e58e663a3$var$Ie(f, d) && a.ref === b.ref) {
            if ($3824e46e58e663a3$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($3824e46e58e663a3$var$Ug = !0);
            else return b.lanes = a.lanes, $3824e46e58e663a3$var$$i(a, b, e);
        }
    }
    return $3824e46e58e663a3$var$dj(a, b, c, d, e);
}
function $3824e46e58e663a3$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $3824e46e58e663a3$var$G($3824e46e58e663a3$var$fj, $3824e46e58e663a3$var$gj), $3824e46e58e663a3$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $3824e46e58e663a3$var$G($3824e46e58e663a3$var$fj, $3824e46e58e663a3$var$gj), $3824e46e58e663a3$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $3824e46e58e663a3$var$G($3824e46e58e663a3$var$fj, $3824e46e58e663a3$var$gj);
            $3824e46e58e663a3$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $3824e46e58e663a3$var$G($3824e46e58e663a3$var$fj, $3824e46e58e663a3$var$gj), $3824e46e58e663a3$var$gj |= d;
    $3824e46e58e663a3$var$Yi(a, b, e, c);
    return b.child;
}
function $3824e46e58e663a3$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $3824e46e58e663a3$var$dj(a, b, c, d, e) {
    var f = $3824e46e58e663a3$var$Zf(c) ? $3824e46e58e663a3$var$Xf : $3824e46e58e663a3$var$H.current;
    f = $3824e46e58e663a3$var$Yf(b, f);
    $3824e46e58e663a3$var$Tg(b, e);
    c = $3824e46e58e663a3$var$Xh(a, b, c, d, f, e);
    d = $3824e46e58e663a3$var$bi();
    if (null !== a && !$3824e46e58e663a3$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $3824e46e58e663a3$var$$i(a, b, e);
    $3824e46e58e663a3$var$I && d && $3824e46e58e663a3$var$vg(b);
    b.flags |= 1;
    $3824e46e58e663a3$var$Yi(a, b, c, e);
    return b.child;
}
function $3824e46e58e663a3$var$ij(a, b, c, d, e) {
    if ($3824e46e58e663a3$var$Zf(c)) {
        var f = !0;
        $3824e46e58e663a3$var$cg(b);
    } else f = !1;
    $3824e46e58e663a3$var$Tg(b, e);
    if (null === b.stateNode) $3824e46e58e663a3$var$jj(a, b), $3824e46e58e663a3$var$ph(b, c, d), $3824e46e58e663a3$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $3824e46e58e663a3$var$Vg(l) : (l = $3824e46e58e663a3$var$Zf(c) ? $3824e46e58e663a3$var$Xf : $3824e46e58e663a3$var$H.current, l = $3824e46e58e663a3$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $3824e46e58e663a3$var$qh(b, g, d, l);
        $3824e46e58e663a3$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $3824e46e58e663a3$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $3824e46e58e663a3$var$Wf.current || $3824e46e58e663a3$var$$g ? ("function" === typeof m && ($3824e46e58e663a3$var$kh(b, c, m, d), k = b.memoizedState), (h = $3824e46e58e663a3$var$$g || $3824e46e58e663a3$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $3824e46e58e663a3$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $3824e46e58e663a3$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $3824e46e58e663a3$var$Vg(k) : (k = $3824e46e58e663a3$var$Zf(c) ? $3824e46e58e663a3$var$Xf : $3824e46e58e663a3$var$H.current, k = $3824e46e58e663a3$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $3824e46e58e663a3$var$qh(b, g, d, k);
        $3824e46e58e663a3$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $3824e46e58e663a3$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $3824e46e58e663a3$var$Wf.current || $3824e46e58e663a3$var$$g ? ("function" === typeof y && ($3824e46e58e663a3$var$kh(b, c, y, d), n = b.memoizedState), (l = $3824e46e58e663a3$var$$g || $3824e46e58e663a3$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $3824e46e58e663a3$var$kj(a, b, c, d, f, e);
}
function $3824e46e58e663a3$var$kj(a, b, c, d, e, f) {
    $3824e46e58e663a3$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $3824e46e58e663a3$var$dg(b, c, !1), $3824e46e58e663a3$var$$i(a, b, f);
    d = b.stateNode;
    $3824e46e58e663a3$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $3824e46e58e663a3$var$Bh(b, a.child, null, f), b.child = $3824e46e58e663a3$var$Bh(b, null, h, f)) : $3824e46e58e663a3$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $3824e46e58e663a3$var$dg(b, c, !0);
    return b.child;
}
function $3824e46e58e663a3$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $3824e46e58e663a3$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $3824e46e58e663a3$var$ag(a, b.context, !1);
    $3824e46e58e663a3$var$Ih(a, b.containerInfo);
}
function $3824e46e58e663a3$var$mj(a, b, c, d, e) {
    $3824e46e58e663a3$var$Ig();
    $3824e46e58e663a3$var$Jg(e);
    b.flags |= 256;
    $3824e46e58e663a3$var$Yi(a, b, c, d);
    return b.child;
}
var $3824e46e58e663a3$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $3824e46e58e663a3$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $3824e46e58e663a3$var$pj(a, b, c) {
    var d = b.pendingProps, e = $3824e46e58e663a3$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $3824e46e58e663a3$var$G($3824e46e58e663a3$var$M, e & 1);
    if (null === a) {
        $3824e46e58e663a3$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $3824e46e58e663a3$var$qj(g, d, 0, null), a = $3824e46e58e663a3$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $3824e46e58e663a3$var$oj(c), b.memoizedState = $3824e46e58e663a3$var$nj, a) : $3824e46e58e663a3$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $3824e46e58e663a3$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $3824e46e58e663a3$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $3824e46e58e663a3$var$wh(h, f) : (f = $3824e46e58e663a3$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $3824e46e58e663a3$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $3824e46e58e663a3$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $3824e46e58e663a3$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $3824e46e58e663a3$var$rj(a, b) {
    b = $3824e46e58e663a3$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $3824e46e58e663a3$var$tj(a, b, c, d) {
    null !== d && $3824e46e58e663a3$var$Jg(d);
    $3824e46e58e663a3$var$Bh(b, a.child, null, c);
    a = $3824e46e58e663a3$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $3824e46e58e663a3$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $3824e46e58e663a3$var$Li(Error($3824e46e58e663a3$var$p(422))), $3824e46e58e663a3$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $3824e46e58e663a3$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $3824e46e58e663a3$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $3824e46e58e663a3$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $3824e46e58e663a3$var$oj(g);
        b.memoizedState = $3824e46e58e663a3$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $3824e46e58e663a3$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($3824e46e58e663a3$var$p(419));
        d = $3824e46e58e663a3$var$Li(f, d, void 0);
        return $3824e46e58e663a3$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($3824e46e58e663a3$var$Ug || h) {
        d = $3824e46e58e663a3$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $3824e46e58e663a3$var$Zg(a, e), $3824e46e58e663a3$var$mh(d, a, e, -1));
        }
        $3824e46e58e663a3$var$uj();
        d = $3824e46e58e663a3$var$Li(Error($3824e46e58e663a3$var$p(421)));
        return $3824e46e58e663a3$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $3824e46e58e663a3$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $3824e46e58e663a3$var$yg = $3824e46e58e663a3$var$Lf(e.nextSibling);
    $3824e46e58e663a3$var$xg = b;
    $3824e46e58e663a3$var$I = !0;
    $3824e46e58e663a3$var$zg = null;
    null !== a && ($3824e46e58e663a3$var$og[$3824e46e58e663a3$var$pg++] = $3824e46e58e663a3$var$rg, $3824e46e58e663a3$var$og[$3824e46e58e663a3$var$pg++] = $3824e46e58e663a3$var$sg, $3824e46e58e663a3$var$og[$3824e46e58e663a3$var$pg++] = $3824e46e58e663a3$var$qg, $3824e46e58e663a3$var$rg = a.id, $3824e46e58e663a3$var$sg = a.overflow, $3824e46e58e663a3$var$qg = b);
    b = $3824e46e58e663a3$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $3824e46e58e663a3$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $3824e46e58e663a3$var$Sg(a.return, b, c);
}
function $3824e46e58e663a3$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $3824e46e58e663a3$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $3824e46e58e663a3$var$Yi(a, b, d.children, c);
    d = $3824e46e58e663a3$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $3824e46e58e663a3$var$wj(a, c, b);
            else if (19 === a.tag) $3824e46e58e663a3$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $3824e46e58e663a3$var$G($3824e46e58e663a3$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $3824e46e58e663a3$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $3824e46e58e663a3$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $3824e46e58e663a3$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $3824e46e58e663a3$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $3824e46e58e663a3$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $3824e46e58e663a3$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $3824e46e58e663a3$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $3824e46e58e663a3$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($3824e46e58e663a3$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $3824e46e58e663a3$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $3824e46e58e663a3$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $3824e46e58e663a3$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $3824e46e58e663a3$var$lj(b);
            $3824e46e58e663a3$var$Ig();
            break;
        case 5:
            $3824e46e58e663a3$var$Kh(b);
            break;
        case 1:
            $3824e46e58e663a3$var$Zf(b.type) && $3824e46e58e663a3$var$cg(b);
            break;
        case 4:
            $3824e46e58e663a3$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $3824e46e58e663a3$var$G($3824e46e58e663a3$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $3824e46e58e663a3$var$G($3824e46e58e663a3$var$M, $3824e46e58e663a3$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $3824e46e58e663a3$var$pj(a, b, c);
                $3824e46e58e663a3$var$G($3824e46e58e663a3$var$M, $3824e46e58e663a3$var$M.current & 1);
                a = $3824e46e58e663a3$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $3824e46e58e663a3$var$G($3824e46e58e663a3$var$M, $3824e46e58e663a3$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $3824e46e58e663a3$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $3824e46e58e663a3$var$G($3824e46e58e663a3$var$M, $3824e46e58e663a3$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $3824e46e58e663a3$var$ej(a, b, c);
    }
    return $3824e46e58e663a3$var$$i(a, b, c);
}
var $3824e46e58e663a3$var$Aj, $3824e46e58e663a3$var$Bj, $3824e46e58e663a3$var$Cj, $3824e46e58e663a3$var$Dj;
$3824e46e58e663a3$var$Aj = function Aj(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$3824e46e58e663a3$var$Bj = function Bj() {};
$3824e46e58e663a3$var$Cj = function Cj(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $3824e46e58e663a3$var$Hh($3824e46e58e663a3$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $3824e46e58e663a3$var$Ya(a, e);
                d = $3824e46e58e663a3$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $3824e46e58e663a3$var$A({}, e, {
                    value: void 0
                });
                d = $3824e46e58e663a3$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $3824e46e58e663a3$var$gb(a, e);
                d = $3824e46e58e663a3$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $3824e46e58e663a3$var$Bf);
        }
        $3824e46e58e663a3$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($3824e46e58e663a3$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($3824e46e58e663a3$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $3824e46e58e663a3$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$3824e46e58e663a3$var$Dj = function Dj(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $3824e46e58e663a3$var$Ej(a, b) {
    if (!$3824e46e58e663a3$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $3824e46e58e663a3$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $3824e46e58e663a3$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $3824e46e58e663a3$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $3824e46e58e663a3$var$S(b), null;
        case 1:
            return $3824e46e58e663a3$var$Zf(b.type) && $3824e46e58e663a3$var$$f(), $3824e46e58e663a3$var$S(b), null;
        case 3:
            d = b.stateNode;
            $3824e46e58e663a3$var$Jh();
            $3824e46e58e663a3$var$E($3824e46e58e663a3$var$Wf);
            $3824e46e58e663a3$var$E($3824e46e58e663a3$var$H);
            $3824e46e58e663a3$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $3824e46e58e663a3$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $3824e46e58e663a3$var$zg && ($3824e46e58e663a3$var$Gj($3824e46e58e663a3$var$zg), $3824e46e58e663a3$var$zg = null));
            $3824e46e58e663a3$var$Bj(a, b);
            $3824e46e58e663a3$var$S(b);
            return null;
        case 5:
            $3824e46e58e663a3$var$Lh(b);
            var e = $3824e46e58e663a3$var$Hh($3824e46e58e663a3$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $3824e46e58e663a3$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($3824e46e58e663a3$var$p(166));
                    $3824e46e58e663a3$var$S(b);
                    return null;
                }
                a = $3824e46e58e663a3$var$Hh($3824e46e58e663a3$var$Eh.current);
                if ($3824e46e58e663a3$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$3824e46e58e663a3$var$Of] = b;
                    d[$3824e46e58e663a3$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $3824e46e58e663a3$var$D("cancel", d);
                            $3824e46e58e663a3$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $3824e46e58e663a3$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $3824e46e58e663a3$var$lf.length; e++)$3824e46e58e663a3$var$D($3824e46e58e663a3$var$lf[e], d);
                            break;
                        case "source":
                            $3824e46e58e663a3$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $3824e46e58e663a3$var$D("error", d);
                            $3824e46e58e663a3$var$D("load", d);
                            break;
                        case "details":
                            $3824e46e58e663a3$var$D("toggle", d);
                            break;
                        case "input":
                            $3824e46e58e663a3$var$Za(d, f);
                            $3824e46e58e663a3$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $3824e46e58e663a3$var$D("invalid", d);
                            break;
                        case "textarea":
                            $3824e46e58e663a3$var$hb(d, f), $3824e46e58e663a3$var$D("invalid", d);
                    }
                    $3824e46e58e663a3$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $3824e46e58e663a3$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $3824e46e58e663a3$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $3824e46e58e663a3$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $3824e46e58e663a3$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $3824e46e58e663a3$var$Va(d);
                            $3824e46e58e663a3$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $3824e46e58e663a3$var$Va(d);
                            $3824e46e58e663a3$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $3824e46e58e663a3$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $3824e46e58e663a3$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$3824e46e58e663a3$var$Of] = b;
                    a[$3824e46e58e663a3$var$Pf] = d;
                    $3824e46e58e663a3$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $3824e46e58e663a3$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $3824e46e58e663a3$var$D("cancel", a);
                                $3824e46e58e663a3$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $3824e46e58e663a3$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $3824e46e58e663a3$var$lf.length; e++)$3824e46e58e663a3$var$D($3824e46e58e663a3$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $3824e46e58e663a3$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $3824e46e58e663a3$var$D("error", a);
                                $3824e46e58e663a3$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $3824e46e58e663a3$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $3824e46e58e663a3$var$Za(a, d);
                                e = $3824e46e58e663a3$var$Ya(a, d);
                                $3824e46e58e663a3$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $3824e46e58e663a3$var$A({}, d, {
                                    value: void 0
                                });
                                $3824e46e58e663a3$var$D("invalid", a);
                                break;
                            case "textarea":
                                $3824e46e58e663a3$var$hb(a, d);
                                e = $3824e46e58e663a3$var$gb(a, d);
                                $3824e46e58e663a3$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $3824e46e58e663a3$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $3824e46e58e663a3$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $3824e46e58e663a3$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $3824e46e58e663a3$var$ob(a, k) : "number" === typeof k && $3824e46e58e663a3$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($3824e46e58e663a3$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $3824e46e58e663a3$var$D("scroll", a) : null != k && $3824e46e58e663a3$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $3824e46e58e663a3$var$Va(a);
                                $3824e46e58e663a3$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $3824e46e58e663a3$var$Va(a);
                                $3824e46e58e663a3$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $3824e46e58e663a3$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $3824e46e58e663a3$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $3824e46e58e663a3$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $3824e46e58e663a3$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $3824e46e58e663a3$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $3824e46e58e663a3$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($3824e46e58e663a3$var$p(166));
                c = $3824e46e58e663a3$var$Hh($3824e46e58e663a3$var$Gh.current);
                $3824e46e58e663a3$var$Hh($3824e46e58e663a3$var$Eh.current);
                if ($3824e46e58e663a3$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$3824e46e58e663a3$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $3824e46e58e663a3$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $3824e46e58e663a3$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $3824e46e58e663a3$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$3824e46e58e663a3$var$Of] = b, b.stateNode = d;
            }
            $3824e46e58e663a3$var$S(b);
            return null;
        case 13:
            $3824e46e58e663a3$var$E($3824e46e58e663a3$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($3824e46e58e663a3$var$I && null !== $3824e46e58e663a3$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $3824e46e58e663a3$var$Hg(), $3824e46e58e663a3$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $3824e46e58e663a3$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($3824e46e58e663a3$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($3824e46e58e663a3$var$p(317));
                        f[$3824e46e58e663a3$var$Of] = b;
                    } else $3824e46e58e663a3$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $3824e46e58e663a3$var$S(b);
                    f = !1;
                } else null !== $3824e46e58e663a3$var$zg && ($3824e46e58e663a3$var$Gj($3824e46e58e663a3$var$zg), $3824e46e58e663a3$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($3824e46e58e663a3$var$M.current & 1) ? 0 === $3824e46e58e663a3$var$T && ($3824e46e58e663a3$var$T = 3) : $3824e46e58e663a3$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $3824e46e58e663a3$var$S(b);
            return null;
        case 4:
            return $3824e46e58e663a3$var$Jh(), $3824e46e58e663a3$var$Bj(a, b), null === a && $3824e46e58e663a3$var$sf(b.stateNode.containerInfo), $3824e46e58e663a3$var$S(b), null;
        case 10:
            return $3824e46e58e663a3$var$Rg(b.type._context), $3824e46e58e663a3$var$S(b), null;
        case 17:
            return $3824e46e58e663a3$var$Zf(b.type) && $3824e46e58e663a3$var$$f(), $3824e46e58e663a3$var$S(b), null;
        case 19:
            $3824e46e58e663a3$var$E($3824e46e58e663a3$var$M);
            f = b.memoizedState;
            if (null === f) return $3824e46e58e663a3$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $3824e46e58e663a3$var$Ej(f, !1);
                else {
                    if (0 !== $3824e46e58e663a3$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $3824e46e58e663a3$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $3824e46e58e663a3$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $3824e46e58e663a3$var$G($3824e46e58e663a3$var$M, $3824e46e58e663a3$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $3824e46e58e663a3$var$B() > $3824e46e58e663a3$var$Hj && (b.flags |= 128, d = !0, $3824e46e58e663a3$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $3824e46e58e663a3$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $3824e46e58e663a3$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$3824e46e58e663a3$var$I) return $3824e46e58e663a3$var$S(b), null;
                    } else 2 * $3824e46e58e663a3$var$B() - f.renderingStartTime > $3824e46e58e663a3$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $3824e46e58e663a3$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $3824e46e58e663a3$var$B(), b.sibling = null, c = $3824e46e58e663a3$var$M.current, $3824e46e58e663a3$var$G($3824e46e58e663a3$var$M, d ? c & 1 | 2 : c & 1), b;
            $3824e46e58e663a3$var$S(b);
            return null;
        case 22:
        case 23:
            return $3824e46e58e663a3$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($3824e46e58e663a3$var$gj & 1073741824) && ($3824e46e58e663a3$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $3824e46e58e663a3$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($3824e46e58e663a3$var$p(156, b.tag));
}
function $3824e46e58e663a3$var$Jj(a, b) {
    $3824e46e58e663a3$var$wg(b);
    switch(b.tag){
        case 1:
            return $3824e46e58e663a3$var$Zf(b.type) && $3824e46e58e663a3$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $3824e46e58e663a3$var$Jh(), $3824e46e58e663a3$var$E($3824e46e58e663a3$var$Wf), $3824e46e58e663a3$var$E($3824e46e58e663a3$var$H), $3824e46e58e663a3$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $3824e46e58e663a3$var$Lh(b), null;
        case 13:
            $3824e46e58e663a3$var$E($3824e46e58e663a3$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($3824e46e58e663a3$var$p(340));
                $3824e46e58e663a3$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $3824e46e58e663a3$var$E($3824e46e58e663a3$var$M), null;
        case 4:
            return $3824e46e58e663a3$var$Jh(), null;
        case 10:
            return $3824e46e58e663a3$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $3824e46e58e663a3$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $3824e46e58e663a3$var$Kj = !1, $3824e46e58e663a3$var$U = !1, $3824e46e58e663a3$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $3824e46e58e663a3$var$V = null;
function $3824e46e58e663a3$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $3824e46e58e663a3$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $3824e46e58e663a3$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $3824e46e58e663a3$var$W(a, b, d);
    }
}
var $3824e46e58e663a3$var$Oj = !1;
function $3824e46e58e663a3$var$Pj(a, b) {
    $3824e46e58e663a3$var$Cf = $3824e46e58e663a3$var$dd;
    a = $3824e46e58e663a3$var$Me();
    if ($3824e46e58e663a3$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $3824e46e58e663a3$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $3824e46e58e663a3$var$dd = !1;
    for($3824e46e58e663a3$var$V = b; null !== $3824e46e58e663a3$var$V;)if (b = $3824e46e58e663a3$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $3824e46e58e663a3$var$V = a;
    else for(; null !== $3824e46e58e663a3$var$V;){
        b = $3824e46e58e663a3$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $3824e46e58e663a3$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($3824e46e58e663a3$var$p(163));
            }
        } catch (F) {
            $3824e46e58e663a3$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $3824e46e58e663a3$var$V = a;
            break;
        }
        $3824e46e58e663a3$var$V = b.return;
    }
    n = $3824e46e58e663a3$var$Oj;
    $3824e46e58e663a3$var$Oj = !1;
    return n;
}
function $3824e46e58e663a3$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $3824e46e58e663a3$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $3824e46e58e663a3$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $3824e46e58e663a3$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $3824e46e58e663a3$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $3824e46e58e663a3$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$3824e46e58e663a3$var$Of], delete b[$3824e46e58e663a3$var$Pf], delete b[$3824e46e58e663a3$var$of], delete b[$3824e46e58e663a3$var$Qf], delete b[$3824e46e58e663a3$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $3824e46e58e663a3$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $3824e46e58e663a3$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $3824e46e58e663a3$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $3824e46e58e663a3$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $3824e46e58e663a3$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($3824e46e58e663a3$var$Wj(a, b, c), a = a.sibling; null !== a;)$3824e46e58e663a3$var$Wj(a, b, c), a = a.sibling;
}
function $3824e46e58e663a3$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($3824e46e58e663a3$var$Xj(a, b, c), a = a.sibling; null !== a;)$3824e46e58e663a3$var$Xj(a, b, c), a = a.sibling;
}
var $3824e46e58e663a3$var$X = null, $3824e46e58e663a3$var$Yj = !1;
function $3824e46e58e663a3$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$3824e46e58e663a3$var$ak(a, b, c), c = c.sibling;
}
function $3824e46e58e663a3$var$ak(a, b, c) {
    if ($3824e46e58e663a3$var$lc && "function" === typeof $3824e46e58e663a3$var$lc.onCommitFiberUnmount) try {
        $3824e46e58e663a3$var$lc.onCommitFiberUnmount($3824e46e58e663a3$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $3824e46e58e663a3$var$U || $3824e46e58e663a3$var$Mj(c, b);
        case 6:
            var d = $3824e46e58e663a3$var$X, e = $3824e46e58e663a3$var$Yj;
            $3824e46e58e663a3$var$X = null;
            $3824e46e58e663a3$var$Zj(a, b, c);
            $3824e46e58e663a3$var$X = d;
            $3824e46e58e663a3$var$Yj = e;
            null !== $3824e46e58e663a3$var$X && ($3824e46e58e663a3$var$Yj ? (a = $3824e46e58e663a3$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $3824e46e58e663a3$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $3824e46e58e663a3$var$X && ($3824e46e58e663a3$var$Yj ? (a = $3824e46e58e663a3$var$X, c = c.stateNode, 8 === a.nodeType ? $3824e46e58e663a3$var$Kf(a.parentNode, c) : 1 === a.nodeType && $3824e46e58e663a3$var$Kf(a, c), $3824e46e58e663a3$var$bd(a)) : $3824e46e58e663a3$var$Kf($3824e46e58e663a3$var$X, c.stateNode));
            break;
        case 4:
            d = $3824e46e58e663a3$var$X;
            e = $3824e46e58e663a3$var$Yj;
            $3824e46e58e663a3$var$X = c.stateNode.containerInfo;
            $3824e46e58e663a3$var$Yj = !0;
            $3824e46e58e663a3$var$Zj(a, b, c);
            $3824e46e58e663a3$var$X = d;
            $3824e46e58e663a3$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$3824e46e58e663a3$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $3824e46e58e663a3$var$Nj(c, b, g) : 0 !== (f & 4) && $3824e46e58e663a3$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $3824e46e58e663a3$var$Zj(a, b, c);
            break;
        case 1:
            if (!$3824e46e58e663a3$var$U && ($3824e46e58e663a3$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $3824e46e58e663a3$var$W(c, b, h);
            }
            $3824e46e58e663a3$var$Zj(a, b, c);
            break;
        case 21:
            $3824e46e58e663a3$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($3824e46e58e663a3$var$U = (d = $3824e46e58e663a3$var$U) || null !== c.memoizedState, $3824e46e58e663a3$var$Zj(a, b, c), $3824e46e58e663a3$var$U = d) : $3824e46e58e663a3$var$Zj(a, b, c);
            break;
        default:
            $3824e46e58e663a3$var$Zj(a, b, c);
    }
}
function $3824e46e58e663a3$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $3824e46e58e663a3$var$Lj);
        b.forEach(function(b) {
            var d = $3824e46e58e663a3$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $3824e46e58e663a3$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $3824e46e58e663a3$var$X = h.stateNode;
                        $3824e46e58e663a3$var$Yj = !1;
                        break a;
                    case 3:
                        $3824e46e58e663a3$var$X = h.stateNode.containerInfo;
                        $3824e46e58e663a3$var$Yj = !0;
                        break a;
                    case 4:
                        $3824e46e58e663a3$var$X = h.stateNode.containerInfo;
                        $3824e46e58e663a3$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $3824e46e58e663a3$var$X) throw Error($3824e46e58e663a3$var$p(160));
            $3824e46e58e663a3$var$ak(f, g, e);
            $3824e46e58e663a3$var$X = null;
            $3824e46e58e663a3$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $3824e46e58e663a3$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$3824e46e58e663a3$var$ek(b, a), b = b.sibling;
}
function $3824e46e58e663a3$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $3824e46e58e663a3$var$dk(b, a);
            $3824e46e58e663a3$var$fk(a);
            if (d & 4) {
                try {
                    $3824e46e58e663a3$var$Qj(3, a, a.return), $3824e46e58e663a3$var$Rj(3, a);
                } catch (t) {
                    $3824e46e58e663a3$var$W(a, a.return, t);
                }
                try {
                    $3824e46e58e663a3$var$Qj(5, a, a.return);
                } catch (t) {
                    $3824e46e58e663a3$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $3824e46e58e663a3$var$dk(b, a);
            $3824e46e58e663a3$var$fk(a);
            d & 512 && null !== c && $3824e46e58e663a3$var$Mj(c, c.return);
            break;
        case 5:
            $3824e46e58e663a3$var$dk(b, a);
            $3824e46e58e663a3$var$fk(a);
            d & 512 && null !== c && $3824e46e58e663a3$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $3824e46e58e663a3$var$ob(e, "");
                } catch (t) {
                    $3824e46e58e663a3$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $3824e46e58e663a3$var$ab(e, f);
                    $3824e46e58e663a3$var$vb(h, g);
                    var l = $3824e46e58e663a3$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $3824e46e58e663a3$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $3824e46e58e663a3$var$nb(e, q) : "children" === m ? $3824e46e58e663a3$var$ob(e, q) : $3824e46e58e663a3$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $3824e46e58e663a3$var$bb(e, f);
                            break;
                        case "textarea":
                            $3824e46e58e663a3$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $3824e46e58e663a3$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $3824e46e58e663a3$var$fb(e, !!f.multiple, f.defaultValue, !0) : $3824e46e58e663a3$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$3824e46e58e663a3$var$Pf] = f;
                } catch (t) {
                    $3824e46e58e663a3$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $3824e46e58e663a3$var$dk(b, a);
            $3824e46e58e663a3$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($3824e46e58e663a3$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $3824e46e58e663a3$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $3824e46e58e663a3$var$dk(b, a);
            $3824e46e58e663a3$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $3824e46e58e663a3$var$bd(b.containerInfo);
            } catch (t) {
                $3824e46e58e663a3$var$W(a, a.return, t);
            }
            break;
        case 4:
            $3824e46e58e663a3$var$dk(b, a);
            $3824e46e58e663a3$var$fk(a);
            break;
        case 13:
            $3824e46e58e663a3$var$dk(b, a);
            $3824e46e58e663a3$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($3824e46e58e663a3$var$gk = $3824e46e58e663a3$var$B()));
            d & 4 && $3824e46e58e663a3$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($3824e46e58e663a3$var$U = (l = $3824e46e58e663a3$var$U) || m, $3824e46e58e663a3$var$dk(b, a), $3824e46e58e663a3$var$U = l) : $3824e46e58e663a3$var$dk(b, a);
            $3824e46e58e663a3$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($3824e46e58e663a3$var$V = a, m = a.child; null !== m;){
                    for(q = $3824e46e58e663a3$var$V = m; null !== $3824e46e58e663a3$var$V;){
                        r = $3824e46e58e663a3$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $3824e46e58e663a3$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $3824e46e58e663a3$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $3824e46e58e663a3$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $3824e46e58e663a3$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $3824e46e58e663a3$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $3824e46e58e663a3$var$V = y) : $3824e46e58e663a3$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $3824e46e58e663a3$var$rb("display", g));
                            } catch (t) {
                                $3824e46e58e663a3$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $3824e46e58e663a3$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $3824e46e58e663a3$var$dk(b, a);
            $3824e46e58e663a3$var$fk(a);
            d & 4 && $3824e46e58e663a3$var$bk(a);
            break;
        case 21:
            break;
        default:
            $3824e46e58e663a3$var$dk(b, a), $3824e46e58e663a3$var$fk(a);
    }
}
function $3824e46e58e663a3$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($3824e46e58e663a3$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($3824e46e58e663a3$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($3824e46e58e663a3$var$ob(e, ""), d.flags &= -33);
                    var f = $3824e46e58e663a3$var$Vj(a);
                    $3824e46e58e663a3$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $3824e46e58e663a3$var$Vj(a);
                    $3824e46e58e663a3$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($3824e46e58e663a3$var$p(161));
            }
        } catch (k) {
            $3824e46e58e663a3$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $3824e46e58e663a3$var$ik(a, b, c) {
    $3824e46e58e663a3$var$V = a;
    $3824e46e58e663a3$var$jk(a, b, c);
}
function $3824e46e58e663a3$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $3824e46e58e663a3$var$V;){
        var e = $3824e46e58e663a3$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $3824e46e58e663a3$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $3824e46e58e663a3$var$U;
                h = $3824e46e58e663a3$var$Kj;
                var l = $3824e46e58e663a3$var$U;
                $3824e46e58e663a3$var$Kj = g;
                if (($3824e46e58e663a3$var$U = k) && !l) for($3824e46e58e663a3$var$V = e; null !== $3824e46e58e663a3$var$V;)g = $3824e46e58e663a3$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $3824e46e58e663a3$var$kk(e) : null !== k ? (k.return = g, $3824e46e58e663a3$var$V = k) : $3824e46e58e663a3$var$kk(e);
                for(; null !== f;)$3824e46e58e663a3$var$V = f, $3824e46e58e663a3$var$jk(f, b, c), f = f.sibling;
                $3824e46e58e663a3$var$V = e;
                $3824e46e58e663a3$var$Kj = h;
                $3824e46e58e663a3$var$U = l;
            }
            $3824e46e58e663a3$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $3824e46e58e663a3$var$V = f) : $3824e46e58e663a3$var$lk(a, b, c);
    }
}
function $3824e46e58e663a3$var$lk(a) {
    for(; null !== $3824e46e58e663a3$var$V;){
        var b = $3824e46e58e663a3$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $3824e46e58e663a3$var$U || $3824e46e58e663a3$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$3824e46e58e663a3$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $3824e46e58e663a3$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $3824e46e58e663a3$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $3824e46e58e663a3$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $3824e46e58e663a3$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($3824e46e58e663a3$var$p(163));
                }
                $3824e46e58e663a3$var$U || b.flags & 512 && $3824e46e58e663a3$var$Sj(b);
            } catch (r) {
                $3824e46e58e663a3$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $3824e46e58e663a3$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $3824e46e58e663a3$var$V = c;
            break;
        }
        $3824e46e58e663a3$var$V = b.return;
    }
}
function $3824e46e58e663a3$var$hk(a) {
    for(; null !== $3824e46e58e663a3$var$V;){
        var b = $3824e46e58e663a3$var$V;
        if (b === a) {
            $3824e46e58e663a3$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $3824e46e58e663a3$var$V = c;
            break;
        }
        $3824e46e58e663a3$var$V = b.return;
    }
}
function $3824e46e58e663a3$var$kk(a) {
    for(; null !== $3824e46e58e663a3$var$V;){
        var b = $3824e46e58e663a3$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $3824e46e58e663a3$var$Rj(4, b);
                    } catch (k) {
                        $3824e46e58e663a3$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $3824e46e58e663a3$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $3824e46e58e663a3$var$Sj(b);
                    } catch (k) {
                        $3824e46e58e663a3$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $3824e46e58e663a3$var$Sj(b);
                    } catch (k) {
                        $3824e46e58e663a3$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $3824e46e58e663a3$var$W(b, b.return, k);
        }
        if (b === a) {
            $3824e46e58e663a3$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $3824e46e58e663a3$var$V = h;
            break;
        }
        $3824e46e58e663a3$var$V = b.return;
    }
}
var $3824e46e58e663a3$var$mk = Math.ceil, $3824e46e58e663a3$var$nk = $3824e46e58e663a3$var$ua.ReactCurrentDispatcher, $3824e46e58e663a3$var$ok = $3824e46e58e663a3$var$ua.ReactCurrentOwner, $3824e46e58e663a3$var$pk = $3824e46e58e663a3$var$ua.ReactCurrentBatchConfig, $3824e46e58e663a3$var$K = 0, $3824e46e58e663a3$var$R = null, $3824e46e58e663a3$var$Y = null, $3824e46e58e663a3$var$Z = 0, $3824e46e58e663a3$var$gj = 0, $3824e46e58e663a3$var$fj = $3824e46e58e663a3$var$Uf(0), $3824e46e58e663a3$var$T = 0, $3824e46e58e663a3$var$qk = null, $3824e46e58e663a3$var$hh = 0, $3824e46e58e663a3$var$rk = 0, $3824e46e58e663a3$var$sk = 0, $3824e46e58e663a3$var$tk = null, $3824e46e58e663a3$var$uk = null, $3824e46e58e663a3$var$gk = 0, $3824e46e58e663a3$var$Hj = Infinity, $3824e46e58e663a3$var$vk = null, $3824e46e58e663a3$var$Pi = !1, $3824e46e58e663a3$var$Qi = null, $3824e46e58e663a3$var$Si = null, $3824e46e58e663a3$var$wk = !1, $3824e46e58e663a3$var$xk = null, $3824e46e58e663a3$var$yk = 0, $3824e46e58e663a3$var$zk = 0, $3824e46e58e663a3$var$Ak = null, $3824e46e58e663a3$var$Bk = -1, $3824e46e58e663a3$var$Ck = 0;
function $3824e46e58e663a3$var$L() {
    return 0 !== ($3824e46e58e663a3$var$K & 6) ? $3824e46e58e663a3$var$B() : -1 !== $3824e46e58e663a3$var$Bk ? $3824e46e58e663a3$var$Bk : $3824e46e58e663a3$var$Bk = $3824e46e58e663a3$var$B();
}
function $3824e46e58e663a3$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($3824e46e58e663a3$var$K & 2) && 0 !== $3824e46e58e663a3$var$Z) return $3824e46e58e663a3$var$Z & -$3824e46e58e663a3$var$Z;
    if (null !== $3824e46e58e663a3$var$Kg.transition) return 0 === $3824e46e58e663a3$var$Ck && ($3824e46e58e663a3$var$Ck = $3824e46e58e663a3$var$yc()), $3824e46e58e663a3$var$Ck;
    a = $3824e46e58e663a3$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $3824e46e58e663a3$var$jd(a.type);
    return a;
}
function $3824e46e58e663a3$var$mh(a, b, c, d) {
    if (50 < $3824e46e58e663a3$var$zk) throw $3824e46e58e663a3$var$zk = 0, $3824e46e58e663a3$var$Ak = null, Error($3824e46e58e663a3$var$p(185));
    $3824e46e58e663a3$var$Ac(a, c, d);
    if (0 === ($3824e46e58e663a3$var$K & 2) || a !== $3824e46e58e663a3$var$R) a === $3824e46e58e663a3$var$R && (0 === ($3824e46e58e663a3$var$K & 2) && ($3824e46e58e663a3$var$rk |= c), 4 === $3824e46e58e663a3$var$T && $3824e46e58e663a3$var$Dk(a, $3824e46e58e663a3$var$Z)), $3824e46e58e663a3$var$Ek(a, d), 1 === c && 0 === $3824e46e58e663a3$var$K && 0 === (b.mode & 1) && ($3824e46e58e663a3$var$Hj = $3824e46e58e663a3$var$B() + 500, $3824e46e58e663a3$var$fg && $3824e46e58e663a3$var$jg());
}
function $3824e46e58e663a3$var$Ek(a, b) {
    var c = a.callbackNode;
    $3824e46e58e663a3$var$wc(a, b);
    var d = $3824e46e58e663a3$var$uc(a, a === $3824e46e58e663a3$var$R ? $3824e46e58e663a3$var$Z : 0);
    if (0 === d) null !== c && $3824e46e58e663a3$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $3824e46e58e663a3$var$bc(c);
        if (1 === b) 0 === a.tag ? $3824e46e58e663a3$var$ig($3824e46e58e663a3$var$Fk.bind(null, a)) : $3824e46e58e663a3$var$hg($3824e46e58e663a3$var$Fk.bind(null, a)), $3824e46e58e663a3$var$Jf(function() {
            0 === ($3824e46e58e663a3$var$K & 6) && $3824e46e58e663a3$var$jg();
        }), c = null;
        else {
            switch($3824e46e58e663a3$var$Dc(d)){
                case 1:
                    c = $3824e46e58e663a3$var$fc;
                    break;
                case 4:
                    c = $3824e46e58e663a3$var$gc;
                    break;
                case 16:
                    c = $3824e46e58e663a3$var$hc;
                    break;
                case 536870912:
                    c = $3824e46e58e663a3$var$jc;
                    break;
                default:
                    c = $3824e46e58e663a3$var$hc;
            }
            c = $3824e46e58e663a3$var$Gk(c, $3824e46e58e663a3$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $3824e46e58e663a3$var$Hk(a, b) {
    $3824e46e58e663a3$var$Bk = -1;
    $3824e46e58e663a3$var$Ck = 0;
    if (0 !== ($3824e46e58e663a3$var$K & 6)) throw Error($3824e46e58e663a3$var$p(327));
    var c = a.callbackNode;
    if ($3824e46e58e663a3$var$Ik() && a.callbackNode !== c) return null;
    var d = $3824e46e58e663a3$var$uc(a, a === $3824e46e58e663a3$var$R ? $3824e46e58e663a3$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $3824e46e58e663a3$var$Jk(a, d);
    else {
        b = d;
        var e = $3824e46e58e663a3$var$K;
        $3824e46e58e663a3$var$K |= 2;
        var f = $3824e46e58e663a3$var$Kk();
        if ($3824e46e58e663a3$var$R !== a || $3824e46e58e663a3$var$Z !== b) $3824e46e58e663a3$var$vk = null, $3824e46e58e663a3$var$Hj = $3824e46e58e663a3$var$B() + 500, $3824e46e58e663a3$var$Lk(a, b);
        for(;;)try {
            $3824e46e58e663a3$var$Mk();
            break;
        } catch (h) {
            $3824e46e58e663a3$var$Nk(a, h);
        }
        $3824e46e58e663a3$var$Qg();
        $3824e46e58e663a3$var$nk.current = f;
        $3824e46e58e663a3$var$K = e;
        null !== $3824e46e58e663a3$var$Y ? b = 0 : ($3824e46e58e663a3$var$R = null, $3824e46e58e663a3$var$Z = 0, b = $3824e46e58e663a3$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $3824e46e58e663a3$var$xc(a), 0 !== e && (d = e, b = $3824e46e58e663a3$var$Ok(a, e)));
        if (1 === b) throw c = $3824e46e58e663a3$var$qk, $3824e46e58e663a3$var$Lk(a, 0), $3824e46e58e663a3$var$Dk(a, d), $3824e46e58e663a3$var$Ek(a, $3824e46e58e663a3$var$B()), c;
        if (6 === b) $3824e46e58e663a3$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$3824e46e58e663a3$var$Pk(e) && (b = $3824e46e58e663a3$var$Jk(a, d), 2 === b && (f = $3824e46e58e663a3$var$xc(a), 0 !== f && (d = f, b = $3824e46e58e663a3$var$Ok(a, f))), 1 === b)) throw c = $3824e46e58e663a3$var$qk, $3824e46e58e663a3$var$Lk(a, 0), $3824e46e58e663a3$var$Dk(a, d), $3824e46e58e663a3$var$Ek(a, $3824e46e58e663a3$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($3824e46e58e663a3$var$p(345));
                case 2:
                    $3824e46e58e663a3$var$Qk(a, $3824e46e58e663a3$var$uk, $3824e46e58e663a3$var$vk);
                    break;
                case 3:
                    $3824e46e58e663a3$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $3824e46e58e663a3$var$gk + 500 - $3824e46e58e663a3$var$B(), 10 < b)) {
                        if (0 !== $3824e46e58e663a3$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $3824e46e58e663a3$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $3824e46e58e663a3$var$Ff($3824e46e58e663a3$var$Qk.bind(null, a, $3824e46e58e663a3$var$uk, $3824e46e58e663a3$var$vk), b);
                        break;
                    }
                    $3824e46e58e663a3$var$Qk(a, $3824e46e58e663a3$var$uk, $3824e46e58e663a3$var$vk);
                    break;
                case 4:
                    $3824e46e58e663a3$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $3824e46e58e663a3$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $3824e46e58e663a3$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $3824e46e58e663a3$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $3824e46e58e663a3$var$Ff($3824e46e58e663a3$var$Qk.bind(null, a, $3824e46e58e663a3$var$uk, $3824e46e58e663a3$var$vk), d);
                        break;
                    }
                    $3824e46e58e663a3$var$Qk(a, $3824e46e58e663a3$var$uk, $3824e46e58e663a3$var$vk);
                    break;
                case 5:
                    $3824e46e58e663a3$var$Qk(a, $3824e46e58e663a3$var$uk, $3824e46e58e663a3$var$vk);
                    break;
                default:
                    throw Error($3824e46e58e663a3$var$p(329));
            }
        }
    }
    $3824e46e58e663a3$var$Ek(a, $3824e46e58e663a3$var$B());
    return a.callbackNode === c ? $3824e46e58e663a3$var$Hk.bind(null, a) : null;
}
function $3824e46e58e663a3$var$Ok(a, b) {
    var c = $3824e46e58e663a3$var$tk;
    a.current.memoizedState.isDehydrated && ($3824e46e58e663a3$var$Lk(a, b).flags |= 256);
    a = $3824e46e58e663a3$var$Jk(a, b);
    2 !== a && (b = $3824e46e58e663a3$var$uk, $3824e46e58e663a3$var$uk = c, null !== b && $3824e46e58e663a3$var$Gj(b));
    return a;
}
function $3824e46e58e663a3$var$Gj(a) {
    null === $3824e46e58e663a3$var$uk ? $3824e46e58e663a3$var$uk = a : $3824e46e58e663a3$var$uk.push.apply($3824e46e58e663a3$var$uk, a);
}
function $3824e46e58e663a3$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$3824e46e58e663a3$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $3824e46e58e663a3$var$Dk(a, b) {
    b &= ~$3824e46e58e663a3$var$sk;
    b &= ~$3824e46e58e663a3$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $3824e46e58e663a3$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $3824e46e58e663a3$var$Fk(a) {
    if (0 !== ($3824e46e58e663a3$var$K & 6)) throw Error($3824e46e58e663a3$var$p(327));
    $3824e46e58e663a3$var$Ik();
    var b = $3824e46e58e663a3$var$uc(a, 0);
    if (0 === (b & 1)) return $3824e46e58e663a3$var$Ek(a, $3824e46e58e663a3$var$B()), null;
    var c = $3824e46e58e663a3$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $3824e46e58e663a3$var$xc(a);
        0 !== d && (b = d, c = $3824e46e58e663a3$var$Ok(a, d));
    }
    if (1 === c) throw c = $3824e46e58e663a3$var$qk, $3824e46e58e663a3$var$Lk(a, 0), $3824e46e58e663a3$var$Dk(a, b), $3824e46e58e663a3$var$Ek(a, $3824e46e58e663a3$var$B()), c;
    if (6 === c) throw Error($3824e46e58e663a3$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $3824e46e58e663a3$var$Qk(a, $3824e46e58e663a3$var$uk, $3824e46e58e663a3$var$vk);
    $3824e46e58e663a3$var$Ek(a, $3824e46e58e663a3$var$B());
    return null;
}
function $3824e46e58e663a3$var$Rk(a, b) {
    var c = $3824e46e58e663a3$var$K;
    $3824e46e58e663a3$var$K |= 1;
    try {
        return a(b);
    } finally{
        $3824e46e58e663a3$var$K = c, 0 === $3824e46e58e663a3$var$K && ($3824e46e58e663a3$var$Hj = $3824e46e58e663a3$var$B() + 500, $3824e46e58e663a3$var$fg && $3824e46e58e663a3$var$jg());
    }
}
function $3824e46e58e663a3$var$Sk(a) {
    null !== $3824e46e58e663a3$var$xk && 0 === $3824e46e58e663a3$var$xk.tag && 0 === ($3824e46e58e663a3$var$K & 6) && $3824e46e58e663a3$var$Ik();
    var b = $3824e46e58e663a3$var$K;
    $3824e46e58e663a3$var$K |= 1;
    var c = $3824e46e58e663a3$var$pk.transition, d = $3824e46e58e663a3$var$C;
    try {
        if ($3824e46e58e663a3$var$pk.transition = null, $3824e46e58e663a3$var$C = 1, a) return a();
    } finally{
        $3824e46e58e663a3$var$C = d, $3824e46e58e663a3$var$pk.transition = c, $3824e46e58e663a3$var$K = b, 0 === ($3824e46e58e663a3$var$K & 6) && $3824e46e58e663a3$var$jg();
    }
}
function $3824e46e58e663a3$var$Ij() {
    $3824e46e58e663a3$var$gj = $3824e46e58e663a3$var$fj.current;
    $3824e46e58e663a3$var$E($3824e46e58e663a3$var$fj);
}
function $3824e46e58e663a3$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $3824e46e58e663a3$var$Gf(c));
    if (null !== $3824e46e58e663a3$var$Y) for(c = $3824e46e58e663a3$var$Y.return; null !== c;){
        var d = c;
        $3824e46e58e663a3$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $3824e46e58e663a3$var$$f();
                break;
            case 3:
                $3824e46e58e663a3$var$Jh();
                $3824e46e58e663a3$var$E($3824e46e58e663a3$var$Wf);
                $3824e46e58e663a3$var$E($3824e46e58e663a3$var$H);
                $3824e46e58e663a3$var$Oh();
                break;
            case 5:
                $3824e46e58e663a3$var$Lh(d);
                break;
            case 4:
                $3824e46e58e663a3$var$Jh();
                break;
            case 13:
                $3824e46e58e663a3$var$E($3824e46e58e663a3$var$M);
                break;
            case 19:
                $3824e46e58e663a3$var$E($3824e46e58e663a3$var$M);
                break;
            case 10:
                $3824e46e58e663a3$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $3824e46e58e663a3$var$Ij();
        }
        c = c.return;
    }
    $3824e46e58e663a3$var$R = a;
    $3824e46e58e663a3$var$Y = a = $3824e46e58e663a3$var$wh(a.current, null);
    $3824e46e58e663a3$var$Z = $3824e46e58e663a3$var$gj = b;
    $3824e46e58e663a3$var$T = 0;
    $3824e46e58e663a3$var$qk = null;
    $3824e46e58e663a3$var$sk = $3824e46e58e663a3$var$rk = $3824e46e58e663a3$var$hh = 0;
    $3824e46e58e663a3$var$uk = $3824e46e58e663a3$var$tk = null;
    if (null !== $3824e46e58e663a3$var$Wg) {
        for(b = 0; b < $3824e46e58e663a3$var$Wg.length; b++)if (c = $3824e46e58e663a3$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $3824e46e58e663a3$var$Wg = null;
    }
    return a;
}
function $3824e46e58e663a3$var$Nk(a, b) {
    do {
        var c = $3824e46e58e663a3$var$Y;
        try {
            $3824e46e58e663a3$var$Qg();
            $3824e46e58e663a3$var$Ph.current = $3824e46e58e663a3$var$ai;
            if ($3824e46e58e663a3$var$Sh) {
                for(var d = $3824e46e58e663a3$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $3824e46e58e663a3$var$Sh = !1;
            }
            $3824e46e58e663a3$var$Rh = 0;
            $3824e46e58e663a3$var$P = $3824e46e58e663a3$var$O = $3824e46e58e663a3$var$N = null;
            $3824e46e58e663a3$var$Th = !1;
            $3824e46e58e663a3$var$Uh = 0;
            $3824e46e58e663a3$var$ok.current = null;
            if (null === c || null === c.return) {
                $3824e46e58e663a3$var$T = 1;
                $3824e46e58e663a3$var$qk = b;
                $3824e46e58e663a3$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $3824e46e58e663a3$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $3824e46e58e663a3$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $3824e46e58e663a3$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $3824e46e58e663a3$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $3824e46e58e663a3$var$Ti(f, l, b);
                            $3824e46e58e663a3$var$uj();
                            break a;
                        }
                        k = Error($3824e46e58e663a3$var$p(426));
                    }
                } else if ($3824e46e58e663a3$var$I && h.mode & 1) {
                    var J = $3824e46e58e663a3$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $3824e46e58e663a3$var$Wi(J, g, h, f, b);
                        $3824e46e58e663a3$var$Jg($3824e46e58e663a3$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $3824e46e58e663a3$var$Ki(k, h);
                4 !== $3824e46e58e663a3$var$T && ($3824e46e58e663a3$var$T = 2);
                null === $3824e46e58e663a3$var$tk ? $3824e46e58e663a3$var$tk = [
                    f
                ] : $3824e46e58e663a3$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $3824e46e58e663a3$var$Oi(f, k, b);
                            $3824e46e58e663a3$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $3824e46e58e663a3$var$Si || !$3824e46e58e663a3$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $3824e46e58e663a3$var$Ri(f, h, b);
                                $3824e46e58e663a3$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $3824e46e58e663a3$var$Tk(c);
        } catch (na) {
            b = na;
            $3824e46e58e663a3$var$Y === c && null !== c && ($3824e46e58e663a3$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $3824e46e58e663a3$var$Kk() {
    var a = $3824e46e58e663a3$var$nk.current;
    $3824e46e58e663a3$var$nk.current = $3824e46e58e663a3$var$ai;
    return null === a ? $3824e46e58e663a3$var$ai : a;
}
function $3824e46e58e663a3$var$uj() {
    if (0 === $3824e46e58e663a3$var$T || 3 === $3824e46e58e663a3$var$T || 2 === $3824e46e58e663a3$var$T) $3824e46e58e663a3$var$T = 4;
    null === $3824e46e58e663a3$var$R || 0 === ($3824e46e58e663a3$var$hh & 268435455) && 0 === ($3824e46e58e663a3$var$rk & 268435455) || $3824e46e58e663a3$var$Dk($3824e46e58e663a3$var$R, $3824e46e58e663a3$var$Z);
}
function $3824e46e58e663a3$var$Jk(a, b) {
    var c = $3824e46e58e663a3$var$K;
    $3824e46e58e663a3$var$K |= 2;
    var d = $3824e46e58e663a3$var$Kk();
    if ($3824e46e58e663a3$var$R !== a || $3824e46e58e663a3$var$Z !== b) $3824e46e58e663a3$var$vk = null, $3824e46e58e663a3$var$Lk(a, b);
    for(;;)try {
        $3824e46e58e663a3$var$Uk();
        break;
    } catch (e) {
        $3824e46e58e663a3$var$Nk(a, e);
    }
    $3824e46e58e663a3$var$Qg();
    $3824e46e58e663a3$var$K = c;
    $3824e46e58e663a3$var$nk.current = d;
    if (null !== $3824e46e58e663a3$var$Y) throw Error($3824e46e58e663a3$var$p(261));
    $3824e46e58e663a3$var$R = null;
    $3824e46e58e663a3$var$Z = 0;
    return $3824e46e58e663a3$var$T;
}
function $3824e46e58e663a3$var$Uk() {
    for(; null !== $3824e46e58e663a3$var$Y;)$3824e46e58e663a3$var$Vk($3824e46e58e663a3$var$Y);
}
function $3824e46e58e663a3$var$Mk() {
    for(; null !== $3824e46e58e663a3$var$Y && !$3824e46e58e663a3$var$cc();)$3824e46e58e663a3$var$Vk($3824e46e58e663a3$var$Y);
}
function $3824e46e58e663a3$var$Vk(a) {
    var b = $3824e46e58e663a3$var$Wk(a.alternate, a, $3824e46e58e663a3$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $3824e46e58e663a3$var$Tk(a) : $3824e46e58e663a3$var$Y = b;
    $3824e46e58e663a3$var$ok.current = null;
}
function $3824e46e58e663a3$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $3824e46e58e663a3$var$Fj(c, b, $3824e46e58e663a3$var$gj), null !== c) {
                $3824e46e58e663a3$var$Y = c;
                return;
            }
        } else {
            c = $3824e46e58e663a3$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $3824e46e58e663a3$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $3824e46e58e663a3$var$T = 6;
                $3824e46e58e663a3$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $3824e46e58e663a3$var$Y = b;
            return;
        }
        $3824e46e58e663a3$var$Y = b = a;
    }while (null !== b);
    0 === $3824e46e58e663a3$var$T && ($3824e46e58e663a3$var$T = 5);
}
function $3824e46e58e663a3$var$Qk(a, b, c) {
    var d = $3824e46e58e663a3$var$C, e = $3824e46e58e663a3$var$pk.transition;
    try {
        $3824e46e58e663a3$var$pk.transition = null, $3824e46e58e663a3$var$C = 1, $3824e46e58e663a3$var$Xk(a, b, c, d);
    } finally{
        $3824e46e58e663a3$var$pk.transition = e, $3824e46e58e663a3$var$C = d;
    }
    return null;
}
function $3824e46e58e663a3$var$Xk(a, b, c, d) {
    do $3824e46e58e663a3$var$Ik();
    while (null !== $3824e46e58e663a3$var$xk);
    if (0 !== ($3824e46e58e663a3$var$K & 6)) throw Error($3824e46e58e663a3$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($3824e46e58e663a3$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $3824e46e58e663a3$var$Bc(a, f);
    a === $3824e46e58e663a3$var$R && ($3824e46e58e663a3$var$Y = $3824e46e58e663a3$var$R = null, $3824e46e58e663a3$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $3824e46e58e663a3$var$wk || ($3824e46e58e663a3$var$wk = !0, $3824e46e58e663a3$var$Gk($3824e46e58e663a3$var$hc, function() {
        $3824e46e58e663a3$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $3824e46e58e663a3$var$pk.transition;
        $3824e46e58e663a3$var$pk.transition = null;
        var g = $3824e46e58e663a3$var$C;
        $3824e46e58e663a3$var$C = 1;
        var h = $3824e46e58e663a3$var$K;
        $3824e46e58e663a3$var$K |= 4;
        $3824e46e58e663a3$var$ok.current = null;
        $3824e46e58e663a3$var$Pj(a, c);
        $3824e46e58e663a3$var$ek(c, a);
        $3824e46e58e663a3$var$Oe($3824e46e58e663a3$var$Df);
        $3824e46e58e663a3$var$dd = !!$3824e46e58e663a3$var$Cf;
        $3824e46e58e663a3$var$Df = $3824e46e58e663a3$var$Cf = null;
        a.current = c;
        $3824e46e58e663a3$var$ik(c, a, e);
        $3824e46e58e663a3$var$dc();
        $3824e46e58e663a3$var$K = h;
        $3824e46e58e663a3$var$C = g;
        $3824e46e58e663a3$var$pk.transition = f;
    } else a.current = c;
    $3824e46e58e663a3$var$wk && ($3824e46e58e663a3$var$wk = !1, $3824e46e58e663a3$var$xk = a, $3824e46e58e663a3$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($3824e46e58e663a3$var$Si = null);
    $3824e46e58e663a3$var$mc(c.stateNode, d);
    $3824e46e58e663a3$var$Ek(a, $3824e46e58e663a3$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($3824e46e58e663a3$var$Pi) throw $3824e46e58e663a3$var$Pi = !1, a = $3824e46e58e663a3$var$Qi, $3824e46e58e663a3$var$Qi = null, a;
    0 !== ($3824e46e58e663a3$var$yk & 1) && 0 !== a.tag && $3824e46e58e663a3$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $3824e46e58e663a3$var$Ak ? $3824e46e58e663a3$var$zk++ : ($3824e46e58e663a3$var$zk = 0, $3824e46e58e663a3$var$Ak = a) : $3824e46e58e663a3$var$zk = 0;
    $3824e46e58e663a3$var$jg();
    return null;
}
function $3824e46e58e663a3$var$Ik() {
    if (null !== $3824e46e58e663a3$var$xk) {
        var a = $3824e46e58e663a3$var$Dc($3824e46e58e663a3$var$yk), b = $3824e46e58e663a3$var$pk.transition, c = $3824e46e58e663a3$var$C;
        try {
            $3824e46e58e663a3$var$pk.transition = null;
            $3824e46e58e663a3$var$C = 16 > a ? 16 : a;
            if (null === $3824e46e58e663a3$var$xk) var d = !1;
            else {
                a = $3824e46e58e663a3$var$xk;
                $3824e46e58e663a3$var$xk = null;
                $3824e46e58e663a3$var$yk = 0;
                if (0 !== ($3824e46e58e663a3$var$K & 6)) throw Error($3824e46e58e663a3$var$p(331));
                var e = $3824e46e58e663a3$var$K;
                $3824e46e58e663a3$var$K |= 4;
                for($3824e46e58e663a3$var$V = a.current; null !== $3824e46e58e663a3$var$V;){
                    var f = $3824e46e58e663a3$var$V, g = f.child;
                    if (0 !== ($3824e46e58e663a3$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($3824e46e58e663a3$var$V = l; null !== $3824e46e58e663a3$var$V;){
                                    var m = $3824e46e58e663a3$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $3824e46e58e663a3$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $3824e46e58e663a3$var$V = q;
                                    else for(; null !== $3824e46e58e663a3$var$V;){
                                        m = $3824e46e58e663a3$var$V;
                                        var r = m.sibling, y = m.return;
                                        $3824e46e58e663a3$var$Tj(m);
                                        if (m === l) {
                                            $3824e46e58e663a3$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $3824e46e58e663a3$var$V = r;
                                            break;
                                        }
                                        $3824e46e58e663a3$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $3824e46e58e663a3$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $3824e46e58e663a3$var$V = g;
                    else b: for(; null !== $3824e46e58e663a3$var$V;){
                        f = $3824e46e58e663a3$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $3824e46e58e663a3$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $3824e46e58e663a3$var$V = x;
                            break b;
                        }
                        $3824e46e58e663a3$var$V = f.return;
                    }
                }
                var w = a.current;
                for($3824e46e58e663a3$var$V = w; null !== $3824e46e58e663a3$var$V;){
                    g = $3824e46e58e663a3$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $3824e46e58e663a3$var$V = u;
                    else b: for(g = w; null !== $3824e46e58e663a3$var$V;){
                        h = $3824e46e58e663a3$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $3824e46e58e663a3$var$Rj(9, h);
                            }
                        } catch (na) {
                            $3824e46e58e663a3$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $3824e46e58e663a3$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $3824e46e58e663a3$var$V = F;
                            break b;
                        }
                        $3824e46e58e663a3$var$V = h.return;
                    }
                }
                $3824e46e58e663a3$var$K = e;
                $3824e46e58e663a3$var$jg();
                if ($3824e46e58e663a3$var$lc && "function" === typeof $3824e46e58e663a3$var$lc.onPostCommitFiberRoot) try {
                    $3824e46e58e663a3$var$lc.onPostCommitFiberRoot($3824e46e58e663a3$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $3824e46e58e663a3$var$C = c, $3824e46e58e663a3$var$pk.transition = b;
        }
    }
    return !1;
}
function $3824e46e58e663a3$var$Yk(a, b, c) {
    b = $3824e46e58e663a3$var$Ki(c, b);
    b = $3824e46e58e663a3$var$Oi(a, b, 1);
    a = $3824e46e58e663a3$var$dh(a, b, 1);
    b = $3824e46e58e663a3$var$L();
    null !== a && ($3824e46e58e663a3$var$Ac(a, 1, b), $3824e46e58e663a3$var$Ek(a, b));
}
function $3824e46e58e663a3$var$W(a, b, c) {
    if (3 === a.tag) $3824e46e58e663a3$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $3824e46e58e663a3$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $3824e46e58e663a3$var$Si || !$3824e46e58e663a3$var$Si.has(d))) {
                a = $3824e46e58e663a3$var$Ki(c, a);
                a = $3824e46e58e663a3$var$Ri(b, a, 1);
                b = $3824e46e58e663a3$var$dh(b, a, 1);
                a = $3824e46e58e663a3$var$L();
                null !== b && ($3824e46e58e663a3$var$Ac(b, 1, a), $3824e46e58e663a3$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $3824e46e58e663a3$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $3824e46e58e663a3$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $3824e46e58e663a3$var$R === a && ($3824e46e58e663a3$var$Z & c) === c && (4 === $3824e46e58e663a3$var$T || 3 === $3824e46e58e663a3$var$T && ($3824e46e58e663a3$var$Z & 130023424) === $3824e46e58e663a3$var$Z && 500 > $3824e46e58e663a3$var$B() - $3824e46e58e663a3$var$gk ? $3824e46e58e663a3$var$Lk(a, 0) : $3824e46e58e663a3$var$sk |= c);
    $3824e46e58e663a3$var$Ek(a, b);
}
function $3824e46e58e663a3$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $3824e46e58e663a3$var$sc, $3824e46e58e663a3$var$sc <<= 1, 0 === ($3824e46e58e663a3$var$sc & 130023424) && ($3824e46e58e663a3$var$sc = 4194304)));
    var c = $3824e46e58e663a3$var$L();
    a = $3824e46e58e663a3$var$Zg(a, b);
    null !== a && ($3824e46e58e663a3$var$Ac(a, b, c), $3824e46e58e663a3$var$Ek(a, c));
}
function $3824e46e58e663a3$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $3824e46e58e663a3$var$Zk(a, c);
}
function $3824e46e58e663a3$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($3824e46e58e663a3$var$p(314));
    }
    null !== d && d.delete(b);
    $3824e46e58e663a3$var$Zk(a, c);
}
var $3824e46e58e663a3$var$Wk;
$3824e46e58e663a3$var$Wk = function Wk(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $3824e46e58e663a3$var$Wf.current) $3824e46e58e663a3$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $3824e46e58e663a3$var$Ug = !1, $3824e46e58e663a3$var$zj(a, b, c);
            $3824e46e58e663a3$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $3824e46e58e663a3$var$Ug = !1, $3824e46e58e663a3$var$I && 0 !== (b.flags & 1048576) && $3824e46e58e663a3$var$ug(b, $3824e46e58e663a3$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $3824e46e58e663a3$var$jj(a, b);
            a = b.pendingProps;
            var e = $3824e46e58e663a3$var$Yf(b, $3824e46e58e663a3$var$H.current);
            $3824e46e58e663a3$var$Tg(b, c);
            e = $3824e46e58e663a3$var$Xh(null, b, d, a, e, c);
            var f = $3824e46e58e663a3$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $3824e46e58e663a3$var$Zf(d) ? (f = !0, $3824e46e58e663a3$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $3824e46e58e663a3$var$ah(b), e.updater = $3824e46e58e663a3$var$nh, b.stateNode = e, e._reactInternals = b, $3824e46e58e663a3$var$rh(b, d, a, c), b = $3824e46e58e663a3$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $3824e46e58e663a3$var$I && f && $3824e46e58e663a3$var$vg(b), $3824e46e58e663a3$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $3824e46e58e663a3$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $3824e46e58e663a3$var$$k(d);
                a = $3824e46e58e663a3$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $3824e46e58e663a3$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $3824e46e58e663a3$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $3824e46e58e663a3$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $3824e46e58e663a3$var$aj(null, b, d, $3824e46e58e663a3$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($3824e46e58e663a3$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $3824e46e58e663a3$var$Lg(d, e), $3824e46e58e663a3$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $3824e46e58e663a3$var$Lg(d, e), $3824e46e58e663a3$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $3824e46e58e663a3$var$lj(b);
                if (null === a) throw Error($3824e46e58e663a3$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $3824e46e58e663a3$var$bh(a, b);
                $3824e46e58e663a3$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $3824e46e58e663a3$var$Ki(Error($3824e46e58e663a3$var$p(423)), b);
                        b = $3824e46e58e663a3$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $3824e46e58e663a3$var$Ki(Error($3824e46e58e663a3$var$p(424)), b);
                        b = $3824e46e58e663a3$var$mj(a, b, d, c, e);
                        break a;
                    } else for($3824e46e58e663a3$var$yg = $3824e46e58e663a3$var$Lf(b.stateNode.containerInfo.firstChild), $3824e46e58e663a3$var$xg = b, $3824e46e58e663a3$var$I = !0, $3824e46e58e663a3$var$zg = null, c = $3824e46e58e663a3$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $3824e46e58e663a3$var$Ig();
                    if (d === e) {
                        b = $3824e46e58e663a3$var$$i(a, b, c);
                        break a;
                    }
                    $3824e46e58e663a3$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $3824e46e58e663a3$var$Kh(b), null === a && $3824e46e58e663a3$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $3824e46e58e663a3$var$Ef(d, e) ? g = null : null !== f && $3824e46e58e663a3$var$Ef(d, f) && (b.flags |= 32), $3824e46e58e663a3$var$hj(a, b), $3824e46e58e663a3$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $3824e46e58e663a3$var$Eg(b), null;
        case 13:
            return $3824e46e58e663a3$var$pj(a, b, c);
        case 4:
            return $3824e46e58e663a3$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $3824e46e58e663a3$var$Bh(b, null, d, c) : $3824e46e58e663a3$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $3824e46e58e663a3$var$Lg(d, e), $3824e46e58e663a3$var$Zi(a, b, d, e, c);
        case 7:
            return $3824e46e58e663a3$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $3824e46e58e663a3$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $3824e46e58e663a3$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $3824e46e58e663a3$var$G($3824e46e58e663a3$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($3824e46e58e663a3$var$He(f.value, g)) {
                        if (f.children === e.children && !$3824e46e58e663a3$var$Wf.current) {
                            b = $3824e46e58e663a3$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $3824e46e58e663a3$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $3824e46e58e663a3$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($3824e46e58e663a3$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $3824e46e58e663a3$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $3824e46e58e663a3$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $3824e46e58e663a3$var$Tg(b, c), e = $3824e46e58e663a3$var$Vg(e), d = d(e), b.flags |= 1, $3824e46e58e663a3$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $3824e46e58e663a3$var$Lg(d, b.pendingProps), e = $3824e46e58e663a3$var$Lg(d.type, e), $3824e46e58e663a3$var$aj(a, b, d, e, c);
        case 15:
            return $3824e46e58e663a3$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $3824e46e58e663a3$var$Lg(d, e), $3824e46e58e663a3$var$jj(a, b), b.tag = 1, $3824e46e58e663a3$var$Zf(d) ? (a = !0, $3824e46e58e663a3$var$cg(b)) : a = !1, $3824e46e58e663a3$var$Tg(b, c), $3824e46e58e663a3$var$ph(b, d, e), $3824e46e58e663a3$var$rh(b, d, e, c), $3824e46e58e663a3$var$kj(null, b, d, !0, a, c);
        case 19:
            return $3824e46e58e663a3$var$yj(a, b, c);
        case 22:
            return $3824e46e58e663a3$var$ej(a, b, c);
    }
    throw Error($3824e46e58e663a3$var$p(156, b.tag));
};
function $3824e46e58e663a3$var$Gk(a, b) {
    return $3824e46e58e663a3$var$ac(a, b);
}
function $3824e46e58e663a3$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $3824e46e58e663a3$var$Bg(a, b, c, d) {
    return new $3824e46e58e663a3$var$al(a, b, c, d);
}
function $3824e46e58e663a3$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $3824e46e58e663a3$var$$k(a) {
    if ("function" === typeof a) return $3824e46e58e663a3$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $3824e46e58e663a3$var$Da) return 11;
        if (a === $3824e46e58e663a3$var$Ga) return 14;
    }
    return 2;
}
function $3824e46e58e663a3$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $3824e46e58e663a3$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $3824e46e58e663a3$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $3824e46e58e663a3$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $3824e46e58e663a3$var$ya:
            return $3824e46e58e663a3$var$Ah(c.children, e, f, b);
        case $3824e46e58e663a3$var$za:
            g = 8;
            e |= 8;
            break;
        case $3824e46e58e663a3$var$Aa:
            return a = $3824e46e58e663a3$var$Bg(12, c, b, e | 2), a.elementType = $3824e46e58e663a3$var$Aa, a.lanes = f, a;
        case $3824e46e58e663a3$var$Ea:
            return a = $3824e46e58e663a3$var$Bg(13, c, b, e), a.elementType = $3824e46e58e663a3$var$Ea, a.lanes = f, a;
        case $3824e46e58e663a3$var$Fa:
            return a = $3824e46e58e663a3$var$Bg(19, c, b, e), a.elementType = $3824e46e58e663a3$var$Fa, a.lanes = f, a;
        case $3824e46e58e663a3$var$Ia:
            return $3824e46e58e663a3$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $3824e46e58e663a3$var$Ba:
                    g = 10;
                    break a;
                case $3824e46e58e663a3$var$Ca:
                    g = 9;
                    break a;
                case $3824e46e58e663a3$var$Da:
                    g = 11;
                    break a;
                case $3824e46e58e663a3$var$Ga:
                    g = 14;
                    break a;
                case $3824e46e58e663a3$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($3824e46e58e663a3$var$p(130, null == a ? a : typeof a === "undefined" ? "undefined" : (0, $6zqIC._)(a), ""));
    }
    b = $3824e46e58e663a3$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $3824e46e58e663a3$var$Ah(a, b, c, d) {
    a = $3824e46e58e663a3$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $3824e46e58e663a3$var$qj(a, b, c, d) {
    a = $3824e46e58e663a3$var$Bg(22, a, d, b);
    a.elementType = $3824e46e58e663a3$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $3824e46e58e663a3$var$xh(a, b, c) {
    a = $3824e46e58e663a3$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $3824e46e58e663a3$var$zh(a, b, c) {
    b = $3824e46e58e663a3$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $3824e46e58e663a3$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $3824e46e58e663a3$var$zc(0);
    this.expirationTimes = $3824e46e58e663a3$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $3824e46e58e663a3$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $3824e46e58e663a3$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $3824e46e58e663a3$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $3824e46e58e663a3$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $3824e46e58e663a3$var$ah(f);
    return a;
}
function $3824e46e58e663a3$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $3824e46e58e663a3$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $3824e46e58e663a3$var$el(a) {
    if (!a) return $3824e46e58e663a3$var$Vf;
    a = a._reactInternals;
    a: {
        if ($3824e46e58e663a3$var$Vb(a) !== a || 1 !== a.tag) throw Error($3824e46e58e663a3$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($3824e46e58e663a3$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($3824e46e58e663a3$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($3824e46e58e663a3$var$Zf(c)) return $3824e46e58e663a3$var$bg(a, c, b);
    }
    return b;
}
function $3824e46e58e663a3$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $3824e46e58e663a3$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $3824e46e58e663a3$var$el(null);
    c = a.current;
    d = $3824e46e58e663a3$var$L();
    e = $3824e46e58e663a3$var$lh(c);
    f = $3824e46e58e663a3$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $3824e46e58e663a3$var$dh(c, f, e);
    a.current.lanes = e;
    $3824e46e58e663a3$var$Ac(a, e, d);
    $3824e46e58e663a3$var$Ek(a, d);
    return a;
}
function $3824e46e58e663a3$var$gl(a, b, c, d) {
    var e = b.current, f = $3824e46e58e663a3$var$L(), g = $3824e46e58e663a3$var$lh(e);
    c = $3824e46e58e663a3$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $3824e46e58e663a3$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $3824e46e58e663a3$var$dh(e, b, g);
    null !== a && ($3824e46e58e663a3$var$mh(a, e, g, f), $3824e46e58e663a3$var$eh(a, e, g));
    return g;
}
function $3824e46e58e663a3$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $3824e46e58e663a3$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $3824e46e58e663a3$var$jl(a, b) {
    $3824e46e58e663a3$var$il(a, b);
    (a = a.alternate) && $3824e46e58e663a3$var$il(a, b);
}
function $3824e46e58e663a3$var$kl() {
    return null;
}
var $3824e46e58e663a3$var$ll = "function" === typeof reportError ? reportError : function ll(a) {
    console.error(a);
};
function $3824e46e58e663a3$var$ml(a) {
    this._internalRoot = a;
}
$3824e46e58e663a3$var$nl.prototype.render = $3824e46e58e663a3$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($3824e46e58e663a3$var$p(409));
    $3824e46e58e663a3$var$gl(a, b, null, null);
};
$3824e46e58e663a3$var$nl.prototype.unmount = $3824e46e58e663a3$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $3824e46e58e663a3$var$Sk(function() {
            $3824e46e58e663a3$var$gl(null, a, null, null);
        });
        b[$3824e46e58e663a3$var$uf] = null;
    }
};
function $3824e46e58e663a3$var$nl(a) {
    this._internalRoot = a;
}
$3824e46e58e663a3$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $3824e46e58e663a3$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $3824e46e58e663a3$var$Qc.length && 0 !== b && b < $3824e46e58e663a3$var$Qc[c].priority; c++);
        $3824e46e58e663a3$var$Qc.splice(c, 0, a);
        0 === c && $3824e46e58e663a3$var$Vc(a);
    }
};
function $3824e46e58e663a3$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $3824e46e58e663a3$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $3824e46e58e663a3$var$ql() {}
function $3824e46e58e663a3$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function d() {
                var _$a = $3824e46e58e663a3$var$hl(g);
                f.call(_$a);
            };
        }
        var g = $3824e46e58e663a3$var$fl(b, d, a, 0, null, !1, !1, "", $3824e46e58e663a3$var$ql);
        a._reactRootContainer = g;
        a[$3824e46e58e663a3$var$uf] = g.current;
        $3824e46e58e663a3$var$sf(8 === a.nodeType ? a.parentNode : a);
        $3824e46e58e663a3$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function d() {
            var _$a = $3824e46e58e663a3$var$hl(k);
            h.call(_$a);
        };
    }
    var k = $3824e46e58e663a3$var$cl(a, 0, !1, null, null, !1, !1, "", $3824e46e58e663a3$var$ql);
    a._reactRootContainer = k;
    a[$3824e46e58e663a3$var$uf] = k.current;
    $3824e46e58e663a3$var$sf(8 === a.nodeType ? a.parentNode : a);
    $3824e46e58e663a3$var$Sk(function() {
        $3824e46e58e663a3$var$gl(b, k, c, d);
    });
    return k;
}
function $3824e46e58e663a3$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function e() {
                var _$a = $3824e46e58e663a3$var$hl(g);
                h.call(_$a);
            };
        }
        $3824e46e58e663a3$var$gl(b, g, a, e);
    } else g = $3824e46e58e663a3$var$rl(c, b, a, e, d);
    return $3824e46e58e663a3$var$hl(g);
}
$3824e46e58e663a3$var$Ec = function Ec(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $3824e46e58e663a3$var$tc(b.pendingLanes);
                0 !== c && ($3824e46e58e663a3$var$Cc(b, c | 1), $3824e46e58e663a3$var$Ek(b, $3824e46e58e663a3$var$B()), 0 === ($3824e46e58e663a3$var$K & 6) && ($3824e46e58e663a3$var$Hj = $3824e46e58e663a3$var$B() + 500, $3824e46e58e663a3$var$jg()));
            }
            break;
        case 13:
            $3824e46e58e663a3$var$Sk(function() {
                var b = $3824e46e58e663a3$var$Zg(a, 1);
                if (null !== b) {
                    var c = $3824e46e58e663a3$var$L();
                    $3824e46e58e663a3$var$mh(b, a, 1, c);
                }
            }), $3824e46e58e663a3$var$jl(a, 1);
    }
};
$3824e46e58e663a3$var$Fc = function Fc(a) {
    if (13 === a.tag) {
        var b = $3824e46e58e663a3$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $3824e46e58e663a3$var$L();
            $3824e46e58e663a3$var$mh(b, a, 134217728, c);
        }
        $3824e46e58e663a3$var$jl(a, 134217728);
    }
};
$3824e46e58e663a3$var$Gc = function Gc(a) {
    if (13 === a.tag) {
        var b = $3824e46e58e663a3$var$lh(a), c = $3824e46e58e663a3$var$Zg(a, b);
        if (null !== c) {
            var d = $3824e46e58e663a3$var$L();
            $3824e46e58e663a3$var$mh(c, a, b, d);
        }
        $3824e46e58e663a3$var$jl(a, b);
    }
};
$3824e46e58e663a3$var$Hc = function Hc() {
    return $3824e46e58e663a3$var$C;
};
$3824e46e58e663a3$var$Ic = function Ic(a, b) {
    var c = $3824e46e58e663a3$var$C;
    try {
        return $3824e46e58e663a3$var$C = a, b();
    } finally{
        $3824e46e58e663a3$var$C = c;
    }
};
$3824e46e58e663a3$var$yb = function yb(a, b, c) {
    switch(b){
        case "input":
            $3824e46e58e663a3$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $3824e46e58e663a3$var$Db(d);
                        if (!e) throw Error($3824e46e58e663a3$var$p(90));
                        $3824e46e58e663a3$var$Wa(d);
                        $3824e46e58e663a3$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $3824e46e58e663a3$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $3824e46e58e663a3$var$fb(a, !!c.multiple, b, !1);
    }
};
$3824e46e58e663a3$var$Gb = $3824e46e58e663a3$var$Rk;
$3824e46e58e663a3$var$Hb = $3824e46e58e663a3$var$Sk;
var $3824e46e58e663a3$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $3824e46e58e663a3$var$Cb,
        $3824e46e58e663a3$var$ue,
        $3824e46e58e663a3$var$Db,
        $3824e46e58e663a3$var$Eb,
        $3824e46e58e663a3$var$Fb,
        $3824e46e58e663a3$var$Rk
    ]
}, $3824e46e58e663a3$var$ul = {
    findFiberByHostInstance: $3824e46e58e663a3$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $3824e46e58e663a3$var$vl = {
    bundleType: $3824e46e58e663a3$var$ul.bundleType,
    version: $3824e46e58e663a3$var$ul.version,
    rendererPackageName: $3824e46e58e663a3$var$ul.rendererPackageName,
    rendererConfig: $3824e46e58e663a3$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $3824e46e58e663a3$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function findHostInstanceByFiber(a) {
        a = $3824e46e58e663a3$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $3824e46e58e663a3$var$ul.findFiberByHostInstance || $3824e46e58e663a3$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $3824e46e58e663a3$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$3824e46e58e663a3$var$wl.isDisabled && $3824e46e58e663a3$var$wl.supportsFiber) try {
        $3824e46e58e663a3$var$kc = $3824e46e58e663a3$var$wl.inject($3824e46e58e663a3$var$vl), $3824e46e58e663a3$var$lc = $3824e46e58e663a3$var$wl;
    } catch (a) {}
}
$3824e46e58e663a3$export$ae55be85d98224ed = $3824e46e58e663a3$var$tl;
$3824e46e58e663a3$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$3824e46e58e663a3$var$ol(b)) throw Error($3824e46e58e663a3$var$p(200));
    return $3824e46e58e663a3$var$dl(a, b, null, c);
};
$3824e46e58e663a3$export$882461b6382ed46c = function(a, b) {
    if (!$3824e46e58e663a3$var$ol(a)) throw Error($3824e46e58e663a3$var$p(299));
    var c = !1, d = "", e = $3824e46e58e663a3$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $3824e46e58e663a3$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$3824e46e58e663a3$var$uf] = b.current;
    $3824e46e58e663a3$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $3824e46e58e663a3$var$ml(b);
};
$3824e46e58e663a3$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($3824e46e58e663a3$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($3824e46e58e663a3$var$p(268, a));
    }
    a = $3824e46e58e663a3$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$3824e46e58e663a3$export$cd75ccfd720a3cd4 = function(a) {
    return $3824e46e58e663a3$var$Sk(a);
};
$3824e46e58e663a3$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$3824e46e58e663a3$var$pl(b)) throw Error($3824e46e58e663a3$var$p(200));
    return $3824e46e58e663a3$var$sl(null, a, b, !0, c);
};
$3824e46e58e663a3$export$757ceba2d55c277e = function(a, b, c) {
    if (!$3824e46e58e663a3$var$ol(a)) throw Error($3824e46e58e663a3$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $3824e46e58e663a3$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $3824e46e58e663a3$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$3824e46e58e663a3$var$uf] = b.current;
    $3824e46e58e663a3$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $3824e46e58e663a3$var$nl(b);
};
$3824e46e58e663a3$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$3824e46e58e663a3$var$pl(b)) throw Error($3824e46e58e663a3$var$p(200));
    return $3824e46e58e663a3$var$sl(null, a, b, !1, c);
};
$3824e46e58e663a3$export$502457920280e6be = function(a) {
    if (!$3824e46e58e663a3$var$pl(a)) throw Error($3824e46e58e663a3$var$p(40));
    return a._reactRootContainer ? ($3824e46e58e663a3$var$Sk(function() {
        $3824e46e58e663a3$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$3824e46e58e663a3$var$uf] = null;
        });
    }), !0) : !1;
};
$3824e46e58e663a3$export$c78a37762a8d58e1 = $3824e46e58e663a3$var$Rk;
$3824e46e58e663a3$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$3824e46e58e663a3$var$pl(c)) throw Error($3824e46e58e663a3$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($3824e46e58e663a3$var$p(38));
    return $3824e46e58e663a3$var$sl(a, b, c, !1, d);
};
$3824e46e58e663a3$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("bv0px", function(module, exports) {
"use strict";

module.exports = (parcelRequire("3xuNW"));

});
parcelRegister("3xuNW", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $293c59471acf4432$export$c4744153514ff05d; }, function (v) { return $293c59471acf4432$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $293c59471acf4432$export$3e506c1ccc9cc1a7; }, function (v) { return $293c59471acf4432$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $293c59471acf4432$export$e26fe2ed2fa76875; }, function (v) { return $293c59471acf4432$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $293c59471acf4432$export$502329bbf4b505b1; }, function (v) { return $293c59471acf4432$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $293c59471acf4432$export$6e3807111c4874c4; }, function (v) { return $293c59471acf4432$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $293c59471acf4432$export$c27134553091fb3a; }, function (v) { return $293c59471acf4432$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $293c59471acf4432$export$33ee1acdc04fd2a2; }, function (v) { return $293c59471acf4432$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $293c59471acf4432$export$b00a404bbd5edef2; }, function (v) { return $293c59471acf4432$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $293c59471acf4432$export$8352ce38b91d0c62; }, function (v) { return $293c59471acf4432$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $293c59471acf4432$export$d66a1c1c77bd778b; }, function (v) { return $293c59471acf4432$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $293c59471acf4432$export$d3dfb8e4810cb555; }, function (v) { return $293c59471acf4432$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $293c59471acf4432$export$839f9183b0465a69; }, function (v) { return $293c59471acf4432$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $293c59471acf4432$export$72fdf0e06517287b; }, function (v) { return $293c59471acf4432$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $293c59471acf4432$export$4b844e58a3e414b4; }, function (v) { return $293c59471acf4432$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $293c59471acf4432$export$816d2913ae6b83b1; }, function (v) { return $293c59471acf4432$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $293c59471acf4432$export$61bcfe829111a1d0; }, function (v) { return $293c59471acf4432$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $293c59471acf4432$export$7ee8c9beb337bc3f; }, function (v) { return $293c59471acf4432$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $293c59471acf4432$export$b5836b71941fa3ed; }, function (v) { return $293c59471acf4432$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $293c59471acf4432$export$cf845f2c119da08a; }, function (v) { return $293c59471acf4432$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $293c59471acf4432$export$c4744153514ff05d;
var $293c59471acf4432$export$3e506c1ccc9cc1a7;
var $293c59471acf4432$export$e26fe2ed2fa76875;
var $293c59471acf4432$export$502329bbf4b505b1;
var $293c59471acf4432$export$6e3807111c4874c4;
var $293c59471acf4432$export$c27134553091fb3a;
var $293c59471acf4432$export$33ee1acdc04fd2a2;
var $293c59471acf4432$export$b00a404bbd5edef2;
var $293c59471acf4432$export$8352ce38b91d0c62;
var $293c59471acf4432$export$d66a1c1c77bd778b;
var $293c59471acf4432$export$d3dfb8e4810cb555;
var $293c59471acf4432$export$839f9183b0465a69;
var $293c59471acf4432$export$72fdf0e06517287b;
var $293c59471acf4432$export$4b844e58a3e414b4;
var $293c59471acf4432$export$816d2913ae6b83b1;
var $293c59471acf4432$export$61bcfe829111a1d0;
var $293c59471acf4432$export$7ee8c9beb337bc3f;
var $293c59471acf4432$export$b5836b71941fa3ed;
var $293c59471acf4432$export$cf845f2c119da08a;
"use strict";
function $293c59471acf4432$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $293c59471acf4432$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $293c59471acf4432$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $293c59471acf4432$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $293c59471acf4432$var$g(C, c)) n < e && 0 > $293c59471acf4432$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $293c59471acf4432$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $293c59471acf4432$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $293c59471acf4432$var$l = performance;
    $293c59471acf4432$export$c4744153514ff05d = function() {
        return $293c59471acf4432$var$l.now();
    };
} else {
    var $293c59471acf4432$var$p = Date, $293c59471acf4432$var$q = $293c59471acf4432$var$p.now();
    $293c59471acf4432$export$c4744153514ff05d = function() {
        return $293c59471acf4432$var$p.now() - $293c59471acf4432$var$q;
    };
}
var $293c59471acf4432$var$r = [], $293c59471acf4432$var$t = [], $293c59471acf4432$var$u = 1, $293c59471acf4432$var$v = null, $293c59471acf4432$var$y = 3, $293c59471acf4432$var$z = !1, $293c59471acf4432$var$A = !1, $293c59471acf4432$var$B = !1, $293c59471acf4432$var$D = "function" === typeof setTimeout ? setTimeout : null, $293c59471acf4432$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $293c59471acf4432$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $293c59471acf4432$var$G(a) {
    for(var b = $293c59471acf4432$var$h($293c59471acf4432$var$t); null !== b;){
        if (null === b.callback) $293c59471acf4432$var$k($293c59471acf4432$var$t);
        else if (b.startTime <= a) $293c59471acf4432$var$k($293c59471acf4432$var$t), b.sortIndex = b.expirationTime, $293c59471acf4432$var$f($293c59471acf4432$var$r, b);
        else break;
        b = $293c59471acf4432$var$h($293c59471acf4432$var$t);
    }
}
function $293c59471acf4432$var$H(a) {
    $293c59471acf4432$var$B = !1;
    $293c59471acf4432$var$G(a);
    if (!$293c59471acf4432$var$A) {
        if (null !== $293c59471acf4432$var$h($293c59471acf4432$var$r)) $293c59471acf4432$var$A = !0, $293c59471acf4432$var$I($293c59471acf4432$var$J);
        else {
            var b = $293c59471acf4432$var$h($293c59471acf4432$var$t);
            null !== b && $293c59471acf4432$var$K($293c59471acf4432$var$H, b.startTime - a);
        }
    }
}
function $293c59471acf4432$var$J(a, b) {
    $293c59471acf4432$var$A = !1;
    $293c59471acf4432$var$B && ($293c59471acf4432$var$B = !1, $293c59471acf4432$var$E($293c59471acf4432$var$L), $293c59471acf4432$var$L = -1);
    $293c59471acf4432$var$z = !0;
    var c = $293c59471acf4432$var$y;
    try {
        $293c59471acf4432$var$G(b);
        for($293c59471acf4432$var$v = $293c59471acf4432$var$h($293c59471acf4432$var$r); null !== $293c59471acf4432$var$v && (!($293c59471acf4432$var$v.expirationTime > b) || a && !$293c59471acf4432$var$M());){
            var d = $293c59471acf4432$var$v.callback;
            if ("function" === typeof d) {
                $293c59471acf4432$var$v.callback = null;
                $293c59471acf4432$var$y = $293c59471acf4432$var$v.priorityLevel;
                var e = d($293c59471acf4432$var$v.expirationTime <= b);
                b = $293c59471acf4432$export$c4744153514ff05d();
                "function" === typeof e ? $293c59471acf4432$var$v.callback = e : $293c59471acf4432$var$v === $293c59471acf4432$var$h($293c59471acf4432$var$r) && $293c59471acf4432$var$k($293c59471acf4432$var$r);
                $293c59471acf4432$var$G(b);
            } else $293c59471acf4432$var$k($293c59471acf4432$var$r);
            $293c59471acf4432$var$v = $293c59471acf4432$var$h($293c59471acf4432$var$r);
        }
        if (null !== $293c59471acf4432$var$v) var w = !0;
        else {
            var m = $293c59471acf4432$var$h($293c59471acf4432$var$t);
            null !== m && $293c59471acf4432$var$K($293c59471acf4432$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $293c59471acf4432$var$v = null, $293c59471acf4432$var$y = c, $293c59471acf4432$var$z = !1;
    }
}
var $293c59471acf4432$var$N = !1, $293c59471acf4432$var$O = null, $293c59471acf4432$var$L = -1, $293c59471acf4432$var$P = 5, $293c59471acf4432$var$Q = -1;
function $293c59471acf4432$var$M() {
    return $293c59471acf4432$export$c4744153514ff05d() - $293c59471acf4432$var$Q < $293c59471acf4432$var$P ? !1 : !0;
}
function $293c59471acf4432$var$R() {
    if (null !== $293c59471acf4432$var$O) {
        var a = $293c59471acf4432$export$c4744153514ff05d();
        $293c59471acf4432$var$Q = a;
        var b = !0;
        try {
            b = $293c59471acf4432$var$O(!0, a);
        } finally{
            b ? $293c59471acf4432$var$S() : ($293c59471acf4432$var$N = !1, $293c59471acf4432$var$O = null);
        }
    } else $293c59471acf4432$var$N = !1;
}
var $293c59471acf4432$var$S;
if ("function" === typeof $293c59471acf4432$var$F) $293c59471acf4432$var$S = function S() {
    $293c59471acf4432$var$F($293c59471acf4432$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $293c59471acf4432$var$T = new MessageChannel, $293c59471acf4432$var$U = $293c59471acf4432$var$T.port2;
    $293c59471acf4432$var$T.port1.onmessage = $293c59471acf4432$var$R;
    $293c59471acf4432$var$S = function S() {
        $293c59471acf4432$var$U.postMessage(null);
    };
} else $293c59471acf4432$var$S = function S() {
    $293c59471acf4432$var$D($293c59471acf4432$var$R, 0);
};
function $293c59471acf4432$var$I(a) {
    $293c59471acf4432$var$O = a;
    $293c59471acf4432$var$N || ($293c59471acf4432$var$N = !0, $293c59471acf4432$var$S());
}
function $293c59471acf4432$var$K(a, b) {
    $293c59471acf4432$var$L = $293c59471acf4432$var$D(function() {
        a($293c59471acf4432$export$c4744153514ff05d());
    }, b);
}
$293c59471acf4432$export$3e506c1ccc9cc1a7 = 5;
$293c59471acf4432$export$e26fe2ed2fa76875 = 1;
$293c59471acf4432$export$502329bbf4b505b1 = 4;
$293c59471acf4432$export$6e3807111c4874c4 = 3;
$293c59471acf4432$export$c27134553091fb3a = null;
$293c59471acf4432$export$33ee1acdc04fd2a2 = 2;
$293c59471acf4432$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$293c59471acf4432$export$8352ce38b91d0c62 = function() {
    $293c59471acf4432$var$A || $293c59471acf4432$var$z || ($293c59471acf4432$var$A = !0, $293c59471acf4432$var$I($293c59471acf4432$var$J));
};
$293c59471acf4432$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $293c59471acf4432$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$293c59471acf4432$export$d3dfb8e4810cb555 = function() {
    return $293c59471acf4432$var$y;
};
$293c59471acf4432$export$839f9183b0465a69 = function() {
    return $293c59471acf4432$var$h($293c59471acf4432$var$r);
};
$293c59471acf4432$export$72fdf0e06517287b = function(a) {
    switch($293c59471acf4432$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $293c59471acf4432$var$y;
    }
    var c = $293c59471acf4432$var$y;
    $293c59471acf4432$var$y = b;
    try {
        return a();
    } finally{
        $293c59471acf4432$var$y = c;
    }
};
$293c59471acf4432$export$4b844e58a3e414b4 = function() {};
$293c59471acf4432$export$816d2913ae6b83b1 = function() {};
$293c59471acf4432$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $293c59471acf4432$var$y;
    $293c59471acf4432$var$y = a;
    try {
        return b();
    } finally{
        $293c59471acf4432$var$y = c;
    }
};
$293c59471acf4432$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $293c59471acf4432$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $293c59471acf4432$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $293c59471acf4432$var$f($293c59471acf4432$var$t, a), null === $293c59471acf4432$var$h($293c59471acf4432$var$r) && a === $293c59471acf4432$var$h($293c59471acf4432$var$t) && ($293c59471acf4432$var$B ? ($293c59471acf4432$var$E($293c59471acf4432$var$L), $293c59471acf4432$var$L = -1) : $293c59471acf4432$var$B = !0, $293c59471acf4432$var$K($293c59471acf4432$var$H, c - d))) : (a.sortIndex = e, $293c59471acf4432$var$f($293c59471acf4432$var$r, a), $293c59471acf4432$var$A || $293c59471acf4432$var$z || ($293c59471acf4432$var$A = !0, $293c59471acf4432$var$I($293c59471acf4432$var$J)));
    return a;
};
$293c59471acf4432$export$b5836b71941fa3ed = $293c59471acf4432$var$M;
$293c59471acf4432$export$cf845f2c119da08a = function(a) {
    var b = $293c59471acf4432$var$y;
    return function() {
        var c = $293c59471acf4432$var$y;
        $293c59471acf4432$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $293c59471acf4432$var$y = c;
        }
    };
};

});



parcelRegister("h8OFX", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $c7aa7e29c029cbec$export$bf730a2d8bf68b42; }, function (v) { return $c7aa7e29c029cbec$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c7aa7e29c029cbec$export$bf730a2d8bf68b42;
"use strict";

var $4Bt61 = parcelRequire("4Bt61");
function $c7aa7e29c029cbec$var$n(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $c7aa7e29c029cbec$var$p = "function" === typeof Object.is ? Object.is : $c7aa7e29c029cbec$var$n, $c7aa7e29c029cbec$var$q = $4Bt61.useSyncExternalStore, $c7aa7e29c029cbec$var$r = $4Bt61.useRef, $c7aa7e29c029cbec$var$t = $4Bt61.useEffect, $c7aa7e29c029cbec$var$u = $4Bt61.useMemo, $c7aa7e29c029cbec$var$v = $4Bt61.useDebugValue;
$c7aa7e29c029cbec$export$bf730a2d8bf68b42 = function(a, b, e, l, h) {
    var c = $c7aa7e29c029cbec$var$r(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $c7aa7e29c029cbec$var$u(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== h && f.hasValue) {
                    var _$b = f.value;
                    if (h(_$b, a)) return k = _$b;
                }
                return k = a;
            }
            _$b = k;
            if ($c7aa7e29c029cbec$var$p(d, a)) return _$b;
            var _$e = l(a);
            if (void 0 !== h && h(_$b, _$e)) return _$b;
            d = a;
            return k = _$e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        h
    ]);
    var d = $c7aa7e29c029cbec$var$q(a, c[0], c[1]);
    $c7aa7e29c029cbec$var$t(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $c7aa7e29c029cbec$var$v(d);
    return d;
};

});

parcelRegister("64DyZ", function(module, exports) {

$parcel$export(module.exports, "isDraft", function () { return isDraft; });
$parcel$export(module.exports, "isDraftable", function () { return isDraftable; });
$parcel$export(module.exports, "current", function () { return current; });
$parcel$export(module.exports, "produce", function () { return produce; });

var $cOYso = parcelRequire("cOYso");

var $aliU1 = parcelRequire("aliU1");

var $bMpTA = parcelRequire("bMpTA");

var $73NPw = parcelRequire("73NPw");

var $fZ5u7 = parcelRequire("fZ5u7");

var $f9AIs = parcelRequire("f9AIs");

var $1SMDP = parcelRequire("1SMDP");

var $6zqIC = parcelRequire("6zqIC");

var $6HjaD = parcelRequire("6HjaD");

var $9j1tP = parcelRequire("9j1tP");
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function(obj, key, value) {
    return key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var __spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (__getOwnPropSymbols) try {
        for(var _iterator = __getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return a;
};
// src/utils/env.ts
var NOTHING = Symbol.for("immer-nothing");
var DRAFTABLE = Symbol.for("immer-draftable");
var DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var errors = [];
function die(error) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    throw new Error("[Immer] minified error nr: ".concat(error, ". Full error at: https://bit.ly/3cXEKWf"));
}
// src/utils/common.ts
var getPrototypeOf = Object.getPrototypeOf;
function isDraft(value) {
    return !!value && !!value[DRAFT_STATE];
}
function isDraftable(value) {
    var _a;
    if (!value) return false;
    return isPlainObject(value) || Array.isArray(value) || !!value[DRAFTABLE] || !!((_a = value.constructor) == null ? void 0 : _a[DRAFTABLE]) || isMap(value) || isSet(value);
}
var objectCtorString = Object.prototype.constructor.toString();
function isPlainObject(value) {
    if (!value || typeof value !== "object") return false;
    var proto = getPrototypeOf(value);
    if (proto === null) return true;
    var Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    if (Ctor === Object) return true;
    return typeof Ctor == "function" && Function.toString.call(Ctor) === objectCtorString;
}
function original(value) {
    if (!isDraft(value)) die(15, value);
    return value[DRAFT_STATE].base_;
}
function each(obj, iter) {
    if (getArchtype(obj) === 0 /* Object */ ) Reflect.ownKeys(obj).forEach(function(key) {
        iter(key, obj[key], obj);
    });
    else obj.forEach(function(entry, index) {
        return iter(index, entry, obj);
    });
}
function getArchtype(thing) {
    var state = thing[DRAFT_STATE];
    return state ? state.type_ : Array.isArray(thing) ? 1 /* Array */  : isMap(thing) ? 2 /* Map */  : isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
function has(thing, prop) {
    return getArchtype(thing) === 2 /* Map */  ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function get(thing, prop) {
    return getArchtype(thing) === 2 /* Map */  ? thing.get(prop) : thing[prop];
}
function set(thing, propOrOldValue, value) {
    var t = getArchtype(thing);
    if (t === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (t === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
}
function is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function isMap(target) {
    return target instanceof Map;
}
function isSet(target) {
    return target instanceof Set;
}
function latest(state) {
    return state.copy_ || state.base_;
}
function shallowCopy(base, strict) {
    if (isMap(base)) return new Map(base);
    if (isSet(base)) return new Set(base);
    if (Array.isArray(base)) return Array.prototype.slice.call(base);
    var isPlain = isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        var descriptors = Object.getOwnPropertyDescriptors(base);
        delete descriptors[DRAFT_STATE];
        var keys = Reflect.ownKeys(descriptors);
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            var desc = descriptors[key];
            if (desc.writable === false) {
                desc.writable = true;
                desc.configurable = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                configurable: true,
                writable: true,
                // could live with !!desc.set as well here...
                enumerable: desc.enumerable,
                value: base[key]
            };
        }
        return Object.create(getPrototypeOf(base), descriptors);
    } else {
        var proto = getPrototypeOf(base);
        if (proto !== null && isPlain) return __spreadValues({}, base);
        var obj = Object.create(proto);
        return Object.assign(obj, base);
    }
}
function freeze(obj) {
    var deep = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (isFrozen(obj) || isDraft(obj) || !isDraftable(obj)) return obj;
    if (getArchtype(obj) > 1) obj.set = obj.add = obj.clear = obj.delete = dontMutateFrozenCollections;
    Object.freeze(obj);
    if (deep) Object.entries(obj).forEach(function(param) {
        var _param = (0, $f9AIs._)(param, 2), key = _param[0], value = _param[1];
        return freeze(value, true);
    });
    return obj;
}
function dontMutateFrozenCollections() {
    die(2);
}
function isFrozen(obj) {
    return Object.isFrozen(obj);
}
// src/utils/plugins.ts
var plugins = {};
function getPlugin(pluginKey) {
    var plugin = plugins[pluginKey];
    if (!plugin) die(0, pluginKey);
    return plugin;
}
function loadPlugin(pluginKey, implementation) {
    if (!plugins[pluginKey]) plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var currentScope;
function getCurrentScope() {
    return currentScope;
}
function createScope(parent_, immer_) {
    return {
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0
    };
}
function usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        getPlugin("Patches");
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function revokeScope(scope) {
    leaveScope(scope);
    scope.drafts_.forEach(revokeDraft);
    scope.drafts_ = null;
}
function leaveScope(scope) {
    if (scope === currentScope) currentScope = scope.parent_;
}
function enterScope(immer2) {
    return currentScope = createScope(currentScope, immer2);
}
function revokeDraft(draft) {
    var state = draft[DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    var baseDraft = scope.drafts_[0];
    var isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[DRAFT_STATE].modified_) {
            revokeScope(scope);
            die(4);
        }
        if (isDraftable(result)) {
            result = finalize(scope, result);
            if (!scope.parent_) maybeFreeze(scope, result);
        }
        if (scope.patches_) getPlugin("Patches").generateReplacementPatches_(baseDraft[DRAFT_STATE].base_, result, scope.patches_, scope.inversePatches_);
    } else result = finalize(scope, baseDraft, []);
    revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== NOTHING ? result : void 0;
}
function finalize(rootScope, value, path) {
    if (isFrozen(value)) return value;
    var state = value[DRAFT_STATE];
    if (!state) {
        each(value, function(key, childValue) {
            return finalizeProperty(rootScope, state, value, key, childValue, path);
        });
        return value;
    }
    if (state.scope_ !== rootScope) return value;
    if (!state.modified_) {
        maybeFreeze(rootScope, state.base_, true);
        return state.base_;
    }
    if (!state.finalized_) {
        state.finalized_ = true;
        state.scope_.unfinalizedDrafts_--;
        var result = state.copy_;
        var resultEach = result;
        var isSet2 = false;
        if (state.type_ === 3 /* Set */ ) {
            resultEach = new Set(result);
            result.clear();
            isSet2 = true;
        }
        each(resultEach, function(key, childValue) {
            return finalizeProperty(rootScope, state, result, key, childValue, path, isSet2);
        });
        maybeFreeze(rootScope, result, false);
        if (path && rootScope.patches_) getPlugin("Patches").generatePatches_(state, path, rootScope.patches_, rootScope.inversePatches_);
    }
    return state.copy_;
}
function finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
    if (isDraft(childValue)) {
        var path = rootPath && parentState && parentState.type_ !== 3 /* Set */  && // Set objects are atomic since they have no keys.
        !has(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
        var res = finalize(rootScope, childValue, path);
        set(targetObject, prop, res);
        if (isDraft(res)) rootScope.canAutoFreeze_ = false;
        else return;
    } else if (targetIsSet) targetObject.add(childValue);
    if (isDraftable(childValue) && !isFrozen(childValue)) {
        if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return;
        finalize(rootScope, childValue);
        if ((!parentState || !parentState.scope_.parent_) && (typeof prop === "undefined" ? "undefined" : (0, $6zqIC._)(prop)) !== "symbol" && Object.prototype.propertyIsEnumerable.call(targetObject, prop)) maybeFreeze(rootScope, childValue);
    }
}
function maybeFreeze(scope, value) {
    var deep = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) freeze(value, deep);
}
// src/core/proxy.ts
function createProxyProxy(base, parent) {
    var isArray = Array.isArray(base);
    var state = {
        type_: isArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        assigned_: {},
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false
    };
    var target = state;
    var traps = objectTraps;
    if (isArray) {
        target = [
            state
        ];
        traps = arrayTraps;
    }
    var _Proxy_revocable = Proxy.revocable(target, traps), revoke = _Proxy_revocable.revoke, proxy = _Proxy_revocable.proxy;
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return proxy;
}
var objectTraps = {
    get: function(state, prop) {
        if (prop === DRAFT_STATE) return state;
        var source = latest(state);
        if (!has(source, prop)) return readPropFromProto(state, source, prop);
        var value = source[prop];
        if (state.finalized_ || !isDraftable(value)) return value;
        if (value === peek(state.base_, prop)) {
            prepareCopy(state);
            return state.copy_[prop] = createProxy(value, state);
        }
        return value;
    },
    has: function(state, prop) {
        return prop in latest(state);
    },
    ownKeys: function(state) {
        return Reflect.ownKeys(latest(state));
    },
    set: function(state, prop, value) {
        var desc = getDescriptorFromProto(latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            var current2 = peek(latest(state), prop);
            var currentState = current2 == null ? void 0 : current2[DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_[prop] = false;
                return true;
            }
            if (is(value, current2) && (value !== void 0 || has(state.base_, prop))) return true;
            prepareCopy(state);
            markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_[prop] = true;
        return true;
    },
    deleteProperty: function(state, prop) {
        if (peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_[prop] = false;
            prepareCopy(state);
            markChanged(state);
        } else delete state.assigned_[prop];
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor: function(state, prop) {
        var owner = latest(state);
        var desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            writable: true,
            configurable: state.type_ !== 1 /* Array */  || prop !== "length",
            enumerable: desc.enumerable,
            value: owner[prop]
        };
    },
    defineProperty: function() {
        die(11);
    },
    getPrototypeOf: function(state) {
        return getPrototypeOf(state.base_);
    },
    setPrototypeOf: function() {
        die(12);
    }
};
var arrayTraps = {};
each(objectTraps, function(key, fn) {
    arrayTraps[key] = function() {
        arguments[0] = arguments[0][0];
        return fn.apply(this, arguments);
    };
});
arrayTraps.deleteProperty = function(state, prop) {
    return arrayTraps.set.call(this, state, prop, void 0);
};
arrayTraps.set = function(state, prop, value) {
    return objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function peek(draft, prop) {
    var state = draft[DRAFT_STATE];
    var source = state ? latest(state) : draft;
    return source[prop];
}
function readPropFromProto(state, source, prop) {
    var _a;
    var desc = getDescriptorFromProto(source, prop);
    return desc ? "value" in desc ? desc.value : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    var proto = getPrototypeOf(source);
    while(proto){
        var desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = getPrototypeOf(proto);
    }
    return void 0;
}
function markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) markChanged(state.parent_);
    }
}
function prepareCopy(state) {
    if (!state.copy_) state.copy_ = shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
}
// src/core/immerClass.ts
var Immer2 = /*#__PURE__*/ function() {
    "use strict";
    function Immer2(config) {
        var _this = this;
        (0, $aliU1._)(this, Immer2);
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = function(base, recipe, patchListener) {
            if (typeof base === "function" && typeof recipe !== "function") {
                var defaultBase = recipe;
                recipe = base;
                var self = _this;
                return function curriedProduce() {
                    var _this = this;
                    var base2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultBase;
                    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                        args[_key - 1] = arguments[_key];
                    }
                    var _recipe;
                    return self.produce(base2, function(draft) {
                        return (_recipe = recipe).call.apply(_recipe, [
                            _this,
                            draft
                        ].concat((0, $1SMDP._)(args)));
                    });
                };
            }
            if (typeof recipe !== "function") die(6);
            if (patchListener !== void 0 && typeof patchListener !== "function") die(7);
            var result;
            if (isDraftable(base)) {
                var scope = enterScope(_this);
                var proxy = createProxy(base, void 0);
                var hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) revokeScope(scope);
                    else leaveScope(scope);
                }
                usePatchesInScope(scope, patchListener);
                return processResult(result, scope);
            } else if (!base || typeof base !== "object") {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === NOTHING) result = void 0;
                if (_this.autoFreeze_) freeze(result, true);
                if (patchListener) {
                    var p = [];
                    var ip = [];
                    getPlugin("Patches").generateReplacementPatches_(base, result, p, ip);
                    patchListener(p, ip);
                }
                return result;
            } else die(1, base);
        };
        this.produceWithPatches = function(base, recipe) {
            var _this1 = _this;
            if (typeof base === "function") return function(state) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                return _this1.produceWithPatches(state, function(draft) {
                    return base.apply(void 0, [
                        draft
                    ].concat((0, $1SMDP._)(args)));
                });
            };
            var patches, inversePatches;
            var result = _this.produce(base, recipe, function(p, ip) {
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if (typeof (config == null ? void 0 : config.autoFreeze) === "boolean") this.setAutoFreeze(config.autoFreeze);
        if (typeof (config == null ? void 0 : config.useStrictShallowCopy) === "boolean") this.setUseStrictShallowCopy(config.useStrictShallowCopy);
    }
    (0, $bMpTA._)(Immer2, [
        {
            key: "createDraft",
            value: function createDraft(base) {
                if (!isDraftable(base)) die(8);
                if (isDraft(base)) base = current(base);
                var scope = enterScope(this);
                var proxy = createProxy(base, void 0);
                proxy[DRAFT_STATE].isManual_ = true;
                leaveScope(scope);
                return proxy;
            }
        },
        {
            key: "finishDraft",
            value: function finishDraft(draft, patchListener) {
                var state = draft && draft[DRAFT_STATE];
                if (!state || !state.isManual_) die(9);
                var scope = state.scope_;
                usePatchesInScope(scope, patchListener);
                return processResult(void 0, scope);
            }
        },
        {
            /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ key: "setAutoFreeze",
            value: function setAutoFreeze(value) {
                this.autoFreeze_ = value;
            }
        },
        {
            /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ key: "setUseStrictShallowCopy",
            value: function setUseStrictShallowCopy(value) {
                this.useStrictShallowCopy_ = value;
            }
        },
        {
            key: "applyPatches",
            value: function applyPatches(base, patches) {
                var i;
                for(i = patches.length - 1; i >= 0; i--){
                    var patch = patches[i];
                    if (patch.path.length === 0 && patch.op === "replace") {
                        base = patch.value;
                        break;
                    }
                }
                if (i > -1) patches = patches.slice(i + 1);
                var applyPatchesImpl = getPlugin("Patches").applyPatches_;
                if (isDraft(base)) return applyPatchesImpl(base, patches);
                return this.produce(base, function(draft) {
                    return applyPatchesImpl(draft, patches);
                });
            }
        }
    ]);
    return Immer2;
}();
function createProxy(value, parent) {
    var draft = isMap(value) ? getPlugin("MapSet").proxyMap_(value, parent) : isSet(value) ? getPlugin("MapSet").proxySet_(value, parent) : createProxyProxy(value, parent);
    var scope = parent ? parent.scope_ : getCurrentScope();
    scope.drafts_.push(draft);
    return draft;
}
// src/core/current.ts
function current(value) {
    if (!isDraft(value)) die(10, value);
    return currentImpl(value);
}
function currentImpl(value) {
    if (!isDraftable(value) || isFrozen(value)) return value;
    var state = value[DRAFT_STATE];
    var copy;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
    } else copy = shallowCopy(value, true);
    each(copy, function(key, childValue) {
        set(copy, key, currentImpl(childValue));
    });
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function enablePatches() {
    var errorOffset = 16;
    var REPLACE = "replace";
    var ADD = "add";
    var REMOVE = "remove";
    function generatePatches_(state, basePath, patches, inversePatches) {
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches, inversePatches);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches, inversePatches);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches, inversePatches);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        var base_ = state.base_, assigned_ = state.assigned_;
        var copy_ = state.copy_;
        if (copy_.length < base_.length) {
            var ref;
            ref = [
                copy_,
                base_
            ], base_ = ref[0], copy_ = ref[1], ref;
            var ref1;
            ref1 = [
                inversePatches,
                patches
            ], patches = ref1[0], inversePatches = ref1[1], ref1;
        }
        for(var i = 0; i < base_.length; i++)if (assigned_[i] && copy_[i] !== base_[i]) {
            var path = basePath.concat([
                i
            ]);
            patches.push({
                op: REPLACE,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
            inversePatches.push({
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(base_[i])
            });
        }
        for(var i1 = base_.length; i1 < copy_.length; i1++){
            var path1 = basePath.concat([
                i1
            ]);
            patches.push({
                op: ADD,
                path: path1,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i1])
            });
        }
        for(var i2 = copy_.length - 1; base_.length <= i2; --i2){
            var path2 = basePath.concat([
                i2
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path2
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        var base_ = state.base_, copy_ = state.copy_;
        each(state.assigned_, function(key, assignedValue) {
            var origValue = get(base_, key);
            var value = get(copy_, key);
            var op = !assignedValue ? REMOVE : has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            var path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: value
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        var base_ = state.base_, copy_ = state.copy_;
        var i = 0;
        base_.forEach(function(value) {
            if (!copy_.has(value)) {
                var path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach(function(value) {
            if (!base_.has(value)) {
                var path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, patches, inversePatches) {
        patches.push({
            op: REPLACE,
            path: [],
            value: replacement === NOTHING ? void 0 : replacement
        });
        inversePatches.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach(function(patch) {
            var path = patch.path, op = patch.op;
            var base = draft;
            for(var i = 0; i < path.length - 1; i++){
                var parentType = getArchtype(base);
                var p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === "constructor")) die(errorOffset + 3);
                if (typeof base === "function" && p === "prototype") die(errorOffset + 3);
                base = get(base, p);
                if (typeof base !== "object") die(errorOffset + 2, path.join("/"));
            }
            var type = getArchtype(base);
            var value = deepClonePatchValue(patch.value);
            var key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!isDraftable(obj)) return obj;
        if (Array.isArray(obj)) return obj.map(deepClonePatchValue);
        if (isMap(obj)) return new Map(Array.from(obj.entries()).map(function(param) {
            var _param = (0, $f9AIs._)(param, 2), k = _param[0], v = _param[1];
            return [
                k,
                deepClonePatchValue(v)
            ];
        }));
        if (isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        var cloned = Object.create(getPrototypeOf(obj));
        for(var key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if (has(obj, DRAFTABLE)) cloned[DRAFTABLE] = obj[DRAFTABLE];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if (isDraft(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    loadPlugin("Patches", {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_
    });
}
// src/plugins/mapset.ts
function enableMapSet() {
    var DraftMap = /*#__PURE__*/ function(Map1) {
        "use strict";
        (0, $fZ5u7._)(DraftMap, Map1);
        var _super = (0, $9j1tP._)(DraftMap);
        function DraftMap(target, parent) {
            (0, $aliU1._)(this, DraftMap);
            var _this;
            _this = _super.call(this);
            _this[DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: (0, $cOYso._)(_this),
                isManual_: false,
                revoked_: false
            };
            return _this;
        }
        (0, $bMpTA._)(DraftMap, [
            {
                key: "size",
                get: function get() {
                    return latest(this[DRAFT_STATE]).size;
                }
            },
            {
                key: "has",
                value: function has(key) {
                    return latest(this[DRAFT_STATE]).has(key);
                }
            },
            {
                key: "set",
                value: function set(key, value) {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    if (!latest(state).has(key) || latest(state).get(key) !== value) {
                        prepareMapCopy(state);
                        markChanged(state);
                        state.assigned_.set(key, true);
                        state.copy_.set(key, value);
                        state.assigned_.set(key, true);
                    }
                    return this;
                }
            },
            {
                key: "delete",
                value: function _delete(key) {
                    if (!this.has(key)) return false;
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    prepareMapCopy(state);
                    markChanged(state);
                    if (state.base_.has(key)) state.assigned_.set(key, false);
                    else state.assigned_.delete(key);
                    state.copy_.delete(key);
                    return true;
                }
            },
            {
                key: "clear",
                value: function clear() {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    if (latest(state).size) {
                        prepareMapCopy(state);
                        markChanged(state);
                        state.assigned_ = /* @__PURE__ */ new Map();
                        each(state.base_, function(key) {
                            state.assigned_.set(key, false);
                        });
                        state.copy_.clear();
                    }
                }
            },
            {
                key: "forEach",
                value: function forEach(cb, thisArg) {
                    var _this = this;
                    var state = this[DRAFT_STATE];
                    latest(state).forEach(function(_value, key, _map) {
                        cb.call(thisArg, _this.get(key), key, _this);
                    });
                }
            },
            {
                key: "get",
                value: function get(key) {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    var value = latest(state).get(key);
                    if (state.finalized_ || !isDraftable(value)) return value;
                    if (value !== state.base_.get(key)) return value;
                    var draft = createProxy(value, state);
                    prepareMapCopy(state);
                    state.copy_.set(key, draft);
                    return draft;
                }
            },
            {
                key: "keys",
                value: function keys() {
                    return latest(this[DRAFT_STATE]).keys();
                }
            },
            {
                key: "values",
                value: function values() {
                    var _this = this;
                    var iterator = this.keys();
                    var _obj;
                    return _obj = {}, (0, $73NPw._)(_obj, Symbol.iterator, function() {
                        return _this.values();
                    }), (0, $73NPw._)(_obj, "next", function() {
                        var r = iterator.next();
                        if (r.done) return r;
                        var value = _this.get(r.value);
                        return {
                            done: false,
                            value: value
                        };
                    }), _obj;
                }
            },
            {
                key: "entries",
                value: function entries() {
                    var _this = this;
                    var iterator = this.keys();
                    var _obj;
                    return _obj = {}, (0, $73NPw._)(_obj, Symbol.iterator, function() {
                        return _this.entries();
                    }), (0, $73NPw._)(_obj, "next", function() {
                        var r = iterator.next();
                        if (r.done) return r;
                        var value = _this.get(r.value);
                        return {
                            done: false,
                            value: [
                                r.value,
                                value
                            ]
                        };
                    }), _obj;
                }
            },
            {
                key: (DRAFT_STATE, Symbol.iterator),
                value: function value() {
                    return this.entries();
                }
            }
        ]);
        return DraftMap;
    }((0, $6HjaD._)(Map));
    function proxyMap_(target, parent) {
        return new DraftMap(target, parent);
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    var DraftSet = /*#__PURE__*/ function(Set1) {
        "use strict";
        (0, $fZ5u7._)(DraftSet, Set1);
        var _super = (0, $9j1tP._)(DraftSet);
        function DraftSet(target, parent) {
            (0, $aliU1._)(this, DraftSet);
            var _this;
            _this = _super.call(this);
            _this[DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: (0, $cOYso._)(_this),
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false
            };
            return _this;
        }
        (0, $bMpTA._)(DraftSet, [
            {
                key: "size",
                get: function get() {
                    return latest(this[DRAFT_STATE]).size;
                }
            },
            {
                key: "has",
                value: function has(value) {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    if (!state.copy_) return state.base_.has(value);
                    if (state.copy_.has(value)) return true;
                    if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
                    return false;
                }
            },
            {
                key: "add",
                value: function add(value) {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    if (!this.has(value)) {
                        prepareSetCopy(state);
                        markChanged(state);
                        state.copy_.add(value);
                    }
                    return this;
                }
            },
            {
                key: "delete",
                value: function _delete(value) {
                    if (!this.has(value)) return false;
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    prepareSetCopy(state);
                    markChanged(state);
                    return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
                }
            },
            {
                key: "clear",
                value: function clear() {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    if (latest(state).size) {
                        prepareSetCopy(state);
                        markChanged(state);
                        state.copy_.clear();
                    }
                }
            },
            {
                key: "values",
                value: function values() {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    prepareSetCopy(state);
                    return state.copy_.values();
                }
            },
            {
                key: "entries",
                value: function entries() {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    prepareSetCopy(state);
                    return state.copy_.entries();
                }
            },
            {
                key: "keys",
                value: function keys() {
                    return this.values();
                }
            },
            {
                key: (DRAFT_STATE, Symbol.iterator),
                value: function value() {
                    return this.values();
                }
            },
            {
                key: "forEach",
                value: function forEach(cb, thisArg) {
                    var iterator = this.values();
                    var result = iterator.next();
                    while(!result.done){
                        cb.call(thisArg, result.value, result.value, this);
                        result = iterator.next();
                    }
                }
            }
        ]);
        return DraftSet;
    }((0, $6HjaD._)(Set));
    function proxySet_(target, parent) {
        return new DraftSet(target, parent);
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach(function(value) {
                if (isDraftable(value)) {
                    var draft = createProxy(value, state);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) die(3, JSON.stringify(latest(state)));
    }
    loadPlugin("MapSet", {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_
    });
}
// src/immer.ts
var immer = new Immer2();
var produce = immer.produce;
var produceWithPatches = immer.produceWithPatches.bind(immer);
var setAutoFreeze = immer.setAutoFreeze.bind(immer);
var setUseStrictShallowCopy = immer.setUseStrictShallowCopy.bind(immer);
var applyPatches = immer.applyPatches.bind(immer);
var createDraft = immer.createDraft.bind(immer);
var finishDraft = immer.finishDraft.bind(immer);
function castDraft(value) {
    return value;
}
function castImmutable(value) {
    return value;
}

});
parcelRegister("cOYso", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $95590d0c8085e427$export$71511d61b312f219; });
function $95590d0c8085e427$export$71511d61b312f219(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});

parcelRegister("aliU1", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $787a87339a4cca7b$export$71511d61b312f219; });
function $787a87339a4cca7b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("bMpTA", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $893843b5bdfb5320$export$71511d61b312f219; });
function $893843b5bdfb5320$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $893843b5bdfb5320$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $893843b5bdfb5320$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $893843b5bdfb5320$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("73NPw", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $01539ab334a9139b$export$71511d61b312f219; });
function $01539ab334a9139b$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRegister("fZ5u7", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ba30ceb37f7eb488$export$71511d61b312f219; });

var $hUUmj = parcelRequire("hUUmj");
function $ba30ceb37f7eb488$export$71511d61b312f219(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $hUUmj._)(subClass, superClass);
}

});
parcelRegister("hUUmj", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d0b362515118bdb9$export$71511d61b312f219; });
function $d0b362515118bdb9$export$71511d61b312f219(o, p) {
    $d0b362515118bdb9$export$71511d61b312f219 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $d0b362515118bdb9$export$71511d61b312f219(o, p);
}

});


parcelRegister("1SMDP", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $15f090c73cfda84a$export$71511d61b312f219; });

var $1BeOJ = parcelRequire("1BeOJ");

var $jPgmE = parcelRequire("jPgmE");

var $5DfXH = parcelRequire("5DfXH");

var $f8lFf = parcelRequire("f8lFf");
function $15f090c73cfda84a$export$71511d61b312f219(arr) {
    return (0, $1BeOJ._)(arr) || (0, $jPgmE._)(arr) || (0, $f8lFf._)(arr) || (0, $5DfXH._)();
}

});
parcelRegister("1BeOJ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $12a4bd8835c29f80$export$71511d61b312f219; });

var $h3oB6 = parcelRequire("h3oB6");
function $12a4bd8835c29f80$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $h3oB6._)(arr);
}

});

parcelRegister("jPgmE", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e6ef795f3f4cfa0e$export$71511d61b312f219; });
function $e6ef795f3f4cfa0e$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("5DfXH", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $419cf9fb1c81f8ea$export$71511d61b312f219; });
function $419cf9fb1c81f8ea$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("6HjaD", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $4e05a11b9081f740$export$71511d61b312f219; });

var $6EBGQ = parcelRequire("6EBGQ");

var $92y6r = parcelRequire("92y6r");

var $1jNaH = parcelRequire("1jNaH");

var $hUUmj = parcelRequire("hUUmj");
function $4e05a11b9081f740$export$71511d61b312f219(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $4e05a11b9081f740$export$71511d61b312f219 = function(Class) {
        if (Class === null || !(0, $1jNaH._)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $6EBGQ._)(Class, arguments, (0, $92y6r._)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $hUUmj._)(Wrapper, Class);
    };
    return $4e05a11b9081f740$export$71511d61b312f219(Class);
}

});
parcelRegister("6EBGQ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $4d83b6f05d43e420$export$71511d61b312f219; });

var $iptal = parcelRequire("iptal");

var $hUUmj = parcelRequire("hUUmj");
function $4d83b6f05d43e420$export$71511d61b312f219(Parent, args, Class) {
    if ((0, $iptal._)()) $4d83b6f05d43e420$export$71511d61b312f219 = Reflect.construct;
    else $4d83b6f05d43e420$export$71511d61b312f219 = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $hUUmj._)(instance, Class.prototype);
        return instance;
    };
    return $4d83b6f05d43e420$export$71511d61b312f219.apply(null, arguments);
}

});
parcelRegister("iptal", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d6712f806fb9421e$export$71511d61b312f219; });
function $d6712f806fb9421e$export$71511d61b312f219() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}

});


parcelRegister("92y6r", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $694ec11b01060e1e$export$71511d61b312f219; });
function $694ec11b01060e1e$export$71511d61b312f219(o) {
    $694ec11b01060e1e$export$71511d61b312f219 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $694ec11b01060e1e$export$71511d61b312f219(o);
}

});

parcelRegister("1jNaH", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0f5db5401a009111$export$71511d61b312f219; });
function $0f5db5401a009111$export$71511d61b312f219(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

});


parcelRegister("9j1tP", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $6c67094dc9600d66$export$71511d61b312f219; });

var $92y6r = parcelRequire("92y6r");

var $iptal = parcelRequire("iptal");

var $iJ89D = parcelRequire("iJ89D");
function $6c67094dc9600d66$export$71511d61b312f219(Derived) {
    var hasNativeReflectConstruct = (0, $iptal._)();
    return function _createSuperInternal() {
        var Super = (0, $92y6r._)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $92y6r._)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $iJ89D._)(this, result);
    };
}

});
parcelRegister("iJ89D", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $da22c13eee4a9850$export$71511d61b312f219; });

var $cOYso = parcelRequire("cOYso");

var $6zqIC = parcelRequire("6zqIC");
function $da22c13eee4a9850$export$71511d61b312f219(self, call) {
    if (call && ((0, $6zqIC._)(call) === "object" || typeof call === "function")) return call;
    return (0, $cOYso._)(self);
}

});



parcelRegister("2LEdD", function(module, exports) {


module.exports = (parcelRequire("fxepI"))((parcelRequire("lpl75")).resolve("8jTGL")).then(function() {
    return parcelRequire("fmAlp");
});

});
parcelRegister("fxepI", function(module, exports) {
"use strict";

var $7MKIW = parcelRequire("7MKIW");
module.exports = $7MKIW(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRegister("7MKIW", function(module, exports) {
"use strict";
var $5ab142777c4ed9ec$var$cachedBundles = {};
var $5ab142777c4ed9ec$var$cachedPreloads = {};
var $5ab142777c4ed9ec$var$cachedPrefetches = {};
function $5ab142777c4ed9ec$var$getCache(type) {
    switch(type){
        case "preload":
            return $5ab142777c4ed9ec$var$cachedPreloads;
        case "prefetch":
            return $5ab142777c4ed9ec$var$cachedPrefetches;
        default:
            return $5ab142777c4ed9ec$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $5ab142777c4ed9ec$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});




var $f9AIs = parcelRequire("f9AIs");

var $45FY7 = parcelRequire("45FY7");

var $4Bt61 = parcelRequire("4Bt61");
var $8949e5ebfdf38b70$exports = {};

$parcel$export($8949e5ebfdf38b70$exports, "createRoot", function () { return $8949e5ebfdf38b70$export$882461b6382ed46c; }, function (v) { return $8949e5ebfdf38b70$export$882461b6382ed46c = v; });
$parcel$export($8949e5ebfdf38b70$exports, "hydrateRoot", function () { return $8949e5ebfdf38b70$export$757ceba2d55c277e; }, function (v) { return $8949e5ebfdf38b70$export$757ceba2d55c277e = v; });
var $8949e5ebfdf38b70$export$882461b6382ed46c;
var $8949e5ebfdf38b70$export$757ceba2d55c277e;
"use strict";
var $89f99546f5054100$exports = {};
"use strict";
function $89f99546f5054100$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($89f99546f5054100$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$89f99546f5054100$var$checkDCE();

$89f99546f5054100$exports = (parcelRequire("4OQVW"));


var $8949e5ebfdf38b70$var$i;
$8949e5ebfdf38b70$export$882461b6382ed46c = $89f99546f5054100$exports.createRoot;
$8949e5ebfdf38b70$export$757ceba2d55c277e = $89f99546f5054100$exports.hydrateRoot;



var $f9AIs = parcelRequire("f9AIs");

var $45FY7 = parcelRequire("45FY7");

var $4Bt61 = parcelRequire("4Bt61");
/**
 * React Router DOM v6.23.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $1d3fb01611386816$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $1d3fb01611386816$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $1d3fb01611386816$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $1d3fb01611386816$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var $aliU1 = parcelRequire("aliU1");

var $f9AIs = parcelRequire("f9AIs");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ 
var $6zqIC = parcelRequire("6zqIC");
var $47055dab5b247348$var$extendStatics = function extendStatics1(d, b) {
    $47055dab5b247348$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $47055dab5b247348$var$extendStatics(d, b);
};
function $47055dab5b247348$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $47055dab5b247348$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $47055dab5b247348$export$18ce0697a983be9b = function __assign1() {
    $47055dab5b247348$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $47055dab5b247348$export$18ce0697a983be9b.apply(this, arguments);
};
function $47055dab5b247348$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $47055dab5b247348$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $47055dab5b247348$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $47055dab5b247348$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $47055dab5b247348$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $47055dab5b247348$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $6zqIC._)(x)) === "symbol" ? x : "".concat(x);
}
function $47055dab5b247348$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $6zqIC._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $47055dab5b247348$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $47055dab5b247348$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $47055dab5b247348$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $47055dab5b247348$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $47055dab5b247348$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $47055dab5b247348$export$45d3717a4c69092e(o, m, p);
}
function $47055dab5b247348$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $47055dab5b247348$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $47055dab5b247348$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($47055dab5b247348$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $47055dab5b247348$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $47055dab5b247348$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $47055dab5b247348$export$10c90e4f7922046c(v) {
    return this instanceof $47055dab5b247348$export$10c90e4f7922046c ? (this.v = v, this) : new $47055dab5b247348$export$10c90e4f7922046c(v);
}
function $47055dab5b247348$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $47055dab5b247348$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $47055dab5b247348$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $47055dab5b247348$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $47055dab5b247348$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $47055dab5b247348$export$19a8beecd37a4c45 === "function" ? $47055dab5b247348$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $47055dab5b247348$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $47055dab5b247348$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $47055dab5b247348$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $47055dab5b247348$export$45d3717a4c69092e(result, mod, k);
    }
    $47055dab5b247348$var$__setModuleDefault(result, mod);
    return result;
}
function $47055dab5b247348$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $47055dab5b247348$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $47055dab5b247348$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $47055dab5b247348$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $47055dab5b247348$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $47055dab5b247348$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $47055dab5b247348$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $47055dab5b247348$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $47055dab5b247348$export$2e2bcd8739ae039 = {
    __extends: $47055dab5b247348$export$a8ba968b8961cb8a,
    __assign: $47055dab5b247348$export$18ce0697a983be9b,
    __rest: $47055dab5b247348$export$3c9a16f847548506,
    __decorate: $47055dab5b247348$export$29e00dfd3077644b,
    __param: $47055dab5b247348$export$d5ad3fd78186038f,
    __metadata: $47055dab5b247348$export$f1db080c865becb9,
    __awaiter: $47055dab5b247348$export$1050f835b63b671e,
    __generator: $47055dab5b247348$export$67ebef60e6f28a6,
    __createBinding: $47055dab5b247348$export$45d3717a4c69092e,
    __exportStar: $47055dab5b247348$export$f33643c0debef087,
    __values: $47055dab5b247348$export$19a8beecd37a4c45,
    __read: $47055dab5b247348$export$8d051b38c9118094,
    __spread: $47055dab5b247348$export$afc72e2116322959,
    __spreadArrays: $47055dab5b247348$export$6388937ca91ccae8,
    __spreadArray: $47055dab5b247348$export$1216008129fb82ed,
    __await: $47055dab5b247348$export$10c90e4f7922046c,
    __asyncGenerator: $47055dab5b247348$export$e427f37a30a4de9b,
    __asyncDelegator: $47055dab5b247348$export$bbd80228419bb833,
    __asyncValues: $47055dab5b247348$export$e3b29a3d6162315f,
    __makeTemplateObject: $47055dab5b247348$export$4fb47efe1390b86f,
    __importStar: $47055dab5b247348$export$c21735bcef00d192,
    __importDefault: $47055dab5b247348$export$da59b14a69baef04,
    __classPrivateFieldGet: $47055dab5b247348$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $47055dab5b247348$export$d40a35129aaff81f,
    __classPrivateFieldIn: $47055dab5b247348$export$81fdc39f203e4e04,
    __addDisposableResource: $47055dab5b247348$export$88ac25d8e944e405,
    __disposeResources: $47055dab5b247348$export$8f076105dc360e92
};



var $4Bt61 = parcelRequire("4Bt61");

/**
 * @remix-run/router v1.16.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 

var $aliU1 = parcelRequire("aliU1");

var $bMpTA = parcelRequire("bMpTA");

var $73NPw = parcelRequire("73NPw");

var $fZ5u7 = parcelRequire("fZ5u7");

var $f9AIs = parcelRequire("f9AIs");

var $byJ7Q = parcelRequire("byJ7Q");

var $jPgmE = parcelRequire("jPgmE");

var $jUUb8 = parcelRequire("jUUb8");

var $f8lFf = parcelRequire("f8lFf");
function $e71697af67a1332e$export$71511d61b312f219(arr) {
    return (0, $byJ7Q._)(arr) || (0, $jPgmE._)(arr) || (0, $f8lFf._)(arr) || (0, $jUUb8._)();
}



var $1SMDP = parcelRequire("1SMDP");

var $6HjaD = parcelRequire("6HjaD");

var $9j1tP = parcelRequire("9j1tP");


function $3a208abeb0ec52b2$var$_extends() {
    $3a208abeb0ec52b2$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3a208abeb0ec52b2$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $3a208abeb0ec52b2$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($3a208abeb0ec52b2$export$e19cd5f9376f8cee || ($3a208abeb0ec52b2$export$e19cd5f9376f8cee = {}));
var $3a208abeb0ec52b2$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $3a208abeb0ec52b2$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    var _options_initialEntries = options.initialEntries, initialEntries = _options_initialEntries === void 0 ? [
        "/"
    ] : _options_initialEntries, initialIndex = options.initialIndex, _options_v5Compat = options.v5Compat, v5Compat = _options_v5Compat === void 0 ? false : _options_v5Compat;
    var entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map(function(entry, index) {
        return createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined);
    });
    var index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    var action = $3a208abeb0ec52b2$export$e19cd5f9376f8cee.Pop;
    var listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        var location = $3a208abeb0ec52b2$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $3a208abeb0ec52b2$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $3a208abeb0ec52b2$export$fe53371bee54353d(to);
    }
    var history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL: function(to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation: function(to) {
            var path = typeof to === "string" ? $3a208abeb0ec52b2$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push: function(to, state) {
            action = $3a208abeb0ec52b2$export$e19cd5f9376f8cee.Push;
            var nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace: function(to, state) {
            action = $3a208abeb0ec52b2$export$e19cd5f9376f8cee.Replace;
            var nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go: function(delta) {
            action = $3a208abeb0ec52b2$export$e19cd5f9376f8cee.Pop;
            var nextIndex = clampIndex(index + delta);
            var nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen: function(fn) {
            listener = fn;
            return function() {
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $3a208abeb0ec52b2$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        var _window_location = window1.location, pathname = _window_location.pathname, search = _window_location.search, hash = _window_location.hash;
        return $3a208abeb0ec52b2$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $3a208abeb0ec52b2$export$fe53371bee54353d(to);
    }
    return $3a208abeb0ec52b2$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $3a208abeb0ec52b2$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        var _parsePath = $3a208abeb0ec52b2$export$8ccf933b0513f8d0(window1.location.hash.substr(1)), _parsePath_pathname = _parsePath.pathname, pathname = _parsePath_pathname === void 0 ? "/" : _parsePath_pathname, _parsePath_search = _parsePath.search, search = _parsePath_search === void 0 ? "" : _parsePath_search, _parsePath_hash = _parsePath.hash, hash = _parsePath_hash === void 0 ? "" : _parsePath_hash;
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $3a208abeb0ec52b2$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        var base = window1.document.querySelector("base");
        var href = "";
        if (base && base.getAttribute("href")) {
            var url = window1.location.href;
            var hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $3a208abeb0ec52b2$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $3a208abeb0ec52b2$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $3a208abeb0ec52b2$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $3a208abeb0ec52b2$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $3a208abeb0ec52b2$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $3a208abeb0ec52b2$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $3a208abeb0ec52b2$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $3a208abeb0ec52b2$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    var location = $3a208abeb0ec52b2$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $3a208abeb0ec52b2$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $3a208abeb0ec52b2$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $3a208abeb0ec52b2$export$fe53371bee54353d(_ref) {
    var _ref_pathname = _ref.pathname, pathname = _ref_pathname === void 0 ? "/" : _ref_pathname, _ref_search = _ref.search, search = _ref_search === void 0 ? "" : _ref_search, _ref_hash = _ref.hash, hash = _ref_hash === void 0 ? "" : _ref_hash;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $3a208abeb0ec52b2$export$8ccf933b0513f8d0(path) {
    var parsedPath = {};
    if (path) {
        var hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        var searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $3a208abeb0ec52b2$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    var _options_window = options.window, window1 = _options_window === void 0 ? document.defaultView : _options_window, _options_v5Compat = options.v5Compat, v5Compat = _options_v5Compat === void 0 ? false : _options_v5Compat;
    var globalHistory = window1.history;
    var action = $3a208abeb0ec52b2$export$e19cd5f9376f8cee.Pop;
    var listener = null;
    var index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($3a208abeb0ec52b2$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        var state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $3a208abeb0ec52b2$export$e19cd5f9376f8cee.Pop;
        var nextIndex = getIndex();
        var delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $3a208abeb0ec52b2$export$e19cd5f9376f8cee.Push;
        var location = $3a208abeb0ec52b2$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        var historyState = $3a208abeb0ec52b2$var$getHistoryState(location, index);
        var url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $3a208abeb0ec52b2$export$e19cd5f9376f8cee.Replace;
        var location = $3a208abeb0ec52b2$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        var historyState = $3a208abeb0ec52b2$var$getHistoryState(location, index);
        var url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        var base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        var href = typeof to === "string" ? to : $3a208abeb0ec52b2$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $3a208abeb0ec52b2$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen: function(fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($3a208abeb0ec52b2$var$PopStateEventType, handlePop);
            listener = fn;
            return function() {
                window1.removeEventListener($3a208abeb0ec52b2$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref: function(to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation: function(to) {
            // Encode a Location the same way window.location would
            var url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go: function(n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $3a208abeb0ec52b2$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($3a208abeb0ec52b2$var$ResultType || ($3a208abeb0ec52b2$var$ResultType = {}));
var $3a208abeb0ec52b2$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $3a208abeb0ec52b2$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $3a208abeb0ec52b2$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map(function(route, index) {
        var treePath = (0, $1SMDP._)(parentPath).concat([
            index
        ]);
        var id = typeof route.id === "string" ? route.id : treePath.join("-");
        $3a208abeb0ec52b2$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $3a208abeb0ec52b2$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($3a208abeb0ec52b2$var$isIndexRoute(route)) {
            var indexRoute = $3a208abeb0ec52b2$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            var pathOrLayoutRoute = $3a208abeb0ec52b2$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $3a208abeb0ec52b2$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $3a208abeb0ec52b2$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    var location = typeof locationArg === "string" ? $3a208abeb0ec52b2$export$8ccf933b0513f8d0(locationArg) : locationArg;
    var pathname = $3a208abeb0ec52b2$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    var branches = $3a208abeb0ec52b2$var$flattenRoutes(routes);
    $3a208abeb0ec52b2$var$rankRouteBranches(branches);
    var matches = null;
    for(var i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        var decoded = $3a208abeb0ec52b2$var$decodePath(pathname);
        matches = $3a208abeb0ec52b2$var$matchRouteBranch(branches[i], decoded);
    }
    return matches;
}
function $3a208abeb0ec52b2$export$b3fac024fad9e8ff(match, loaderData) {
    var route = match.route, pathname = match.pathname, params = match.params;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $3a208abeb0ec52b2$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    var flattenRoute = function(route, index, relativePath) {
        var meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $3a208abeb0ec52b2$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        var path = $3a208abeb0ec52b2$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        var routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $3a208abeb0ec52b2$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $3a208abeb0ec52b2$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $3a208abeb0ec52b2$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach(function(route, index) {
        var _route$path;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else try {
            for(var _iterator = $3a208abeb0ec52b2$var$explodeOptionalSegments(route.path)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var exploded = _step.value;
                flattenRoute(route, index, exploded);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $3a208abeb0ec52b2$var$explodeOptionalSegments(path) {
    var // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    _result, _result1;
    var segments = path.split("/");
    if (segments.length === 0) return [];
    var _segments = (0, $e71697af67a1332e$export$71511d61b312f219)(segments), first = _segments[0], rest = _segments.slice(1);
    // Optional path segments are denoted by a trailing `?`
    var isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    var required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    var restExploded = $3a208abeb0ec52b2$var$explodeOptionalSegments(rest.join("/"));
    var result = [];
    (_result = result).push.apply(_result, (0, $1SMDP._)(restExploded.map(function(subpath) {
        return subpath === "" ? required : [
            required,
            subpath
        ].join("/");
    })));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) (_result1 = result).push.apply(_result1, (0, $1SMDP._)(restExploded));
    // for absolute paths, ensure `/` instead of empty segment
    return result.map(function(exploded) {
        return path.startsWith("/") && exploded === "" ? "/" : exploded;
    });
}
function $3a208abeb0ec52b2$var$rankRouteBranches(branches) {
    branches.sort(function(a, b) {
        return a.score !== b.score ? b.score - a.score // Higher score first
         : $3a208abeb0ec52b2$var$compareIndexes(a.routesMeta.map(function(meta) {
            return meta.childrenIndex;
        }), b.routesMeta.map(function(meta) {
            return meta.childrenIndex;
        }));
    });
}
var $3a208abeb0ec52b2$var$paramRe = /^:[\w-]+$/;
var $3a208abeb0ec52b2$var$dynamicSegmentValue = 3;
var $3a208abeb0ec52b2$var$indexRouteValue = 2;
var $3a208abeb0ec52b2$var$emptySegmentValue = 1;
var $3a208abeb0ec52b2$var$staticSegmentValue = 10;
var $3a208abeb0ec52b2$var$splatPenalty = -2;
var $3a208abeb0ec52b2$var$isSplat = function(s) {
    return s === "*";
};
function $3a208abeb0ec52b2$var$computeScore(path, index) {
    var segments = path.split("/");
    var initialScore = segments.length;
    if (segments.some($3a208abeb0ec52b2$var$isSplat)) initialScore += $3a208abeb0ec52b2$var$splatPenalty;
    if (index) initialScore += $3a208abeb0ec52b2$var$indexRouteValue;
    return segments.filter(function(s) {
        return !$3a208abeb0ec52b2$var$isSplat(s);
    }).reduce(function(score, segment) {
        return score + ($3a208abeb0ec52b2$var$paramRe.test(segment) ? $3a208abeb0ec52b2$var$dynamicSegmentValue : segment === "" ? $3a208abeb0ec52b2$var$emptySegmentValue : $3a208abeb0ec52b2$var$staticSegmentValue);
    }, initialScore);
}
function $3a208abeb0ec52b2$var$compareIndexes(a, b) {
    var siblings = a.length === b.length && a.slice(0, -1).every(function(n, i) {
        return n === b[i];
    });
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $3a208abeb0ec52b2$var$matchRouteBranch(branch, pathname) {
    var routesMeta = branch.routesMeta;
    var matchedParams = {};
    var matchedPathname = "/";
    var matches = [];
    for(var i = 0; i < routesMeta.length; ++i){
        var meta = routesMeta[i];
        var end = i === routesMeta.length - 1;
        var remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        var match = $3a208abeb0ec52b2$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        var route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $3a208abeb0ec52b2$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $3a208abeb0ec52b2$export$a5c6d149b50c1d86($3a208abeb0ec52b2$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $3a208abeb0ec52b2$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $3a208abeb0ec52b2$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    var path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $3a208abeb0ec52b2$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    var prefix = path.startsWith("/") ? "/" : "";
    var stringify = function(p) {
        return p == null ? "" : typeof p === "string" ? p : String(p);
    };
    var segments = path.split(/\/+/).map(function(segment, index, array) {
        var isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            var star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        var keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            var _keyMatch = (0, $f9AIs._)(keyMatch, 3), key = _keyMatch[1], optional = _keyMatch[2];
            var param = params[key];
            $3a208abeb0ec52b2$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter(function(segment) {
        return !!segment;
    });
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $3a208abeb0ec52b2$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    var _compilePath = (0, $f9AIs._)($3a208abeb0ec52b2$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end), 2), matcher = _compilePath[0], compiledParams = _compilePath[1];
    var match = pathname.match(matcher);
    if (!match) return null;
    var matchedPathname = match[0];
    var pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    var captureGroups = match.slice(1);
    var params = compiledParams.reduce(function(memo, _ref, index) {
        var paramName = _ref.paramName, isOptional = _ref.isOptional;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            var splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        var value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $3a208abeb0ec52b2$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $3a208abeb0ec52b2$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    var params = [];
    var regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, function(_, paramName, isOptional) {
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    var matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $3a208abeb0ec52b2$var$decodePath(value) {
    try {
        return value.split("/").map(function(v) {
            return decodeURIComponent(v).replace(/\//g, "%2F");
        }).join("/");
    } catch (error) {
        $3a208abeb0ec52b2$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $3a208abeb0ec52b2$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    var startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    var nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $3a208abeb0ec52b2$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    var _ref = typeof to === "string" ? $3a208abeb0ec52b2$export$8ccf933b0513f8d0(to) : to, toPathname = _ref.pathname, _ref_search = _ref.search, search = _ref_search === void 0 ? "" : _ref_search, _ref_hash = _ref.hash, hash = _ref_hash === void 0 ? "" : _ref_hash;
    var pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $3a208abeb0ec52b2$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $3a208abeb0ec52b2$var$normalizeSearch(search),
        hash: $3a208abeb0ec52b2$var$normalizeHash(hash)
    };
}
function $3a208abeb0ec52b2$var$resolvePathname(relativePath, fromPathname) {
    var segments = fromPathname.replace(/\/+$/, "").split("/");
    var relativeSegments = relativePath.split("/");
    relativeSegments.forEach(function(segment) {
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $3a208abeb0ec52b2$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $3a208abeb0ec52b2$var$getPathContributingMatches(matches) {
    return matches.filter(function(match, index) {
        return index === 0 || match.route.path && match.route.path.length > 0;
    });
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $3a208abeb0ec52b2$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    var pathMatches = $3a208abeb0ec52b2$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map(function(match, idx) {
        return idx === matches.length - 1 ? match.pathname : match.pathnameBase;
    });
    return pathMatches.map(function(match) {
        return match.pathnameBase;
    });
}
/**
 * @private
 */ function $3a208abeb0ec52b2$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    var to;
    if (typeof toArg === "string") to = $3a208abeb0ec52b2$export$8ccf933b0513f8d0(toArg);
    else {
        to = $3a208abeb0ec52b2$var$_extends({}, toArg);
        $3a208abeb0ec52b2$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $3a208abeb0ec52b2$var$getInvalidPathError("?", "pathname", "search", to));
        $3a208abeb0ec52b2$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $3a208abeb0ec52b2$var$getInvalidPathError("#", "pathname", "hash", to));
        $3a208abeb0ec52b2$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $3a208abeb0ec52b2$var$getInvalidPathError("#", "search", "hash", to));
    }
    var isEmptyPath = toArg === "" || to.pathname === "";
    var toPathname = isEmptyPath ? "/" : to.pathname;
    var from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        var routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            var toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    var path = $3a208abeb0ec52b2$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    var hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    var hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $3a208abeb0ec52b2$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $3a208abeb0ec52b2$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ var $3a208abeb0ec52b2$export$86d9a7913e44197e = function(paths) {
    return paths.join("/").replace(/\/\/+/g, "/");
};
/**
 * @private
 */ var $3a208abeb0ec52b2$export$a5c6d149b50c1d86 = function(pathname) {
    return pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
};
/**
 * @private
 */ var $3a208abeb0ec52b2$var$normalizeSearch = function(search) {
    return !search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
};
/**
 * @private
 */ var $3a208abeb0ec52b2$var$normalizeHash = function(hash) {
    return !hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
};
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ var $3a208abeb0ec52b2$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    var responseInit = typeof init === "number" ? {
        status: init
    } : init;
    var headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $3a208abeb0ec52b2$var$_extends({}, responseInit, {
        headers: headers
    }));
};
var $3a208abeb0ec52b2$export$42a99a7a4bc0e76a = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $fZ5u7._)(AbortedDeferredError, Error1);
    var _super = (0, $9j1tP._)(AbortedDeferredError);
    function AbortedDeferredError() {
        (0, $aliU1._)(this, AbortedDeferredError);
        return _super.apply(this, arguments);
    }
    return AbortedDeferredError;
}((0, $6HjaD._)(Error));
var $3a208abeb0ec52b2$export$61d759255b4eec65 = /*#__PURE__*/ function() {
    "use strict";
    function DeferredData(data, responseInit) {
        var _this = this;
        (0, $aliU1._)(this, DeferredData);
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $3a208abeb0ec52b2$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        var reject;
        this.abortPromise = new Promise(function(_, r) {
            return reject = r;
        });
        this.controller = new AbortController();
        var onAbort = function() {
            return reject(new $3a208abeb0ec52b2$export$42a99a7a4bc0e76a("Deferred data aborted"));
        };
        this.unlistenAbortSignal = function() {
            return _this.controller.signal.removeEventListener("abort", onAbort);
        };
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce(function(acc, _ref2) {
            var _$_ref2 = (0, $f9AIs._)(_ref2, 2), key = _$_ref2[0], value = _$_ref2[1];
            return Object.assign(acc, (0, $73NPw._)({}, key, _this.trackPromise(key, value)));
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    (0, $bMpTA._)(DeferredData, [
        {
            key: "trackPromise",
            value: function trackPromise(key, value) {
                var _this = this;
                if (!(value instanceof Promise)) return value;
                this.deferredKeys.push(key);
                this.pendingKeysSet.add(key);
                // We store a little wrapper promise that will be extended with
                // _data/_error props upon resolve/reject
                var promise = Promise.race([
                    value,
                    this.abortPromise
                ]).then(function(data) {
                    return _this.onSettle(promise, key, undefined, data);
                }, function(error) {
                    return _this.onSettle(promise, key, error);
                });
                // Register rejection listeners to avoid uncaught promise rejections on
                // errors or aborted deferred values
                promise.catch(function() {});
                Object.defineProperty(promise, "_tracked", {
                    get: function() {
                        return true;
                    }
                });
                return promise;
            }
        },
        {
            key: "onSettle",
            value: function onSettle(promise, key, error, data) {
                if (this.controller.signal.aborted && error instanceof $3a208abeb0ec52b2$export$42a99a7a4bc0e76a) {
                    this.unlistenAbortSignal();
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return error;
                        }
                    });
                    return Promise.reject(error);
                }
                this.pendingKeysSet.delete(key);
                if (this.done) // Nothing left to abort!
                this.unlistenAbortSignal();
                // If the promise was resolved/rejected with undefined, we'll throw an error as you
                // should always resolve with a value or null
                if (error === undefined && data === undefined) {
                    var undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return undefinedError;
                        }
                    });
                    this.emit(false, key);
                    return Promise.reject(undefinedError);
                }
                if (data === undefined) {
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return error;
                        }
                    });
                    this.emit(false, key);
                    return Promise.reject(error);
                }
                Object.defineProperty(promise, "_data", {
                    get: function() {
                        return data;
                    }
                });
                this.emit(false, key);
                return data;
            }
        },
        {
            key: "emit",
            value: function emit(aborted, settledKey) {
                this.subscribers.forEach(function(subscriber) {
                    return subscriber(aborted, settledKey);
                });
            }
        },
        {
            key: "subscribe",
            value: function subscribe(fn) {
                var _this = this;
                this.subscribers.add(fn);
                return function() {
                    return _this.subscribers.delete(fn);
                };
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                var _this = this;
                this.controller.abort();
                this.pendingKeysSet.forEach(function(v, k) {
                    return _this.pendingKeysSet.delete(k);
                });
                this.emit(true);
            }
        },
        {
            key: "resolveData",
            value: function resolveData(signal) {
                var _this = this;
                return (0, $1d3fb01611386816$export$71511d61b312f219)(function() {
                    var aborted, onAbort;
                    return (0, $47055dab5b247348$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                aborted = false;
                                if (!!_this.done) return [
                                    3,
                                    2
                                ];
                                onAbort = function() {
                                    return _this.cancel();
                                };
                                signal.addEventListener("abort", onAbort);
                                return [
                                    4,
                                    new Promise(function(resolve) {
                                        _this.subscribe(function(aborted) {
                                            signal.removeEventListener("abort", onAbort);
                                            if (aborted || _this.done) resolve(aborted);
                                        });
                                    })
                                ];
                            case 1:
                                aborted = _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2,
                                    aborted
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "done",
            get: function get() {
                return this.pendingKeysSet.size === 0;
            }
        },
        {
            key: "unwrappedData",
            get: function get() {
                $3a208abeb0ec52b2$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
                return Object.entries(this.data).reduce(function(acc, _ref3) {
                    var _$_ref3 = (0, $f9AIs._)(_ref3, 2), key = _$_ref3[0], value = _$_ref3[1];
                    return Object.assign(acc, (0, $73NPw._)({}, key, $3a208abeb0ec52b2$var$unwrapTrackedPromise(value)));
                }, {});
            }
        },
        {
            key: "pendingKeys",
            get: function get() {
                return Array.from(this.pendingKeysSet);
            }
        }
    ]);
    return DeferredData;
}();
function $3a208abeb0ec52b2$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $3a208abeb0ec52b2$var$unwrapTrackedPromise(value) {
    if (!$3a208abeb0ec52b2$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
var $3a208abeb0ec52b2$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    var responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $3a208abeb0ec52b2$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ var $3a208abeb0ec52b2$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    var responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    var headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $3a208abeb0ec52b2$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ var $3a208abeb0ec52b2$export$a6cd19cd1951a23c = function(url, init) {
    var response = $3a208abeb0ec52b2$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ var $3a208abeb0ec52b2$export$6c6580e81da25755 = function ErrorResponseImpl(status, statusText, data, internal) {
    "use strict";
    (0, $aliU1._)(this, ErrorResponseImpl);
    if (internal === void 0) internal = false;
    this.status = status;
    this.statusText = statusText || "";
    this.internal = internal;
    if (data instanceof Error) {
        this.data = data.toString();
        this.error = data;
    } else this.data = data;
};
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $3a208abeb0ec52b2$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
var $3a208abeb0ec52b2$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
var $3a208abeb0ec52b2$var$validMutationMethods = new Set($3a208abeb0ec52b2$var$validMutationMethodsArr);
var $3a208abeb0ec52b2$var$validRequestMethodsArr = [
    "get"
].concat((0, $1SMDP._)($3a208abeb0ec52b2$var$validMutationMethodsArr));
var $3a208abeb0ec52b2$var$validRequestMethods = new Set($3a208abeb0ec52b2$var$validRequestMethodsArr);
var $3a208abeb0ec52b2$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
var $3a208abeb0ec52b2$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
var $3a208abeb0ec52b2$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
var $3a208abeb0ec52b2$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
var $3a208abeb0ec52b2$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
var $3a208abeb0ec52b2$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $3a208abeb0ec52b2$var$defaultMapRouteProperties = function(route) {
    return {
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    };
};
var $3a208abeb0ec52b2$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $3a208abeb0ec52b2$export$baddd0131ee8c05b(init) {
    var routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    var isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    var isServer = !isBrowser;
    $3a208abeb0ec52b2$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    var mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        var detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = function(route) {
            return {
                hasErrorBoundary: detectErrorBoundary(route)
            };
        };
    } else mapRouteProperties = $3a208abeb0ec52b2$var$defaultMapRouteProperties;
    // Routes keyed by ID
    var manifest = {};
    // Routes in tree format for matching
    var dataRoutes = $3a208abeb0ec52b2$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    var inFlightDataRoutes;
    var basename = init.basename || "/";
    var dataStrategyImpl = init.unstable_dataStrategy || $3a208abeb0ec52b2$var$defaultDataStrategy;
    // Config driven behavior flags
    var future = $3a208abeb0ec52b2$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        unstable_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    var unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    var subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    var savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    var getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    var getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    var initialScrollRestored = init.hydrationData != null;
    var initialMatches = $3a208abeb0ec52b2$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    var initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        var error = $3a208abeb0ec52b2$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        var _getShortCircuitMatches = $3a208abeb0ec52b2$var$getShortCircuitMatches(dataRoutes), matches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
        initialMatches = matches;
        initialErrors = (0, $73NPw._)({}, route.id, error);
    }
    var initialized;
    var hasLazyRoutes = initialMatches.some(function(m) {
        return m.route.lazy;
    });
    var hasLoaders = initialMatches.some(function(m) {
        return m.route.loader;
    });
    if (hasLazyRoutes) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!hasLoaders) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        var loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        var errors = init.hydrationData ? init.hydrationData.errors : null;
        var isRouteInitialized = function(m) {
            // No loader, nothing to initialize
            if (!m.route.loader) return true;
            // Explicitly opting-in to running on hydration
            if (typeof m.route.loader === "function" && m.route.loader.hydrate === true) return false;
            // Otherwise, initialized if hydrated with data or an error
            return loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined;
        };
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            var idx = initialMatches.findIndex(function(m) {
                return errors[m.route.id] !== undefined;
            });
            initialized = initialMatches.slice(0, idx + 1).every(isRouteInitialized);
        } else initialized = initialMatches.every(isRouteInitialized);
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    var router;
    var state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $3a208abeb0ec52b2$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    var pendingAction = $3a208abeb0ec52b2$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    var pendingPreventScrollReset = false;
    // AbortController for the active navigation
    var pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    var pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    var appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    var removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    var isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    var isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    var cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    var cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    var fetchControllers = new Map();
    // Track loads based on the order in which they started
    var incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    var pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    var fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    var fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    var fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    var activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    var deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    var activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    var blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    var ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen(function(_ref) {
            var historyAction = _ref.action, location = _ref.location, delta = _ref.delta;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $3a208abeb0ec52b2$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            var blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed: function() {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset: function() {
                        var blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $3a208abeb0ec52b2$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $3a208abeb0ec52b2$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            var _saveAppliedTransitions = function() {
                return $3a208abeb0ec52b2$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            };
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = function() {
                return routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
            };
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($3a208abeb0ec52b2$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach(function(_, key) {
            return deleteFetcher(key);
        });
        state.blockers.forEach(function(_, key) {
            return deleteBlocker(key);
        });
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return function() {
            return subscribers.delete(fn);
        };
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $3a208abeb0ec52b2$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        var completedFetchers = [];
        var deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach(function(fetcher, key) {
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        (0, $1SMDP._)(subscribers).forEach(function(subscriber) {
            return subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            });
        });
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach(function(key) {
                return state.fetchers.delete(key);
            });
            deletedFetchersKeys.forEach(function(key) {
                return deleteFetcher(key);
            });
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        var flushSync = (_temp === void 0 ? {} : _temp).flushSync;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        var isActionReload = state.actionData != null && state.navigation.formMethod != null && $3a208abeb0ec52b2$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        var actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        var loaderData = newState.loaderData ? $3a208abeb0ec52b2$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        var blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach(function(_, k) {
                return blockers.set(k, $3a208abeb0ec52b2$export$386d57f03f0b2883);
            });
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        var preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $3a208abeb0ec52b2$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $3a208abeb0ec52b2$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $3a208abeb0ec52b2$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $3a208abeb0ec52b2$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        var viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $3a208abeb0ec52b2$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            var priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            var toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($3a208abeb0ec52b2$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $3a208abeb0ec52b2$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $3a208abeb0ec52b2$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    function navigate(to, opts) {
        return _navigate.apply(this, arguments);
    }
    function _navigate() {
        _navigate = // Trigger a navigation event, which can either be a numerical POP or a PUSH
        // replace with an optional submission
        (0, $1d3fb01611386816$export$71511d61b312f219)(function(to, opts) {
            var normalizedPath, _normalizeNavigateOptions, path, submission, error, currentLocation, nextLocation, userReplace, historyAction, preventScrollReset, flushSync, blockerKey;
            return (0, $47055dab5b247348$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (typeof to === "number") {
                            init.history.go(to);
                            return [
                                2
                            ];
                        }
                        normalizedPath = $3a208abeb0ec52b2$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
                        _normalizeNavigateOptions = $3a208abeb0ec52b2$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts), path = _normalizeNavigateOptions.path, submission = _normalizeNavigateOptions.submission, error = _normalizeNavigateOptions.error;
                        currentLocation = state.location;
                        nextLocation = $3a208abeb0ec52b2$var$createLocation(state.location, path, opts && opts.state);
                        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
                        // URL from window.location, so we need to encode it here so the behavior
                        // remains the same as POP and non-data-router usages.  new URL() does all
                        // the same encoding we'd get from a history.pushState/window.location read
                        // without having to touch history
                        nextLocation = $3a208abeb0ec52b2$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
                        userReplace = opts && opts.replace != null ? opts.replace : undefined;
                        historyAction = $3a208abeb0ec52b2$export$e19cd5f9376f8cee.Push;
                        if (userReplace === true) historyAction = $3a208abeb0ec52b2$export$e19cd5f9376f8cee.Replace;
                        else if (userReplace === false) ;
                        else if (submission != null && $3a208abeb0ec52b2$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
                        // users don't have to double-click the back button to get to the prior
                        // location.  If the user redirects to a different location from the
                        // action/loader this will be ignored and the redirect will be a PUSH
                        historyAction = $3a208abeb0ec52b2$export$e19cd5f9376f8cee.Replace;
                        preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
                        flushSync = (opts && opts.unstable_flushSync) === true;
                        blockerKey = shouldBlockNavigation({
                            currentLocation: currentLocation,
                            nextLocation: nextLocation,
                            historyAction: historyAction
                        });
                        if (blockerKey) {
                            // Put the blocker into a blocked state
                            updateBlocker(blockerKey, {
                                state: "blocked",
                                location: nextLocation,
                                proceed: function() {
                                    updateBlocker(blockerKey, {
                                        state: "proceeding",
                                        proceed: undefined,
                                        reset: undefined,
                                        location: nextLocation
                                    });
                                    // Send the same navigation through
                                    navigate(to, opts);
                                },
                                reset: function() {
                                    var blockers = new Map(state.blockers);
                                    blockers.set(blockerKey, $3a208abeb0ec52b2$export$386d57f03f0b2883);
                                    updateState({
                                        blockers: blockers
                                    });
                                }
                            });
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            startNavigation(historyAction, nextLocation, {
                                submission: submission,
                                // Send through the formData serialization error if we have one so we can
                                // render at the right error boundary after we match routes
                                pendingError: error,
                                preventScrollReset: preventScrollReset,
                                replace: opts && opts.replace,
                                enableViewTransition: opts && opts.unstable_viewTransition,
                                flushSync: flushSync
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return _navigate.apply(this, arguments);
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    function startNavigation(historyAction, location, opts) {
        return _startNavigation.apply(this, arguments);
    }
    function _startNavigation() {
        _startNavigation = // Start a navigation to the given action/location.  Can optionally provide a
        // overrideNavigation which will override the normalLoad in the case of a redirect
        // navigation
        (0, $1d3fb01611386816$export$71511d61b312f219)(function(historyAction, location, opts) {
            var routesToUse, loadingNavigation, matches, flushSync, error, _getShortCircuitMatches, notFoundMatches, route, request, pendingActionResult, actionResult, _ref, shortCircuited, loaderData, errors;
            return (0, $47055dab5b247348$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // Abort any in-progress navigations and start a new one. Unset any ongoing
                        // uninterrupted revalidations unless told otherwise, since we want this
                        // new navigation to update history normally
                        pendingNavigationController && pendingNavigationController.abort();
                        pendingNavigationController = null;
                        pendingAction = historyAction;
                        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
                        // Save the current scroll position every time we start a new navigation,
                        // and track whether we should reset scroll on completion
                        saveScrollPosition(state.location, state.matches);
                        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
                        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        loadingNavigation = opts && opts.overrideNavigation;
                        matches = $3a208abeb0ec52b2$export$2708184779ceb39d(routesToUse, location, basename);
                        flushSync = (opts && opts.flushSync) === true;
                        // Short circuit with a 404 on the root error boundary if we match nothing
                        if (!matches) {
                            error = $3a208abeb0ec52b2$var$getInternalRouterError(404, {
                                pathname: location.pathname
                            });
                            _getShortCircuitMatches = $3a208abeb0ec52b2$var$getShortCircuitMatches(routesToUse), notFoundMatches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
                            // Cancel all pending deferred on 404s since we don't keep any routes
                            cancelActiveDeferreds();
                            completeNavigation(location, {
                                matches: notFoundMatches,
                                loaderData: {},
                                errors: (0, $73NPw._)({}, route.id, error)
                            }, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        // Short circuit if it's only a hash change and not a revalidation or
                        // mutation submission.
                        //
                        // Ignore on initial page loads because since the initial load will always
                        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
                        // which will default to a navigation to /page
                        if (state.initialized && !isRevalidationRequired && $3a208abeb0ec52b2$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $3a208abeb0ec52b2$var$isMutationMethod(opts.submission.formMethod))) {
                            completeNavigation(location, {
                                matches: matches
                            }, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        // Create a controller/Request for this navigation
                        pendingNavigationController = new AbortController();
                        request = $3a208abeb0ec52b2$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
                        if (!(opts && opts.pendingError)) return [
                            3,
                            1
                        ];
                        // If we have a pendingError, it means the user attempted a GET submission
                        // with binary FormData so assign here and skip to handleLoaders.  That
                        // way we handle calling loaders above the boundary etc.  It's not really
                        // different from an actionError in that sense.
                        pendingActionResult = [
                            $3a208abeb0ec52b2$var$findNearestBoundary(matches).route.id,
                            {
                                type: $3a208abeb0ec52b2$var$ResultType.error,
                                error: opts.pendingError
                            }
                        ];
                        return [
                            3,
                            3
                        ];
                    case 1:
                        if (!(opts && opts.submission && $3a208abeb0ec52b2$var$isMutationMethod(opts.submission.formMethod))) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            handleAction(request, location, opts.submission, matches, {
                                replace: opts.replace,
                                flushSync: flushSync
                            })
                        ];
                    case 2:
                        actionResult = _state.sent();
                        if (actionResult.shortCircuited) return [
                            2
                        ];
                        pendingActionResult = actionResult.pendingActionResult;
                        loadingNavigation = $3a208abeb0ec52b2$var$getLoadingNavigation(location, opts.submission);
                        flushSync = false;
                        // Create a GET request for the loaders
                        request = $3a208abeb0ec52b2$var$createClientSideRequest(init.history, request.url, request.signal);
                        _state.label = 3;
                    case 3:
                        return [
                            4,
                            handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult)
                        ];
                    case 4:
                        _ref = _state.sent(), shortCircuited = _ref.shortCircuited, loaderData = _ref.loaderData, errors = _ref.errors;
                        if (shortCircuited) return [
                            2
                        ];
                        // Clean up now that the action/loaders have completed.  Don't clean up if
                        // we short circuited because pendingNavigationController will have already
                        // been assigned to a new controller for the next navigation
                        pendingNavigationController = null;
                        completeNavigation(location, $3a208abeb0ec52b2$var$_extends({
                            matches: matches
                        }, $3a208abeb0ec52b2$var$getActionDataForCommit(pendingActionResult), {
                            loaderData: loaderData,
                            errors: errors
                        }));
                        return [
                            2
                        ];
                }
            });
        });
        return _startNavigation.apply(this, arguments);
    }
    function handleAction(request, location, submission, matches, opts) {
        return _handleAction.apply(this, arguments);
    }
    function _handleAction() {
        _handleAction = // Call the action matched by the leaf route for this navigation and handle
        // redirects/errors
        (0, $1d3fb01611386816$export$71511d61b312f219)(function(request, location, submission, matches, opts) {
            var navigation, result, actionMatch, results, replace, _$location, boundaryMatch;
            return (0, $47055dab5b247348$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (opts === void 0) opts = {};
                        interruptActiveLoads();
                        // Put us in a submitting state
                        navigation = $3a208abeb0ec52b2$var$getSubmittingNavigation(location, submission);
                        updateState({
                            navigation: navigation
                        }, {
                            flushSync: opts.flushSync === true
                        });
                        actionMatch = $3a208abeb0ec52b2$var$getTargetMatch(matches, location);
                        if (!(!actionMatch.route.action && !actionMatch.route.lazy)) return [
                            3,
                            1
                        ];
                        result = {
                            type: $3a208abeb0ec52b2$var$ResultType.error,
                            error: $3a208abeb0ec52b2$var$getInternalRouterError(405, {
                                method: request.method,
                                pathname: location.pathname,
                                routeId: actionMatch.route.id
                            })
                        };
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            callDataStrategy("action", request, [
                                actionMatch
                            ], matches)
                        ];
                    case 2:
                        results = _state.sent();
                        result = results[0];
                        if (request.signal.aborted) return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        _state.label = 3;
                    case 3:
                        if (!$3a208abeb0ec52b2$var$isRedirectResult(result)) return [
                            3,
                            5
                        ];
                        if (opts && opts.replace != null) replace = opts.replace;
                        else {
                            // If the user didn't explicity indicate replace behavior, replace if
                            // we redirected to the exact same location we're currently at to avoid
                            // double back-buttons
                            _$location = $3a208abeb0ec52b2$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                            replace = _$location === state.location.pathname + state.location.search;
                        }
                        return [
                            4,
                            startRedirectNavigation(request, result, {
                                submission: submission,
                                replace: replace
                            })
                        ];
                    case 4:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 5:
                        if ($3a208abeb0ec52b2$var$isDeferredResult(result)) throw $3a208abeb0ec52b2$var$getInternalRouterError(400, {
                            type: "defer-action"
                        });
                        if ($3a208abeb0ec52b2$var$isErrorResult(result)) {
                            // Store off the pending error - we use it to determine which loaders
                            // to call and will commit it when we complete the navigation
                            boundaryMatch = $3a208abeb0ec52b2$var$findNearestBoundary(matches, actionMatch.route.id);
                            // By default, all submissions are REPLACE navigations, but if the
                            // action threw an error that'll be rendered in an errorElement, we fall
                            // back to PUSH so that the user can use the back button to get back to
                            // the pre-submission form location to try again
                            if ((opts && opts.replace) !== true) pendingAction = $3a208abeb0ec52b2$export$e19cd5f9376f8cee.Push;
                            return [
                                2,
                                {
                                    pendingActionResult: [
                                        boundaryMatch.route.id,
                                        result
                                    ]
                                }
                            ];
                        }
                        return [
                            2,
                            {
                                pendingActionResult: [
                                    actionMatch.route.id,
                                    result
                                ]
                            }
                        ];
                }
            });
        });
        return _handleAction.apply(this, arguments);
    }
    function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        return _handleLoaders.apply(this, arguments);
    }
    function _handleLoaders() {
        _handleLoaders = // Call all applicable loaders for the given matches, handling redirects,
        // errors, etc.
        (0, $1d3fb01611386816$export$71511d61b312f219)(function(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
            var loadingNavigation, activeSubmission, routesToUse, _getMatchesToLoad, matchesToLoad, revalidatingFetchers, updatedFetchers, actionData, abortPendingFetchRevalidations, _ref, loaderResults, fetcherResults, redirect, fetcherKey, _processLoaderData, loaderData, errors, updatedFetchers1, didAbortFetchLoads, shouldUpdateFetchers;
            return (0, $47055dab5b247348$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // Figure out the right navigation we want to use for data loading
                        loadingNavigation = overrideNavigation || $3a208abeb0ec52b2$var$getLoadingNavigation(location, submission);
                        // If this was a redirect from an action we don't have a "submission" but
                        // we have it on the loading navigation so use that if available
                        activeSubmission = submission || fetcherSubmission || $3a208abeb0ec52b2$var$getSubmissionFromNavigation(loadingNavigation);
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        _getMatchesToLoad = (0, $f9AIs._)($3a208abeb0ec52b2$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.unstable_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult), 2), matchesToLoad = _getMatchesToLoad[0], revalidatingFetchers = _getMatchesToLoad[1];
                        // Cancel pending deferreds for no-longer-matched routes or routes we're
                        // about to reload.  Note that if this is an action reload we would have
                        // already cancelled all pending deferreds so this would be a no-op
                        cancelActiveDeferreds(function(routeId) {
                            return !(matches && matches.some(function(m) {
                                return m.route.id === routeId;
                            })) || matchesToLoad && matchesToLoad.some(function(m) {
                                return m.route.id === routeId;
                            });
                        });
                        pendingNavigationLoadId = ++incrementingLoadId;
                        // Short circuit if we have no loaders to run
                        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
                            updatedFetchers = markFetchRedirectsDone();
                            completeNavigation(location, $3a208abeb0ec52b2$var$_extends({
                                matches: matches,
                                loaderData: {},
                                // Commit pending error if we're short circuiting
                                errors: pendingActionResult && $3a208abeb0ec52b2$var$isErrorResult(pendingActionResult[1]) ? (0, $73NPw._)({}, pendingActionResult[0], pendingActionResult[1].error) : null
                            }, $3a208abeb0ec52b2$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                                fetchers: new Map(state.fetchers)
                            } : {}), {
                                flushSync: flushSync
                            });
                            return [
                                2,
                                {
                                    shortCircuited: true
                                }
                            ];
                        }
                        // If this is an uninterrupted revalidation, we remain in our current idle
                        // state.  If not, we need to switch to our loading state and load data,
                        // preserving any new action data or existing action data (in the case of
                        // a revalidation interrupting an actionReload)
                        // If we have partialHydration enabled, then don't update the state for the
                        // initial data load since it's not a "navigation"
                        if (!isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration)) {
                            revalidatingFetchers.forEach(function(rf) {
                                var fetcher = state.fetchers.get(rf.key);
                                var revalidatingFetcher = $3a208abeb0ec52b2$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                                state.fetchers.set(rf.key, revalidatingFetcher);
                            });
                            ;
                            if (pendingActionResult && !$3a208abeb0ec52b2$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
                            // would be a breaking change to use any.
                            // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
                            actionData = (0, $73NPw._)({}, pendingActionResult[0], pendingActionResult[1].data);
                            else if (state.actionData) {
                                if (Object.keys(state.actionData).length === 0) actionData = null;
                                else actionData = state.actionData;
                            }
                            updateState($3a208abeb0ec52b2$var$_extends({
                                navigation: loadingNavigation
                            }, actionData !== undefined ? {
                                actionData: actionData
                            } : {}, revalidatingFetchers.length > 0 ? {
                                fetchers: new Map(state.fetchers)
                            } : {}), {
                                flushSync: flushSync
                            });
                        }
                        revalidatingFetchers.forEach(function(rf) {
                            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
                            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
                            // (via deleteFetcher) does not abort the triggering navigation that
                            // triggered the revalidation
                            fetchControllers.set(rf.key, rf.controller);
                        });
                        // Proxy navigation abort through to revalidation fetchers
                        abortPendingFetchRevalidations = function() {
                            return revalidatingFetchers.forEach(function(f) {
                                return abortFetcher(f.key);
                            });
                        };
                        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
                        return [
                            4,
                            callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request)
                        ];
                    case 1:
                        _ref = _state.sent(), loaderResults = _ref.loaderResults, fetcherResults = _ref.fetcherResults;
                        if (request.signal.aborted) return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        // Clean up _after_ loaders have completed.  Don't clean up if we short
                        // circuited because fetchControllers would have been aborted and
                        // reassigned to new controllers for the next navigation
                        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
                        revalidatingFetchers.forEach(function(rf) {
                            return fetchControllers.delete(rf.key);
                        });
                        // If any loaders returned a redirect Response, start a new REPLACE navigation
                        redirect = $3a208abeb0ec52b2$var$findRedirect((0, $1SMDP._)(loaderResults).concat((0, $1SMDP._)(fetcherResults)));
                        if (!redirect) return [
                            3,
                            3
                        ];
                        if (redirect.idx >= matchesToLoad.length) {
                            // If this redirect came from a fetcher make sure we mark it in
                            // fetchRedirectIds so it doesn't get revalidated on the next set of
                            // loader executions
                            fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                            fetchRedirectIds.add(fetcherKey);
                        }
                        return [
                            4,
                            startRedirectNavigation(request, redirect.result, {
                                replace: replace
                            })
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 3:
                        // Process and commit output from loaders
                        _processLoaderData = $3a208abeb0ec52b2$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds), loaderData = _processLoaderData.loaderData, errors = _processLoaderData.errors;
                        // Wire up subscribers to update loaderData as promises settle
                        activeDeferreds.forEach(function(deferredData, routeId) {
                            deferredData.subscribe(function(aborted) {
                                // Note: No need to updateState here since the TrackedPromise on
                                // loaderData is stable across resolve/reject
                                // Remove this instance if we were aborted or if promises have settled
                                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
                            });
                        });
                        // During partial hydration, preserve SSR errors for routes that don't re-run
                        if (future.v7_partialHydration && initialHydration && state.errors) Object.entries(state.errors).filter(function(_ref2) {
                            var _$_ref2 = (0, $f9AIs._)(_ref2, 1), id = _$_ref2[0];
                            return !matchesToLoad.some(function(m) {
                                return m.route.id === id;
                            });
                        }).forEach(function(_ref3) {
                            var _$_ref3 = (0, $f9AIs._)(_ref3, 2), routeId = _$_ref3[0], error = _$_ref3[1];
                            errors = Object.assign(errors || {}, (0, $73NPw._)({}, routeId, error));
                        });
                        updatedFetchers1 = markFetchRedirectsDone();
                        didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
                        shouldUpdateFetchers = updatedFetchers1 || didAbortFetchLoads || revalidatingFetchers.length > 0;
                        return [
                            2,
                            $3a208abeb0ec52b2$var$_extends({
                                loaderData: loaderData,
                                errors: errors
                            }, shouldUpdateFetchers ? {
                                fetchers: new Map(state.fetchers)
                            } : {})
                        ];
                }
            });
        });
        return _handleLoaders.apply(this, arguments);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        var flushSync = (opts && opts.unstable_flushSync) === true;
        var routesToUse = inFlightDataRoutes || dataRoutes;
        var normalizedPath = $3a208abeb0ec52b2$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        var matches = $3a208abeb0ec52b2$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $3a208abeb0ec52b2$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        var _normalizeNavigateOptions = $3a208abeb0ec52b2$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts), path = _normalizeNavigateOptions.path, submission = _normalizeNavigateOptions.submission, error = _normalizeNavigateOptions.error;
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        var match = $3a208abeb0ec52b2$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $3a208abeb0ec52b2$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission);
    }
    function handleFetcherAction(key, routeId, path, match, requestMatches, flushSync, submission) {
        return _handleFetcherAction.apply(this, arguments);
    }
    function _handleFetcherAction() {
        _handleFetcherAction = // Call the action for the matched fetcher.submit(), and then handle redirects,
        // errors, and revalidation
        (0, $1d3fb01611386816$export$71511d61b312f219)(function(key, routeId, path, match, requestMatches, flushSync, submission) {
            var error, existingFetcher, abortController, fetchRequest, originatingLoadId, actionResults, actionResult, nextLocation, revalidationRequest, routesToUse, matches, loadId, loadFetcher, _getMatchesToLoad, matchesToLoad, revalidatingFetchers, abortPendingFetchRevalidations, _ref, loaderResults, fetcherResults, redirect, fetcherKey, _processLoaderData, loaderData, errors, doneFetcher;
            return (0, $47055dab5b247348$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        interruptActiveLoads();
                        fetchLoadMatches.delete(key);
                        if (!match.route.action && !match.route.lazy) {
                            error = $3a208abeb0ec52b2$var$getInternalRouterError(405, {
                                method: submission.formMethod,
                                pathname: path,
                                routeId: routeId
                            });
                            setFetcherError(key, routeId, error, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        // Put this fetcher into it's submitting state
                        existingFetcher = state.fetchers.get(key);
                        updateFetcherState(key, $3a208abeb0ec52b2$var$getSubmittingFetcher(submission, existingFetcher), {
                            flushSync: flushSync
                        });
                        // Call the action for the fetcher
                        abortController = new AbortController();
                        fetchRequest = $3a208abeb0ec52b2$var$createClientSideRequest(init.history, path, abortController.signal, submission);
                        fetchControllers.set(key, abortController);
                        originatingLoadId = incrementingLoadId;
                        return [
                            4,
                            callDataStrategy("action", fetchRequest, [
                                match
                            ], requestMatches)
                        ];
                    case 1:
                        actionResults = _state.sent();
                        actionResult = actionResults[0];
                        if (fetchRequest.signal.aborted) {
                            // We can delete this so long as we weren't aborted by our own fetcher
                            // re-submit which would have put _new_ controller is in fetchControllers
                            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
                            return [
                                2
                            ];
                        }
                        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
                        // or redirects processed for unmounted fetchers so we just revert them to
                        // idle
                        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
                            if ($3a208abeb0ec52b2$var$isRedirectResult(actionResult) || $3a208abeb0ec52b2$var$isErrorResult(actionResult)) {
                                updateFetcherState(key, $3a208abeb0ec52b2$var$getDoneFetcher(undefined));
                                return [
                                    2
                                ];
                            }
                        } else {
                            if ($3a208abeb0ec52b2$var$isRedirectResult(actionResult)) {
                                fetchControllers.delete(key);
                                if (pendingNavigationLoadId > originatingLoadId) {
                                    // A new navigation was kicked off after our action started, so that
                                    // should take precedence over this redirect navigation.  We already
                                    // set isRevalidationRequired so all loaders for the new route should
                                    // fire unless opted out via shouldRevalidate
                                    updateFetcherState(key, $3a208abeb0ec52b2$var$getDoneFetcher(undefined));
                                    return [
                                        2
                                    ];
                                } else {
                                    fetchRedirectIds.add(key);
                                    updateFetcherState(key, $3a208abeb0ec52b2$var$getLoadingFetcher(submission));
                                    return [
                                        2,
                                        startRedirectNavigation(fetchRequest, actionResult, {
                                            fetcherSubmission: submission
                                        })
                                    ];
                                }
                            }
                            // Process any non-redirect errors thrown
                            if ($3a208abeb0ec52b2$var$isErrorResult(actionResult)) {
                                setFetcherError(key, routeId, actionResult.error);
                                return [
                                    2
                                ];
                            }
                        }
                        if ($3a208abeb0ec52b2$var$isDeferredResult(actionResult)) throw $3a208abeb0ec52b2$var$getInternalRouterError(400, {
                            type: "defer-action"
                        });
                        // Start the data load for current matches, or the next location if we're
                        // in the middle of a navigation
                        nextLocation = state.navigation.location || state.location;
                        revalidationRequest = $3a208abeb0ec52b2$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        matches = state.navigation.state !== "idle" ? $3a208abeb0ec52b2$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
                        $3a208abeb0ec52b2$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
                        loadId = ++incrementingLoadId;
                        fetchReloadIds.set(key, loadId);
                        loadFetcher = $3a208abeb0ec52b2$var$getLoadingFetcher(submission, actionResult.data);
                        state.fetchers.set(key, loadFetcher);
                        _getMatchesToLoad = (0, $f9AIs._)($3a208abeb0ec52b2$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.unstable_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
                            match.route.id,
                            actionResult
                        ]), 2), matchesToLoad = _getMatchesToLoad[0], revalidatingFetchers = _getMatchesToLoad[1];
                        // Put all revalidating fetchers into the loading state, except for the
                        // current fetcher which we want to keep in it's current loading state which
                        // contains it's action submission info + action data
                        revalidatingFetchers.filter(function(rf) {
                            return rf.key !== key;
                        }).forEach(function(rf) {
                            var staleKey = rf.key;
                            var existingFetcher = state.fetchers.get(staleKey);
                            var revalidatingFetcher = $3a208abeb0ec52b2$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
                            state.fetchers.set(staleKey, revalidatingFetcher);
                            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
                            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
                        });
                        updateState({
                            fetchers: new Map(state.fetchers)
                        });
                        abortPendingFetchRevalidations = function() {
                            return revalidatingFetchers.forEach(function(rf) {
                                return abortFetcher(rf.key);
                            });
                        };
                        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
                        return [
                            4,
                            callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest)
                        ];
                    case 2:
                        _ref = _state.sent(), loaderResults = _ref.loaderResults, fetcherResults = _ref.fetcherResults;
                        if (abortController.signal.aborted) return [
                            2
                        ];
                        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
                        fetchReloadIds.delete(key);
                        fetchControllers.delete(key);
                        revalidatingFetchers.forEach(function(r) {
                            return fetchControllers.delete(r.key);
                        });
                        redirect = $3a208abeb0ec52b2$var$findRedirect((0, $1SMDP._)(loaderResults).concat((0, $1SMDP._)(fetcherResults)));
                        if (redirect) {
                            if (redirect.idx >= matchesToLoad.length) {
                                // If this redirect came from a fetcher make sure we mark it in
                                // fetchRedirectIds so it doesn't get revalidated on the next set of
                                // loader executions
                                fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                                fetchRedirectIds.add(fetcherKey);
                            }
                            return [
                                2,
                                startRedirectNavigation(revalidationRequest, redirect.result)
                            ];
                        }
                        // Process and commit output from loaders
                        _processLoaderData = $3a208abeb0ec52b2$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds), loaderData = _processLoaderData.loaderData, errors = _processLoaderData.errors;
                        // Since we let revalidations complete even if the submitting fetcher was
                        // deleted, only put it back to idle if it hasn't been deleted
                        if (state.fetchers.has(key)) {
                            doneFetcher = $3a208abeb0ec52b2$var$getDoneFetcher(actionResult.data);
                            state.fetchers.set(key, doneFetcher);
                        }
                        abortStaleFetchLoads(loadId);
                        // If we are currently in a navigation loading state and this fetcher is
                        // more recent than the navigation, we want the newer data so abort the
                        // navigation and complete it with the fetcher data
                        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
                            $3a208abeb0ec52b2$export$3e9cee6b33872309(pendingAction, "Expected pending action");
                            pendingNavigationController && pendingNavigationController.abort();
                            completeNavigation(state.navigation.location, {
                                matches: matches,
                                loaderData: loaderData,
                                errors: errors,
                                fetchers: new Map(state.fetchers)
                            });
                        } else {
                            // otherwise just update with the fetcher data, preserving any existing
                            // loaderData for loaders that did not need to reload.  We have to
                            // manually merge here since we aren't going through completeNavigation
                            updateState({
                                errors: errors,
                                loaderData: $3a208abeb0ec52b2$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                                fetchers: new Map(state.fetchers)
                            });
                            isRevalidationRequired = false;
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return _handleFetcherAction.apply(this, arguments);
    }
    function handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission) {
        return _handleFetcherLoader.apply(this, arguments);
    }
    function _handleFetcherLoader() {
        _handleFetcherLoader = // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
        (0, $1d3fb01611386816$export$71511d61b312f219)(function(key, routeId, path, match, matches, flushSync, submission) {
            var existingFetcher, abortController, fetchRequest, originatingLoadId, results, result;
            return (0, $47055dab5b247348$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        existingFetcher = state.fetchers.get(key);
                        updateFetcherState(key, $3a208abeb0ec52b2$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
                            flushSync: flushSync
                        });
                        // Call the loader for this fetcher route match
                        abortController = new AbortController();
                        fetchRequest = $3a208abeb0ec52b2$var$createClientSideRequest(init.history, path, abortController.signal);
                        fetchControllers.set(key, abortController);
                        originatingLoadId = incrementingLoadId;
                        return [
                            4,
                            callDataStrategy("loader", fetchRequest, [
                                match
                            ], matches)
                        ];
                    case 1:
                        results = _state.sent();
                        result = results[0];
                        if (!$3a208abeb0ec52b2$var$isDeferredResult(result)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            $3a208abeb0ec52b2$var$resolveDeferredData(result, fetchRequest.signal, true)
                        ];
                    case 2:
                        result = _state.sent() || result;
                        _state.label = 3;
                    case 3:
                        // We can delete this so long as we weren't aborted by our our own fetcher
                        // re-load which would have put _new_ controller is in fetchControllers
                        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
                        if (fetchRequest.signal.aborted) return [
                            2
                        ];
                        // We don't want errors bubbling up or redirects followed for unmounted
                        // fetchers, so short circuit here if it was removed from the UI
                        if (deletedFetchers.has(key)) {
                            updateFetcherState(key, $3a208abeb0ec52b2$var$getDoneFetcher(undefined));
                            return [
                                2
                            ];
                        }
                        if (!$3a208abeb0ec52b2$var$isRedirectResult(result)) return [
                            3,
                            6
                        ];
                        if (!(pendingNavigationLoadId > originatingLoadId)) return [
                            3,
                            4
                        ];
                        // A new navigation was kicked off after our loader started, so that
                        // should take precedence over this redirect navigation
                        updateFetcherState(key, $3a208abeb0ec52b2$var$getDoneFetcher(undefined));
                        return [
                            2
                        ];
                    case 4:
                        fetchRedirectIds.add(key);
                        return [
                            4,
                            startRedirectNavigation(fetchRequest, result)
                        ];
                    case 5:
                        _state.sent();
                        return [
                            2
                        ];
                    case 6:
                        // Process any non-redirect errors thrown
                        if ($3a208abeb0ec52b2$var$isErrorResult(result)) {
                            setFetcherError(key, routeId, result.error);
                            return [
                                2
                            ];
                        }
                        $3a208abeb0ec52b2$export$3e9cee6b33872309(!$3a208abeb0ec52b2$var$isDeferredResult(result), "Unhandled fetcher deferred data");
                        // Put the fetcher back into an idle state
                        updateFetcherState(key, $3a208abeb0ec52b2$var$getDoneFetcher(result.data));
                        return [
                            2
                        ];
                }
            });
        });
        return _handleFetcherLoader.apply(this, arguments);
    }
    function startRedirectNavigation(request, redirect, _temp2) {
        return _startRedirectNavigation.apply(this, arguments);
    }
    function _startRedirectNavigation() {
        _startRedirectNavigation = /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ (0, $1d3fb01611386816$export$71511d61b312f219)(function(request, redirect, _temp2) {
            var _ref, submission, fetcherSubmission, replace, location, redirectLocation, isDocumentReload, url, redirectHistoryAction, _state_navigation, formMethod, formAction, formEncType, activeSubmission, overrideNavigation;
            return (0, $47055dab5b247348$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _temp2 === void 0 ? {} : _temp2, submission = _ref.submission, fetcherSubmission = _ref.fetcherSubmission, replace = _ref.replace;
                        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
                        location = redirect.response.headers.get("Location");
                        $3a208abeb0ec52b2$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
                        location = $3a208abeb0ec52b2$var$normalizeRedirectLocation(location, new URL(request.url), basename);
                        redirectLocation = $3a208abeb0ec52b2$var$createLocation(state.location, location, {
                            _isRedirect: true
                        });
                        if (isBrowser) {
                            isDocumentReload = false;
                            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
                            isDocumentReload = true;
                            else if ($3a208abeb0ec52b2$var$ABSOLUTE_URL_REGEX.test(location)) {
                                url = init.history.createURL(location);
                                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                                $3a208abeb0ec52b2$export$b69e3301ce081aa3(url.pathname, basename) == null;
                            }
                            if (isDocumentReload) {
                                if (replace) routerWindow.location.replace(location);
                                else routerWindow.location.assign(location);
                                return [
                                    2
                                ];
                            }
                        }
                        // There's no need to abort on redirects, since we don't detect the
                        // redirect until the action/loaders have settled
                        pendingNavigationController = null;
                        redirectHistoryAction = replace === true ? $3a208abeb0ec52b2$export$e19cd5f9376f8cee.Replace : $3a208abeb0ec52b2$export$e19cd5f9376f8cee.Push;
                        // Use the incoming submission if provided, fallback on the active one in
                        // state.navigation
                        _state_navigation = state.navigation, formMethod = _state_navigation.formMethod, formAction = _state_navigation.formAction, formEncType = _state_navigation.formEncType;
                        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $3a208abeb0ec52b2$var$getSubmissionFromNavigation(state.navigation);
                        // If this was a 307/308 submission we want to preserve the HTTP method and
                        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
                        // redirected location
                        activeSubmission = submission || fetcherSubmission;
                        if (!($3a208abeb0ec52b2$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $3a208abeb0ec52b2$var$isMutationMethod(activeSubmission.formMethod))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            startNavigation(redirectHistoryAction, redirectLocation, {
                                submission: $3a208abeb0ec52b2$var$_extends({}, activeSubmission, {
                                    formAction: location
                                }),
                                // Preserve this flag across redirects
                                preventScrollReset: pendingPreventScrollReset
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        // If we have a navigation submission, we will preserve it through the
                        // redirect navigation
                        overrideNavigation = $3a208abeb0ec52b2$var$getLoadingNavigation(redirectLocation, submission);
                        return [
                            4,
                            startNavigation(redirectHistoryAction, redirectLocation, {
                                overrideNavigation: overrideNavigation,
                                // Send fetcher submissions through for shouldRevalidate
                                fetcherSubmission: fetcherSubmission,
                                // Preserve this flag across redirects
                                preventScrollReset: pendingPreventScrollReset
                            })
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return _startRedirectNavigation.apply(this, arguments);
    }
    function callDataStrategy(type, request, matchesToLoad, matches) {
        return _callDataStrategy.apply(this, arguments);
    }
    function _callDataStrategy() {
        _callDataStrategy = // Utility wrapper for calling dataStrategy client-side without having to
        // pass around the manifest, mapRouteProperties, etc.
        (0, $1d3fb01611386816$export$71511d61b312f219)(function(type, request, matchesToLoad, matches) {
            var results, e;
            return (0, $47055dab5b247348$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            $3a208abeb0ec52b2$var$callDataStrategyImpl(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties)
                        ];
                    case 1:
                        results = _state.sent();
                        return [
                            4,
                            Promise.all(results.map(function(result, i) {
                                if ($3a208abeb0ec52b2$var$isRedirectHandlerResult(result)) {
                                    var response = result.result;
                                    return {
                                        type: $3a208abeb0ec52b2$var$ResultType.redirect,
                                        response: $3a208abeb0ec52b2$var$normalizeRelativeRoutingRedirectResponse(response, request, matchesToLoad[i].route.id, matches, basename, future.v7_relativeSplatPath)
                                    };
                                }
                                return $3a208abeb0ec52b2$var$convertHandlerResultToDataResult(result);
                            }))
                        ];
                    case 2:
                        return [
                            2,
                            _state.sent()
                        ];
                    case 3:
                        e = _state.sent();
                        // If the outer dataStrategy method throws, just return the error for all
                        // matches - and it'll naturally bubble to the root
                        return [
                            2,
                            matchesToLoad.map(function() {
                                return {
                                    type: $3a208abeb0ec52b2$var$ResultType.error,
                                    error: e
                                };
                            })
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return _callDataStrategy.apply(this, arguments);
    }
    function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        return _callLoadersAndMaybeResolveData.apply(this, arguments);
    }
    function _callLoadersAndMaybeResolveData() {
        _callLoadersAndMaybeResolveData = (0, $1d3fb01611386816$export$71511d61b312f219)(function(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
            var _ref, loaderResults, fetcherResults;
            return (0, $47055dab5b247348$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            Promise.all([
                                matchesToLoad.length ? callDataStrategy("loader", request, matchesToLoad, matches) : []
                            ].concat((0, $1SMDP._)(fetchersToLoad.map(function(f) {
                                if (f.matches && f.match && f.controller) {
                                    var fetcherRequest = $3a208abeb0ec52b2$var$createClientSideRequest(init.history, f.path, f.controller.signal);
                                    return callDataStrategy("loader", fetcherRequest, [
                                        f.match
                                    ], f.matches).then(function(r) {
                                        return r[0];
                                    });
                                } else return Promise.resolve({
                                    type: $3a208abeb0ec52b2$var$ResultType.error,
                                    error: $3a208abeb0ec52b2$var$getInternalRouterError(404, {
                                        pathname: f.path
                                    })
                                });
                            }))))
                        ];
                    case 1:
                        _ref = (0, $e71697af67a1332e$export$71511d61b312f219).apply(void 0, [
                            _state.sent()
                        ]), loaderResults = _ref[0], fetcherResults = _ref.slice(1);
                        return [
                            4,
                            Promise.all([
                                $3a208abeb0ec52b2$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(function() {
                                    return request.signal;
                                }), false, state.loaderData),
                                $3a208abeb0ec52b2$var$resolveDeferredResults(currentMatches, fetchersToLoad.map(function(f) {
                                    return f.match;
                                }), fetcherResults, fetchersToLoad.map(function(f) {
                                    return f.controller ? f.controller.signal : null;
                                }), true)
                            ])
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2,
                            {
                                loaderResults: loaderResults,
                                fetcherResults: fetcherResults
                            }
                        ];
                }
            });
        });
        return _callLoadersAndMaybeResolveData.apply(this, arguments);
    }
    function interruptActiveLoads() {
        var // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        _cancelledDeferredRoutes;
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        (_cancelledDeferredRoutes = cancelledDeferredRoutes).push.apply(_cancelledDeferredRoutes, (0, $1SMDP._)(cancelActiveDeferreds()));
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach(function(_, key) {
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        var boundaryMatch = $3a208abeb0ec52b2$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: (0, $73NPw._)({}, boundaryMatch.route.id, error),
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $3a208abeb0ec52b2$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        var fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            var count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        var controller = fetchControllers.get(key);
        $3a208abeb0ec52b2$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var fetcher = getFetcher(key);
                var doneFetcher = $3a208abeb0ec52b2$var$getDoneFetcher(fetcher.data);
                state.fetchers.set(key, doneFetcher);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    function markFetchRedirectsDone() {
        var doneKeys = [];
        var updatedFetchers = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fetchRedirectIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var fetcher = state.fetchers.get(key);
                $3a208abeb0ec52b2$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
                if (fetcher.state === "loading") {
                    fetchRedirectIds.delete(key);
                    doneKeys.push(key);
                    updatedFetchers = true;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        var yeetedKeys = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fetchReloadIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $f9AIs._)(_step.value, 2), key = _step_value[0], id = _step_value[1];
                if (id < landedId) {
                    var fetcher = state.fetchers.get(key);
                    $3a208abeb0ec52b2$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
                    if (fetcher.state === "loading") {
                        abortFetcher(key);
                        fetchReloadIds.delete(key);
                        yeetedKeys.push(key);
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        var blocker = state.blockers.get(key) || $3a208abeb0ec52b2$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        var blocker = state.blockers.get(key) || $3a208abeb0ec52b2$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $3a208abeb0ec52b2$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        var blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref4) {
        var currentLocation = _ref4.currentLocation, nextLocation = _ref4.nextLocation, historyAction = _ref4.historyAction;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $3a208abeb0ec52b2$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        var entries = Array.from(blockerFunctions.entries());
        var _entries_ = (0, $f9AIs._)(entries[entries.length - 1], 2), blockerKey = _entries_[0], blockerFunction = _entries_[1];
        var blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        var cancelledRouteIds = [];
        activeDeferreds.forEach(function(dfd, routeId) {
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $3a208abeb0ec52b2$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            var y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return function() {
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            var key = getScrollRestorationKey(location, matches.map(function(m) {
                return $3a208abeb0ec52b2$export$b3fac024fad9e8ff(m, state.loaderData);
            }));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            var key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            var key = getScrollKey(location, matches);
            var y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $3a208abeb0ec52b2$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: function(to) {
            return init.history.createHref(to);
        },
        encodeLocation: function(to) {
            return init.history.encodeLocation(to);
        },
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes: _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
var $3a208abeb0ec52b2$export$4d0306f8f6a4585b = Symbol("deferred");
function $3a208abeb0ec52b2$export$3336b097a6fbc59a(routes, opts) {
    $3a208abeb0ec52b2$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    var manifest = {};
    var basename = (opts ? opts.basename : null) || "/";
    var mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        var detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = function(route) {
            return {
                hasErrorBoundary: detectErrorBoundary(route)
            };
        };
    } else mapRouteProperties = $3a208abeb0ec52b2$var$defaultMapRouteProperties;
    // Config driven behavior flags
    var future = $3a208abeb0ec52b2$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    var dataRoutes = $3a208abeb0ec52b2$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    function query(request, _temp3) {
        return _query.apply(this, arguments);
    }
    function _query() {
        _query = /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ (0, $1d3fb01611386816$export$71511d61b312f219)(function(request, _temp3) {
            var _ref, requestContext, skipLoaderErrorBubbling, unstable_dataStrategy, url, method, location, matches, error, _getShortCircuitMatches, methodNotAllowedMatches, route, error1, _getShortCircuitMatches1, notFoundMatches, route1, result;
            return (0, $47055dab5b247348$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _temp3 === void 0 ? {} : _temp3, requestContext = _ref.requestContext, skipLoaderErrorBubbling = _ref.skipLoaderErrorBubbling, unstable_dataStrategy = _ref.unstable_dataStrategy;
                        url = new URL(request.url);
                        method = request.method;
                        location = $3a208abeb0ec52b2$var$createLocation("", $3a208abeb0ec52b2$export$fe53371bee54353d(url), null, "default");
                        matches = $3a208abeb0ec52b2$export$2708184779ceb39d(dataRoutes, location, basename);
                        // SSR supports HEAD requests while SPA doesn't
                        if (!$3a208abeb0ec52b2$var$isValidMethod(method) && method !== "HEAD") {
                            error = $3a208abeb0ec52b2$var$getInternalRouterError(405, {
                                method: method
                            });
                            _getShortCircuitMatches = $3a208abeb0ec52b2$var$getShortCircuitMatches(dataRoutes), methodNotAllowedMatches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
                            return [
                                2,
                                {
                                    basename: basename,
                                    location: location,
                                    matches: methodNotAllowedMatches,
                                    loaderData: {},
                                    actionData: null,
                                    errors: (0, $73NPw._)({}, route.id, error),
                                    statusCode: error.status,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        } else if (!matches) {
                            error1 = $3a208abeb0ec52b2$var$getInternalRouterError(404, {
                                pathname: location.pathname
                            });
                            _getShortCircuitMatches1 = $3a208abeb0ec52b2$var$getShortCircuitMatches(dataRoutes), notFoundMatches = _getShortCircuitMatches1.matches, route1 = _getShortCircuitMatches1.route;
                            return [
                                2,
                                {
                                    basename: basename,
                                    location: location,
                                    matches: notFoundMatches,
                                    loaderData: {},
                                    actionData: null,
                                    errors: (0, $73NPw._)({}, route1.id, error1),
                                    statusCode: error1.status,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        }
                        return [
                            4,
                            queryImpl(request, location, matches, requestContext, unstable_dataStrategy || null, skipLoaderErrorBubbling === true, null)
                        ];
                    case 1:
                        result = _state.sent();
                        if ($3a208abeb0ec52b2$var$isResponse(result)) return [
                            2,
                            result
                        ];
                        // When returning StaticHandlerContext, we patch back in the location here
                        // since we need it for React Context.  But this helps keep our submit and
                        // loadRouteData operating on a Request instead of a Location
                        return [
                            2,
                            $3a208abeb0ec52b2$var$_extends({
                                location: location,
                                basename: basename
                            }, result)
                        ];
                }
            });
        });
        return _query.apply(this, arguments);
    }
    function queryRoute(request, _temp4) {
        return _queryRoute.apply(this, arguments);
    }
    function _queryRoute() {
        _queryRoute = /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ (0, $1d3fb01611386816$export$71511d61b312f219)(function(request, _temp4) {
            var _ref, routeId, requestContext, url, method, location, matches, match, result, error, _result$activeDeferre, data;
            return (0, $47055dab5b247348$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _temp4 === void 0 ? {} : _temp4, routeId = _ref.routeId, requestContext = _ref.requestContext;
                        url = new URL(request.url);
                        method = request.method;
                        location = $3a208abeb0ec52b2$var$createLocation("", $3a208abeb0ec52b2$export$fe53371bee54353d(url), null, "default");
                        matches = $3a208abeb0ec52b2$export$2708184779ceb39d(dataRoutes, location, basename);
                        // SSR supports HEAD requests while SPA doesn't
                        if (!$3a208abeb0ec52b2$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $3a208abeb0ec52b2$var$getInternalRouterError(405, {
                            method: method
                        });
                        else if (!matches) throw $3a208abeb0ec52b2$var$getInternalRouterError(404, {
                            pathname: location.pathname
                        });
                        match = routeId ? matches.find(function(m) {
                            return m.route.id === routeId;
                        }) : $3a208abeb0ec52b2$var$getTargetMatch(matches, location);
                        if (routeId && !match) throw $3a208abeb0ec52b2$var$getInternalRouterError(403, {
                            pathname: location.pathname,
                            routeId: routeId
                        });
                        else if (!match) // This should never hit I don't think?
                        throw $3a208abeb0ec52b2$var$getInternalRouterError(404, {
                            pathname: location.pathname
                        });
                        return [
                            4,
                            queryImpl(request, location, matches, requestContext, null, false, match)
                        ];
                    case 1:
                        result = _state.sent();
                        if ($3a208abeb0ec52b2$var$isResponse(result)) return [
                            2,
                            result
                        ];
                        error = result.errors ? Object.values(result.errors)[0] : undefined;
                        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
                        // _something_ that wasn't a Response, but it's not guaranteed/required
                        // to be an `instanceof Error` either, so we have to use throw here to
                        // preserve the "error" state outside of queryImpl.
                        throw error;
                        // Pick off the right state value to return
                        if (result.actionData) return [
                            2,
                            Object.values(result.actionData)[0]
                        ];
                        if (result.loaderData) {
                            ;
                            data = Object.values(result.loaderData)[0];
                            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$3a208abeb0ec52b2$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
                            return [
                                2,
                                data
                            ];
                        }
                        return [
                            2,
                            undefined
                        ];
                }
            });
        });
        return _queryRoute.apply(this, arguments);
    }
    function queryImpl(request, location, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        return _queryImpl.apply(this, arguments);
    }
    function _queryImpl() {
        _queryImpl = (0, $1d3fb01611386816$export$71511d61b312f219)(function(request, location, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch) {
            var result, result1, e;
            return (0, $47055dab5b247348$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        $3a208abeb0ec52b2$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        if (!$3a208abeb0ec52b2$var$isMutationMethod(request.method.toLowerCase())) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            submit(request, matches, routeMatch || $3a208abeb0ec52b2$var$getTargetMatch(matches, location), requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch != null)
                        ];
                    case 2:
                        result = _state.sent();
                        return [
                            2,
                            result
                        ];
                    case 3:
                        return [
                            4,
                            loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch)
                        ];
                    case 4:
                        result1 = _state.sent();
                        return [
                            2,
                            $3a208abeb0ec52b2$var$isResponse(result1) ? result1 : $3a208abeb0ec52b2$var$_extends({}, result1, {
                                actionData: null,
                                actionHeaders: {}
                            })
                        ];
                    case 5:
                        e = _state.sent();
                        // If the user threw/returned a Response in callLoaderOrAction for a
                        // `queryRoute` call, we throw the `HandlerResult` to bail out early
                        // and then return or throw the raw Response here accordingly
                        if ($3a208abeb0ec52b2$var$isHandlerResult(e) && $3a208abeb0ec52b2$var$isResponse(e.result)) {
                            if (e.type === $3a208abeb0ec52b2$var$ResultType.error) throw e.result;
                            return [
                                2,
                                e.result
                            ];
                        }
                        // Redirects are always returned since they don't propagate to catch
                        // boundaries
                        if ($3a208abeb0ec52b2$var$isRedirectResponse(e)) return [
                            2,
                            e
                        ];
                        throw e;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return _queryImpl.apply(this, arguments);
    }
    function submit(request, matches, actionMatch, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        return _submit.apply(this, arguments);
    }
    function _submit() {
        _submit = (0, $1d3fb01611386816$export$71511d61b312f219)(function(request, matches, actionMatch, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
            var result, error, results, error1, loaderRequest, boundaryMatch, context, context1;
            return (0, $47055dab5b247348$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(!actionMatch.route.action && !actionMatch.route.lazy)) return [
                            3,
                            1
                        ];
                        error = $3a208abeb0ec52b2$var$getInternalRouterError(405, {
                            method: request.method,
                            pathname: new URL(request.url).pathname,
                            routeId: actionMatch.route.id
                        });
                        if (isRouteRequest) throw error;
                        result = {
                            type: $3a208abeb0ec52b2$var$ResultType.error,
                            error: error
                        };
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            callDataStrategy("action", request, [
                                actionMatch
                            ], matches, isRouteRequest, requestContext, unstable_dataStrategy)
                        ];
                    case 2:
                        results = _state.sent();
                        result = results[0];
                        if (request.signal.aborted) $3a208abeb0ec52b2$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
                        _state.label = 3;
                    case 3:
                        if ($3a208abeb0ec52b2$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
                        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
                        // can get back on the "throw all redirect responses" train here should
                        // this ever happen :/
                        throw new Response(null, {
                            status: result.response.status,
                            headers: {
                                Location: result.response.headers.get("Location")
                            }
                        });
                        if ($3a208abeb0ec52b2$var$isDeferredResult(result)) {
                            error1 = $3a208abeb0ec52b2$var$getInternalRouterError(400, {
                                type: "defer-action"
                            });
                            if (isRouteRequest) throw error1;
                            result = {
                                type: $3a208abeb0ec52b2$var$ResultType.error,
                                error: error1
                            };
                        }
                        if (isRouteRequest) {
                            // Note: This should only be non-Response values if we get here, since
                            // isRouteRequest should throw any Response received in callLoaderOrAction
                            if ($3a208abeb0ec52b2$var$isErrorResult(result)) throw result.error;
                            return [
                                2,
                                {
                                    matches: [
                                        actionMatch
                                    ],
                                    loaderData: {},
                                    actionData: (0, $73NPw._)({}, actionMatch.route.id, result.data),
                                    errors: null,
                                    // Note: statusCode + headers are unused here since queryRoute will
                                    // return the raw Response or value
                                    statusCode: 200,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        }
                        // Create a GET request for the loaders
                        loaderRequest = new Request(request.url, {
                            headers: request.headers,
                            redirect: request.redirect,
                            signal: request.signal
                        });
                        if (!$3a208abeb0ec52b2$var$isErrorResult(result)) return [
                            3,
                            5
                        ];
                        // Store off the pending error - we use it to determine which loaders
                        // to call and will commit it when we complete the navigation
                        boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $3a208abeb0ec52b2$var$findNearestBoundary(matches, actionMatch.route.id);
                        return [
                            4,
                            loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null, [
                                boundaryMatch.route.id,
                                result
                            ])
                        ];
                    case 4:
                        context = _state.sent();
                        // action status codes take precedence over loader status codes
                        return [
                            2,
                            $3a208abeb0ec52b2$var$_extends({}, context, {
                                statusCode: $3a208abeb0ec52b2$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                                actionData: null,
                                actionHeaders: $3a208abeb0ec52b2$var$_extends({}, result.headers ? (0, $73NPw._)({}, actionMatch.route.id, result.headers) : {})
                            })
                        ];
                    case 5:
                        return [
                            4,
                            loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null)
                        ];
                    case 6:
                        context1 = _state.sent();
                        return [
                            2,
                            $3a208abeb0ec52b2$var$_extends({}, context1, {
                                actionData: (0, $73NPw._)({}, actionMatch.route.id, result.data)
                            }, result.statusCode ? {
                                statusCode: result.statusCode
                            } : {}, {
                                actionHeaders: result.headers ? (0, $73NPw._)({}, actionMatch.route.id, result.headers) : {}
                            })
                        ];
                }
            });
        });
        return _submit.apply(this, arguments);
    }
    function loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        return _loadRouteData.apply(this, arguments);
    }
    function _loadRouteData() {
        _loadRouteData = (0, $1d3fb01611386816$export$71511d61b312f219)(function(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
            var isRouteRequest, requestMatches, matchesToLoad, results, activeDeferreds, context, executedLoaders;
            return (0, $47055dab5b247348$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isRouteRequest = routeMatch != null;
                        // Short circuit if we have no loaders to run (queryRoute())
                        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $3a208abeb0ec52b2$var$getInternalRouterError(400, {
                            method: request.method,
                            pathname: new URL(request.url).pathname,
                            routeId: routeMatch == null ? void 0 : routeMatch.route.id
                        });
                        requestMatches = routeMatch ? [
                            routeMatch
                        ] : pendingActionResult && $3a208abeb0ec52b2$var$isErrorResult(pendingActionResult[1]) ? $3a208abeb0ec52b2$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
                        matchesToLoad = requestMatches.filter(function(m) {
                            return m.route.loader || m.route.lazy;
                        });
                        // Short circuit if we have no loaders to run (query())
                        if (matchesToLoad.length === 0) return [
                            2,
                            {
                                matches: matches,
                                // Add a null for all matched routes for proper revalidation on the client
                                loaderData: matches.reduce(function(acc, m) {
                                    return Object.assign(acc, (0, $73NPw._)({}, m.route.id, null));
                                }, {}),
                                errors: pendingActionResult && $3a208abeb0ec52b2$var$isErrorResult(pendingActionResult[1]) ? (0, $73NPw._)({}, pendingActionResult[0], pendingActionResult[1].error) : null,
                                statusCode: 200,
                                loaderHeaders: {},
                                activeDeferreds: null
                            }
                        ];
                        return [
                            4,
                            callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy)
                        ];
                    case 1:
                        results = _state.sent();
                        if (request.signal.aborted) $3a208abeb0ec52b2$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
                        // Process and commit output from loaders
                        activeDeferreds = new Map();
                        context = $3a208abeb0ec52b2$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
                        // Add a null for any non-loader matches for proper revalidation on the client
                        executedLoaders = new Set(matchesToLoad.map(function(match) {
                            return match.route.id;
                        }));
                        matches.forEach(function(match) {
                            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
                        });
                        return [
                            2,
                            $3a208abeb0ec52b2$var$_extends({}, context, {
                                matches: matches,
                                activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
                            })
                        ];
                }
            });
        });
        return _loadRouteData.apply(this, arguments);
    }
    function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy) {
        return _callDataStrategy.apply(this, arguments);
    }
    function _callDataStrategy() {
        _callDataStrategy = // Utility wrapper for calling dataStrategy server-side without having to
        // pass around the manifest, mapRouteProperties, etc.
        (0, $1d3fb01611386816$export$71511d61b312f219)(function(type, request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy) {
            var results;
            return (0, $47055dab5b247348$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            $3a208abeb0ec52b2$var$callDataStrategyImpl(unstable_dataStrategy || $3a208abeb0ec52b2$var$defaultDataStrategy, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext)
                        ];
                    case 1:
                        results = _state.sent();
                        return [
                            4,
                            Promise.all(results.map(function(result, i) {
                                if ($3a208abeb0ec52b2$var$isRedirectHandlerResult(result)) {
                                    var response = result.result;
                                    // Throw redirects and let the server handle them with an HTTP redirect
                                    throw $3a208abeb0ec52b2$var$normalizeRelativeRoutingRedirectResponse(response, request, matchesToLoad[i].route.id, matches, basename, future.v7_relativeSplatPath);
                                }
                                if ($3a208abeb0ec52b2$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
                                // directly without unwrapping
                                throw result;
                                return $3a208abeb0ec52b2$var$convertHandlerResultToDataResult(result);
                            }))
                        ];
                    case 2:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return _callDataStrategy.apply(this, arguments);
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $3a208abeb0ec52b2$export$fec11da027c70692(routes, context, error) {
    var newContext = $3a208abeb0ec52b2$var$_extends({}, context, {
        statusCode: $3a208abeb0ec52b2$export$972111febbeef05b(error) ? error.status : 500,
        errors: (0, $73NPw._)({}, context._deepestRenderedBoundaryId || routes[0].id, error)
    });
    return newContext;
}
function $3a208abeb0ec52b2$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    var method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $3a208abeb0ec52b2$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $3a208abeb0ec52b2$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    var contextualMatches;
    var activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var match = _step.value;
                contextualMatches.push(match);
                if (match.route.id === fromRouteId) {
                    activeRouteMatch = match;
                    break;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    var path = $3a208abeb0ec52b2$export$cae722b0cc860f13(to ? to : ".", $3a208abeb0ec52b2$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $3a208abeb0ec52b2$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$3a208abeb0ec52b2$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $3a208abeb0ec52b2$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $3a208abeb0ec52b2$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $3a208abeb0ec52b2$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$3a208abeb0ec52b2$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$3a208abeb0ec52b2$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $3a208abeb0ec52b2$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    var getInvalidBodyError = function() {
        return {
            path: path,
            error: $3a208abeb0ec52b2$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        };
    };
    // Create a Submission on non-GET navigations
    var rawFormMethod = opts.formMethod || "get";
    var formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    var formAction = $3a208abeb0ec52b2$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$3a208abeb0ec52b2$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            var text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce(function(acc, _ref5) {
                var _$_ref5 = (0, $f9AIs._)(_ref5, 2), name = _$_ref5[0], value = _$_ref5[1];
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$3a208abeb0ec52b2$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                var json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $3a208abeb0ec52b2$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    var searchParams;
    var formData;
    if (opts.formData) {
        searchParams = $3a208abeb0ec52b2$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $3a208abeb0ec52b2$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $3a208abeb0ec52b2$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $3a208abeb0ec52b2$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    var submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($3a208abeb0ec52b2$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    var parsedPath = $3a208abeb0ec52b2$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $3a208abeb0ec52b2$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $3a208abeb0ec52b2$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $3a208abeb0ec52b2$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    var boundaryMatches = matches;
    if (boundaryId) {
        var index = matches.findIndex(function(m) {
            return m.route.id === boundaryId;
        });
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $3a208abeb0ec52b2$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    var actionResult = pendingActionResult ? $3a208abeb0ec52b2$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    var currentUrl = history.createURL(state.location);
    var nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    var boundaryId = pendingActionResult && $3a208abeb0ec52b2$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[0] : undefined;
    var boundaryMatches = boundaryId ? $3a208abeb0ec52b2$var$getLoaderMatchesUntilBoundary(matches, boundaryId) : matches;
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    var actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    var shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    var navigationMatches = boundaryMatches.filter(function(match, index) {
        var route = match.route;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (typeof route.loader !== "function" || route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if ($3a208abeb0ec52b2$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some(function(id) {
            return id === match.route.id;
        })) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        var currentRouteMatch = state.matches[index];
        var nextRouteMatch = match;
        return $3a208abeb0ec52b2$var$shouldRevalidateLoader(match, $3a208abeb0ec52b2$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            unstable_actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $3a208abeb0ec52b2$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    var revalidatingFetchers = [];
    fetchLoadMatches.forEach(function(f, key) {
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some(function(m) {
            return m.route.id === f.routeId;
        }) || deletedFetchers.has(key)) return;
        var fetcherMatches = $3a208abeb0ec52b2$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        var fetcher = state.fetchers.get(key);
        var fetcherMatch = $3a208abeb0ec52b2$var$getTargetMatch(fetcherMatches, f.path);
        var shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $3a208abeb0ec52b2$var$shouldRevalidateLoader(fetcherMatch, $3a208abeb0ec52b2$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            unstable_actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $3a208abeb0ec52b2$var$isNewLoader(currentLoaderData, currentMatch, match) {
    var isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    var isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $3a208abeb0ec52b2$var$isNewRouteInstance(currentMatch, match) {
    var currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $3a208abeb0ec52b2$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        var routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $3a208abeb0ec52b2$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    return $3a208abeb0ec52b2$var$_loadLazyRouteModule.apply(this, arguments);
}
function $3a208abeb0ec52b2$var$_loadLazyRouteModule() {
    $3a208abeb0ec52b2$var$_loadLazyRouteModule = /**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ (0, $1d3fb01611386816$export$71511d61b312f219)(function(route, mapRouteProperties, manifest) {
        var lazyRoute, routeToUpdate, routeUpdates, lazyRouteProperty, staticRouteValue, isPropertyStaticallyDefined;
        return (0, $47055dab5b247348$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!route.lazy) return [
                        2
                    ];
                    return [
                        4,
                        route.lazy()
                    ];
                case 1:
                    lazyRoute = _state.sent();
                    // If the lazy route function was executed and removed by another parallel
                    // call then we can return - first lazy() to finish wins because the return
                    // value of lazy is expected to be static
                    if (!route.lazy) return [
                        2
                    ];
                    routeToUpdate = manifest[route.id];
                    $3a208abeb0ec52b2$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
                    // Update the route in place.  This should be safe because there's no way
                    // we could yet be sitting on this route as we can't get there without
                    // resolving lazy() first.
                    //
                    // This is different than the HMR "update" use-case where we may actively be
                    // on the route being updated.  The main concern boils down to "does this
                    // mutation affect any ongoing navigations or any current state.matches
                    // values?".  If not, it should be safe to update in place.
                    routeUpdates = {};
                    for(var lazyRouteProperty in lazyRoute){
                        staticRouteValue = routeToUpdate[lazyRouteProperty];
                        isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
                        // on the route updates
                        lazyRouteProperty !== "hasErrorBoundary";
                        $3a208abeb0ec52b2$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
                        if (!isPropertyStaticallyDefined && !$3a208abeb0ec52b2$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
                    }
                    // Mutate the route with the provided updates.  Do this first so we pass
                    // the updated version to mapRouteProperties
                    Object.assign(routeToUpdate, routeUpdates);
                    // Mutate the `hasErrorBoundary` property on the route based on the route
                    // updates and remove the `lazy` function so we don't resolve the lazy
                    // route again.
                    Object.assign(routeToUpdate, $3a208abeb0ec52b2$var$_extends({}, mapRouteProperties(routeToUpdate), {
                        lazy: undefined
                    }));
                    return [
                        2
                    ];
            }
        });
    });
    return $3a208abeb0ec52b2$var$_loadLazyRouteModule.apply(this, arguments);
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
function $3a208abeb0ec52b2$var$defaultDataStrategy(opts) {
    return Promise.all(opts.matches.map(function(m) {
        return m.resolve();
    }));
}
function $3a208abeb0ec52b2$var$callDataStrategyImpl(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext) {
    return $3a208abeb0ec52b2$var$_callDataStrategyImpl.apply(this, arguments);
}
function $3a208abeb0ec52b2$var$_callDataStrategyImpl() {
    $3a208abeb0ec52b2$var$_callDataStrategyImpl = (0, $1d3fb01611386816$export$71511d61b312f219)(function(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext) {
        var routeIdsToLoad, loadedMatches, results;
        return (0, $47055dab5b247348$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    routeIdsToLoad = matchesToLoad.reduce(function(acc, m) {
                        return acc.add(m.route.id);
                    }, new Set());
                    loadedMatches = new Set();
                    return [
                        4,
                        dataStrategyImpl({
                            matches: matches.map(function(match) {
                                var shouldLoad = routeIdsToLoad.has(match.route.id);
                                // `resolve` encapsulates the route.lazy, executing the
                                // loader/action, and mapping return values/thrown errors to a
                                // HandlerResult.  Users can pass a callback to take fine-grained control
                                // over the execution of the loader/action
                                var resolve = function(handlerOverride) {
                                    loadedMatches.add(match.route.id);
                                    return shouldLoad ? $3a208abeb0ec52b2$var$callLoaderOrAction(type, request, match, manifest, mapRouteProperties, handlerOverride, requestContext) : Promise.resolve({
                                        type: $3a208abeb0ec52b2$var$ResultType.data,
                                        result: undefined
                                    });
                                };
                                return $3a208abeb0ec52b2$var$_extends({}, match, {
                                    shouldLoad: shouldLoad,
                                    resolve: resolve
                                });
                            }),
                            request: request,
                            params: matches[0].params,
                            context: requestContext
                        })
                    ];
                case 1:
                    results = _state.sent();
                    // Throw if any loadRoute implementations not called since they are what
                    // ensures a route is fully loaded
                    matches.forEach(function(m) {
                        return $3a208abeb0ec52b2$export$3e9cee6b33872309(loadedMatches.has(m.route.id), '`match.resolve()` was not called for route id "' + m.route.id + '". ' + "You must call `match.resolve()` on every match passed to " + "`dataStrategy` to ensure all routes are properly loaded.");
                    });
                    // Filter out any middleware-only matches for which we didn't need to run handlers
                    return [
                        2,
                        results.filter(function(_, i) {
                            return routeIdsToLoad.has(matches[i].route.id);
                        })
                    ];
            }
        });
    });
    return $3a208abeb0ec52b2$var$_callDataStrategyImpl.apply(this, arguments);
}
function $3a208abeb0ec52b2$var$callLoaderOrAction(type, request, match, manifest, mapRouteProperties, handlerOverride, staticContext) {
    return $3a208abeb0ec52b2$var$_callLoaderOrAction.apply(this, arguments);
}
function $3a208abeb0ec52b2$var$_callLoaderOrAction() {
    $3a208abeb0ec52b2$var$_callLoaderOrAction = // Default logic for calling a loader/action is the user has no specified a dataStrategy
    (0, $1d3fb01611386816$export$71511d61b312f219)(function(type, request, match, manifest, mapRouteProperties, handlerOverride, staticContext) {
        var result, onReject, runHandler, handler, handlerError, _ref, value, url, pathname, url1, pathname1, e;
        return (0, $47055dab5b247348$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    runHandler = function(handler) {
                        // Setup a promise we can race against so that abort signals short circuit
                        var reject;
                        // This will never resolve so safe to type it as Promise<HandlerResult> to
                        // satisfy the function return value
                        var abortPromise = new Promise(function(_, r) {
                            return reject = r;
                        });
                        onReject = function() {
                            return reject();
                        };
                        request.signal.addEventListener("abort", onReject);
                        var actualHandler = function(ctx) {
                            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ('"' + type + '" [routeId: ' + match.route.id + "]")));
                            return handler.apply(void 0, [
                                {
                                    request: request,
                                    params: match.params,
                                    context: staticContext
                                }
                            ].concat((0, $1SMDP._)(ctx !== undefined ? [
                                ctx
                            ] : [])));
                        };
                        var handlerPromise;
                        if (handlerOverride) handlerPromise = handlerOverride(function(ctx) {
                            return actualHandler(ctx);
                        });
                        else handlerPromise = (0, $1d3fb01611386816$export$71511d61b312f219)(function() {
                            var val, e;
                            return (0, $47055dab5b247348$export$67ebef60e6f28a6)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _state.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4,
                                            actualHandler()
                                        ];
                                    case 1:
                                        val = _state.sent();
                                        return [
                                            2,
                                            {
                                                type: "data",
                                                result: val
                                            }
                                        ];
                                    case 2:
                                        e = _state.sent();
                                        return [
                                            2,
                                            {
                                                type: "error",
                                                result: e
                                            }
                                        ];
                                    case 3:
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                        return Promise.race([
                            handlerPromise,
                            abortPromise
                        ]);
                    };
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        12,
                        13,
                        14
                    ]);
                    handler = match.route[type];
                    if (!match.route.lazy) return [
                        3,
                        8
                    ];
                    if (!handler) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        Promise.all([
                            // If the handler throws, don't let it immediately bubble out,
                            // since we need to let the lazy() execution finish so we know if this
                            // route has a boundary that can handle the error
                            runHandler(handler).catch(function(e) {
                                handlerError = e;
                            }),
                            $3a208abeb0ec52b2$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                        ])
                    ];
                case 2:
                    _ref = (0, $f9AIs._).apply(void 0, [
                        _state.sent(),
                        1
                    ]), value = _ref[0];
                    if (handlerError !== undefined) throw handlerError;
                    result = value;
                    return [
                        3,
                        7
                    ];
                case 3:
                    // Load lazy route module, then run any returned handler
                    return [
                        4,
                        $3a208abeb0ec52b2$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                    ];
                case 4:
                    _state.sent();
                    handler = match.route[type];
                    if (!handler) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        runHandler(handler)
                    ];
                case 5:
                    // Handler still runs even if we got interrupted to maintain consistency
                    // with un-abortable behavior of handler execution on non-lazy or
                    // previously-lazy-loaded routes
                    result = _state.sent();
                    return [
                        3,
                        7
                    ];
                case 6:
                    if (type === "action") {
                        url = new URL(request.url);
                        pathname = url.pathname + url.search;
                        throw $3a208abeb0ec52b2$var$getInternalRouterError(405, {
                            method: request.method,
                            pathname: pathname,
                            routeId: match.route.id
                        });
                    } else // lazy() route has no loader to run.  Short circuit here so we don't
                    // hit the invariant below that errors on returning undefined.
                    return [
                        2,
                        {
                            type: $3a208abeb0ec52b2$var$ResultType.data,
                            result: undefined
                        }
                    ];
                    _state.label = 7;
                case 7:
                    return [
                        3,
                        11
                    ];
                case 8:
                    if (!!handler) return [
                        3,
                        9
                    ];
                    url1 = new URL(request.url);
                    pathname1 = url1.pathname + url1.search;
                    throw $3a208abeb0ec52b2$var$getInternalRouterError(404, {
                        pathname: pathname1
                    });
                case 9:
                    return [
                        4,
                        runHandler(handler)
                    ];
                case 10:
                    result = _state.sent();
                    _state.label = 11;
                case 11:
                    $3a208abeb0ec52b2$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
                    return [
                        3,
                        14
                    ];
                case 12:
                    e = _state.sent();
                    // We should already be catching and converting normal handler executions to
                    // HandlerResults and returning them, so anything that throws here is an
                    // unexpected error we still need to wrap
                    return [
                        2,
                        {
                            type: $3a208abeb0ec52b2$var$ResultType.error,
                            result: e
                        }
                    ];
                case 13:
                    if (onReject) request.signal.removeEventListener("abort", onReject);
                    return [
                        7
                    ];
                case 14:
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return $3a208abeb0ec52b2$var$_callLoaderOrAction.apply(this, arguments);
}
function $3a208abeb0ec52b2$var$convertHandlerResultToDataResult(handlerResult) {
    return $3a208abeb0ec52b2$var$_convertHandlerResultToDataResult.apply(this, arguments);
}
function $3a208abeb0ec52b2$var$_convertHandlerResultToDataResult() {
    $3a208abeb0ec52b2$var$_convertHandlerResultToDataResult = (0, $1d3fb01611386816$export$71511d61b312f219)(function(handlerResult) {
        var result, type, status, data, contentType, e, _result$init, _result$init2;
        return (0, $47055dab5b247348$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    result = handlerResult.result, type = handlerResult.type, status = handlerResult.status;
                    if (!$3a208abeb0ec52b2$var$isResponse(result)) return [
                        3,
                        10
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        8,
                        ,
                        9
                    ]);
                    contentType = result.headers.get("Content-Type");
                    if (!(contentType && /\bapplication\/json\b/.test(contentType))) return [
                        3,
                        5
                    ];
                    if (!(result.body == null)) return [
                        3,
                        2
                    ];
                    data = null;
                    return [
                        3,
                        4
                    ];
                case 2:
                    return [
                        4,
                        result.json()
                    ];
                case 3:
                    data = _state.sent();
                    _state.label = 4;
                case 4:
                    return [
                        3,
                        7
                    ];
                case 5:
                    return [
                        4,
                        result.text()
                    ];
                case 6:
                    data = _state.sent();
                    _state.label = 7;
                case 7:
                    return [
                        3,
                        9
                    ];
                case 8:
                    e = _state.sent();
                    return [
                        2,
                        {
                            type: $3a208abeb0ec52b2$var$ResultType.error,
                            error: e
                        }
                    ];
                case 9:
                    if (type === $3a208abeb0ec52b2$var$ResultType.error) return [
                        2,
                        {
                            type: $3a208abeb0ec52b2$var$ResultType.error,
                            error: new $3a208abeb0ec52b2$export$6c6580e81da25755(result.status, result.statusText, data),
                            statusCode: result.status,
                            headers: result.headers
                        }
                    ];
                    return [
                        2,
                        {
                            type: $3a208abeb0ec52b2$var$ResultType.data,
                            data: data,
                            statusCode: result.status,
                            headers: result.headers
                        }
                    ];
                case 10:
                    if (type === $3a208abeb0ec52b2$var$ResultType.error) return [
                        2,
                        {
                            type: $3a208abeb0ec52b2$var$ResultType.error,
                            error: result,
                            statusCode: $3a208abeb0ec52b2$export$972111febbeef05b(result) ? result.status : status
                        }
                    ];
                    if ($3a208abeb0ec52b2$export$fbcedacb60443473(result)) {
                        ;
                        return [
                            2,
                            {
                                type: $3a208abeb0ec52b2$var$ResultType.deferred,
                                deferredData: result,
                                statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                                headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            type: $3a208abeb0ec52b2$var$ResultType.data,
                            data: result,
                            statusCode: status
                        }
                    ];
            }
        });
    });
    return $3a208abeb0ec52b2$var$_convertHandlerResultToDataResult.apply(this, arguments);
}
// Support relative routing in internal redirects
function $3a208abeb0ec52b2$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    var location = response.headers.get("Location");
    $3a208abeb0ec52b2$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$3a208abeb0ec52b2$var$ABSOLUTE_URL_REGEX.test(location)) {
        var trimmedMatches = matches.slice(0, matches.findIndex(function(m) {
            return m.route.id === routeId;
        }) + 1);
        location = $3a208abeb0ec52b2$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $3a208abeb0ec52b2$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($3a208abeb0ec52b2$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        var normalizedLocation = location;
        var url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        var isSameBasename = $3a208abeb0ec52b2$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $3a208abeb0ec52b2$var$createClientSideRequest(history, location, signal, submission) {
    var url = history.createURL($3a208abeb0ec52b2$var$stripHashFromPath(location)).toString();
    var init = {
        signal: signal
    };
    if (submission && $3a208abeb0ec52b2$var$isMutationMethod(submission.formMethod)) {
        var formMethod = submission.formMethod, formEncType = submission.formEncType;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $3a208abeb0ec52b2$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $3a208abeb0ec52b2$var$convertFormDataToSearchParams(formData) {
    var searchParams = new URLSearchParams();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = formData.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $f9AIs._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
            searchParams.append(key, typeof value === "string" ? value : value.name);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return searchParams;
}
function $3a208abeb0ec52b2$var$convertSearchParamsToFormData(searchParams) {
    var formData = new FormData();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = searchParams.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $f9AIs._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            formData.append(key, value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return formData;
}
function $3a208abeb0ec52b2$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    var loaderData = {};
    var errors = null;
    var statusCode;
    var foundError = false;
    var loaderHeaders = {};
    var pendingError = pendingActionResult && $3a208abeb0ec52b2$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    results.forEach(function(result, index) {
        var id = matchesToLoad[index].route.id;
        $3a208abeb0ec52b2$export$3e9cee6b33872309(!$3a208abeb0ec52b2$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($3a208abeb0ec52b2$var$isErrorResult(result)) {
            var error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                var boundaryMatch = $3a208abeb0ec52b2$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $3a208abeb0ec52b2$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($3a208abeb0ec52b2$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = (0, $73NPw._)({}, pendingActionResult[0], pendingError);
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $3a208abeb0ec52b2$var$processLoaderData(state, matches, matchesToLoad, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    var _processRouteLoaderData = $3a208abeb0ec52b2$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    ), loaderData = _processRouteLoaderData.loaderData, errors = _processRouteLoaderData.errors;
    // Process results from our revalidating fetchers
    for(var index = 0; index < revalidatingFetchers.length; index++){
        var _revalidatingFetchers_index = revalidatingFetchers[index], key = _revalidatingFetchers_index.key, match = _revalidatingFetchers_index.match, controller = _revalidatingFetchers_index.controller;
        $3a208abeb0ec52b2$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        var result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($3a208abeb0ec52b2$var$isErrorResult(result)) {
            var boundaryMatch = $3a208abeb0ec52b2$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $3a208abeb0ec52b2$var$_extends({}, errors, (0, $73NPw._)({}, boundaryMatch.route.id, result.error));
            state.fetchers.delete(key);
        } else if ($3a208abeb0ec52b2$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $3a208abeb0ec52b2$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($3a208abeb0ec52b2$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $3a208abeb0ec52b2$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            var doneFetcher = $3a208abeb0ec52b2$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $3a208abeb0ec52b2$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    var mergedLoaderData = $3a208abeb0ec52b2$var$_extends({}, newLoaderData);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var match = _step.value;
            var id = match.route.id;
            if (newLoaderData.hasOwnProperty(id)) {
                if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
            } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
            // wasn't removed by HMR
            mergedLoaderData[id] = loaderData[id];
            if (errors && errors.hasOwnProperty(id)) break;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return mergedLoaderData;
}
function $3a208abeb0ec52b2$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $3a208abeb0ec52b2$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: (0, $73NPw._)({}, pendingActionResult[0], pendingActionResult[1].data)
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $3a208abeb0ec52b2$var$findNearestBoundary(matches, routeId) {
    var eligibleMatches = routeId ? matches.slice(0, matches.findIndex(function(m) {
        return m.route.id === routeId;
    }) + 1) : (0, $1SMDP._)(matches);
    return eligibleMatches.reverse().find(function(m) {
        return m.route.hasErrorBoundary === true;
    }) || matches[0];
}
function $3a208abeb0ec52b2$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    var route = routes.length === 1 ? routes[0] : routes.find(function(r) {
        return r.index || !r.path || r.path === "/";
    }) || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $3a208abeb0ec52b2$var$getInternalRouterError(status, _temp5) {
    var _ref = _temp5 === void 0 ? {} : _temp5, pathname = _ref.pathname, routeId = _ref.routeId, method = _ref.method, type = _ref.type;
    var statusText = "Unknown Server Error";
    var errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $3a208abeb0ec52b2$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $3a208abeb0ec52b2$var$findRedirect(results) {
    for(var i = results.length - 1; i >= 0; i--){
        var result = results[i];
        if ($3a208abeb0ec52b2$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $3a208abeb0ec52b2$var$stripHashFromPath(path) {
    var parsedPath = typeof path === "string" ? $3a208abeb0ec52b2$export$8ccf933b0513f8d0(path) : path;
    return $3a208abeb0ec52b2$export$fe53371bee54353d($3a208abeb0ec52b2$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $3a208abeb0ec52b2$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $3a208abeb0ec52b2$var$isHandlerResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $3a208abeb0ec52b2$var$ResultType.data || result.type === $3a208abeb0ec52b2$var$ResultType.error);
}
function $3a208abeb0ec52b2$var$isRedirectHandlerResult(result) {
    return $3a208abeb0ec52b2$var$isResponse(result.result) && $3a208abeb0ec52b2$var$redirectStatusCodes.has(result.result.status);
}
function $3a208abeb0ec52b2$var$isDeferredResult(result) {
    return result.type === $3a208abeb0ec52b2$var$ResultType.deferred;
}
function $3a208abeb0ec52b2$var$isErrorResult(result) {
    return result.type === $3a208abeb0ec52b2$var$ResultType.error;
}
function $3a208abeb0ec52b2$var$isRedirectResult(result) {
    return (result && result.type) === $3a208abeb0ec52b2$var$ResultType.redirect;
}
function $3a208abeb0ec52b2$export$fbcedacb60443473(value) {
    var deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $3a208abeb0ec52b2$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $3a208abeb0ec52b2$var$isRedirectResponse(result) {
    if (!$3a208abeb0ec52b2$var$isResponse(result)) return false;
    var status = result.status;
    var location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $3a208abeb0ec52b2$var$isValidMethod(method) {
    return $3a208abeb0ec52b2$var$validRequestMethods.has(method.toLowerCase());
}
function $3a208abeb0ec52b2$var$isMutationMethod(method) {
    return $3a208abeb0ec52b2$var$validMutationMethods.has(method.toLowerCase());
}
function $3a208abeb0ec52b2$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    return $3a208abeb0ec52b2$var$_resolveDeferredResults.apply(this, arguments);
}
function $3a208abeb0ec52b2$var$_resolveDeferredResults() {
    $3a208abeb0ec52b2$var$_resolveDeferredResults = (0, $1d3fb01611386816$export$71511d61b312f219)(function(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
        var _loop, index;
        return (0, $47055dab5b247348$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _loop = function(index) {
                        var result, match, currentMatch, isRevalidatingLoader, signal;
                        return (0, $47055dab5b247348$export$67ebef60e6f28a6)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    result = results[index];
                                    match = matchesToLoad[index];
                                    // If we don't have a match, then we can have a deferred result to do
                                    // anything with.  This is for revalidating fetchers where the route was
                                    // removed during HMR
                                    if (!match) return [
                                        2,
                                        "continue"
                                    ];
                                    currentMatch = currentMatches.find(function(m) {
                                        return m.route.id === match.route.id;
                                    });
                                    isRevalidatingLoader = currentMatch != null && !$3a208abeb0ec52b2$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
                                    if (!($3a208abeb0ec52b2$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader))) return [
                                        3,
                                        2
                                    ];
                                    // Note: we do not have to touch activeDeferreds here since we race them
                                    // against the signal in resolveDeferredData and they'll get aborted
                                    // there if needed
                                    signal = signals[index];
                                    $3a208abeb0ec52b2$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
                                    return [
                                        4,
                                        $3a208abeb0ec52b2$var$resolveDeferredData(result, signal, isFetcher).then(function(result) {
                                            if (result) results[index] = result || results[index];
                                        })
                                    ];
                                case 1:
                                    _state.sent();
                                    _state.label = 2;
                                case 2:
                                    return [
                                        2
                                    ];
                            }
                        });
                    };
                    index = 0;
                    _state.label = 1;
                case 1:
                    if (!(index < results.length)) return [
                        3,
                        4
                    ];
                    return [
                        5,
                        (0, $47055dab5b247348$export$19a8beecd37a4c45)(_loop(index))
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    index++;
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $3a208abeb0ec52b2$var$_resolveDeferredResults.apply(this, arguments);
}
function $3a208abeb0ec52b2$var$resolveDeferredData(result, signal, unwrap) {
    return $3a208abeb0ec52b2$var$_resolveDeferredData.apply(this, arguments);
}
function $3a208abeb0ec52b2$var$_resolveDeferredData() {
    $3a208abeb0ec52b2$var$_resolveDeferredData = (0, $1d3fb01611386816$export$71511d61b312f219)(function(result, signal, unwrap) {
        var aborted;
        return (0, $47055dab5b247348$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (unwrap === void 0) unwrap = false;
                    return [
                        4,
                        result.deferredData.resolveData(signal)
                    ];
                case 1:
                    aborted = _state.sent();
                    if (aborted) return [
                        2
                    ];
                    if (unwrap) try {
                        return [
                            2,
                            {
                                type: $3a208abeb0ec52b2$var$ResultType.data,
                                data: result.deferredData.unwrappedData
                            }
                        ];
                    } catch (e) {
                        // Handle any TrackedPromise._error values encountered while unwrapping
                        return [
                            2,
                            {
                                type: $3a208abeb0ec52b2$var$ResultType.error,
                                error: e
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            type: $3a208abeb0ec52b2$var$ResultType.data,
                            data: result.deferredData.data
                        }
                    ];
            }
        });
    });
    return $3a208abeb0ec52b2$var$_resolveDeferredData.apply(this, arguments);
}
function $3a208abeb0ec52b2$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some(function(v) {
        return v === "";
    });
}
function $3a208abeb0ec52b2$var$getTargetMatch(matches, location) {
    var search = typeof location === "string" ? $3a208abeb0ec52b2$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $3a208abeb0ec52b2$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    var pathMatches = $3a208abeb0ec52b2$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $3a208abeb0ec52b2$var$getSubmissionFromNavigation(navigation) {
    var formMethod = navigation.formMethod, formAction = navigation.formAction, formEncType = navigation.formEncType, text = navigation.text, formData = navigation.formData, json = navigation.json;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $3a208abeb0ec52b2$var$getLoadingNavigation(location, submission) {
    if (submission) {
        var navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        var navigation1 = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation1;
    }
}
function $3a208abeb0ec52b2$var$getSubmittingNavigation(location, submission) {
    var navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $3a208abeb0ec52b2$var$getLoadingFetcher(submission, data) {
    if (submission) {
        var fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        var fetcher1 = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher1;
    }
}
function $3a208abeb0ec52b2$var$getSubmittingFetcher(submission, existingFetcher) {
    var fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $3a208abeb0ec52b2$var$getDoneFetcher(data) {
    var fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $3a208abeb0ec52b2$var$restoreAppliedTransitions(_window, transitions) {
    try {
        var sessionPositions = _window.sessionStorage.getItem($3a208abeb0ec52b2$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            var json = JSON.parse(sessionPositions);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Object.entries(json || {})[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = (0, $f9AIs._)(_step.value, 2), k = _step_value[0], v = _step_value[1];
                    if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $3a208abeb0ec52b2$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        var json = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = transitions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $f9AIs._)(_step.value, 2), k = _step_value[0], v = _step_value[1];
                json[k] = (0, $1SMDP._)(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        try {
            _window.sessionStorage.setItem($3a208abeb0ec52b2$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $3a208abeb0ec52b2$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.23.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $aliU1 = parcelRequire("aliU1");

var $bMpTA = parcelRequire("bMpTA");

var $fZ5u7 = parcelRequire("fZ5u7");

var $f9AIs = parcelRequire("f9AIs");

var $1SMDP = parcelRequire("1SMDP");

var $9j1tP = parcelRequire("9j1tP");

var $4Bt61 = parcelRequire("4Bt61");

function $f0792a32d62fec93$var$_extends() {
    $f0792a32d62fec93$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f0792a32d62fec93$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
var $f0792a32d62fec93$export$3add0d5dce533e2e = /*#__PURE__*/ $4Bt61.createContext(null);
var $f0792a32d62fec93$export$145dfa71566a64dc = /*#__PURE__*/ $4Bt61.createContext(null);
var $f0792a32d62fec93$var$AwaitContext = /*#__PURE__*/ $4Bt61.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ var $f0792a32d62fec93$export$26749e8557646306 = /*#__PURE__*/ $4Bt61.createContext(null);
var $f0792a32d62fec93$export$c7914228fb69b0f5 = /*#__PURE__*/ $4Bt61.createContext(null);
var $f0792a32d62fec93$export$9072aa6dd1f93057 = /*#__PURE__*/ $4Bt61.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
var $f0792a32d62fec93$var$RouteErrorContext = /*#__PURE__*/ $4Bt61.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $f0792a32d62fec93$export$b66bb29c5006f12f(to, _temp) {
    var relative = (_temp === void 0 ? {} : _temp).relative;
    !$f0792a32d62fec93$export$9c954a9d03d32f4a() && (0, $3a208abeb0ec52b2$export$3e9cee6b33872309)(false);
    var _React_useContext = $4Bt61.useContext($f0792a32d62fec93$export$26749e8557646306), basename = _React_useContext.basename, navigator = _React_useContext.navigator;
    var _useResolvedPath = $f0792a32d62fec93$export$e75d2a2d1b3c245b(to, {
        relative: relative
    }), hash = _useResolvedPath.hash, pathname = _useResolvedPath.pathname, search = _useResolvedPath.search;
    var joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $3a208abeb0ec52b2$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $f0792a32d62fec93$export$9c954a9d03d32f4a() {
    return $4Bt61.useContext($f0792a32d62fec93$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $f0792a32d62fec93$export$45d76561a5302f2b() {
    !$f0792a32d62fec93$export$9c954a9d03d32f4a() && (0, $3a208abeb0ec52b2$export$3e9cee6b33872309)(false);
    return $4Bt61.useContext($f0792a32d62fec93$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $f0792a32d62fec93$export$1b3f31771c5d07c() {
    return $4Bt61.useContext($f0792a32d62fec93$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $f0792a32d62fec93$export$6c330e8992e8a295(pattern) {
    !$f0792a32d62fec93$export$9c954a9d03d32f4a() && (0, $3a208abeb0ec52b2$export$3e9cee6b33872309)(false);
    var pathname = $f0792a32d62fec93$export$45d76561a5302f2b().pathname;
    return $4Bt61.useMemo(function() {
        return (0, $3a208abeb0ec52b2$export$81336c211d5ff295)(pattern, pathname);
    }, [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ var $f0792a32d62fec93$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $f0792a32d62fec93$var$useIsomorphicLayoutEffect(cb) {
    var isStatic = $4Bt61.useContext($f0792a32d62fec93$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $4Bt61.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $f0792a32d62fec93$export$9770f232ac06a008() {
    var isDataRoute = $4Bt61.useContext($f0792a32d62fec93$export$9072aa6dd1f93057).isDataRoute;
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $f0792a32d62fec93$var$useNavigateStable() : $f0792a32d62fec93$var$useNavigateUnstable();
}
function $f0792a32d62fec93$var$useNavigateUnstable() {
    !$f0792a32d62fec93$export$9c954a9d03d32f4a() && (0, $3a208abeb0ec52b2$export$3e9cee6b33872309)(false);
    var dataRouterContext = $4Bt61.useContext($f0792a32d62fec93$export$3add0d5dce533e2e);
    var _React_useContext = $4Bt61.useContext($f0792a32d62fec93$export$26749e8557646306), basename = _React_useContext.basename, future = _React_useContext.future, navigator = _React_useContext.navigator;
    var matches = $4Bt61.useContext($f0792a32d62fec93$export$9072aa6dd1f93057).matches;
    var _useLocation = $f0792a32d62fec93$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var routePathnamesJson = JSON.stringify((0, $3a208abeb0ec52b2$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    var activeRef = $4Bt61.useRef(false);
    $f0792a32d62fec93$var$useIsomorphicLayoutEffect(function() {
        activeRef.current = true;
    });
    var navigate = $4Bt61.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        var path = (0, $3a208abeb0ec52b2$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $3a208abeb0ec52b2$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $f0792a32d62fec93$var$OutletContext = /*#__PURE__*/ $4Bt61.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $f0792a32d62fec93$export$4138103a3ae699cc() {
    return $4Bt61.useContext($f0792a32d62fec93$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $f0792a32d62fec93$export$a3be3530d8e40d0b(context) {
    var outlet = $4Bt61.useContext($f0792a32d62fec93$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $4Bt61.createElement($f0792a32d62fec93$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $f0792a32d62fec93$export$99eaa27ddbbb95ef() {
    var matches = $4Bt61.useContext($f0792a32d62fec93$export$9072aa6dd1f93057).matches;
    var routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $f0792a32d62fec93$export$e75d2a2d1b3c245b(to, _temp2) {
    var relative = (_temp2 === void 0 ? {} : _temp2).relative;
    var future = $4Bt61.useContext($f0792a32d62fec93$export$26749e8557646306).future;
    var matches = $4Bt61.useContext($f0792a32d62fec93$export$9072aa6dd1f93057).matches;
    var _useLocation = $f0792a32d62fec93$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var routePathnamesJson = JSON.stringify((0, $3a208abeb0ec52b2$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $4Bt61.useMemo(function() {
        return (0, $3a208abeb0ec52b2$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path");
    }, [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $f0792a32d62fec93$export$5d3fca4a98652595(routes, locationArg) {
    return $f0792a32d62fec93$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $f0792a32d62fec93$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$f0792a32d62fec93$export$9c954a9d03d32f4a() && (0, $3a208abeb0ec52b2$export$3e9cee6b33872309)(false);
    var navigator = $4Bt61.useContext($f0792a32d62fec93$export$26749e8557646306).navigator;
    var _React_useContext = $4Bt61.useContext($f0792a32d62fec93$export$9072aa6dd1f93057), parentMatches = _React_useContext.matches;
    var routeMatch = parentMatches[parentMatches.length - 1];
    var parentParams = routeMatch ? routeMatch.params : {};
    var parentPathname = routeMatch ? routeMatch.pathname : "/";
    var parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    var parentRoute = routeMatch && routeMatch.route;
    var locationFromContext = $f0792a32d62fec93$export$45d76561a5302f2b();
    var location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        var parsedLocationArg = typeof locationArg === "string" ? (0, $3a208abeb0ec52b2$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $3a208abeb0ec52b2$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    var pathname = location.pathname || "/";
    var remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        var parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        var segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    var matches = (0, $3a208abeb0ec52b2$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    var renderedMatches = $f0792a32d62fec93$var$_renderMatches(matches && matches.map(function(match) {
        return Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $3a208abeb0ec52b2$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $3a208abeb0ec52b2$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        });
    }), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $4Bt61.createElement($f0792a32d62fec93$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $f0792a32d62fec93$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $3a208abeb0ec52b2$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $f0792a32d62fec93$var$DefaultErrorComponent() {
    var error = $f0792a32d62fec93$export$ed527bf60f6e05f2();
    var message = (0, $3a208abeb0ec52b2$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    var stack = error instanceof Error ? error.stack : null;
    var lightgrey = "rgba(200,200,200, 0.5)";
    var preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    var codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    var devInfo = null;
    return /*#__PURE__*/ $4Bt61.createElement($4Bt61.Fragment, null, /*#__PURE__*/ $4Bt61.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $4Bt61.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $4Bt61.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $f0792a32d62fec93$var$defaultErrorElement = /*#__PURE__*/ $4Bt61.createElement($f0792a32d62fec93$var$DefaultErrorComponent, null);
var $f0792a32d62fec93$var$RenderErrorBoundary = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $fZ5u7._)(RenderErrorBoundary, _React_Component);
    var _super = (0, $9j1tP._)(RenderErrorBoundary);
    function RenderErrorBoundary(props) {
        (0, $aliU1._)(this, RenderErrorBoundary);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
        return _this;
    }
    (0, $bMpTA._)(RenderErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                console.error("React Router caught the following error during render", error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                return this.state.error !== undefined ? /*#__PURE__*/ $4Bt61.createElement($f0792a32d62fec93$export$9072aa6dd1f93057.Provider, {
                    value: this.props.routeContext
                }, /*#__PURE__*/ $4Bt61.createElement($f0792a32d62fec93$var$RouteErrorContext.Provider, {
                    value: this.state.error,
                    children: this.props.component
                })) : this.props.children;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                // When we get into an error state, the user will likely click "back" to the
                // previous page that didn't have an error. Because this wraps the entire
                // application, that will have no effect--the error page continues to display.
                // This gives us a mechanism to recover from the error when the location changes.
                //
                // Whether we're in an error state or not, we update the location in state
                // so that when we are in an error state, it gets reset when a new location
                // comes in and the user recovers from the error.
                if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
                    error: props.error,
                    location: props.location,
                    revalidation: props.revalidation
                };
                // If we're not changing locations, preserve the location but still surface
                // any new errors that may come through. We retain the existing error, we do
                // this because the error provided from the app state may be cleared without
                // the location changing.
                return {
                    error: props.error !== undefined ? props.error : state.error,
                    location: state.location,
                    revalidation: props.revalidation || state.revalidation
                };
            }
        }
    ]);
    return RenderErrorBoundary;
}($4Bt61.Component);
function $f0792a32d62fec93$var$RenderedRoute(_ref) {
    var routeContext = _ref.routeContext, match = _ref.match, children = _ref.children;
    var dataRouterContext = $4Bt61.useContext($f0792a32d62fec93$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $4Bt61.createElement($f0792a32d62fec93$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $f0792a32d62fec93$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    var renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    var errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        var errorIndex = renderedMatches.findIndex(function(m) {
            return m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined;
        });
        !(errorIndex >= 0) && (0, $3a208abeb0ec52b2$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    var renderFallback = false;
    var fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(var i = 0; i < renderedMatches.length; i++){
        var match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            var loaderData = dataRouterState.loaderData, errors1 = dataRouterState.errors;
            var needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors1 || errors1[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight(function(outlet, match, index) {
        // Only data routers handle errors/fallbacks
        var error;
        var shouldRenderHydrateFallback = false;
        var errorElement = null;
        var hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $f0792a32d62fec93$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $f0792a32d62fec93$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        var _$matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        var getChildren = function() {
            var children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $4Bt61.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $4Bt61.createElement($f0792a32d62fec93$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: _$matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $4Bt61.createElement($f0792a32d62fec93$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: _$matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $f0792a32d62fec93$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($f0792a32d62fec93$var$DataRouterHook || {});
var $f0792a32d62fec93$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($f0792a32d62fec93$var$DataRouterStateHook || {});
function $f0792a32d62fec93$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $f0792a32d62fec93$var$useDataRouterContext(hookName) {
    var ctx = $4Bt61.useContext($f0792a32d62fec93$export$3add0d5dce533e2e);
    !ctx && (0, $3a208abeb0ec52b2$export$3e9cee6b33872309)(false);
    return ctx;
}
function $f0792a32d62fec93$var$useDataRouterState(hookName) {
    var state = $4Bt61.useContext($f0792a32d62fec93$export$145dfa71566a64dc);
    !state && (0, $3a208abeb0ec52b2$export$3e9cee6b33872309)(false);
    return state;
}
function $f0792a32d62fec93$var$useRouteContext(hookName) {
    var route = $4Bt61.useContext($f0792a32d62fec93$export$9072aa6dd1f93057);
    !route && (0, $3a208abeb0ec52b2$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $f0792a32d62fec93$var$useCurrentRouteId(hookName) {
    var route = $f0792a32d62fec93$var$useRouteContext(hookName);
    var thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $3a208abeb0ec52b2$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $f0792a32d62fec93$export$5fc8298006ad9e58() {
    return $f0792a32d62fec93$var$useCurrentRouteId($f0792a32d62fec93$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $f0792a32d62fec93$export$d0fd4b7106de2769() {
    var state = $f0792a32d62fec93$var$useDataRouterState($f0792a32d62fec93$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $f0792a32d62fec93$export$600dc272ed516c15() {
    var dataRouterContext = $f0792a32d62fec93$var$useDataRouterContext($f0792a32d62fec93$var$DataRouterHook.UseRevalidator);
    var state = $f0792a32d62fec93$var$useDataRouterState($f0792a32d62fec93$var$DataRouterStateHook.UseRevalidator);
    return $4Bt61.useMemo(function() {
        return {
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        };
    }, [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $f0792a32d62fec93$export$2378eb7f5ff86053() {
    var _useDataRouterState = $f0792a32d62fec93$var$useDataRouterState($f0792a32d62fec93$var$DataRouterStateHook.UseMatches), matches = _useDataRouterState.matches, loaderData = _useDataRouterState.loaderData;
    return $4Bt61.useMemo(function() {
        return matches.map(function(m) {
            return (0, $3a208abeb0ec52b2$export$b3fac024fad9e8ff)(m, loaderData);
        });
    }, [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $f0792a32d62fec93$export$1448a5050d252c4d() {
    var state = $f0792a32d62fec93$var$useDataRouterState($f0792a32d62fec93$var$DataRouterStateHook.UseLoaderData);
    var routeId = $f0792a32d62fec93$var$useCurrentRouteId($f0792a32d62fec93$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $f0792a32d62fec93$export$fd5d37484eab868d(routeId) {
    var state = $f0792a32d62fec93$var$useDataRouterState($f0792a32d62fec93$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $f0792a32d62fec93$export$fdc00f3f26066d5e() {
    var state = $f0792a32d62fec93$var$useDataRouterState($f0792a32d62fec93$var$DataRouterStateHook.UseActionData);
    var routeId = $f0792a32d62fec93$var$useCurrentRouteId($f0792a32d62fec93$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $f0792a32d62fec93$export$ed527bf60f6e05f2() {
    var _state$errors;
    var error = $4Bt61.useContext($f0792a32d62fec93$var$RouteErrorContext);
    var state = $f0792a32d62fec93$var$useDataRouterState($f0792a32d62fec93$var$DataRouterStateHook.UseRouteError);
    var routeId = $f0792a32d62fec93$var$useCurrentRouteId($f0792a32d62fec93$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $f0792a32d62fec93$export$78a72ddb39bdd145() {
    var value = $4Bt61.useContext($f0792a32d62fec93$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $f0792a32d62fec93$export$17f53340677d5831() {
    var value = $4Bt61.useContext($f0792a32d62fec93$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
var $f0792a32d62fec93$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $f0792a32d62fec93$export$b273b3273281a049(shouldBlock) {
    var _useDataRouterContext = $f0792a32d62fec93$var$useDataRouterContext($f0792a32d62fec93$var$DataRouterHook.UseBlocker), router = _useDataRouterContext.router, basename = _useDataRouterContext.basename;
    var state = $f0792a32d62fec93$var$useDataRouterState($f0792a32d62fec93$var$DataRouterStateHook.UseBlocker);
    var _React_useState = (0, $f9AIs._)($4Bt61.useState(""), 2), blockerKey = _React_useState[0], setBlockerKey = _React_useState[1];
    var blockerFunction = $4Bt61.useCallback(function(arg) {
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        var currentLocation = arg.currentLocation, nextLocation = arg.nextLocation, historyAction = arg.historyAction;
        return shouldBlock({
            currentLocation: $f0792a32d62fec93$var$_extends({}, currentLocation, {
                pathname: (0, $3a208abeb0ec52b2$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $f0792a32d62fec93$var$_extends({}, nextLocation, {
                pathname: (0, $3a208abeb0ec52b2$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $4Bt61.useEffect(function() {
        var key = String(++$f0792a32d62fec93$var$blockerId);
        setBlockerKey(key);
        return function() {
            return router.deleteBlocker(key);
        };
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $4Bt61.useEffect(function() {
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $3a208abeb0ec52b2$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $f0792a32d62fec93$var$useNavigateStable() {
    var router = $f0792a32d62fec93$var$useDataRouterContext($f0792a32d62fec93$var$DataRouterHook.UseNavigateStable).router;
    var id = $f0792a32d62fec93$var$useCurrentRouteId($f0792a32d62fec93$var$DataRouterStateHook.UseNavigateStable);
    var activeRef = $4Bt61.useRef(false);
    $f0792a32d62fec93$var$useIsomorphicLayoutEffect(function() {
        activeRef.current = true;
    });
    var navigate = $4Bt61.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $f0792a32d62fec93$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
var $f0792a32d62fec93$var$alreadyWarned = {};
function $f0792a32d62fec93$var$warningOnce(key, cond, message) {
    if (!cond && !$f0792a32d62fec93$var$alreadyWarned[key]) $f0792a32d62fec93$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ var $f0792a32d62fec93$var$START_TRANSITION = "startTransition";
var $f0792a32d62fec93$var$startTransitionImpl = $4Bt61[$f0792a32d62fec93$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $f0792a32d62fec93$export$323e4fc2fa4753fb(_ref) {
    var fallbackElement = _ref.fallbackElement, router = _ref.router, future = _ref.future;
    var _React_useState = (0, $f9AIs._)($4Bt61.useState(router.state), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $4Bt61.useCallback(function(newState) {
        if (v7_startTransition && $f0792a32d62fec93$var$startTransitionImpl) $f0792a32d62fec93$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        });
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $4Bt61.useLayoutEffect(function() {
        return router.subscribe(setState);
    }, [
        router,
        setState
    ]);
    $4Bt61.useEffect(function() {
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var navigator = $4Bt61.useMemo(function() {
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: function(n) {
                return router.navigate(n);
            },
            push: function(to, state, opts) {
                return router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            },
            replace: function(to, state, opts) {
                return router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            }
        };
    }, [
        router
    ]);
    var basename = router.basename || "/";
    var dataRouterContext = $4Bt61.useMemo(function() {
        return {
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        };
    }, [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $4Bt61.createElement($4Bt61.Fragment, null, /*#__PURE__*/ $4Bt61.createElement($f0792a32d62fec93$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $4Bt61.createElement($f0792a32d62fec93$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $4Bt61.createElement($f0792a32d62fec93$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $4Bt61.createElement($f0792a32d62fec93$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $f0792a32d62fec93$var$DataRoutes(_ref2) {
    var routes = _ref2.routes, future = _ref2.future, state = _ref2.state;
    return $f0792a32d62fec93$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $f0792a32d62fec93$export$ae46f04cfaffe093(_ref3) {
    var basename = _ref3.basename, children = _ref3.children, initialEntries = _ref3.initialEntries, initialIndex = _ref3.initialIndex, future = _ref3.future;
    var historyRef = $4Bt61.useRef();
    if (historyRef.current == null) historyRef.current = (0, $3a208abeb0ec52b2$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $f9AIs._)($4Bt61.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $4Bt61.useCallback(function(newState) {
        v7_startTransition && $f0792a32d62fec93$var$startTransitionImpl ? $f0792a32d62fec93$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $4Bt61.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ $4Bt61.createElement($f0792a32d62fec93$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $f0792a32d62fec93$export$444b3ab0cb9aec40(_ref4) {
    var to = _ref4.to, replace = _ref4.replace, state = _ref4.state, relative = _ref4.relative;
    !$f0792a32d62fec93$export$9c954a9d03d32f4a() && (0, $3a208abeb0ec52b2$export$3e9cee6b33872309)(false);
    var _React_useContext = $4Bt61.useContext($f0792a32d62fec93$export$26749e8557646306), future = _React_useContext.future, isStatic = _React_useContext.static;
    var matches = $4Bt61.useContext($f0792a32d62fec93$export$9072aa6dd1f93057).matches;
    var _useLocation = $f0792a32d62fec93$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var navigate = $f0792a32d62fec93$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    var path = (0, $3a208abeb0ec52b2$export$cae722b0cc860f13)(to, (0, $3a208abeb0ec52b2$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    var jsonPath = JSON.stringify(path);
    $4Bt61.useEffect(function() {
        return navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $f0792a32d62fec93$export$910ae8079b2c2852(props) {
    return $f0792a32d62fec93$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $f0792a32d62fec93$export$e7b0ac011bb776c6(_props) {
    (0, $3a208abeb0ec52b2$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $f0792a32d62fec93$export$55185c17a0fcbe46(_ref5) {
    var tmp = _ref5.basename, basenameProp = tmp === void 0 ? "/" : tmp, _ref5_children = _ref5.children, children = _ref5_children === void 0 ? null : _ref5_children, locationProp = _ref5.location, _ref5_navigationType = _ref5.navigationType, navigationType = _ref5_navigationType === void 0 ? (0, $3a208abeb0ec52b2$export$e19cd5f9376f8cee).Pop : _ref5_navigationType, navigator = _ref5.navigator, tmp1 = _ref5.static, staticProp = tmp1 === void 0 ? false : tmp1, future = _ref5.future;
    !!$f0792a32d62fec93$export$9c954a9d03d32f4a() && (0, $3a208abeb0ec52b2$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    var basename = basenameProp.replace(/^\/*/, "/");
    var navigationContext = $4Bt61.useMemo(function() {
        return {
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $f0792a32d62fec93$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        };
    }, [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $3a208abeb0ec52b2$export$8ccf933b0513f8d0)(locationProp);
    var _locationProp_pathname = locationProp.pathname, pathname = _locationProp_pathname === void 0 ? "/" : _locationProp_pathname, _locationProp_search = locationProp.search, search = _locationProp_search === void 0 ? "" : _locationProp_search, _locationProp_hash = locationProp.hash, hash = _locationProp_hash === void 0 ? "" : _locationProp_hash, _locationProp_state = locationProp.state, state = _locationProp_state === void 0 ? null : _locationProp_state, _locationProp_key = locationProp.key, key = _locationProp_key === void 0 ? "default" : _locationProp_key;
    var locationContext = $4Bt61.useMemo(function() {
        var trailingPathname = (0, $3a208abeb0ec52b2$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $4Bt61.createElement($f0792a32d62fec93$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $4Bt61.createElement($f0792a32d62fec93$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $f0792a32d62fec93$export$3565eb3d00ca5a74(_ref6) {
    var children = _ref6.children, location = _ref6.location;
    return $f0792a32d62fec93$export$5d3fca4a98652595($f0792a32d62fec93$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $f0792a32d62fec93$export$6ddabde395c8c576(_ref7) {
    var children = _ref7.children, errorElement = _ref7.errorElement, resolve = _ref7.resolve;
    return /*#__PURE__*/ $4Bt61.createElement($f0792a32d62fec93$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $4Bt61.createElement($f0792a32d62fec93$var$ResolveAwait, null, children));
}
var $f0792a32d62fec93$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($f0792a32d62fec93$var$AwaitRenderStatus || {});
var $f0792a32d62fec93$var$neverSettledPromise = new Promise(function() {});
var $f0792a32d62fec93$var$AwaitErrorBoundary = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $fZ5u7._)(AwaitErrorBoundary, _React_Component);
    var _super = (0, $9j1tP._)(AwaitErrorBoundary);
    function AwaitErrorBoundary(props) {
        (0, $aliU1._)(this, AwaitErrorBoundary);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            error: null
        };
        return _this;
    }
    (0, $bMpTA._)(AwaitErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                console.error("<Await> caught the following error during render", error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, children = _this_props.children, errorElement = _this_props.errorElement, resolve = _this_props.resolve;
                var promise = null;
                var status = $f0792a32d62fec93$var$AwaitRenderStatus.pending;
                if (!(resolve instanceof Promise)) {
                    // Didn't get a promise - provide as a resolved promise
                    status = $f0792a32d62fec93$var$AwaitRenderStatus.success;
                    promise = Promise.resolve();
                    Object.defineProperty(promise, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    Object.defineProperty(promise, "_data", {
                        get: function() {
                            return resolve;
                        }
                    });
                } else if (this.state.error) {
                    // Caught a render error, provide it as a rejected promise
                    status = $f0792a32d62fec93$var$AwaitRenderStatus.error;
                    var renderError = this.state.error;
                    promise = Promise.reject().catch(function() {}); // Avoid unhandled rejection warnings
                    Object.defineProperty(promise, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return renderError;
                        }
                    });
                } else if (resolve._tracked) {
                    // Already tracked promise - check contents
                    promise = resolve;
                    status = promise._error !== undefined ? $f0792a32d62fec93$var$AwaitRenderStatus.error : promise._data !== undefined ? $f0792a32d62fec93$var$AwaitRenderStatus.success : $f0792a32d62fec93$var$AwaitRenderStatus.pending;
                } else {
                    // Raw (untracked) promise - track it
                    status = $f0792a32d62fec93$var$AwaitRenderStatus.pending;
                    Object.defineProperty(resolve, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    promise = resolve.then(function(data) {
                        return Object.defineProperty(resolve, "_data", {
                            get: function() {
                                return data;
                            }
                        });
                    }, function(error) {
                        return Object.defineProperty(resolve, "_error", {
                            get: function() {
                                return error;
                            }
                        });
                    });
                }
                if (status === $f0792a32d62fec93$var$AwaitRenderStatus.error && promise._error instanceof (0, $3a208abeb0ec52b2$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
                throw $f0792a32d62fec93$var$neverSettledPromise;
                if (status === $f0792a32d62fec93$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
                throw promise._error;
                if (status === $f0792a32d62fec93$var$AwaitRenderStatus.error) // Render via our errorElement
                return /*#__PURE__*/ $4Bt61.createElement($f0792a32d62fec93$var$AwaitContext.Provider, {
                    value: promise,
                    children: errorElement
                });
                if (status === $f0792a32d62fec93$var$AwaitRenderStatus.success) // Render children with resolved value
                return /*#__PURE__*/ $4Bt61.createElement($f0792a32d62fec93$var$AwaitContext.Provider, {
                    value: promise,
                    children: children
                });
                // Throw to the suspense boundary
                throw promise;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        }
    ]);
    return AwaitErrorBoundary;
}($4Bt61.Component);
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $f0792a32d62fec93$var$ResolveAwait(_ref8) {
    var children = _ref8.children;
    var data = $f0792a32d62fec93$export$78a72ddb39bdd145();
    var toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $4Bt61.createElement($4Bt61.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $f0792a32d62fec93$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    var routes = [];
    $4Bt61.Children.forEach(children, function(element, index) {
        if (!/*#__PURE__*/ $4Bt61.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        var treePath = (0, $1SMDP._)(parentPath).concat([
            index
        ]);
        if (element.type === $4Bt61.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $f0792a32d62fec93$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $f0792a32d62fec93$export$e7b0ac011bb776c6) && (0, $3a208abeb0ec52b2$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $3a208abeb0ec52b2$export$3e9cee6b33872309)(false);
        var route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $f0792a32d62fec93$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $f0792a32d62fec93$export$daf73786167a7f72(matches) {
    return $f0792a32d62fec93$var$_renderMatches(matches);
}
function $f0792a32d62fec93$export$52b333d321859367(route) {
    var updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $4Bt61.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $4Bt61.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $4Bt61.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $f0792a32d62fec93$export$f30f7e456d254e83(routes, opts) {
    return (0, $3a208abeb0ec52b2$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $f0792a32d62fec93$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $3a208abeb0ec52b2$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $f0792a32d62fec93$export$52b333d321859367,
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy
    }).initialize();
}



function $8f0ad21e84364a49$var$_extends() {
    $8f0ad21e84364a49$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8f0ad21e84364a49$var$_extends.apply(this, arguments);
}
function $8f0ad21e84364a49$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $8f0ad21e84364a49$var$defaultMethod = "get";
var $8f0ad21e84364a49$var$defaultEncType = "application/x-www-form-urlencoded";
function $8f0ad21e84364a49$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $8f0ad21e84364a49$var$isButtonElement(object) {
    return $8f0ad21e84364a49$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $8f0ad21e84364a49$var$isFormElement(object) {
    return $8f0ad21e84364a49$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $8f0ad21e84364a49$var$isInputElement(object) {
    return $8f0ad21e84364a49$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $8f0ad21e84364a49$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $8f0ad21e84364a49$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$8f0ad21e84364a49$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $8f0ad21e84364a49$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce(function(memo, key) {
        var value = init[key];
        return memo.concat(Array.isArray(value) ? value.map(function(v) {
            return [
                key,
                v
            ];
        }) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $8f0ad21e84364a49$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    var searchParams = $8f0ad21e84364a49$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach(function(_, key) {
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach(function(value) {
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
var $8f0ad21e84364a49$var$_formDataSupportsSubmitter = null;
function $8f0ad21e84364a49$var$isFormDataSubmitterSupported() {
    if ($8f0ad21e84364a49$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $8f0ad21e84364a49$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $8f0ad21e84364a49$var$_formDataSupportsSubmitter = true;
    }
    return $8f0ad21e84364a49$var$_formDataSupportsSubmitter;
}
var $8f0ad21e84364a49$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $8f0ad21e84364a49$var$getFormEncType(encType) {
    if (encType != null && !$8f0ad21e84364a49$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $8f0ad21e84364a49$var$getFormSubmissionInfo(target, basename) {
    var method;
    var action;
    var encType;
    var formData;
    var body;
    if ($8f0ad21e84364a49$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        var attr = target.getAttribute("action");
        action = attr ? (0, $3a208abeb0ec52b2$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $8f0ad21e84364a49$var$defaultMethod;
        encType = $8f0ad21e84364a49$var$getFormEncType(target.getAttribute("enctype")) || $8f0ad21e84364a49$var$defaultEncType;
        formData = new FormData(target);
    } else if ($8f0ad21e84364a49$var$isButtonElement(target) || $8f0ad21e84364a49$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        var form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        var attr1 = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr1 ? (0, $3a208abeb0ec52b2$export$b69e3301ce081aa3)(attr1, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $8f0ad21e84364a49$var$defaultMethod;
        encType = $8f0ad21e84364a49$var$getFormEncType(target.getAttribute("formenctype")) || $8f0ad21e84364a49$var$getFormEncType(form.getAttribute("enctype")) || $8f0ad21e84364a49$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$8f0ad21e84364a49$var$isFormDataSubmitterSupported()) {
            var name = target.name, type = target.type, value = target.value;
            if (type === "image") {
                var prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($8f0ad21e84364a49$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $8f0ad21e84364a49$var$defaultMethod;
        action = null;
        encType = $8f0ad21e84364a49$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
var $8f0ad21e84364a49$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $8f0ad21e84364a49$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $8f0ad21e84364a49$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
var $8f0ad21e84364a49$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $8f0ad21e84364a49$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $8f0ad21e84364a49$export$1f3f55432a00e06d(routes, opts) {
    return (0, $3a208abeb0ec52b2$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $8f0ad21e84364a49$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $3a208abeb0ec52b2$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $8f0ad21e84364a49$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $f0792a32d62fec93$export$52b333d321859367),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $8f0ad21e84364a49$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $3a208abeb0ec52b2$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $8f0ad21e84364a49$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $3a208abeb0ec52b2$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $8f0ad21e84364a49$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $f0792a32d62fec93$export$52b333d321859367),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $8f0ad21e84364a49$var$parseHydrationData() {
    var _window;
    var state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $8f0ad21e84364a49$var$_extends({}, state, {
        errors: $8f0ad21e84364a49$var$deserializeErrors(state.errors)
    });
    return state;
}
function $8f0ad21e84364a49$var$deserializeErrors(errors) {
    if (!errors) return null;
    var entries = Object.entries(errors);
    var serialized = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $f9AIs._)(_step.value, 2), key = _step_value[0], val = _step_value[1];
            // Hey you!  If you change this, please change the corresponding logic in
            // serializeErrors in react-router-dom/server.tsx :)
            if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $3a208abeb0ec52b2$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
            else if (val && val.__type === "Error") {
                // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
                if (val.__subType) {
                    var ErrorConstructor = window[val.__subType];
                    if (typeof ErrorConstructor === "function") try {
                        // @ts-expect-error
                        var error = new ErrorConstructor(val.message);
                        // Wipe away the client-side stack trace.  Nothing to fill it in with
                        // because we don't serialize SSR stack traces for security reasons
                        error.stack = "";
                        serialized[key] = error;
                    } catch (e) {
                    // no-op - fall through and create a normal Error
                    }
                }
                if (serialized[key] == null) {
                    var error1 = new Error(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error1.stack = "";
                    serialized[key] = error1;
                }
            } else serialized[key] = val;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return serialized;
}
var $8f0ad21e84364a49$export$7ad602f0e94e62d1 = /*#__PURE__*/ $4Bt61.createContext({
    isTransitioning: false
});
var $8f0ad21e84364a49$export$148fd98d095596d4 = /*#__PURE__*/ $4Bt61.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ var $8f0ad21e84364a49$var$START_TRANSITION = "startTransition";
var $8f0ad21e84364a49$var$startTransitionImpl = $4Bt61[$8f0ad21e84364a49$var$START_TRANSITION];
var $8f0ad21e84364a49$var$FLUSH_SYNC = "flushSync";
var $8f0ad21e84364a49$var$flushSyncImpl = $89f99546f5054100$exports[$8f0ad21e84364a49$var$FLUSH_SYNC];
var $8f0ad21e84364a49$var$USE_ID = "useId";
var $8f0ad21e84364a49$var$useIdImpl = $4Bt61[$8f0ad21e84364a49$var$USE_ID];
function $8f0ad21e84364a49$var$startTransitionSafe(cb) {
    if ($8f0ad21e84364a49$var$startTransitionImpl) $8f0ad21e84364a49$var$startTransitionImpl(cb);
    else cb();
}
function $8f0ad21e84364a49$var$flushSyncSafe(cb) {
    if ($8f0ad21e84364a49$var$flushSyncImpl) $8f0ad21e84364a49$var$flushSyncImpl(cb);
    else cb();
}
var $8f0ad21e84364a49$var$Deferred = function Deferred() {
    "use strict";
    var _this = this;
    (0, $aliU1._)(this, Deferred);
    this.status = "pending";
    this.promise = new Promise(function(resolve, reject) {
        _this.resolve = function(value) {
            if (_this.status === "pending") {
                _this.status = "resolved";
                resolve(value);
            }
        };
        _this.reject = function(reason) {
            if (_this.status === "pending") {
                _this.status = "rejected";
                reject(reason);
            }
        };
    });
};
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $8f0ad21e84364a49$export$323e4fc2fa4753fb(_ref) {
    var fallbackElement = _ref.fallbackElement, router = _ref.router, future = _ref.future;
    var _React_useState = (0, $f9AIs._)($4Bt61.useState(router.state), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var _React_useState1 = (0, $f9AIs._)($4Bt61.useState(), 2), pendingState = _React_useState1[0], setPendingState = _React_useState1[1];
    var _React_useState2 = (0, $f9AIs._)($4Bt61.useState({
        isTransitioning: false
    }), 2), vtContext = _React_useState2[0], setVtContext = _React_useState2[1];
    var _React_useState3 = (0, $f9AIs._)($4Bt61.useState(), 2), renderDfd = _React_useState3[0], setRenderDfd = _React_useState3[1];
    var _React_useState4 = (0, $f9AIs._)($4Bt61.useState(), 2), transition = _React_useState4[0], setTransition = _React_useState4[1];
    var _React_useState5 = (0, $f9AIs._)($4Bt61.useState(), 2), interruption = _React_useState5[0], setInterruption = _React_useState5[1];
    var fetcherData = $4Bt61.useRef(new Map());
    var v7_startTransition = (future || {}).v7_startTransition;
    var optInStartTransition = $4Bt61.useCallback(function(cb) {
        if (v7_startTransition) $8f0ad21e84364a49$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    var setState = $4Bt61.useCallback(function(newState, _ref2) {
        var deletedFetchers = _ref2.deletedFetchers, flushSync = _ref2.unstable_flushSync, viewTransitionOpts = _ref2.unstable_viewTransitionOpts;
        deletedFetchers.forEach(function(key) {
            return fetcherData.current.delete(key);
        });
        newState.fetchers.forEach(function(fetcher, key) {
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        var isViewTransitionUnavailable = router.window == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $8f0ad21e84364a49$var$flushSyncSafe(function() {
                return setStateImpl(newState);
            });
            else optInStartTransition(function() {
                return setStateImpl(newState);
            });
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $8f0ad21e84364a49$var$flushSyncSafe(function() {
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            var t = router.window.document.startViewTransition(function() {
                $8f0ad21e84364a49$var$flushSyncSafe(function() {
                    return setStateImpl(newState);
                });
            });
            // Clean up after the animation completes
            t.finished.finally(function() {
                $8f0ad21e84364a49$var$flushSyncSafe(function() {
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $8f0ad21e84364a49$var$flushSyncSafe(function() {
                return setTransition(t);
            });
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $4Bt61.useLayoutEffect(function() {
        return router.subscribe(setState);
    }, [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $4Bt61.useEffect(function() {
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $8f0ad21e84364a49$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $4Bt61.useEffect(function() {
        if (renderDfd && pendingState && router.window) {
            var newState = pendingState;
            var renderPromise = renderDfd.promise;
            var transition = router.window.document.startViewTransition(/*#__PURE__*/ (0, $1d3fb01611386816$export$71511d61b312f219)(function() {
                return (0, $47055dab5b247348$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            optInStartTransition(function() {
                                return setStateImpl(newState);
                            });
                            return [
                                4,
                                renderPromise
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            }));
            transition.finished.finally(function() {
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $4Bt61.useEffect(function() {
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $4Bt61.useEffect(function() {
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $4Bt61.useEffect(function() {
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var navigator = $4Bt61.useMemo(function() {
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: function(n) {
                return router.navigate(n);
            },
            push: function(to, state, opts) {
                return router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            },
            replace: function(to, state, opts) {
                return router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            }
        };
    }, [
        router
    ]);
    var basename = router.basename || "/";
    var dataRouterContext = $4Bt61.useMemo(function() {
        return {
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        };
    }, [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $4Bt61.createElement($4Bt61.Fragment, null, /*#__PURE__*/ $4Bt61.createElement((0, $f0792a32d62fec93$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $4Bt61.createElement((0, $f0792a32d62fec93$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $4Bt61.createElement($8f0ad21e84364a49$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $4Bt61.createElement($8f0ad21e84364a49$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $4Bt61.createElement((0, $f0792a32d62fec93$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $4Bt61.createElement($8f0ad21e84364a49$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
function $8f0ad21e84364a49$var$DataRoutes(_ref3) {
    var routes = _ref3.routes, future = _ref3.future, state = _ref3.state;
    return (0, $f0792a32d62fec93$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $8f0ad21e84364a49$export$9ba4e89fdfa1fc54(_ref4) {
    var basename = _ref4.basename, children = _ref4.children, future = _ref4.future, _$window = _ref4.window;
    var historyRef = $4Bt61.useRef();
    if (historyRef.current == null) historyRef.current = (0, $3a208abeb0ec52b2$export$719fc203c4e16dee)({
        window: _$window,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $f9AIs._)($4Bt61.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $4Bt61.useCallback(function(newState) {
        v7_startTransition && $8f0ad21e84364a49$var$startTransitionImpl ? $8f0ad21e84364a49$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $4Bt61.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ $4Bt61.createElement((0, $f0792a32d62fec93$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $8f0ad21e84364a49$export$7221d69dcfc8e36b(_ref5) {
    var basename = _ref5.basename, children = _ref5.children, future = _ref5.future, _$window = _ref5.window;
    var historyRef = $4Bt61.useRef();
    if (historyRef.current == null) historyRef.current = (0, $3a208abeb0ec52b2$export$b71fdd3798280242)({
        window: _$window,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $f9AIs._)($4Bt61.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $4Bt61.useCallback(function(newState) {
        v7_startTransition && $8f0ad21e84364a49$var$startTransitionImpl ? $8f0ad21e84364a49$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $4Bt61.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ $4Bt61.createElement((0, $f0792a32d62fec93$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $8f0ad21e84364a49$export$eefb0c834599897e(_ref6) {
    var basename = _ref6.basename, children = _ref6.children, future = _ref6.future, history = _ref6.history;
    var _React_useState = (0, $f9AIs._)($4Bt61.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $4Bt61.useCallback(function(newState) {
        v7_startTransition && $8f0ad21e84364a49$var$startTransitionImpl ? $8f0ad21e84364a49$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $4Bt61.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ $4Bt61.createElement((0, $f0792a32d62fec93$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
var $8f0ad21e84364a49$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
var $8f0ad21e84364a49$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ var $8f0ad21e84364a49$export$a6c7ac8248d6e38a = /*#__PURE__*/ $4Bt61.forwardRef(function LinkWithRef(_ref7, ref) {
    var onClick = _ref7.onClick, relative = _ref7.relative, reloadDocument = _ref7.reloadDocument, replace = _ref7.replace, state = _ref7.state, target = _ref7.target, to = _ref7.to, preventScrollReset = _ref7.preventScrollReset, unstable_viewTransition = _ref7.unstable_viewTransition, rest = $8f0ad21e84364a49$var$_objectWithoutPropertiesLoose(_ref7, $8f0ad21e84364a49$var$_excluded);
    var basename = $4Bt61.useContext((0, $f0792a32d62fec93$export$26749e8557646306)).basename;
    // Rendered into <a href> for absolute URLs
    var absoluteHref;
    var isExternal = false;
    if (typeof to === "string" && $8f0ad21e84364a49$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($8f0ad21e84364a49$var$isBrowser) try {
            var currentUrl = new URL(window.location.href);
            var targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            var path = (0, $3a208abeb0ec52b2$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    var href = (0, $f0792a32d62fec93$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    var internalOnClick = $8f0ad21e84364a49$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $4Bt61.createElement("a", $8f0ad21e84364a49$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ var $8f0ad21e84364a49$export$b0d92dbee9b5b60d = /*#__PURE__*/ $4Bt61.forwardRef(function NavLinkWithRef(_ref8, ref) {
    var tmp = _ref8["aria-current"], ariaCurrentProp = tmp === void 0 ? "page" : tmp, _ref8_caseSensitive = _ref8.caseSensitive, caseSensitive = _ref8_caseSensitive === void 0 ? false : _ref8_caseSensitive, tmp1 = _ref8.className, classNameProp = tmp1 === void 0 ? "" : tmp1, _ref8_end = _ref8.end, end = _ref8_end === void 0 ? false : _ref8_end, styleProp = _ref8.style, to = _ref8.to, unstable_viewTransition = _ref8.unstable_viewTransition, children = _ref8.children, rest = $8f0ad21e84364a49$var$_objectWithoutPropertiesLoose(_ref8, $8f0ad21e84364a49$var$_excluded2);
    var path = (0, $f0792a32d62fec93$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    var location = (0, $f0792a32d62fec93$export$45d76561a5302f2b)();
    var routerState = $4Bt61.useContext((0, $f0792a32d62fec93$export$145dfa71566a64dc));
    var _React_useContext = $4Bt61.useContext((0, $f0792a32d62fec93$export$26749e8557646306)), navigator = _React_useContext.navigator, basename = _React_useContext.basename;
    var isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $8f0ad21e84364a49$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    var toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    var locationPathname = location.pathname;
    var nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $3a208abeb0ec52b2$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    var endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    var isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    var isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    var renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    var ariaCurrent = isActive ? ariaCurrentProp : undefined;
    var className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    var style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $4Bt61.createElement($8f0ad21e84364a49$export$a6c7ac8248d6e38a, $8f0ad21e84364a49$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ var $8f0ad21e84364a49$export$a7fed597f4b8afd8 = /*#__PURE__*/ $4Bt61.forwardRef(function(_ref9, forwardedRef) {
    var fetcherKey = _ref9.fetcherKey, navigate = _ref9.navigate, reloadDocument = _ref9.reloadDocument, replace = _ref9.replace, state = _ref9.state, _ref9_method = _ref9.method, method = _ref9_method === void 0 ? $8f0ad21e84364a49$var$defaultMethod : _ref9_method, action = _ref9.action, onSubmit = _ref9.onSubmit, relative = _ref9.relative, preventScrollReset = _ref9.preventScrollReset, unstable_viewTransition = _ref9.unstable_viewTransition, props = $8f0ad21e84364a49$var$_objectWithoutPropertiesLoose(_ref9, $8f0ad21e84364a49$var$_excluded3);
    var submit = $8f0ad21e84364a49$export$47c85c6e3a081d3();
    var formAction = $8f0ad21e84364a49$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    var formMethod = method.toLowerCase() === "get" ? "get" : "post";
    var submitHandler = function(event) {
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        var submitter = event.nativeEvent.submitter;
        var submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $4Bt61.createElement("form", $8f0ad21e84364a49$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $8f0ad21e84364a49$export$11aac1aab828f1fa(_ref10) {
    var getKey = _ref10.getKey, storageKey = _ref10.storageKey;
    $8f0ad21e84364a49$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $8f0ad21e84364a49$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($8f0ad21e84364a49$var$DataRouterHook || ($8f0ad21e84364a49$var$DataRouterHook = {}));
var $8f0ad21e84364a49$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($8f0ad21e84364a49$var$DataRouterStateHook || ($8f0ad21e84364a49$var$DataRouterStateHook = {}));
// Internal hooks
function $8f0ad21e84364a49$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $8f0ad21e84364a49$var$useDataRouterContext(hookName) {
    var ctx = $4Bt61.useContext((0, $f0792a32d62fec93$export$3add0d5dce533e2e));
    !ctx && (0, $3a208abeb0ec52b2$export$3e9cee6b33872309)(false);
    return ctx;
}
function $8f0ad21e84364a49$var$useDataRouterState(hookName) {
    var state = $4Bt61.useContext((0, $f0792a32d62fec93$export$145dfa71566a64dc));
    !state && (0, $3a208abeb0ec52b2$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $8f0ad21e84364a49$export$67621102c14d847(to, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, target = _ref.target, replaceProp = _ref.replace, state = _ref.state, preventScrollReset = _ref.preventScrollReset, relative = _ref.relative, unstable_viewTransition = _ref.unstable_viewTransition;
    var navigate = (0, $f0792a32d62fec93$export$9770f232ac06a008)();
    var location = (0, $f0792a32d62fec93$export$45d76561a5302f2b)();
    var path = (0, $f0792a32d62fec93$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $4Bt61.useCallback(function(event) {
        if ($8f0ad21e84364a49$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            var replace = replaceProp !== undefined ? replaceProp : (0, $3a208abeb0ec52b2$export$fe53371bee54353d)(location) === (0, $3a208abeb0ec52b2$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $8f0ad21e84364a49$export$f1a78c17382fe22a(defaultInit) {
    var defaultSearchParamsRef = $4Bt61.useRef($8f0ad21e84364a49$export$a2e4e2dcc7b1f22f(defaultInit));
    var hasSetSearchParamsRef = $4Bt61.useRef(false);
    var location = (0, $f0792a32d62fec93$export$45d76561a5302f2b)();
    var searchParams = $4Bt61.useMemo(function() {
        return(// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $8f0ad21e84364a49$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current));
    }, [
        location.search
    ]);
    var navigate = (0, $f0792a32d62fec93$export$9770f232ac06a008)();
    var setSearchParams = $4Bt61.useCallback(function(nextInit, navigateOptions) {
        var newSearchParams = $8f0ad21e84364a49$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $8f0ad21e84364a49$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
var $8f0ad21e84364a49$var$fetcherId = 0;
var $8f0ad21e84364a49$var$getUniqueFetcherId = function() {
    return "__" + String(++$8f0ad21e84364a49$var$fetcherId) + "__";
};
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $8f0ad21e84364a49$export$47c85c6e3a081d3() {
    var router = $8f0ad21e84364a49$var$useDataRouterContext($8f0ad21e84364a49$var$DataRouterHook.UseSubmit).router;
    var basename = $4Bt61.useContext((0, $f0792a32d62fec93$export$26749e8557646306)).basename;
    var currentRouteId = (0, $f0792a32d62fec93$export$5fc8298006ad9e58)();
    return $4Bt61.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $8f0ad21e84364a49$var$validateClientSideSubmission();
        var _getFormSubmissionInfo = $8f0ad21e84364a49$var$getFormSubmissionInfo(target, basename), action = _getFormSubmissionInfo.action, method = _getFormSubmissionInfo.method, encType = _getFormSubmissionInfo.encType, formData = _getFormSubmissionInfo.formData, body = _getFormSubmissionInfo.body;
        if (options.navigate === false) {
            var key = options.fetcherKey || $8f0ad21e84364a49$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $8f0ad21e84364a49$export$89a6bd6db0d97c56(action, _temp2) {
    var relative = (_temp2 === void 0 ? {} : _temp2).relative;
    var basename = $4Bt61.useContext((0, $f0792a32d62fec93$export$26749e8557646306)).basename;
    var routeContext = $4Bt61.useContext((0, $f0792a32d62fec93$export$9072aa6dd1f93057));
    !routeContext && (0, $3a208abeb0ec52b2$export$3e9cee6b33872309)(false);
    var _routeContext_matches_slice = (0, $f9AIs._)(routeContext.matches.slice(-1), 1), match = _routeContext_matches_slice[0];
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    var path = $8f0ad21e84364a49$var$_extends({}, (0, $f0792a32d62fec93$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    var location = (0, $f0792a32d62fec93$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        var params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $3a208abeb0ec52b2$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $3a208abeb0ec52b2$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $8f0ad21e84364a49$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    var key = (_temp3 === void 0 ? {} : _temp3).key;
    var router = $8f0ad21e84364a49$var$useDataRouterContext($8f0ad21e84364a49$var$DataRouterHook.UseFetcher).router;
    var state = $8f0ad21e84364a49$var$useDataRouterState($8f0ad21e84364a49$var$DataRouterStateHook.UseFetcher);
    var fetcherData = $4Bt61.useContext($8f0ad21e84364a49$export$148fd98d095596d4);
    var route = $4Bt61.useContext((0, $f0792a32d62fec93$export$9072aa6dd1f93057));
    var routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $3a208abeb0ec52b2$export$3e9cee6b33872309)(false);
    !route && (0, $3a208abeb0ec52b2$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $3a208abeb0ec52b2$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var defaultKey = $8f0ad21e84364a49$var$useIdImpl ? $8f0ad21e84364a49$var$useIdImpl() : "";
    var _React_useState = (0, $f9AIs._)($4Bt61.useState(key || defaultKey), 2), fetcherKey = _React_useState[0], setFetcherKey = _React_useState[1];
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($8f0ad21e84364a49$var$getUniqueFetcherId());
    // Registration/cleanup
    $4Bt61.useEffect(function() {
        router.getFetcher(fetcherKey);
        return function() {
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    var load = $4Bt61.useCallback(function(href, opts) {
        !routeId && (0, $3a208abeb0ec52b2$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    var submitImpl = $8f0ad21e84364a49$export$47c85c6e3a081d3();
    var submit = $4Bt61.useCallback(function(target, opts) {
        submitImpl(target, $8f0ad21e84364a49$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    var FetcherForm = $4Bt61.useMemo(function() {
        var FetcherForm = /*#__PURE__*/ $4Bt61.forwardRef(function(props, ref) {
            return /*#__PURE__*/ $4Bt61.createElement($8f0ad21e84364a49$export$a7fed597f4b8afd8, $8f0ad21e84364a49$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    var fetcher = state.fetchers.get(fetcherKey) || (0, $3a208abeb0ec52b2$export$52eace9c284d3585);
    var data = fetcherData.get(fetcherKey);
    var fetcherWithComponents = $4Bt61.useMemo(function() {
        return $8f0ad21e84364a49$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        });
    }, [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $8f0ad21e84364a49$export$fa996778a3a31087() {
    var state = $8f0ad21e84364a49$var$useDataRouterState($8f0ad21e84364a49$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map(function(_ref11) {
        var _$_ref11 = (0, $f9AIs._)(_ref11, 2), key = _$_ref11[0], fetcher = _$_ref11[1];
        return $8f0ad21e84364a49$var$_extends({}, fetcher, {
            key: key
        });
    });
}
var $8f0ad21e84364a49$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $8f0ad21e84364a49$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $8f0ad21e84364a49$export$25057cfe5591e3e9(_temp4) {
    var _ref = _temp4 === void 0 ? {} : _temp4, getKey = _ref.getKey, storageKey = _ref.storageKey;
    var router = $8f0ad21e84364a49$var$useDataRouterContext($8f0ad21e84364a49$var$DataRouterHook.UseScrollRestoration).router;
    var _useDataRouterState = $8f0ad21e84364a49$var$useDataRouterState($8f0ad21e84364a49$var$DataRouterStateHook.UseScrollRestoration), restoreScrollPosition = _useDataRouterState.restoreScrollPosition, preventScrollReset = _useDataRouterState.preventScrollReset;
    var basename = $4Bt61.useContext((0, $f0792a32d62fec93$export$26749e8557646306)).basename;
    var location = (0, $f0792a32d62fec93$export$45d76561a5302f2b)();
    var matches = (0, $f0792a32d62fec93$export$2378eb7f5ff86053)();
    var navigation = (0, $f0792a32d62fec93$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $4Bt61.useEffect(function() {
        window.history.scrollRestoration = "manual";
        return function() {
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $8f0ad21e84364a49$var$usePageHide($4Bt61.useCallback(function() {
        if (navigation.state === "idle") {
            var key = (getKey ? getKey(location, matches) : null) || location.key;
            $8f0ad21e84364a49$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $8f0ad21e84364a49$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($8f0ad21e84364a49$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $4Bt61.useLayoutEffect(function() {
            try {
                var sessionPositions = sessionStorage.getItem(storageKey || $8f0ad21e84364a49$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $8f0ad21e84364a49$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $4Bt61.useLayoutEffect(function() {
            var getKeyWithoutBasename = getKey && basename !== "/" ? function(location, matches) {
                return getKey($8f0ad21e84364a49$var$_extends({}, location, {
                    pathname: (0, $3a208abeb0ec52b2$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches);
            } : getKey;
            var disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($8f0ad21e84364a49$var$savedScrollPositions, function() {
                return window.scrollY;
            }, getKeyWithoutBasename);
            return function() {
                return disableScrollRestoration && disableScrollRestoration();
            };
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $4Bt61.useLayoutEffect(function() {
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                var el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $8f0ad21e84364a49$export$c0a586b329cae57d(callback, options) {
    var capture = (options || {}).capture;
    $4Bt61.useEffect(function() {
        var opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return function() {
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $8f0ad21e84364a49$var$usePageHide(callback, options) {
    var capture = (options || {}).capture;
    $4Bt61.useEffect(function() {
        var opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return function() {
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $8f0ad21e84364a49$export$39f4eb3dbd812741(_ref12) {
    var when = _ref12.when, message = _ref12.message;
    var blocker = (0, $f0792a32d62fec93$export$b273b3273281a049)(when);
    $4Bt61.useEffect(function() {
        if (blocker.state === "blocked") {
            var proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $4Bt61.useEffect(function() {
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $8f0ad21e84364a49$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    var vtContext = $4Bt61.useContext($8f0ad21e84364a49$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $3a208abeb0ec52b2$export$3e9cee6b33872309)(false);
    var basename = $8f0ad21e84364a49$var$useDataRouterContext($8f0ad21e84364a49$var$DataRouterHook.useViewTransitionState).basename;
    var path = (0, $f0792a32d62fec93$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    var currentPath = (0, $3a208abeb0ec52b2$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    var nextPath = (0, $3a208abeb0ec52b2$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $3a208abeb0ec52b2$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $3a208abeb0ec52b2$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



var $f9AIs = parcelRequire("f9AIs");

var $4Bt61 = parcelRequire("4Bt61");
var $5a05f2f4001176d2$var$useOnline = function() {
    var _useState = (0, $f9AIs._)((0, $4Bt61.useState)(true), 2), isOnline = _useState[0], setIsOnline = _useState[1];
    (0, $4Bt61.useEffect)(function() {
        var handleOnline = function() {
            setIsOnline(true);
        };
        var handleOffline = function() {
            setIsOnline(false);
        };
        window.addEventListener("online", handleOnline);
        window.addEventListener("offline", handleOffline);
        return function() {
            window.removeEventListener("online", handleOnline);
            window.removeEventListener("online", handleOffline);
        };
    }, []);
    return isOnline;
};
var $5a05f2f4001176d2$export$2e2bcd8739ae039 = $5a05f2f4001176d2$var$useOnline;



var $4Bt61 = parcelRequire("4Bt61");
var $2819d30547b11aa2$var$UserContext = /*#__PURE__*/ (0, $4Bt61.createContext)({
    user: {
        height: "nawaf",
        age: 18
    }
});
$2819d30547b11aa2$var$UserContext.displayName = "usercontext";
var $2819d30547b11aa2$export$2e2bcd8739ae039 //game:{
 //played:'PUBG',
 //  time:202
 //  }
 = $2819d30547b11aa2$var$UserContext;



var $73NPw = parcelRequire("73NPw");

var $f9AIs = parcelRequire("f9AIs");

var $1SMDP = parcelRequire("1SMDP");

var $6zqIC = parcelRequire("6zqIC");

var $4Bt61 = parcelRequire("4Bt61");
var $759ca12a6d25751d$exports = {};
"use strict";

$759ca12a6d25751d$exports = (parcelRequire("h8OFX"));


var $d7493d97555cda1a$var$__defProp = Object.defineProperty;
var $d7493d97555cda1a$var$__defProps = Object.defineProperties;
var $d7493d97555cda1a$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $d7493d97555cda1a$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $d7493d97555cda1a$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $d7493d97555cda1a$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $d7493d97555cda1a$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $d7493d97555cda1a$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $d7493d97555cda1a$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($d7493d97555cda1a$var$__hasOwnProp.call(b, prop)) $d7493d97555cda1a$var$__defNormalProp(a, prop, b[prop]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if ($d7493d97555cda1a$var$__getOwnPropSymbols) try {
        for(var _iterator = $d7493d97555cda1a$var$__getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if ($d7493d97555cda1a$var$__propIsEnum.call(b, prop)) $d7493d97555cda1a$var$__defNormalProp(a, prop, b[prop]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return a;
};
var $d7493d97555cda1a$var$__spreadProps = function(a, b) {
    return $d7493d97555cda1a$var$__defProps(a, $d7493d97555cda1a$var$__getOwnPropDescs(b));
};
var $d7493d97555cda1a$var$__objRest = function(source, exclude) {
    var target = {};
    for(var prop in source)if ($d7493d97555cda1a$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (source != null && $d7493d97555cda1a$var$__getOwnPropSymbols) try {
        for(var _iterator = $d7493d97555cda1a$var$__getOwnPropSymbols(source)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if (exclude.indexOf(prop) < 0 && $d7493d97555cda1a$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return target;
};
var $d7493d97555cda1a$var$React = // prettier-ignore
// @ts-ignore
"default" in $4Bt61 ? $4Bt61["default"] : $4Bt61;
// src/components/Context.ts
var $d7493d97555cda1a$var$ContextKey = Symbol.for("react-redux-context");
var $d7493d97555cda1a$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $d7493d97555cda1a$var$getContext() {
    var _a;
    if (!$d7493d97555cda1a$var$React.createContext) return {};
    var contextMap = (_a = $d7493d97555cda1a$var$gT[$d7493d97555cda1a$var$ContextKey]) != null ? _a : $d7493d97555cda1a$var$gT[$d7493d97555cda1a$var$ContextKey] = /* @__PURE__ */ new Map();
    var realContext = contextMap.get($d7493d97555cda1a$var$React.createContext);
    if (!realContext) {
        realContext = $d7493d97555cda1a$var$React.createContext(null);
        contextMap.set($d7493d97555cda1a$var$React.createContext, realContext);
    }
    return realContext;
}
var $d7493d97555cda1a$export$cc80c08dc91f1c00 = /* @__PURE__ */ $d7493d97555cda1a$var$getContext();
// src/utils/useSyncExternalStore.ts
var $d7493d97555cda1a$var$notInitialized = function() {
    throw new Error("uSES not initialized!");
};
// src/hooks/useReduxContext.ts
function $d7493d97555cda1a$var$createReduxContextHook() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $d7493d97555cda1a$export$cc80c08dc91f1c00;
    return function useReduxContext2() {
        var contextValue = $d7493d97555cda1a$var$React.useContext(context);
        return contextValue;
    };
}
var $d7493d97555cda1a$var$useReduxContext = /* @__PURE__ */ $d7493d97555cda1a$var$createReduxContextHook();
// src/hooks/useSelector.ts
var $d7493d97555cda1a$var$useSyncExternalStoreWithSelector = $d7493d97555cda1a$var$notInitialized;
var $d7493d97555cda1a$var$initializeUseSelector = function(fn) {
    $d7493d97555cda1a$var$useSyncExternalStoreWithSelector = fn;
};
var $d7493d97555cda1a$var$refEquality = function(a, b) {
    return a === b;
};
function $d7493d97555cda1a$export$2b53f90d2bd1cbfb() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $d7493d97555cda1a$export$cc80c08dc91f1c00;
    var useReduxContext2 = context === $d7493d97555cda1a$export$cc80c08dc91f1c00 ? $d7493d97555cda1a$var$useReduxContext : $d7493d97555cda1a$var$createReduxContextHook(context);
    var useSelector2 = function(selector) {
        var equalityFnOrOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var _ref = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions, _ref_equalityFn = _ref.equalityFn, equalityFn = _ref_equalityFn === void 0 ? $d7493d97555cda1a$var$refEquality : _ref_equalityFn, _ref_devModeChecks = _ref.devModeChecks, devModeChecks = _ref_devModeChecks === void 0 ? {} : _ref_devModeChecks;
        var _useReduxContext2 = useReduxContext2(), store = _useReduxContext2.store, subscription = _useReduxContext2.subscription, getServerState = _useReduxContext2.getServerState, stabilityCheck = _useReduxContext2.stabilityCheck, identityFunctionCheck = _useReduxContext2.identityFunctionCheck;
        var firstRun = $d7493d97555cda1a$var$React.useRef(true);
        var wrappedSelector = $d7493d97555cda1a$var$React.useCallback((0, $73NPw._)({}, selector.name, function(state) {
            var selected = selector(state);
            var e, e1;
            return selected;
        })[selector.name], [
            selector,
            stabilityCheck,
            devModeChecks.stabilityCheck
        ]);
        var selectedState = $d7493d97555cda1a$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        $d7493d97555cda1a$var$React.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: function() {
            return useSelector2;
        }
    });
    return useSelector2;
}
var $d7493d97555cda1a$export$2105062e25df4afe = /* @__PURE__ */ $d7493d97555cda1a$export$2b53f90d2bd1cbfb();
// src/utils/react-is.ts
var $d7493d97555cda1a$var$REACT_ELEMENT_TYPE = Symbol.for("react.element");
var $d7493d97555cda1a$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
var $d7493d97555cda1a$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
var $d7493d97555cda1a$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
var $d7493d97555cda1a$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler");
var $d7493d97555cda1a$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider");
var $d7493d97555cda1a$var$REACT_CONTEXT_TYPE = Symbol.for("react.context");
var $d7493d97555cda1a$var$REACT_SERVER_CONTEXT_TYPE = Symbol.for("react.server_context");
var $d7493d97555cda1a$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
var $d7493d97555cda1a$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
var $d7493d97555cda1a$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
var $d7493d97555cda1a$var$REACT_MEMO_TYPE = Symbol.for("react.memo");
var $d7493d97555cda1a$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
var $d7493d97555cda1a$var$REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
var $d7493d97555cda1a$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
var $d7493d97555cda1a$var$ForwardRef = $d7493d97555cda1a$var$REACT_FORWARD_REF_TYPE;
var $d7493d97555cda1a$var$Memo = $d7493d97555cda1a$var$REACT_MEMO_TYPE;
function $d7493d97555cda1a$var$isValidElementType(type) {
    if (typeof type === "string" || typeof type === "function") return true;
    if (type === $d7493d97555cda1a$var$REACT_FRAGMENT_TYPE || type === $d7493d97555cda1a$var$REACT_PROFILER_TYPE || type === $d7493d97555cda1a$var$REACT_STRICT_MODE_TYPE || type === $d7493d97555cda1a$var$REACT_SUSPENSE_TYPE || type === $d7493d97555cda1a$var$REACT_SUSPENSE_LIST_TYPE || type === $d7493d97555cda1a$var$REACT_OFFSCREEN_TYPE) return true;
    if (typeof type === "object" && type !== null) {
        if (type.$$typeof === $d7493d97555cda1a$var$REACT_LAZY_TYPE || type.$$typeof === $d7493d97555cda1a$var$REACT_MEMO_TYPE || type.$$typeof === $d7493d97555cda1a$var$REACT_PROVIDER_TYPE || type.$$typeof === $d7493d97555cda1a$var$REACT_CONTEXT_TYPE || type.$$typeof === $d7493d97555cda1a$var$REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
        // types supported by any Flight configuration anywhere since
        // we don't know which Flight build this will end up being used
        // with.
        type.$$typeof === $d7493d97555cda1a$var$REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) return true;
    }
    return false;
}
function $d7493d97555cda1a$var$typeOf(object) {
    if (typeof object === "object" && object !== null) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case $d7493d97555cda1a$var$REACT_ELEMENT_TYPE:
                {
                    var type = object.type;
                    switch(type){
                        case $d7493d97555cda1a$var$REACT_FRAGMENT_TYPE:
                        case $d7493d97555cda1a$var$REACT_PROFILER_TYPE:
                        case $d7493d97555cda1a$var$REACT_STRICT_MODE_TYPE:
                        case $d7493d97555cda1a$var$REACT_SUSPENSE_TYPE:
                        case $d7493d97555cda1a$var$REACT_SUSPENSE_LIST_TYPE:
                            return type;
                        default:
                            {
                                var $$typeofType = type && type.$$typeof;
                                switch($$typeofType){
                                    case $d7493d97555cda1a$var$REACT_SERVER_CONTEXT_TYPE:
                                    case $d7493d97555cda1a$var$REACT_CONTEXT_TYPE:
                                    case $d7493d97555cda1a$var$REACT_FORWARD_REF_TYPE:
                                    case $d7493d97555cda1a$var$REACT_LAZY_TYPE:
                                    case $d7493d97555cda1a$var$REACT_MEMO_TYPE:
                                    case $d7493d97555cda1a$var$REACT_PROVIDER_TYPE:
                                        return $$typeofType;
                                    default:
                                        return $$typeof;
                                }
                            }
                    }
                }
            case $d7493d97555cda1a$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
    return void 0;
}
function $d7493d97555cda1a$var$isContextConsumer(object) {
    return $d7493d97555cda1a$var$typeOf(object) === $d7493d97555cda1a$var$REACT_CONTEXT_TYPE;
}
function $d7493d97555cda1a$var$isMemo(object) {
    return $d7493d97555cda1a$var$typeOf(object) === $d7493d97555cda1a$var$REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function $d7493d97555cda1a$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function $d7493d97555cda1a$var$verify(selector, methodName) {
    if (!selector) throw new Error("Unexpected value for ".concat(methodName, " in connect."));
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) $d7493d97555cda1a$var$warning("The selector for ".concat(methodName, " of connect did not specify a value for dependsOnOwnProps."));
    }
}
function $d7493d97555cda1a$var$verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    $d7493d97555cda1a$var$verify(mapStateToProps, "mapStateToProps");
    $d7493d97555cda1a$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $d7493d97555cda1a$var$verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function $d7493d97555cda1a$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, param) {
    var areStatesEqual = param.areStatesEqual, areOwnPropsEqual = param.areOwnPropsEqual, areStatePropsEqual = param.areStatePropsEqual;
    var hasRunAtLeastOnce = false;
    var state;
    var ownProps;
    var stateProps;
    var dispatchProps;
    var mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        var nextStateProps = mapStateToProps(state, ownProps);
        var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        var stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $d7493d97555cda1a$var$finalPropsSelectorFactory(dispatch, _a) {
    var _b = _a, initMapStateToProps = _b.initMapStateToProps, initMapDispatchToProps = _b.initMapDispatchToProps, initMergeProps = _b.initMergeProps, options = $d7493d97555cda1a$var$__objRest(_b, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    var mapStateToProps = initMapStateToProps(dispatch, options);
    var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    var mergeProps = initMergeProps(dispatch, options);
    return $d7493d97555cda1a$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function $d7493d97555cda1a$var$bindActionCreators(actionCreators, dispatch) {
    var _loop = function(key) {
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return dispatch(actionCreator.apply(void 0, (0, $1SMDP._)(args)));
        };
    };
    var boundActionCreators = {};
    for(var key in actionCreators)_loop(key);
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function $d7493d97555cda1a$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function $d7493d97555cda1a$var$verifyPlainObject(value, displayName, methodName) {
    if (!$d7493d97555cda1a$var$isPlainObject(value)) $d7493d97555cda1a$var$warning("".concat(methodName, "() in ").concat(displayName, " must return a plain object. Instead received ").concat(value, "."));
}
// src/connect/wrapMapToProps.ts
function $d7493d97555cda1a$var$wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        var constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function $d7493d97555cda1a$var$getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function $d7493d97555cda1a$var$wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, param) {
        var displayName = param.displayName;
        var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $d7493d97555cda1a$var$getDependsOnOwnProps(mapToProps);
            var props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $d7493d97555cda1a$var$getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function $d7493d97555cda1a$var$createInvalidArgFactory(arg, name) {
    return function(dispatch, options) {
        throw new Error("Invalid value of type ".concat(typeof arg === "undefined" ? "undefined" : (0, $6zqIC._)(arg), " for ").concat(name, " argument when connecting component ").concat(options.wrappedComponentName, "."));
    };
}
// src/connect/mapDispatchToProps.ts
function $d7493d97555cda1a$var$mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? $d7493d97555cda1a$var$wrapMapToPropsConstant(function(dispatch) {
        return(// @ts-ignore
        $d7493d97555cda1a$var$bindActionCreators(mapDispatchToProps, dispatch));
    }) : !mapDispatchToProps ? $d7493d97555cda1a$var$wrapMapToPropsConstant(function(dispatch) {
        return {
            dispatch: dispatch
        };
    }) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    $d7493d97555cda1a$var$wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : $d7493d97555cda1a$var$createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function $d7493d97555cda1a$var$mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? $d7493d97555cda1a$var$wrapMapToPropsConstant(function() {
        return {};
    }) : typeof mapStateToProps === "function" ? // @ts-ignore
    $d7493d97555cda1a$var$wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : $d7493d97555cda1a$var$createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function $d7493d97555cda1a$var$defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return $d7493d97555cda1a$var$__spreadValues($d7493d97555cda1a$var$__spreadValues($d7493d97555cda1a$var$__spreadValues({}, ownProps), stateProps), dispatchProps);
}
function $d7493d97555cda1a$var$wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, param) {
        var displayName = param.displayName, areMergedPropsEqual = param.areMergedPropsEqual;
        var hasRunOnce = false;
        var mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $d7493d97555cda1a$var$mergePropsFactory(mergeProps) {
    return !mergeProps ? function() {
        return $d7493d97555cda1a$var$defaultMergeProps;
    } : typeof mergeProps === "function" ? $d7493d97555cda1a$var$wrapMergePropsFunc(mergeProps) : $d7493d97555cda1a$var$createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function $d7493d97555cda1a$var$defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function $d7493d97555cda1a$var$createListenerCollection() {
    var first = null;
    var last = null;
    return {
        clear: function() {
            first = null;
            last = null;
        },
        notify: function() {
            $d7493d97555cda1a$var$defaultNoopBatch(function() {
                var listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get: function() {
            var listeners = [];
            var listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe: function(callback) {
            var isSubscribed = true;
            var listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $d7493d97555cda1a$var$nullListeners = {
    notify: function() {},
    get: function() {
        return [];
    }
};
function $d7493d97555cda1a$var$createSubscription(store, parentSub) {
    var unsubscribe;
    var listeners = $d7493d97555cda1a$var$nullListeners;
    var subscriptionsAmount = 0;
    var selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        var cleanupListener = listeners.subscribe(listener);
        var removed = false;
        return function() {
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $d7493d97555cda1a$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = $d7493d97555cda1a$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    var subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: function() {
            return listeners;
        }
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var $d7493d97555cda1a$var$canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var $d7493d97555cda1a$var$isReactNative = typeof navigator !== "undefined" && navigator.product === "ReactNative";
var $d7493d97555cda1a$var$useIsomorphicLayoutEffect = $d7493d97555cda1a$var$canUseDOM || $d7493d97555cda1a$var$isReactNative ? $d7493d97555cda1a$var$React.useLayoutEffect : $d7493d97555cda1a$var$React.useEffect;
// src/utils/shallowEqual.ts
function $d7493d97555cda1a$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $d7493d97555cda1a$export$d36bdfa510afb180(objA, objB) {
    if ($d7493d97555cda1a$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$d7493d97555cda1a$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var $d7493d97555cda1a$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $d7493d97555cda1a$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $d7493d97555cda1a$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $d7493d97555cda1a$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $d7493d97555cda1a$var$_obj;
var $d7493d97555cda1a$var$TYPE_STATICS = ($d7493d97555cda1a$var$_obj = {}, (0, $73NPw._)($d7493d97555cda1a$var$_obj, $d7493d97555cda1a$var$ForwardRef, $d7493d97555cda1a$var$FORWARD_REF_STATICS), (0, $73NPw._)($d7493d97555cda1a$var$_obj, $d7493d97555cda1a$var$Memo, $d7493d97555cda1a$var$MEMO_STATICS), $d7493d97555cda1a$var$_obj);
function $d7493d97555cda1a$var$getStatics(component) {
    if ($d7493d97555cda1a$var$isMemo(component)) return $d7493d97555cda1a$var$MEMO_STATICS;
    return $d7493d97555cda1a$var$TYPE_STATICS[component["$$typeof"]] || $d7493d97555cda1a$var$REACT_STATICS;
}
var $d7493d97555cda1a$var$defineProperty = Object.defineProperty;
var $d7493d97555cda1a$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $d7493d97555cda1a$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $d7493d97555cda1a$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $d7493d97555cda1a$var$getPrototypeOf = Object.getPrototypeOf;
var $d7493d97555cda1a$var$objectPrototype = Object.prototype;
function $d7493d97555cda1a$var$hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if ($d7493d97555cda1a$var$objectPrototype) {
            var inheritedComponent = $d7493d97555cda1a$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $d7493d97555cda1a$var$objectPrototype) $d7493d97555cda1a$var$hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        var keys = $d7493d97555cda1a$var$getOwnPropertyNames(sourceComponent);
        if ($d7493d97555cda1a$var$getOwnPropertySymbols) keys = keys.concat($d7493d97555cda1a$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $d7493d97555cda1a$var$getStatics(targetComponent);
        var sourceStatics = $d7493d97555cda1a$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$d7493d97555cda1a$var$KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $d7493d97555cda1a$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $d7493d97555cda1a$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/connect.tsx
var $d7493d97555cda1a$var$useSyncExternalStore = $d7493d97555cda1a$var$notInitialized;
var $d7493d97555cda1a$var$initializeConnect = function(fn) {
    $d7493d97555cda1a$var$useSyncExternalStore = fn;
};
var $d7493d97555cda1a$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $d7493d97555cda1a$var$stringifyComponent = function(Comp) {
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $d7493d97555cda1a$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    $d7493d97555cda1a$var$useIsomorphicLayoutEffect(function() {
        return effectFunc.apply(void 0, (0, $1SMDP._)(effectArgs));
    }, dependencies);
}
function $d7493d97555cda1a$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $d7493d97555cda1a$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return function() {};
    var didUnsubscribe = false;
    var lastThrownError = null;
    var checkForUpdates = function() {
        if (didUnsubscribe || !isMounted.current) return;
        var latestStoreState = store.getState();
        var newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    var unsubscribeWrapper = function() {
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function $d7493d97555cda1a$var$strictEqual(a, b) {
    return a === b;
}
var $d7493d97555cda1a$var$hasWarnedAboutDeprecatedPureOption = false;
function $d7493d97555cda1a$var$connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
    // @ts-ignore
    pure = _ref.pure, _ref_areStatesEqual = _ref.areStatesEqual, areStatesEqual = _ref_areStatesEqual === void 0 ? $d7493d97555cda1a$var$strictEqual : _ref_areStatesEqual, _ref_areOwnPropsEqual = _ref.areOwnPropsEqual, areOwnPropsEqual = _ref_areOwnPropsEqual === void 0 ? $d7493d97555cda1a$export$d36bdfa510afb180 : _ref_areOwnPropsEqual, _ref_areStatePropsEqual = _ref.areStatePropsEqual, areStatePropsEqual = _ref_areStatePropsEqual === void 0 ? $d7493d97555cda1a$export$d36bdfa510afb180 : _ref_areStatePropsEqual, _ref_areMergedPropsEqual = _ref.areMergedPropsEqual, areMergedPropsEqual = _ref_areMergedPropsEqual === void 0 ? $d7493d97555cda1a$export$d36bdfa510afb180 : _ref_areMergedPropsEqual, _ref_forwardRef = _ref.// use React's forwardRef to expose a ref of the wrapped component
    forwardRef, forwardRef = _ref_forwardRef === void 0 ? false : _ref_forwardRef, _ref_context = _ref.// the context consumer to use
    context, context = _ref_context === void 0 ? $d7493d97555cda1a$export$cc80c08dc91f1c00 : _ref_context;
    var Context = context;
    var initMapStateToProps = $d7493d97555cda1a$var$mapStateToPropsFactory(mapStateToProps);
    var initMapDispatchToProps = $d7493d97555cda1a$var$mapDispatchToPropsFactory(mapDispatchToProps);
    var initMergeProps = $d7493d97555cda1a$var$mergePropsFactory(mergeProps);
    var shouldHandleStateChanges = Boolean(mapStateToProps);
    var wrapWithConnect = function(WrappedComponent) {
        var ConnectFunction = function ConnectFunction(props) {
            var _React_useMemo = (0, $f9AIs._)($d7493d97555cda1a$var$React.useMemo(function() {
                var _a = props, reactReduxForwardedRef2 = _a.reactReduxForwardedRef, wrapperProps2 = $d7493d97555cda1a$var$__objRest(_a, [
                    "reactReduxForwardedRef"
                ]);
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]), 3), propsContext = _React_useMemo[0], reactReduxForwardedRef = _React_useMemo[1], wrapperProps = _React_useMemo[2];
            var ContextToUse = $d7493d97555cda1a$var$React.useMemo(function() {
                var ResultContext = Context;
                propsContext == null || propsContext.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            var contextValue = $d7493d97555cda1a$var$React.useContext(ContextToUse);
            var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            var store = didStoreComeFromProps ? props.store : contextValue.store;
            var getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            var childPropsSelector = $d7493d97555cda1a$var$React.useMemo(function() {
                return $d7493d97555cda1a$var$finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            var _React_useMemo1 = (0, $f9AIs._)($d7493d97555cda1a$var$React.useMemo(function() {
                if (!shouldHandleStateChanges) return $d7493d97555cda1a$var$NO_SUBSCRIPTION_ARRAY;
                var subscription2 = $d7493d97555cda1a$var$createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                var notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]), 2), subscription = _React_useMemo1[0], notifyNestedSubs = _React_useMemo1[1];
            var overriddenContextValue = $d7493d97555cda1a$var$React.useMemo(function() {
                if (didStoreComeFromProps) return contextValue;
                return $d7493d97555cda1a$var$__spreadProps($d7493d97555cda1a$var$__spreadValues({}, contextValue), {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            var lastChildProps = $d7493d97555cda1a$var$React.useRef(void 0);
            var lastWrapperProps = $d7493d97555cda1a$var$React.useRef(wrapperProps);
            var childPropsFromStoreUpdate = $d7493d97555cda1a$var$React.useRef(void 0);
            var renderIsScheduled = $d7493d97555cda1a$var$React.useRef(false);
            var isMounted = $d7493d97555cda1a$var$React.useRef(false);
            var latestSubscriptionCallbackError = $d7493d97555cda1a$var$React.useRef(void 0);
            $d7493d97555cda1a$var$useIsomorphicLayoutEffect(function() {
                isMounted.current = true;
                return function() {
                    isMounted.current = false;
                };
            }, []);
            var actualChildPropsSelector = $d7493d97555cda1a$var$React.useMemo(function() {
                var selector = function() {
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            var subscribeForReact = $d7493d97555cda1a$var$React.useMemo(function() {
                var subscribe = function(reactListener) {
                    if (!subscription) return function() {};
                    return $d7493d97555cda1a$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $d7493d97555cda1a$var$useIsomorphicLayoutEffectWithArgs($d7493d97555cda1a$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            var actualChildProps;
            try {
                actualChildProps = $d7493d97555cda1a$var$useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? function() {
                    return childPropsSelector(getServerState(), wrapperProps);
                } : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += "\nThe error may be correlated with this previous error:\n".concat(latestSubscriptionCallbackError.current.stack, "\n\n");
                throw err;
            }
            $d7493d97555cda1a$var$useIsomorphicLayoutEffect(function() {
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            var renderedWrappedComponent = $d7493d97555cda1a$var$React.useMemo(function() {
                return(// @ts-ignore
                /* @__PURE__ */ $d7493d97555cda1a$var$React.createElement(WrappedComponent, $d7493d97555cda1a$var$__spreadProps($d7493d97555cda1a$var$__spreadValues({}, actualChildProps), {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            var renderedChild = $d7493d97555cda1a$var$React.useMemo(function() {
                if (shouldHandleStateChanges) return /* @__PURE__ */ $d7493d97555cda1a$var$React.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        };
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        var displayName = "Connect(".concat(wrappedComponentName, ")");
        var selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            // @ts-ignore
            initMapStateToProps: initMapStateToProps,
            // @ts-ignore
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        var _Connect = $d7493d97555cda1a$var$React.memo(ConnectFunction);
        var Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            var _forwarded = $d7493d97555cda1a$var$React.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ $d7493d97555cda1a$var$React.createElement(Connect, $d7493d97555cda1a$var$__spreadProps($d7493d97555cda1a$var$__spreadValues({}, props), {
                    reactReduxForwardedRef: ref
                }));
            });
            var forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ $d7493d97555cda1a$var$hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ $d7493d97555cda1a$var$hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $d7493d97555cda1a$export$64605811ab45167f = $d7493d97555cda1a$var$connect;
// src/components/Provider.tsx
function $d7493d97555cda1a$var$Provider(param) {
    var store = param.store, context = param.context, children = param.children, serverState = param.serverState, _param_stabilityCheck = param.stabilityCheck, stabilityCheck = _param_stabilityCheck === void 0 ? "once" : _param_stabilityCheck, _param_identityFunctionCheck = param.identityFunctionCheck, identityFunctionCheck = _param_identityFunctionCheck === void 0 ? "once" : _param_identityFunctionCheck;
    var contextValue = $d7493d97555cda1a$var$React.useMemo(function() {
        var subscription = $d7493d97555cda1a$var$createSubscription(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? function() {
                return serverState;
            } : void 0,
            stabilityCheck: stabilityCheck,
            identityFunctionCheck: identityFunctionCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        identityFunctionCheck
    ]);
    var previousState = $d7493d97555cda1a$var$React.useMemo(function() {
        return store.getState();
    }, [
        store
    ]);
    $d7493d97555cda1a$var$useIsomorphicLayoutEffect(function() {
        var subscription = contextValue.subscription;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return function() {
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    var Context = context || $d7493d97555cda1a$export$cc80c08dc91f1c00;
    return /* @__PURE__ */ $d7493d97555cda1a$var$React.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $d7493d97555cda1a$export$2881499e37b75b9a = $d7493d97555cda1a$var$Provider;
// src/hooks/useStore.ts
function $d7493d97555cda1a$export$671dba69185d0304() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $d7493d97555cda1a$export$cc80c08dc91f1c00;
    var useReduxContext2 = context === $d7493d97555cda1a$export$cc80c08dc91f1c00 ? $d7493d97555cda1a$var$useReduxContext : // @ts-ignore
    $d7493d97555cda1a$var$createReduxContextHook(context);
    var useStore2 = function() {
        var store = useReduxContext2().store;
        return store;
    };
    Object.assign(useStore2, {
        withTypes: function() {
            return useStore2;
        }
    });
    return useStore2;
}
var $d7493d97555cda1a$export$6ccbb43953eebf8 = /* @__PURE__ */ $d7493d97555cda1a$export$671dba69185d0304();
// src/hooks/useDispatch.ts
function $d7493d97555cda1a$export$bc9b55530897c558() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $d7493d97555cda1a$export$cc80c08dc91f1c00;
    var useStore2 = context === $d7493d97555cda1a$export$cc80c08dc91f1c00 ? $d7493d97555cda1a$export$6ccbb43953eebf8 : $d7493d97555cda1a$export$671dba69185d0304(context);
    var useDispatch2 = function() {
        var store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: function() {
            return useDispatch2;
        }
    });
    return useDispatch2;
}
var $d7493d97555cda1a$export$8ad76b76a4c905f8 = /* @__PURE__ */ $d7493d97555cda1a$export$bc9b55530897c558();
// src/exports.ts
var $d7493d97555cda1a$export$712ea50be43a7858 = $d7493d97555cda1a$var$defaultNoopBatch;
// src/index.ts
$d7493d97555cda1a$var$initializeUseSelector((0, $759ca12a6d25751d$exports.useSyncExternalStoreWithSelector));
$d7493d97555cda1a$var$initializeConnect($4Bt61.useSyncExternalStore);


var $e780f7d3b9acb821$var$Heading = function() {
    return /*#__PURE__*/ (0, $45FY7.jsx)("a", {
        href: "/",
        children: /*#__PURE__*/ (0, $45FY7.jsx)("img", {
            className: "h-24",
            "data-testid": "logo",
            alt: "image here ",
            src: "https://fpimages.withfloats.com/tile/632972807f42460001be357d.png"
        })
    });
};
var $e780f7d3b9acb821$var$HeaderComponent = function() {
    var cartItems = (0, $d7493d97555cda1a$export$2105062e25df4afe)(function(store) {
        return store.cart.items;
    });
    console.log(cartItems);
    var _useState = (0, $f9AIs._)((0, $4Bt61.useState)(false), 2), isLogged = _useState[0], setIsLogged = _useState[1];
    var online = (0, $5a05f2f4001176d2$export$2e2bcd8739ae039)();
    var _useContext = (0, $4Bt61.useContext)((0, $2819d30547b11aa2$export$2e2bcd8739ae039)), user = _useContext.user, game = _useContext.game;
    return /*#__PURE__*/ (0, $45FY7.jsxs)("div", {
        className: "flex justify-between bg-pink-50 sm:bg-blue-50 md:bg-yellow-100",
        children: [
            /*#__PURE__*/ (0, $45FY7.jsx)($e780f7d3b9acb821$var$Heading, {}),
            /*#__PURE__*/ (0, $45FY7.jsx)("div", {
                className: "py-10",
                children: /*#__PURE__*/ (0, $45FY7.jsxs)("ul", {
                    className: "flex",
                    children: [
                        /*#__PURE__*/ (0, $45FY7.jsx)("li", {
                            className: "px-2",
                            children: /*#__PURE__*/ (0, $45FY7.jsx)((0, $8f0ad21e84364a49$export$a6c7ac8248d6e38a), {
                                to: "/",
                                children: "Home"
                            })
                        }),
                        /*#__PURE__*/ (0, $45FY7.jsxs)("li", {
                            className: "px-2",
                            children: [
                                " ",
                                /*#__PURE__*/ (0, $45FY7.jsx)((0, $8f0ad21e84364a49$export$a6c7ac8248d6e38a), {
                                    to: "/About",
                                    children: "About us"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $45FY7.jsxs)("li", {
                            className: "px-2",
                            children: [
                                " ",
                                /*#__PURE__*/ (0, $45FY7.jsx)((0, $8f0ad21e84364a49$export$a6c7ac8248d6e38a), {
                                    to: "/Contact",
                                    children: "Conatact us"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $45FY7.jsx)("li", {
                            className: "px-2",
                            children: /*#__PURE__*/ (0, $45FY7.jsx)((0, $8f0ad21e84364a49$export$a6c7ac8248d6e38a), {
                                to: "/Instamart",
                                children: "Instamart"
                            })
                        }),
                        /*#__PURE__*/ (0, $45FY7.jsx)("li", {
                            className: "px-2",
                            children: /*#__PURE__*/ (0, $45FY7.jsxs)((0, $8f0ad21e84364a49$export$a6c7ac8248d6e38a), {
                                "data-testid": "cart",
                                to: "/Cart",
                                children: [
                                    "Cart-",
                                    cartItems.length
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $45FY7.jsx)("h1", {
                "data-testid": "onlinestatus",
                children: online ? "\uD83D\uDC9A" : "\u2764\uFE0F"
            }),
            user.name + user.email,
            isLogged ? /*#__PURE__*/ (0, $45FY7.jsx)("button", {
                onClick: function() {
                    return setIsLogged(false);
                },
                children: "logout"
            }) : /*#__PURE__*/ (0, $45FY7.jsx)("button", {
                onClick: function() {
                    return setIsLogged(true);
                },
                children: "login"
            })
        ]
    });
};
var $e780f7d3b9acb821$export$2e2bcd8739ae039 = $e780f7d3b9acb821$var$HeaderComponent;




var $73NPw = parcelRequire("73NPw");
function $5f1309c2fb31fc13$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $73NPw._)(target, key, source[key]);
        });
    }
    return target;
}


function $d5be4a96a008f2f4$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d5be4a96a008f2f4$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $d5be4a96a008f2f4$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}



var $f9AIs = parcelRequire("f9AIs");


var $45FY7 = parcelRequire("45FY7");

var $4Bt61 = parcelRequire("4Bt61");
var $4cda32079dcbcebc$export$63cce10c00d8eaa3 = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/";
var $4cda32079dcbcebc$export$6ebceabf77cea5d3 = "https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=11.31973&lng=75.80146549999999&restaurantId=";
var $4cda32079dcbcebc$export$94e7423f6fc45a54 = [
    {
        "info": {
            "id": "359066",
            "name": "Pizza Hut",
            "cloudinaryImageId": "2b4f62d606d1b2bfba9ba9e5386fabb7",
            "locality": "Indira Gandhi Road",
            "areaName": "Arayidathupalam",
            "costForTwo": "\u20B9500 for two",
            "cuisines": [
                "Pizzas"
            ],
            "avgRating": 4.1,
            "parentId": "721",
            "avgRatingString": "4.1",
            "totalRatingsString": "1K+",
            "sla": {
                "deliveryTime": 42,
                "lastMileTravel": 8.9,
                "serviceability": "SERVICEABLE",
                "slaString": "40-45 mins",
                "lastMileTravelString": "8.9 km",
                "iconType": "ICON_TYPE_EMPTY"
            },
            "availability": {
                "nextCloseTime": "2024-04-25 00:00:00",
                "opened": true
            },
            "badges": {
                "imageBadges": [
                    {
                        "imageId": "Rxawards/_CATEGORY-Pizza.png",
                        "description": "Delivery!"
                    }
                ]
            },
            "isOpen": true,
            "type": "F",
            "badgesV2": {
                "entityBadges": {
                    "imageBased": {
                        "badgeObject": [
                            {
                                "attributes": {
                                    "description": "Delivery!",
                                    "imageId": "Rxawards/_CATEGORY-Pizza.png"
                                }
                            }
                        ]
                    },
                    "textBased": {},
                    "textExtendedBadges": {}
                }
            },
            "aggregatedDiscountInfoV3": {
                "header": "50% OFF",
                "subHeader": "UPTO \u20B9100"
            },
            "differentiatedUi": {
                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                "differentiatedUiMediaDetails": {
                    "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                    "lottie": {},
                    "video": {}
                }
            },
            "reviewsSummary": {},
            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            "restaurantOfferPresentationInfo": {}
        },
        "analytics": {},
        "cta": {
            "link": "https://www.swiggy.com/restaurants/pizza-hut-indira-gandhi-road-arayidathupalam-kozhikode-359066",
            "type": "WEBLINK"
        }
    },
    {
        "info": {
            "id": "490981",
            "name": "Top Form_Mavoor Road",
            "cloudinaryImageId": "b5303a94c367062c158ce278bf6307a3",
            "locality": "Mavoor Road",
            "areaName": "Kuttichira",
            "costForTwo": "\u20B9400 for two",
            "cuisines": [
                "South Indian",
                "Kerala",
                "Biryani",
                "Chinese",
                "Salads",
                "Seafood"
            ],
            "avgRating": 4.4,
            "parentId": "454775",
            "avgRatingString": "4.4",
            "totalRatingsString": "10K+",
            "sla": {
                "deliveryTime": 36,
                "lastMileTravel": 9.6,
                "serviceability": "SERVICEABLE",
                "slaString": "35-40 mins",
                "lastMileTravelString": "9.6 km",
                "iconType": "ICON_TYPE_EMPTY"
            },
            "availability": {
                "nextCloseTime": "2024-04-25 02:00:00",
                "opened": true
            },
            "badges": {
                "imageBadges": [
                    {
                        "imageId": "Rxawards/_CATEGORY-Biryani.png",
                        "description": "Delivery!"
                    }
                ]
            },
            "isOpen": true,
            "aggregatedDiscountInfoV2": {},
            "type": "F",
            "badgesV2": {
                "entityBadges": {
                    "imageBased": {
                        "badgeObject": [
                            {
                                "attributes": {
                                    "description": "Delivery!",
                                    "imageId": "Rxawards/_CATEGORY-Biryani.png"
                                }
                            }
                        ]
                    },
                    "textBased": {},
                    "textExtendedBadges": {}
                }
            },
            "differentiatedUi": {
                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                "differentiatedUiMediaDetails": {
                    "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                    "lottie": {},
                    "video": {}
                }
            },
            "reviewsSummary": {},
            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            "restaurantOfferPresentationInfo": {}
        },
        "analytics": {},
        "cta": {
            "link": "https://www.swiggy.com/restaurants/top-form-mavoor-road-mavoor-road-kuttichira-kozhikode-490981",
            "type": "WEBLINK"
        }
    },
    {
        "info": {
            "id": "395946",
            "name": "Kuttichira Biriyani Centre",
            "cloudinaryImageId": "xywyltlvxs5pagooukuo",
            "locality": "Mavoor Road",
            "areaName": "Jafar Khan Colony",
            "costForTwo": "\u20B9249 for two",
            "cuisines": [
                "Biryani",
                "South Indian"
            ],
            "avgRating": 4.3,
            "parentId": "122112",
            "avgRatingString": "4.3",
            "totalRatingsString": "5K+",
            "sla": {
                "deliveryTime": 34,
                "lastMileTravel": 8.6,
                "serviceability": "SERVICEABLE",
                "slaString": "30-35 mins",
                "lastMileTravelString": "8.6 km",
                "iconType": "ICON_TYPE_EMPTY"
            },
            "availability": {
                "nextCloseTime": "2024-04-24 18:00:00",
                "opened": true
            },
            "badges": {
                "imageBadges": [
                    {
                        "imageId": "Rxawards/_CATEGORY-Biryani.png",
                        "description": "Delivery!"
                    }
                ]
            },
            "isOpen": true,
            "type": "F",
            "badgesV2": {
                "entityBadges": {
                    "imageBased": {
                        "badgeObject": [
                            {
                                "attributes": {
                                    "description": "Delivery!",
                                    "imageId": "Rxawards/_CATEGORY-Biryani.png"
                                }
                            }
                        ]
                    },
                    "textBased": {},
                    "textExtendedBadges": {}
                }
            },
            "aggregatedDiscountInfoV3": {
                "header": "20% OFF",
                "subHeader": "UPTO \u20B950"
            },
            "differentiatedUi": {
                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                "differentiatedUiMediaDetails": {
                    "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                    "lottie": {},
                    "video": {}
                }
            },
            "reviewsSummary": {},
            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            "restaurantOfferPresentationInfo": {}
        },
        "analytics": {},
        "cta": {
            "link": "https://www.swiggy.com/restaurants/kuttichira-biriyani-centre-mavoor-road-jafar-khan-colony-kozhikode-395946",
            "type": "WEBLINK"
        }
    },
    {
        "info": {
            "id": "382724",
            "name": "New Malabar Family Restaurant",
            "cloudinaryImageId": "dypfwfzd1seuqyanabsv",
            "locality": "Karaparamba",
            "areaName": "Bilathikkulam",
            "costForTwo": "\u20B9300 for two",
            "cuisines": [
                "Chinese",
                "North Indian",
                "South Indian",
                "Biryani"
            ],
            "avgRating": 4.4,
            "parentId": "251724",
            "avgRatingString": "4.4",
            "totalRatingsString": "5K+",
            "sla": {
                "deliveryTime": 29,
                "lastMileTravel": 4.8,
                "serviceability": "SERVICEABLE",
                "slaString": "25-30 mins",
                "lastMileTravelString": "4.8 km",
                "iconType": "ICON_TYPE_EMPTY"
            },
            "availability": {
                "nextCloseTime": "2024-04-24 23:00:00",
                "opened": true
            },
            "badges": {},
            "isOpen": true,
            "type": "F",
            "badgesV2": {
                "entityBadges": {
                    "imageBased": {},
                    "textBased": {},
                    "textExtendedBadges": {}
                }
            },
            "aggregatedDiscountInfoV3": {
                "header": "\u20B940 OFF",
                "subHeader": "ABOVE \u20B9499",
                "discountTag": "FLAT DEAL"
            },
            "differentiatedUi": {
                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                "differentiatedUiMediaDetails": {
                    "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                    "lottie": {},
                    "video": {}
                }
            },
            "reviewsSummary": {},
            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            "restaurantOfferPresentationInfo": {}
        },
        "analytics": {},
        "cta": {
            "link": "https://www.swiggy.com/restaurants/new-malabar-family-restaurant-karaparamba-bilathikkulam-kozhikode-382724",
            "type": "WEBLINK"
        }
    }
];



var $45FY7 = parcelRequire("45FY7");
parcelRequire("4Bt61");

var $c16deb4fa849954d$export$7be1d6cab7accc11 = function(props) {
    var resData = props;
    var _ref = resData === null || resData === void 0 ? void 0 : resData.info, cloudinaryImageId = _ref.cloudinaryImageId, name = _ref.name, cuisines = _ref.cuisines, avgRating = _ref.avgRating;
    return /*#__PURE__*/ (0, $45FY7.jsxs)("div", {
        className: "w-52 p-2 m-2 shadow-lg bg-pink-50 ",
        children: [
            /*#__PURE__*/ (0, $45FY7.jsx)("img", {
                className: " ",
                alt: "burger",
                src: (0, $4cda32079dcbcebc$export$63cce10c00d8eaa3) + cloudinaryImageId
            }),
            /*#__PURE__*/ (0, $45FY7.jsx)("h2", {
                className: "font-bold text-xl",
                children: name
            }),
            /*#__PURE__*/ (0, $45FY7.jsx)("h3", {
                children: cuisines
            }),
            /*#__PURE__*/ (0, $45FY7.jsx)("h4", {
                children: avgRating
            })
        ]
    });
};



var $45FY7 = parcelRequire("45FY7");
parcelRequire("4Bt61");
function $881701763a680210$var$Shimmer() {
    return /*#__PURE__*/ (0, $45FY7.jsx)("div", {
        className: "Restaurantlist",
        "data-testid": "shimmer",
        children: Array(10).fill("").map(function(e, index) {
            return /*#__PURE__*/ (0, $45FY7.jsx)("div", {
                className: "shimmercard"
            }, index);
        })
    });
}
var $881701763a680210$export$2e2bcd8739ae039 = $881701763a680210$var$Shimmer;



function $9f69d031e2e3fc5d$export$642576f8935df945(originalRestroList, inputText) {
    var filteredData = originalRestroList.filter(function(res) {
        return res.info.name.toLowerCase().includes(inputText.toLowerCase());
    });
    return filteredData;
}





var $0d5eb0c0145439a3$var$Body = function() {
    var _useState = (0, $f9AIs._)((0, $4Bt61.useState)(""), 2), inputText = _useState[0], setInputText = _useState[1];
    var _useState1 = (0, $f9AIs._)((0, $4Bt61.useState)([]), 2), originalRestroList = _useState1[0], setOriginalRestroList = _useState1[1];
    //const [originalRestroList2, setOriginalRestroList2] = useState([]);
    var _useState2 = (0, $f9AIs._)((0, $4Bt61.useState)([]), 2), filteredRestroList = _useState2[0], setFilteredRestroList = _useState2[1];
    //const [filteredRestroList2, setFilteredRestroList2] = useState([]);
    var _useContext = (0, $4Bt61.useContext)((0, $2819d30547b11aa2$export$2e2bcd8739ae039)), user = _useContext.user, setUser = _useContext.setUser;
    (0, $4Bt61.useEffect)(function() {
        // console.log('hello')
        fetchData();
    }, []);
    var fetchData = function() {
        var _ref = (0, $1d3fb01611386816$export$71511d61b312f219)(function() {
            var _json_data_cards__card_card_gridElements_infoWithStyle, _json_data_cards__card_card_gridElements, _json_data_cards__card_card, _json_data_cards__card, _json_data_cards_, _json_data, data, json, restaurantCards;
            return (0, $47055dab5b247348$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetch("https://www.swiggy.com/dapi/restaurants/list/v5?lat=11.2587531&lng=75.78041&is-seo-homepage-enabled=true&page_type=DESKTOP_WEB_LISTING")
                        ];
                    case 1:
                        data = _state.sent();
                        return [
                            4,
                            data.json()
                        ];
                    case 2:
                        json = _state.sent();
                        restaurantCards = (json === null || json === void 0 ? void 0 : (_json_data = json.data) === null || _json_data === void 0 ? void 0 : (_json_data_cards_ = _json_data.cards[2]) === null || _json_data_cards_ === void 0 ? void 0 : (_json_data_cards__card = _json_data_cards_.card) === null || _json_data_cards__card === void 0 ? void 0 : (_json_data_cards__card_card = _json_data_cards__card.card) === null || _json_data_cards__card_card === void 0 ? void 0 : (_json_data_cards__card_card_gridElements = _json_data_cards__card_card.gridElements) === null || _json_data_cards__card_card_gridElements === void 0 ? void 0 : (_json_data_cards__card_card_gridElements_infoWithStyle = _json_data_cards__card_card_gridElements.infoWithStyle) === null || _json_data_cards__card_card_gridElements_infoWithStyle === void 0 ? void 0 : _json_data_cards__card_card_gridElements_infoWithStyle.restaurants) || [];
                        //const restaurantCards = json?.data?.cards?.find(card => card.card?.card?.gridElements)?.card?.card?.gridElements?.infoWithStyle?.restaurants || [];
                        console.log(restaurantCards);
                        setOriginalRestroList(restaurantCards);
                        setFilteredRestroList(restaurantCards);
                        console.log(json);
                        return [
                            2
                        ];
                }
            });
        });
        return function fetchData() {
            return _ref.apply(this, arguments);
        };
    }();
    var online = (0, $5a05f2f4001176d2$export$2e2bcd8739ae039)();
    if (!online) return /*#__PURE__*/ (0, $45FY7.jsx)("h1", {
        children: "The site is offline"
    });
    //if(filteredRestroList.length===0) return <h1>There are no restaurant that match your filter</h1>;
    return (originalRestroList === null || originalRestroList === void 0 ? void 0 : originalRestroList.length) === 0 ? /*#__PURE__*/ (0, $45FY7.jsx)((0, $881701763a680210$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $45FY7.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $45FY7.jsxs)("div", {
                className: "searchcontainer p-5 bg-pink-50 my-2",
                children: [
                    /*#__PURE__*/ (0, $45FY7.jsx)("input", {
                        "data-testid": "input",
                        type: "text",
                        className: "focus:bg-slate-200",
                        placeholder: "Search for restaurant",
                        value: inputText,
                        onChange: function(e) {
                            return setInputText(e.target.value);
                        }
                    }),
                    /*#__PURE__*/ (0, $45FY7.jsx)("button", {
                        "data-testid": "searchbtn",
                        className: "p-2 m-2 text-white rounded-lg  bg-slate-400 hover:bg-black",
                        onClick: function() {
                            var data = (0, $9f69d031e2e3fc5d$export$642576f8935df945)(originalRestroList, inputText);
                            setFilteredRestroList(data);
                        },
                        children: "Search"
                    }),
                    /*#__PURE__*/ (0, $45FY7.jsx)("input", {
                        value: user.name,
                        onChange: function(e) {
                            return setUser((0, $d5be4a96a008f2f4$export$71511d61b312f219)((0, $5f1309c2fb31fc13$export$71511d61b312f219)({}, user), {
                                name: e.target.value
                            }));
                        }
                    }),
                    /*#__PURE__*/ (0, $45FY7.jsx)("input", {
                        value: user.email,
                        onChange: function(e) {
                            return setUser((0, $d5be4a96a008f2f4$export$71511d61b312f219)((0, $5f1309c2fb31fc13$export$71511d61b312f219)({}, user), {
                                email: e.target.value
                            }));
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $45FY7.jsx)("div", {
                className: "flex flex-wrap",
                "data-testid": "reslist",
                children: filteredRestroList.map(function(res) {
                    return /*#__PURE__*/ (0, $45FY7.jsx)((0, $8f0ad21e84364a49$export$a6c7ac8248d6e38a), {
                        to: "restaurant/" + res.info.id,
                        children: /*#__PURE__*/ (0, $45FY7.jsx)((0, $c16deb4fa849954d$export$7be1d6cab7accc11), (0, $5f1309c2fb31fc13$export$71511d61b312f219)({}, res))
                    }, res.info.id);
                })
            })
        ]
    });
};
var $0d5eb0c0145439a3$export$2e2bcd8739ae039 /**
 * 
 * Testing 
 * Different types of Testing
 * -manual Testing 
 * -Automated Testing
 *  -Selenium Testing 
 * 
 * 
 * 
 * steps
 * 1.npm install --save-dev @testing-library/react
 * 2. Install  npm install -D jest
 * 3.Configure jest
 * 4.npx jest --init
 * Test environment -js dom
 * provider for coverage =babel
 * 5. Install jest environment jsdom
 * 6.create test file __tests__
 * 7. write test.js on the file of 
 * 8.import the file for test 
 * 9.jest babel config npm install --save-dev babel-jest @babel/core @babel/preset-env
 * 10.babel.config.js
 *  module.exports = {
  presets: [['@babel/preset-env', {targets: {node: 'current'}}]],
};
babelrc need json
 * 11. Import {render} from react testing library
     test("the condition to nderstand what we are testing",()=>{
      const header = render(<Component/>)
     }
 * the render is given by the react library
 * now there will be error as the file cannot understand what is jsx
 * so we want to configure babel in the preset that we made in the babelrc
 *  ["babel/preset-react",{"runtime":"automatic"}]
 * 12.install npm i -D @babel/preset-react
 * 13.add provider
 * 14.add react router dom or {static router}
 * import { StaticRouter } from 'react-router-dom/server'
 * 15.when we test on body the fetch will not work so we need to create
 *   global.fetch = jest.fn()
 * 16.    "watch-test":"jest --watchAll" in json lock
 * 17. npm i @testing-library/jest-dom

 * 
 *
 * 
*/  = $0d5eb0c0145439a3$var$Body;



var $45FY7 = parcelRequire("45FY7");
var $5ca1458fc886d126$var$Footer = function() {
    return /*#__PURE__*/ (0, $45FY7.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $45FY7.jsx)("button", {
                onClick: function() {
                    for(i = 0; i < 100; i++)console.log("l ");
                },
                children: "here"
            }),
            " ",
            /*#__PURE__*/ (0, $45FY7.jsx)("h2", {
                children: "footer"
            })
        ]
    });
};
var $5ca1458fc886d126$export$2e2bcd8739ae039 //onclick={ ()=>{  for(i=0;i<100;i++){console.log("l ")  }}}>here</button>
 = $5ca1458fc886d126$var$Footer;



var $aliU1 = parcelRequire("aliU1");

var $bMpTA = parcelRequire("bMpTA");

var $fZ5u7 = parcelRequire("fZ5u7");

var $9j1tP = parcelRequire("9j1tP");

var $45FY7 = parcelRequire("45FY7");


var $aliU1 = parcelRequire("aliU1");

var $bMpTA = parcelRequire("bMpTA");

var $fZ5u7 = parcelRequire("fZ5u7");

var $9j1tP = parcelRequire("9j1tP");

var $45FY7 = parcelRequire("45FY7");

var $4Bt61 = parcelRequire("4Bt61");
var $d9a82d00c3625927$var$Profile = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $fZ5u7._)(Profile, _React_Component);
    var _super = (0, $9j1tP._)(Profile);
    function Profile(props) {
        (0, $aliU1._)(this, Profile);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            count: 0,
            count2: 1
        };
        return _this;
    }
    (0, $bMpTA._)(Profile, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var count = this.state.count;
                return /*#__PURE__*/ (0, $45FY7.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $45FY7.jsx)("h1", {
                            children: "Hi I am profile class componenet"
                        }),
                        /*#__PURE__*/ (0, $45FY7.jsxs)("h1", {
                            children: [
                                "Hi I am ",
                                this.props.name,
                                "and ",
                                this.props.xyz
                            ]
                        }),
                        /*#__PURE__*/ (0, $45FY7.jsx)("h2", {
                            children: count
                        }),
                        /*#__PURE__*/ (0, $45FY7.jsx)("button", {
                            onClick: function() {
                                _this.setState({
                                    count: count + 1
                                });
                            },
                            children: "click  me"
                        })
                    ]
                });
            }
        }
    ]);
    return Profile;
}((0, (/*@__PURE__*/$parcel$interopDefault($4Bt61))).Component);
var $d9a82d00c3625927$export$2e2bcd8739ae039 = $d9a82d00c3625927$var$Profile;



var $4Bt61 = parcelRequire("4Bt61");
var $8713b77ebe1ec3fa$var$About = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $fZ5u7._)(About, Component);
    var _super = (0, $9j1tP._)(About);
    function About(props) {
        (0, $aliU1._)(this, About);
        return _super.call(this, props);
    }
    (0, $bMpTA._)(About, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
            // Best place to make an Api call
            //console.log("Parent - componentDidMount");
            }
        },
        {
            key: "render",
            value: function render() {
                //console.log("Parent - render");
                return /*#__PURE__*/ (0, $45FY7.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $45FY7.jsx)("h1", {
                            children: "About Us Page"
                        }),
                        /*#__PURE__*/ (0, $45FY7.jsx)("p", {
                            children: "This is the Namaste React Live Course Chapter 07 - Finding the Path \uD83D\uDE80"
                        }),
                        /*#__PURE__*/ (0, $45FY7.jsx)((0, $d9a82d00c3625927$export$2e2bcd8739ae039), {})
                    ]
                });
            }
        }
    ]);
    return About;
}((0, $4Bt61.Component));
var $8713b77ebe1ec3fa$export$2e2bcd8739ae039 /**
 *
 * Parent Constructor
 * Parent render
 *    First Child constructor
 *    First Child render
 *    Second Child constructor
 *    Second Child render
 *
 *    DOM UPDATED for children
 *
 *    first Child componentDidMount
 *    Second Child componentDid
 *  Parent componentDidMount
 *
 *
 */  = $8713b77ebe1ec3fa$var$About;



var $45FY7 = parcelRequire("45FY7");

function $72b17a93ab28127a$var$Error() {
    var err = (0, $f0792a32d62fec93$export$ed527bf60f6e05f2)();
    console.log(err);
    return /*#__PURE__*/ (0, $45FY7.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $45FY7.jsx)("h1", {
                children: "Oops!!!"
            }),
            /*#__PURE__*/ (0, $45FY7.jsx)("h2", {
                children: " Something went wrong!!!"
            }),
            /*#__PURE__*/ (0, $45FY7.jsx)("h2", {
                children: err.status + ": " + err.statusText
            })
        ]
    });
}
var $72b17a93ab28127a$export$2e2bcd8739ae039 = $72b17a93ab28127a$var$Error;




var $f9AIs = parcelRequire("f9AIs");

var $45FY7 = parcelRequire("45FY7");

var $4Bt61 = parcelRequire("4Bt61");
function $1f103d71b128a1d8$var$Contact() {
    return /*#__PURE__*/ (0, $45FY7.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $45FY7.jsx)($1f103d71b128a1d8$var$Timer, {}),
            /*#__PURE__*/ (0, $45FY7.jsx)("h1", {
                children: "This is a contact Page"
            })
        ]
    });
}
var $1f103d71b128a1d8$export$2e2bcd8739ae039 = $1f103d71b128a1d8$var$Contact;
function $1f103d71b128a1d8$var$Timer() {
    var _useState = (0, $f9AIs._)((0, $4Bt61.useState)(0), 2), count = _useState[0], setCount = _useState[1];
    (0, $4Bt61.useEffect)(function() {
        // This function will be called when the component mounts
        var interval = setInterval(function() {
            // Update the count by incrementing it
            setCount(function(prevCount) {
                return prevCount + 1;
            });
        }, 1000); // Update count every 1000 milliseconds (1 second)
        // Return a cleanup function to clear the interval when the component unmounts
        return function() {
            return clearInterval(interval);
        };
    }, []); // Empty dependency array means this effect runs only once on mount
    return /*#__PURE__*/ (0, $45FY7.jsx)("div", {
        children: /*#__PURE__*/ (0, $45FY7.jsxs)("h1", {
            children: [
                "Count: ",
                count
            ]
        })
    });
}



var $45FY7 = parcelRequire("45FY7");

parcelRequire("4Bt61");



var $f9AIs = parcelRequire("f9AIs");


var $4Bt61 = parcelRequire("4Bt61");

var $e9b8049928d5875e$var$useRestaurant = function(id) {
    var RestaurantDetails = function RestaurantDetails() {
        return _RestaurantDetails.apply(this, arguments);
    };
    var _useState = (0, $f9AIs._)((0, $4Bt61.useState)([]), 2), res = _useState[0], setres = _useState[1];
    (0, $4Bt61.useEffect)(function() {
        RestaurantDetails();
    }, []);
    function _RestaurantDetails() {
        _RestaurantDetails = (0, $1d3fb01611386816$export$71511d61b312f219)(function() {
            var data, json;
            return (0, $47055dab5b247348$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetch((0, $4cda32079dcbcebc$export$6ebceabf77cea5d3) + id)
                        ];
                    case 1:
                        data = _state.sent();
                        return [
                            4,
                            data.json()
                        ];
                    case 2:
                        json = _state.sent();
                        setres(json === null || json === void 0 ? void 0 : json.data) //.cards[2]?.card?.card?.info
                        ;
                        console.log(json);
                        return [
                            2
                        ];
                }
            });
        });
        return _RestaurantDetails.apply(this, arguments);
    }
    return res;
};
var $e9b8049928d5875e$export$2e2bcd8739ae039 = $e9b8049928d5875e$var$useRestaurant;




var $cOYso = parcelRequire("cOYso");


var $aliU1 = parcelRequire("aliU1");

var $6EBGQ = parcelRequire("6EBGQ");

var $bMpTA = parcelRequire("bMpTA");

var $73NPw = parcelRequire("73NPw");

var $92y6r = parcelRequire("92y6r");
function $2c1b1b294047a10d$export$71511d61b312f219(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, $92y6r._)(object);
        if (object === null) break;
    }
    return object;
}


function $a07cb0dafe2a93d7$export$71511d61b312f219(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $a07cb0dafe2a93d7$export$71511d61b312f219 = Reflect.get;
    else $a07cb0dafe2a93d7$export$71511d61b312f219 = function get(target, property, receiver) {
        var base = (0, $2c1b1b294047a10d$export$71511d61b312f219)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $a07cb0dafe2a93d7$export$71511d61b312f219(target, property, receiver || target);
}



var $92y6r = parcelRequire("92y6r");

var $fZ5u7 = parcelRequire("fZ5u7");

var $f9AIs = parcelRequire("f9AIs");

var $1SMDP = parcelRequire("1SMDP");

var $6zqIC = parcelRequire("6zqIC");

var $6HjaD = parcelRequire("6HjaD");

var $9j1tP = parcelRequire("9j1tP");

// src/utils/formatProdErrorMessage.ts

var $73NPw = parcelRequire("73NPw");



var $1SMDP = parcelRequire("1SMDP");

var $6zqIC = parcelRequire("6zqIC");
function $c4195dcee631f3e8$var$formatProdErrorMessage(code) {
    return "Minified Redux error #".concat(code, "; visit https://redux.js.org/Errors?code=").concat(code, " for the full message or use the non-minified dev environment for full errors. ");
}
// src/utils/symbol-observable.ts
var $c4195dcee631f3e8$var$$$observable = /* @__PURE__ */ function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
var $c4195dcee631f3e8$var$symbol_observable_default = $c4195dcee631f3e8$var$$$observable;
// src/utils/actionTypes.ts
var $c4195dcee631f3e8$var$randomString = function() {
    return Math.random().toString(36).substring(7).split("").join(".");
};
var $c4195dcee631f3e8$var$ActionTypes = {
    INIT: "@@redux/INIT".concat($c4195dcee631f3e8$var$randomString()),
    REPLACE: "@@redux/REPLACE".concat($c4195dcee631f3e8$var$randomString()),
    PROBE_UNKNOWN_ACTION: function() {
        return "@@redux/PROBE_UNKNOWN_ACTION".concat($c4195dcee631f3e8$var$randomString());
    }
};
var $c4195dcee631f3e8$export$4219e499db7ca678 = $c4195dcee631f3e8$var$ActionTypes;
// src/utils/isPlainObject.ts
function $c4195dcee631f3e8$export$53b83ca8eaab0383(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function $c4195dcee631f3e8$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    var type = typeof val === "undefined" ? "undefined" : (0, $6zqIC._)(val);
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($c4195dcee631f3e8$var$isDate(val)) return "date";
    if ($c4195dcee631f3e8$var$isError(val)) return "error";
    var constructorName = $c4195dcee631f3e8$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $c4195dcee631f3e8$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $c4195dcee631f3e8$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $c4195dcee631f3e8$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $c4195dcee631f3e8$var$kindOf(val) {
    var typeOfVal = typeof val === "undefined" ? "undefined" : (0, $6zqIC._)(val);
    return typeOfVal;
}
// src/createStore.ts
function $c4195dcee631f3e8$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error($c4195dcee631f3e8$var$formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($c4195dcee631f3e8$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($c4195dcee631f3e8$var$formatProdErrorMessage(1));
        return enhancer($c4195dcee631f3e8$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = /* @__PURE__ */ new Map();
    var nextListeners = currentListeners;
    var listenerIdCounter = 0;
    var isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach(function(listener, key) {
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error($c4195dcee631f3e8$var$formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($c4195dcee631f3e8$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($c4195dcee631f3e8$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        var listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($c4195dcee631f3e8$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!$c4195dcee631f3e8$export$53b83ca8eaab0383(action)) throw new Error($c4195dcee631f3e8$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($c4195dcee631f3e8$var$formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error($c4195dcee631f3e8$var$formatProdErrorMessage(17));
        if (isDispatching) throw new Error($c4195dcee631f3e8$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        listeners.forEach(function(listener) {
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($c4195dcee631f3e8$var$formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: $c4195dcee631f3e8$export$4219e499db7ca678.REPLACE
        });
    }
    function observable() {
        var outerSubscribe = subscribe;
        return (0, $73NPw._)({
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function(observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($c4195dcee631f3e8$var$formatProdErrorMessage(11));
                function observeState() {
                    var observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, $c4195dcee631f3e8$var$symbol_observable_default, function() {
            return this;
        });
    }
    dispatch({
        type: $c4195dcee631f3e8$export$4219e499db7ca678.INIT
    });
    var store = (0, $73NPw._)({
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, $c4195dcee631f3e8$var$symbol_observable_default, observable);
    return store;
}
function $c4195dcee631f3e8$export$8928921ea2d3b126(reducer, preloadedState, enhancer) {
    return $c4195dcee631f3e8$export$f51a9068ac82ea43(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function $c4195dcee631f3e8$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function $c4195dcee631f3e8$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $c4195dcee631f3e8$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$c4195dcee631f3e8$export$53b83ca8eaab0383(inputState)) return "The ".concat(argumentName, ' has unexpected type of "').concat($c4195dcee631f3e8$var$kindOf(inputState), '". Expected argument to be an object with the following keys: "').concat(reducerKeys.join('", "'), '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $c4195dcee631f3e8$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected ".concat(unexpectedKeys.length > 1 ? "keys" : "key", ' "').concat(unexpectedKeys.join('", "'), '" found in ').concat(argumentName, '. Expected to find one of the known reducer keys instead: "').concat(reducerKeys.join('", "'), '". Unexpected keys will be ignored.');
}
function $c4195dcee631f3e8$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(void 0, {
            type: $c4195dcee631f3e8$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($c4195dcee631f3e8$var$formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: $c4195dcee631f3e8$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($c4195dcee631f3e8$var$formatProdErrorMessage(13));
    });
}
function $c4195dcee631f3e8$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers);
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $c4195dcee631f3e8$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination() {
        var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, action = arguments.length > 1 ? arguments[1] : void 0;
        if (shapeAssertionError) throw shapeAssertionError;
        var hasChanged = false;
        var nextState = {};
        for(var i = 0; i < finalReducerKeys.length; i++){
            var key = finalReducerKeys[i];
            var reducer = finalReducers[key];
            var previousStateForKey = state[key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var actionType = action && action.type;
                throw new Error($c4195dcee631f3e8$var$formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function $c4195dcee631f3e8$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return dispatch(actionCreator.apply(this, args));
    };
}
function $c4195dcee631f3e8$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $c4195dcee631f3e8$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($c4195dcee631f3e8$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $c4195dcee631f3e8$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function $c4195dcee631f3e8$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++){
        funcs[_key] = arguments[_key];
    }
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return a(b.apply(void 0, (0, $1SMDP._)(args)));
        };
    });
}
// src/applyMiddleware.ts
function $c4195dcee631f3e8$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++){
        middlewares[_key] = arguments[_key];
    }
    return function(createStore2) {
        return function(reducer, preloadedState) {
            var store = createStore2(reducer, preloadedState);
            var dispatch = function() {
                throw new Error($c4195dcee631f3e8$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function(action) {
                    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                        args[_key - 1] = arguments[_key];
                    }
                    return dispatch.apply(void 0, [
                        action
                    ].concat((0, $1SMDP._)(args)));
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            dispatch = $c4195dcee631f3e8$export$f672e0b6f7222cd7.apply(void 0, (0, $1SMDP._)(chain))(store.dispatch);
            return (0, $d5be4a96a008f2f4$export$71511d61b312f219)((0, $5f1309c2fb31fc13$export$71511d61b312f219)({}, store), {
                dispatch: dispatch
            });
        };
    };
}
// src/utils/isAction.ts
function $c4195dcee631f3e8$export$b956e38827fca970(action) {
    return $c4195dcee631f3e8$export$53b83ca8eaab0383(action) && "type" in action && typeof action.type === "string";
}



var $64DyZ = parcelRequire("64DyZ");

var $aliU1 = parcelRequire("aliU1");

var $bMpTA = parcelRequire("bMpTA");

var $f9AIs = parcelRequire("f9AIs");

var $1SMDP = parcelRequire("1SMDP");

var $6zqIC = parcelRequire("6zqIC");
var $7af1c055eddd0169$var$__defProp = Object.defineProperty;
var $7af1c055eddd0169$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $7af1c055eddd0169$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $7af1c055eddd0169$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $7af1c055eddd0169$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $7af1c055eddd0169$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $7af1c055eddd0169$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($7af1c055eddd0169$var$__hasOwnProp.call(b, prop)) $7af1c055eddd0169$var$__defNormalProp(a, prop, b[prop]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if ($7af1c055eddd0169$var$__getOwnPropSymbols) try {
        for(var _iterator = $7af1c055eddd0169$var$__getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if ($7af1c055eddd0169$var$__propIsEnum.call(b, prop)) $7af1c055eddd0169$var$__defNormalProp(a, prop, b[prop]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return a;
};
var $7af1c055eddd0169$var$__publicField = function(obj, key, value) {
    $7af1c055eddd0169$var$__defNormalProp(obj, (typeof key === "undefined" ? "undefined" : (0, $6zqIC._)(key)) !== "symbol" ? key + "" : key, value);
    return value;
};
// src/devModeChecks/identityFunctionCheck.ts
var $7af1c055eddd0169$var$runIdentityFunctionCheck = function(resultFunc, inputSelectorsResults, outputSelectorResult) {
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        var isInputSameAsOutput = false;
        try {
            var emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch (e) {}
        if (isInputSameAsOutput) {
            var stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                stack = e.stack;
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack: stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $7af1c055eddd0169$var$runInputStabilityCheck = function(inputSelectorResultsObject, options, inputSelectorArgs) {
    var memoize = options.memoize, memoizeOptions = options.memoizeOptions;
    var inputSelectorResults = inputSelectorResultsObject.inputSelectorResults, inputSelectorResultsCopy = inputSelectorResultsObject.inputSelectorResultsCopy;
    var createAnEmptyObject = memoize.apply(void 0, [
        function() {
            return {};
        }
    ].concat((0, $1SMDP._)(memoizeOptions)));
    var areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        var stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            stack = e.stack;
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $7af1c055eddd0169$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var $7af1c055eddd0169$export$1e290349de99e28c = function(devModeChecks) {
    Object.assign($7af1c055eddd0169$var$globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var $7af1c055eddd0169$var$NOT_FOUND = "NOT_FOUND";
function $7af1c055eddd0169$var$assertIsFunction(func) {
    var errorMessage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "expected a function, instead received ".concat(typeof func === "undefined" ? "undefined" : (0, $6zqIC._)(func));
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $7af1c055eddd0169$var$assertIsObject(object) {
    var errorMessage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "expected an object, instead received ".concat(typeof object === "undefined" ? "undefined" : (0, $6zqIC._)(object));
    if (typeof object !== "object") throw new TypeError(errorMessage);
}
function $7af1c055eddd0169$var$assertIsArrayOfFunctions(array) {
    var errorMessage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "expected all items to be functions, instead received the following types: ";
    if (!array.every(function(item) {
        return typeof item === "function";
    })) {
        var itemTypes = array.map(function(item) {
            return typeof item === "function" ? "function ".concat(item.name || "unnamed", "()") : typeof item === "undefined" ? "undefined" : (0, $6zqIC._)(item);
        }).join(", ");
        throw new TypeError("".concat(errorMessage, "[").concat(itemTypes, "]"));
    }
}
var $7af1c055eddd0169$var$ensureIsArray = function(item) {
    return Array.isArray(item) ? item : [
        item
    ];
};
function $7af1c055eddd0169$var$getDependencies(createSelectorArgs) {
    var dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $7af1c055eddd0169$var$assertIsArrayOfFunctions(dependencies, "createSelector expects all input-selectors to be functions, but received the following types: ");
    return dependencies;
}
function $7af1c055eddd0169$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    var inputSelectorResults = [];
    var length = dependencies.length;
    for(var i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var $7af1c055eddd0169$var$getDevModeChecksExecutionInfo = function(firstRun, devModeChecks) {
    var __spreadValues1 = $7af1c055eddd0169$var$__spreadValues($7af1c055eddd0169$var$__spreadValues({}, $7af1c055eddd0169$var$globalDevModeChecks), devModeChecks), identityFunctionCheck = __spreadValues1.identityFunctionCheck, inputStabilityCheck = __spreadValues1.inputStabilityCheck;
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: $7af1c055eddd0169$var$runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: $7af1c055eddd0169$var$runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $7af1c055eddd0169$var$$REVISION = 0;
var $7af1c055eddd0169$var$CURRENT_TRACKER = null;
var $7af1c055eddd0169$var$Cell = /*#__PURE__*/ function() {
    "use strict";
    function Cell(initialValue) {
        var isEqual = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $7af1c055eddd0169$var$tripleEq;
        (0, $aliU1._)(this, Cell);
        $7af1c055eddd0169$var$__publicField(this, "revision", $7af1c055eddd0169$var$$REVISION);
        $7af1c055eddd0169$var$__publicField(this, "_value");
        $7af1c055eddd0169$var$__publicField(this, "_lastValue");
        $7af1c055eddd0169$var$__publicField(this, "_isEqual", $7af1c055eddd0169$var$tripleEq);
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
    (0, $bMpTA._)(Cell, [
        {
            key: "value",
            get: // Whenever a storage value is read, it'll add itself to the current tracker if
            // one exists, entangling its state with that cache.
            function get() {
                $7af1c055eddd0169$var$CURRENT_TRACKER == null || $7af1c055eddd0169$var$CURRENT_TRACKER.add(this);
                return this._value;
            },
            set: // Whenever a storage value is updated, we bump the global revision clock,
            // assign the revision for this storage to the new value, _and_ we schedule a
            // rerender. This is important, and it's what makes autotracking  _pull_
            // based. We don't actively tell the caches which depend on the storage that
            // anything has happened. Instead, we recompute the caches when needed.
            function set(newValue) {
                if (this.value === newValue) return;
                this._value = newValue;
                this.revision = ++$7af1c055eddd0169$var$$REVISION;
            }
        }
    ]);
    return Cell;
}();
function $7af1c055eddd0169$var$tripleEq(a, b) {
    return a === b;
}
var $7af1c055eddd0169$var$TrackingCache = /*#__PURE__*/ function() {
    "use strict";
    function TrackingCache(fn) {
        (0, $aliU1._)(this, TrackingCache);
        $7af1c055eddd0169$var$__publicField(this, "_cachedValue");
        $7af1c055eddd0169$var$__publicField(this, "_cachedRevision", -1);
        $7af1c055eddd0169$var$__publicField(this, "_deps", []);
        $7af1c055eddd0169$var$__publicField(this, "hits", 0);
        $7af1c055eddd0169$var$__publicField(this, "fn");
        this.fn = fn;
    }
    (0, $bMpTA._)(TrackingCache, [
        {
            key: "clear",
            value: function clear() {
                this._cachedValue = void 0;
                this._cachedRevision = -1;
                this._deps = [];
                this.hits = 0;
            }
        },
        {
            key: "value",
            get: function get() {
                if (this.revision > this._cachedRevision) {
                    var fn = this.fn;
                    var currentTracker = /* @__PURE__ */ new Set();
                    var prevTracker = $7af1c055eddd0169$var$CURRENT_TRACKER;
                    $7af1c055eddd0169$var$CURRENT_TRACKER = currentTracker;
                    this._cachedValue = fn();
                    $7af1c055eddd0169$var$CURRENT_TRACKER = prevTracker;
                    this.hits++;
                    this._deps = Array.from(currentTracker);
                    this._cachedRevision = this.revision;
                }
                $7af1c055eddd0169$var$CURRENT_TRACKER == null || $7af1c055eddd0169$var$CURRENT_TRACKER.add(this);
                return this._cachedValue;
            }
        },
        {
            key: "revision",
            get: function get() {
                var _Math;
                return (_Math = Math).max.apply(_Math, (0, $1SMDP._)(this._deps.map(function(d) {
                    return d.revision;
                })).concat([
                    0
                ]));
            }
        }
    ]);
    return TrackingCache;
}();
function $7af1c055eddd0169$var$getValue(cell) {
    if (!(cell instanceof $7af1c055eddd0169$var$Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function $7af1c055eddd0169$var$setValue(storage, value) {
    if (!(storage instanceof $7af1c055eddd0169$var$Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function $7af1c055eddd0169$var$createCell(initialValue) {
    var isEqual = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $7af1c055eddd0169$var$tripleEq;
    return new $7af1c055eddd0169$var$Cell(initialValue, isEqual);
}
function $7af1c055eddd0169$var$createCache(fn) {
    $7af1c055eddd0169$var$assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new $7af1c055eddd0169$var$TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var $7af1c055eddd0169$var$neverEq = function(a, b) {
    return false;
};
function $7af1c055eddd0169$var$createTag() {
    return $7af1c055eddd0169$var$createCell(null, $7af1c055eddd0169$var$neverEq);
}
function $7af1c055eddd0169$var$dirtyTag(tag, value) {
    $7af1c055eddd0169$var$setValue(tag, value);
}
var $7af1c055eddd0169$var$consumeCollection = function(node) {
    var tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = $7af1c055eddd0169$var$createTag();
    $7af1c055eddd0169$var$getValue(tag);
};
var $7af1c055eddd0169$var$dirtyCollection = function(node) {
    var tag = node.collectionTag;
    if (tag !== null) $7af1c055eddd0169$var$dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var $7af1c055eddd0169$var$REDUX_PROXY_LABEL = Symbol();
var $7af1c055eddd0169$var$nextId = 0;
var $7af1c055eddd0169$var$proto = Object.getPrototypeOf({});
var $7af1c055eddd0169$var$ObjectTreeNode = function ObjectTreeNode(value) {
    "use strict";
    (0, $aliU1._)(this, ObjectTreeNode);
    this.value = value;
    $7af1c055eddd0169$var$__publicField(this, "proxy", new Proxy(this, $7af1c055eddd0169$var$objectProxyHandler));
    $7af1c055eddd0169$var$__publicField(this, "tag", $7af1c055eddd0169$var$createTag());
    $7af1c055eddd0169$var$__publicField(this, "tags", {});
    $7af1c055eddd0169$var$__publicField(this, "children", {});
    $7af1c055eddd0169$var$__publicField(this, "collectionTag", null);
    $7af1c055eddd0169$var$__publicField(this, "id", $7af1c055eddd0169$var$nextId++);
    this.value = value;
    this.tag.value = value;
};
var $7af1c055eddd0169$var$objectProxyHandler = {
    get: function(node, key) {
        function calculateResult() {
            var value = node.value;
            var childValue = Reflect.get(value, key);
            if ((typeof key === "undefined" ? "undefined" : (0, $6zqIC._)(key)) === "symbol") return childValue;
            if (key in $7af1c055eddd0169$var$proto) return childValue;
            if (typeof childValue === "object" && childValue !== null) {
                var childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = $7af1c055eddd0169$var$createNode(childValue);
                if (childNode.tag) $7af1c055eddd0169$var$getValue(childNode.tag);
                return childNode.proxy;
            } else {
                var tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = $7af1c055eddd0169$var$createTag();
                    tag.value = childValue;
                }
                $7af1c055eddd0169$var$getValue(tag);
                return childValue;
            }
        }
        var res = calculateResult();
        return res;
    },
    ownKeys: function(node) {
        $7af1c055eddd0169$var$consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor: function(node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has: function(node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var $7af1c055eddd0169$var$ArrayTreeNode = function ArrayTreeNode(value) {
    "use strict";
    (0, $aliU1._)(this, ArrayTreeNode);
    this.value = value;
    $7af1c055eddd0169$var$__publicField(this, "proxy", new Proxy([
        this
    ], $7af1c055eddd0169$var$arrayProxyHandler));
    $7af1c055eddd0169$var$__publicField(this, "tag", $7af1c055eddd0169$var$createTag());
    $7af1c055eddd0169$var$__publicField(this, "tags", {});
    $7af1c055eddd0169$var$__publicField(this, "children", {});
    $7af1c055eddd0169$var$__publicField(this, "collectionTag", null);
    $7af1c055eddd0169$var$__publicField(this, "id", $7af1c055eddd0169$var$nextId++);
    this.value = value;
    this.tag.value = value;
};
var $7af1c055eddd0169$var$arrayProxyHandler = {
    get: function(param, key) {
        var _param = (0, $f9AIs._)(param, 1), node = _param[0];
        if (key === "length") $7af1c055eddd0169$var$consumeCollection(node);
        return $7af1c055eddd0169$var$objectProxyHandler.get(node, key);
    },
    ownKeys: function(param) {
        var _param = (0, $f9AIs._)(param, 1), node = _param[0];
        return $7af1c055eddd0169$var$objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor: function(param, prop) {
        var _param = (0, $f9AIs._)(param, 1), node = _param[0];
        return $7af1c055eddd0169$var$objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has: function(param, prop) {
        var _param = (0, $f9AIs._)(param, 1), node = _param[0];
        return $7af1c055eddd0169$var$objectProxyHandler.has(node, prop);
    }
};
function $7af1c055eddd0169$var$createNode(value) {
    if (Array.isArray(value)) return new $7af1c055eddd0169$var$ArrayTreeNode(value);
    return new $7af1c055eddd0169$var$ObjectTreeNode(value);
}
function $7af1c055eddd0169$var$updateNode(node, newValue) {
    var value = node.value, tags = node.tags, children = node.children;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) $7af1c055eddd0169$var$dirtyCollection(node);
    else if (value !== newValue) {
        var oldKeysSize = 0;
        var newKeysSize = 0;
        var anyKeysAdded = false;
        for(var _key in value)oldKeysSize++;
        for(var key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        var isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) $7af1c055eddd0169$var$dirtyCollection(node);
    }
    for(var key1 in tags){
        var childValue = value[key1];
        var newChildValue = newValue[key1];
        if (childValue !== newChildValue) {
            $7af1c055eddd0169$var$dirtyCollection(node);
            $7af1c055eddd0169$var$dirtyTag(tags[key1], newChildValue);
        }
        if (typeof newChildValue === "object" && newChildValue !== null) delete tags[key1];
    }
    for(var key2 in children){
        var childNode = children[key2];
        var newChildValue1 = newValue[key2];
        var childValue1 = childNode.value;
        if (childValue1 === newChildValue1) continue;
        else if (typeof newChildValue1 === "object" && newChildValue1 !== null) $7af1c055eddd0169$var$updateNode(childNode, newChildValue1);
        else {
            $7af1c055eddd0169$var$deleteNode(childNode);
            delete children[key2];
        }
    }
}
function $7af1c055eddd0169$var$deleteNode(node) {
    if (node.tag) $7af1c055eddd0169$var$dirtyTag(node.tag, null);
    $7af1c055eddd0169$var$dirtyCollection(node);
    for(var key in node.tags)$7af1c055eddd0169$var$dirtyTag(node.tags[key], null);
    for(var key1 in node.children)$7af1c055eddd0169$var$deleteNode(node.children[key1]);
}
// src/lruMemoize.ts
function $7af1c055eddd0169$var$createSingletonCache(equals) {
    var entry;
    return {
        get: function(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $7af1c055eddd0169$var$NOT_FOUND;
        },
        put: function(key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries: function() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function() {
            entry = void 0;
        }
    };
}
function $7af1c055eddd0169$var$createLruCache(maxSize, equals) {
    var entries = [];
    function get(key) {
        var cacheIndex = entries.findIndex(function(entry) {
            return equals(key, entry.key);
        });
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $7af1c055eddd0169$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $7af1c055eddd0169$var$NOT_FOUND) {
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $7af1c055eddd0169$export$3f025202a230c6dd = function(a, b) {
    return a === b;
};
function $7af1c055eddd0169$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        var length = prev.length;
        for(var i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $7af1c055eddd0169$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    var providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions_equalityCheck = providedOptions.equalityCheck, equalityCheck = _providedOptions_equalityCheck === void 0 ? $7af1c055eddd0169$export$3f025202a230c6dd : _providedOptions_equalityCheck, _providedOptions_maxSize = providedOptions.maxSize, maxSize = _providedOptions_maxSize === void 0 ? 1 : _providedOptions_maxSize, resultEqualityCheck = providedOptions.resultEqualityCheck;
    var comparator = $7af1c055eddd0169$var$createCacheKeyComparator(equalityCheck);
    var resultsCount = 0;
    var cache = maxSize === 1 ? $7af1c055eddd0169$var$createSingletonCache(comparator) : $7af1c055eddd0169$var$createLruCache(maxSize, comparator);
    function memoized() {
        var value = cache.get(arguments);
        if (value === $7af1c055eddd0169$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                var entries = cache.getEntries();
                var matchingEntry = entries.find(function(entry) {
                    return resultEqualityCheck(entry.value, value);
                });
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = function() {
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = function() {
        return resultsCount;
    };
    memoized.resetResultsCount = function() {
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function $7af1c055eddd0169$export$c8f9cf88d9fdee55(func) {
    var node = $7af1c055eddd0169$var$createNode([]);
    var lastArgs = null;
    var shallowEqual = $7af1c055eddd0169$var$createCacheKeyComparator($7af1c055eddd0169$export$3f025202a230c6dd);
    var cache = $7af1c055eddd0169$var$createCache(function() {
        var res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            $7af1c055eddd0169$var$updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = function() {
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var $7af1c055eddd0169$var$StrongRef = /*#__PURE__*/ function() {
    "use strict";
    function StrongRef(value) {
        (0, $aliU1._)(this, StrongRef);
        this.value = value;
    }
    (0, $bMpTA._)(StrongRef, [
        {
            key: "deref",
            value: function deref() {
                return this.value;
            }
        }
    ]);
    return StrongRef;
}();
var $7af1c055eddd0169$var$Ref = typeof WeakRef !== "undefined" ? WeakRef : $7af1c055eddd0169$var$StrongRef;
var $7af1c055eddd0169$var$UNTERMINATED = 0;
var $7af1c055eddd0169$var$TERMINATED = 1;
function $7af1c055eddd0169$var$createCacheNode() {
    return {
        s: $7af1c055eddd0169$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $7af1c055eddd0169$export$8402dc26d96f6902(func) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var fnNode = $7af1c055eddd0169$var$createCacheNode();
    var resultEqualityCheck = options.resultEqualityCheck;
    var lastResult;
    var resultsCount = 0;
    function memoized() {
        var _a, _b;
        var cacheNode = fnNode;
        var length = arguments.length;
        for(var i = 0, l = length; i < l; i++){
            var arg = arguments[i];
            if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                var objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                var objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $7af1c055eddd0169$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                var primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                var primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $7af1c055eddd0169$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        var terminatedNode = cacheNode;
        var result;
        if (cacheNode.s === $7af1c055eddd0169$var$TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
        }
        terminatedNode.s = $7af1c055eddd0169$var$TERMINATED;
        if (resultEqualityCheck) {
            var lastResultValue = (_b = (_a = lastResult == null ? void 0 : lastResult.deref) == null ? void 0 : _a.call(lastResult)) != null ? _b : lastResult;
            if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                result = lastResultValue;
                resultsCount !== 0 && resultsCount--;
            }
            var needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
            lastResult = needsWeakRef ? new $7af1c055eddd0169$var$Ref(result) : result;
        }
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = function() {
        fnNode = $7af1c055eddd0169$var$createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = function() {
        return resultsCount;
    };
    memoized.resetResultsCount = function() {
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function $7af1c055eddd0169$export$5943f4447f6ef248(memoizeOrOptions) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    }
    var createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    var createSelector2 = function() {
        for(var _len = arguments.length, createSelectorArgs = new Array(_len), _key = 0; _key < _len; _key++){
            createSelectorArgs[_key] = arguments[_key];
        }
        var recomputations = 0;
        var dependencyRecomputations = 0;
        var lastResult;
        var directlyPassedOptions = {};
        var resultFunc = createSelectorArgs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $7af1c055eddd0169$var$assertIsFunction(resultFunc, "createSelector expects an output function after the inputs, but received: [".concat(typeof resultFunc === "undefined" ? "undefined" : (0, $6zqIC._)(resultFunc), "]"));
        var combinedOptions = $7af1c055eddd0169$var$__spreadValues($7af1c055eddd0169$var$__spreadValues({}, createSelectorCreatorOptions), directlyPassedOptions);
        var memoize = combinedOptions.memoize, _combinedOptions_memoizeOptions = combinedOptions.memoizeOptions, memoizeOptions = _combinedOptions_memoizeOptions === void 0 ? [] : _combinedOptions_memoizeOptions, _combinedOptions_argsMemoize = combinedOptions.argsMemoize, argsMemoize = _combinedOptions_argsMemoize === void 0 ? $7af1c055eddd0169$export$8402dc26d96f6902 : _combinedOptions_argsMemoize, _combinedOptions_argsMemoizeOptions = combinedOptions.argsMemoizeOptions, argsMemoizeOptions = _combinedOptions_argsMemoizeOptions === void 0 ? [] : _combinedOptions_argsMemoizeOptions, _combinedOptions_devModeChecks = combinedOptions.devModeChecks, devModeChecks = _combinedOptions_devModeChecks === void 0 ? {} : _combinedOptions_devModeChecks;
        var finalMemoizeOptions = $7af1c055eddd0169$var$ensureIsArray(memoizeOptions);
        var finalArgsMemoizeOptions = $7af1c055eddd0169$var$ensureIsArray(argsMemoizeOptions);
        var dependencies = $7af1c055eddd0169$var$getDependencies(createSelectorArgs);
        var memoizedResultFunc = memoize.apply(void 0, [
            function recomputationWrapper() {
                recomputations++;
                return resultFunc.apply(null, arguments);
            }
        ].concat((0, $1SMDP._)(finalMemoizeOptions)));
        var firstRun = true;
        var selector = argsMemoize.apply(void 0, [
            function dependenciesChecker() {
                dependencyRecomputations++;
                var inputSelectorResults = $7af1c055eddd0169$var$collectInputSelectorResults(dependencies, arguments);
                lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
                return lastResult;
            }
        ].concat((0, $1SMDP._)(finalArgsMemoizeOptions)));
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: function() {
                return dependencyRecomputations;
            },
            resetDependencyRecomputations: function() {
                dependencyRecomputations = 0;
            },
            lastResult: function() {
                return lastResult;
            },
            recomputations: function() {
                return recomputations;
            },
            resetRecomputations: function() {
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: function() {
            return createSelector2;
        }
    });
    return createSelector2;
}
var $7af1c055eddd0169$export$595d22ed68ca2841 = /* @__PURE__ */ $7af1c055eddd0169$export$5943f4447f6ef248($7af1c055eddd0169$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $7af1c055eddd0169$export$75979cfcd91bf38f = Object.assign(function(inputSelectorsObject) {
    var selectorCreator = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $7af1c055eddd0169$export$595d22ed68ca2841;
    $7af1c055eddd0169$var$assertIsObject(inputSelectorsObject, "createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ".concat(typeof inputSelectorsObject === "undefined" ? "undefined" : (0, $6zqIC._)(inputSelectorsObject)));
    var inputSelectorKeys = Object.keys(inputSelectorsObject);
    var dependencies = inputSelectorKeys.map(function(key) {
        return inputSelectorsObject[key];
    });
    var structuredSelector = selectorCreator(dependencies, function() {
        for(var _len = arguments.length, inputSelectorResults = new Array(_len), _key = 0; _key < _len; _key++){
            inputSelectorResults[_key] = arguments[_key];
        }
        return inputSelectorResults.reduce(function(composition, value, index) {
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: function() {
        return $7af1c055eddd0169$export$75979cfcd91bf38f;
    }
});


// src/index.ts
function $f9dc39e91a0a4a67$var$createThunkMiddleware(extraArgument) {
    var middleware = function(param) {
        var dispatch = param.dispatch, getState = param.getState;
        return function(next) {
            return function(action) {
                if (typeof action === "function") return action(dispatch, getState, extraArgument);
                return next(action);
            };
        };
    };
    return middleware;
}
var $f9dc39e91a0a4a67$export$dd164f5517779f15 = $f9dc39e91a0a4a67$var$createThunkMiddleware();
var $f9dc39e91a0a4a67$export$16d06542a1949d9e = $f9dc39e91a0a4a67$var$createThunkMiddleware;


var $75c31d18d8204522$exports = {};
// shim for using process in browser
var $75c31d18d8204522$var$process = $75c31d18d8204522$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $75c31d18d8204522$var$cachedSetTimeout;
var $75c31d18d8204522$var$cachedClearTimeout;
function $75c31d18d8204522$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $75c31d18d8204522$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $75c31d18d8204522$var$cachedSetTimeout = setTimeout;
        else $75c31d18d8204522$var$cachedSetTimeout = $75c31d18d8204522$var$defaultSetTimout;
    } catch (e) {
        $75c31d18d8204522$var$cachedSetTimeout = $75c31d18d8204522$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $75c31d18d8204522$var$cachedClearTimeout = clearTimeout;
        else $75c31d18d8204522$var$cachedClearTimeout = $75c31d18d8204522$var$defaultClearTimeout;
    } catch (e) {
        $75c31d18d8204522$var$cachedClearTimeout = $75c31d18d8204522$var$defaultClearTimeout;
    }
})();
function $75c31d18d8204522$var$runTimeout(fun) {
    if ($75c31d18d8204522$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($75c31d18d8204522$var$cachedSetTimeout === $75c31d18d8204522$var$defaultSetTimout || !$75c31d18d8204522$var$cachedSetTimeout) && setTimeout) {
        $75c31d18d8204522$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $75c31d18d8204522$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $75c31d18d8204522$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $75c31d18d8204522$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $75c31d18d8204522$var$runClearTimeout(marker) {
    if ($75c31d18d8204522$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($75c31d18d8204522$var$cachedClearTimeout === $75c31d18d8204522$var$defaultClearTimeout || !$75c31d18d8204522$var$cachedClearTimeout) && clearTimeout) {
        $75c31d18d8204522$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $75c31d18d8204522$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $75c31d18d8204522$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $75c31d18d8204522$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $75c31d18d8204522$var$queue = [];
var $75c31d18d8204522$var$draining = false;
var $75c31d18d8204522$var$currentQueue;
var $75c31d18d8204522$var$queueIndex = -1;
function $75c31d18d8204522$var$cleanUpNextTick() {
    if (!$75c31d18d8204522$var$draining || !$75c31d18d8204522$var$currentQueue) return;
    $75c31d18d8204522$var$draining = false;
    if ($75c31d18d8204522$var$currentQueue.length) $75c31d18d8204522$var$queue = $75c31d18d8204522$var$currentQueue.concat($75c31d18d8204522$var$queue);
    else $75c31d18d8204522$var$queueIndex = -1;
    if ($75c31d18d8204522$var$queue.length) $75c31d18d8204522$var$drainQueue();
}
function $75c31d18d8204522$var$drainQueue() {
    if ($75c31d18d8204522$var$draining) return;
    var timeout = $75c31d18d8204522$var$runTimeout($75c31d18d8204522$var$cleanUpNextTick);
    $75c31d18d8204522$var$draining = true;
    var len = $75c31d18d8204522$var$queue.length;
    while(len){
        $75c31d18d8204522$var$currentQueue = $75c31d18d8204522$var$queue;
        $75c31d18d8204522$var$queue = [];
        while(++$75c31d18d8204522$var$queueIndex < len)if ($75c31d18d8204522$var$currentQueue) $75c31d18d8204522$var$currentQueue[$75c31d18d8204522$var$queueIndex].run();
        $75c31d18d8204522$var$queueIndex = -1;
        len = $75c31d18d8204522$var$queue.length;
    }
    $75c31d18d8204522$var$currentQueue = null;
    $75c31d18d8204522$var$draining = false;
    $75c31d18d8204522$var$runClearTimeout(timeout);
}
$75c31d18d8204522$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $75c31d18d8204522$var$queue.push(new $75c31d18d8204522$var$Item(fun, args));
    if ($75c31d18d8204522$var$queue.length === 1 && !$75c31d18d8204522$var$draining) $75c31d18d8204522$var$runTimeout($75c31d18d8204522$var$drainQueue);
};
// v8 likes predictible objects
function $75c31d18d8204522$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$75c31d18d8204522$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$75c31d18d8204522$var$process.title = "browser";
$75c31d18d8204522$var$process.browser = true;
$75c31d18d8204522$var$process.env = {};
$75c31d18d8204522$var$process.argv = [];
$75c31d18d8204522$var$process.version = ""; // empty string to avoid regexp issues
$75c31d18d8204522$var$process.versions = {};
function $75c31d18d8204522$var$noop() {}
$75c31d18d8204522$var$process.on = $75c31d18d8204522$var$noop;
$75c31d18d8204522$var$process.addListener = $75c31d18d8204522$var$noop;
$75c31d18d8204522$var$process.once = $75c31d18d8204522$var$noop;
$75c31d18d8204522$var$process.off = $75c31d18d8204522$var$noop;
$75c31d18d8204522$var$process.removeListener = $75c31d18d8204522$var$noop;
$75c31d18d8204522$var$process.removeAllListeners = $75c31d18d8204522$var$noop;
$75c31d18d8204522$var$process.emit = $75c31d18d8204522$var$noop;
$75c31d18d8204522$var$process.prependListener = $75c31d18d8204522$var$noop;
$75c31d18d8204522$var$process.prependOnceListener = $75c31d18d8204522$var$noop;
$75c31d18d8204522$var$process.listeners = function(name) {
    return [];
};
$75c31d18d8204522$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$75c31d18d8204522$var$process.cwd = function() {
    return "/";
};
$75c31d18d8204522$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$75c31d18d8204522$var$process.umask = function() {
    return 0;
};


var $710a88b49044c621$var$__defProp = Object.defineProperty;
var $710a88b49044c621$var$__defProps = Object.defineProperties;
var $710a88b49044c621$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $710a88b49044c621$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $710a88b49044c621$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $710a88b49044c621$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $710a88b49044c621$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $710a88b49044c621$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $710a88b49044c621$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($710a88b49044c621$var$__hasOwnProp.call(b, prop)) $710a88b49044c621$var$__defNormalProp(a, prop, b[prop]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if ($710a88b49044c621$var$__getOwnPropSymbols) try {
        for(var _iterator = $710a88b49044c621$var$__getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if ($710a88b49044c621$var$__propIsEnum.call(b, prop)) $710a88b49044c621$var$__defNormalProp(a, prop, b[prop]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return a;
};
var $710a88b49044c621$var$__spreadProps = function(a, b) {
    return $710a88b49044c621$var$__defProps(a, $710a88b49044c621$var$__getOwnPropDescs(b));
};
var $710a88b49044c621$var$__objRest = function(source, exclude) {
    var target = {};
    for(var prop in source)if ($710a88b49044c621$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (source != null && $710a88b49044c621$var$__getOwnPropSymbols) try {
        for(var _iterator = $710a88b49044c621$var$__getOwnPropSymbols(source)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if (exclude.indexOf(prop) < 0 && $710a88b49044c621$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return target;
};
var $710a88b49044c621$var$__publicField = function(obj, key, value) {
    $710a88b49044c621$var$__defNormalProp(obj, (typeof key === "undefined" ? "undefined" : (0, $6zqIC._)(key)) !== "symbol" ? key + "" : key, value);
    return value;
};
var $710a88b49044c621$export$aab6de9e3dbb1473 = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var createSelector2 = (0, $7af1c055eddd0169$export$5943f4447f6ef248).apply(void 0, (0, $1SMDP._)(args));
    var createDraftSafeSelector2 = Object.assign(function() {
        for(var _len = arguments.length, args2 = new Array(_len), _key = 0; _key < _len; _key++){
            args2[_key] = arguments[_key];
        }
        var selector = createSelector2.apply(void 0, (0, $1SMDP._)(args2));
        var wrappedSelector = function(value) {
            for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                rest[_key - 1] = arguments[_key];
            }
            return selector.apply(void 0, [
                (0, $64DyZ.isDraft)(value) ? (0, $64DyZ.current)(value) : value
            ].concat((0, $1SMDP._)(rest)));
        };
        Object.assign(wrappedSelector, selector);
        return wrappedSelector;
    }, {
        withTypes: function() {
            return createDraftSafeSelector2;
        }
    });
    return createDraftSafeSelector2;
};
var $710a88b49044c621$export$a5d3c27355e35910 = $710a88b49044c621$export$aab6de9e3dbb1473((0, $7af1c055eddd0169$export$8402dc26d96f6902));
var $710a88b49044c621$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function composeWithDevTools() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $c4195dcee631f3e8$export$f672e0b6f7222cd7;
    return (0, $c4195dcee631f3e8$export$f672e0b6f7222cd7).apply(null, arguments);
};
var $710a88b49044c621$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function devToolsEnhancer() {
    return function(noop3) {
        return noop3;
    };
};
// src/tsHelpers.ts
var $710a88b49044c621$var$hasMatchFunction = function(v) {
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $710a88b49044c621$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (prepareAction) {
            var prepared = prepareAction.apply(void 0, (0, $1SMDP._)(args));
            if (!prepared) throw new Error($710a88b49044c621$export$378fa86b259c0280(0));
            return $710a88b49044c621$var$__spreadValues($710a88b49044c621$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = function() {
        return "".concat(type);
    };
    actionCreator.type = type;
    actionCreator.match = function(action) {
        return (0, $c4195dcee631f3e8$export$b956e38827fca970)(action) && action.type === type;
    };
    return actionCreator;
}
function $710a88b49044c621$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
    $710a88b49044c621$var$hasMatchFunction(action);
}
function $710a88b49044c621$export$ebd532f9034651f3(action) {
    return (0, $c4195dcee631f3e8$export$b956e38827fca970)(action) && Object.keys(action).every($710a88b49044c621$var$isValidKey);
}
function $710a88b49044c621$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
// src/actionCreatorInvariantMiddleware.ts
function $710a88b49044c621$var$getMessage(type) {
    var splitType = type ? "".concat(type).split("/") : [];
    var actionName = splitType[splitType.length - 1] || "actionCreator";
    return 'Detected an action creator with type "'.concat(type || "unknown", "\" being dispatched. \nMake sure you're calling the action creator before dispatching, i.e. `dispatch(").concat(actionName, "())` instead of `dispatch(").concat(actionName, ")`. This is necessary even if the action has no payload.");
}
function $710a88b49044c621$export$6a1fcb4ceef578f() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var next, action;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
function $710a88b49044c621$var$getTimeMeasureUtils(maxDelay, fnName) {
    var elapsed = 0;
    return {
        measureTime: function(fn) {
            var started = Date.now();
            try {
                return fn();
            } finally{
                var finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded: function() {
            if (elapsed > maxDelay) console.warn("".concat(fnName, " took ").concat(elapsed, "ms, which is more than the warning threshold of ").concat(maxDelay, "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that."));
        }
    };
}
function $710a88b49044c621$var$find(iterable, comparator) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = iterable[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var entry = _step.value;
            if (comparator(entry)) return entry;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return void 0;
}
var $710a88b49044c621$export$1908877435b1d5e9 = /*#__PURE__*/ function(Array1) {
    "use strict";
    (0, $fZ5u7._)(_Tuple, Array1);
    var _super = (0, $9j1tP._)(_Tuple);
    function _Tuple() {
        for(var _len = arguments.length, items = new Array(_len), _key = 0; _key < _len; _key++){
            items[_key] = arguments[_key];
        }
        (0, $aliU1._)(this, _Tuple);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0, $1SMDP._)(items)));
        Object.setPrototypeOf((0, $cOYso._)(_this), _Tuple.prototype);
        return _this;
    }
    (0, $bMpTA._)(_Tuple, [
        {
            key: "concat",
            value: function concat() {
                for(var _len = arguments.length, arr = new Array(_len), _key = 0; _key < _len; _key++){
                    arr[_key] = arguments[_key];
                }
                return (0, $a07cb0dafe2a93d7$export$71511d61b312f219)((0, $92y6r._)(_Tuple.prototype), "concat", this).apply(this, arr);
            }
        },
        {
            key: "prepend",
            value: function prepend() {
                for(var _len = arguments.length, arr = new Array(_len), _key = 0; _key < _len; _key++){
                    arr[_key] = arguments[_key];
                }
                if (arr.length === 1 && Array.isArray(arr[0])) return (0, $6EBGQ._)(_Tuple, (0, $1SMDP._)(arr[0].concat(this)));
                return (0, $6EBGQ._)(_Tuple, (0, $1SMDP._)(arr.concat(this)));
            }
        }
    ], [
        {
            key: Symbol.species,
            get: function get() {
                return _Tuple;
            }
        }
    ]);
    return _Tuple;
}((0, $6HjaD._)(Array));
function $710a88b49044c621$var$freezeDraftable(val) {
    return (0, $64DyZ.isDraftable)(val) ? (0, $64DyZ.produce)(val, function() {}) : val;
}
function $710a88b49044c621$var$emplace(map, key, handler) {
    if (map.has(key)) {
        var value = map.get(key);
        if (handler.update) {
            value = handler.update(value, key, map);
            map.set(key, value);
        }
        return value;
    }
    if (!handler.insert) throw new Error($710a88b49044c621$export$378fa86b259c0280(10));
    var inserted = handler.insert(key, map);
    map.set(key, inserted);
    return inserted;
}
// src/immutableStateInvariantMiddleware.ts
function $710a88b49044c621$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $710a88b49044c621$var$trackForMutations(isImmutable, ignorePaths, obj) {
    var trackedProperties = $710a88b49044c621$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations: function() {
            return $710a88b49044c621$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $710a88b49044c621$var$trackProperties(isImmutable) {
    var ignorePaths = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], obj = arguments.length > 2 ? arguments[2] : void 0, path = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", checkedObjects = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : /* @__PURE__ */ new Set();
    var tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(var key in obj){
            var childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $710a88b49044c621$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $710a88b49044c621$var$detectMutations(isImmutable) {
    var _loop = function(key2) {
        var nestedPath = path ? path + "." + key2 : key2;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        var result = $710a88b49044c621$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key2], obj[key2], sameRef, nestedPath);
        if (result.wasMutated) return {
            v: result
        };
    };
    var ignoredPaths = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], trackedProperty = arguments.length > 2 ? arguments[2] : void 0, obj = arguments.length > 3 ? arguments[3] : void 0, sameParentRef = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false, path = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "";
    var prevObj = trackedProperty ? trackedProperty.value : void 0;
    var sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    var keysToDetect = {};
    for(var key in trackedProperty.children)keysToDetect[key] = true;
    for(var key1 in obj)keysToDetect[key1] = true;
    var hasIgnoredPaths = ignoredPaths.length > 0;
    for(var key2 in keysToDetect){
        var _ret = _loop(key2);
        if ((0, $6zqIC._)(_ret) === "object") return _ret.v;
    }
    return {
        wasMutated: false
    };
}
function $710a88b49044c621$export$9181bb1a5474289() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var stringify, getSerialize, getState, next, action;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
function $710a88b49044c621$export$77670485918dab4e(val) {
    var type = typeof val === "undefined" ? "undefined" : (0, $6zqIC._)(val);
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || (0, $c4195dcee631f3e8$export$53b83ca8eaab0383)(val);
}
function $710a88b49044c621$export$ada5dca0b571bc7(value) {
    var path = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", isSerializable = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $710a88b49044c621$export$77670485918dab4e, getEntries = arguments.length > 3 ? arguments[3] : void 0, ignoredPaths = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : [], cache = arguments.length > 5 ? arguments[5] : void 0;
    var foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    var entries = getEntries != null ? getEntries(value) : Object.entries(value);
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var _step_value = (0, $f9AIs._)(_step.value, 2), key = _step_value[0], nestedValue = _step_value[1];
            var nestedPath = path ? path + "." + key : key;
            if (hasIgnoredPaths) {
                var hasMatches = ignoredPaths.some(function(ignored) {
                    if (ignored instanceof RegExp) return ignored.test(nestedPath);
                    return nestedPath === ignored;
                });
                if (hasMatches) return "continue";
            }
            if (!isSerializable(nestedValue)) return {
                v: {
                    keyPath: nestedPath,
                    value: nestedValue
                }
            };
            if (typeof nestedValue === "object") {
                foundNestedSerializable = $710a88b49044c621$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
                if (foundNestedSerializable) return {
                    v: foundNestedSerializable
                };
            }
        };
        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _ret = _loop();
            if ((0, $6zqIC._)(_ret) === "object") return _ret.v;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (cache && $710a88b49044c621$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $710a88b49044c621$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.values(value)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var nestedValue = _step.value;
            if (typeof nestedValue !== "object" || nestedValue === null) continue;
            if (!$710a88b49044c621$var$isNestedFrozen(nestedValue)) return false;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
}
function $710a88b49044c621$export$6dea1aad6dac5ac2() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var storeAPI, next, action;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/getDefaultMiddleware.ts
function $710a88b49044c621$var$isBoolean(x) {
    return typeof x === "boolean";
}
var $710a88b49044c621$var$buildGetDefaultMiddleware = function() {
    return function getDefaultMiddleware(options) {
        var _ref = options != null ? options : {}, _ref_thunk = _ref.thunk, thunk = _ref_thunk === void 0 ? true : _ref_thunk, _ref_immutableCheck = _ref.immutableCheck, immutableCheck = _ref_immutableCheck === void 0 ? true : _ref_immutableCheck, _ref_serializableCheck = _ref.serializableCheck, serializableCheck = _ref_serializableCheck === void 0 ? true : _ref_serializableCheck, _ref_actionCreatorCheck = _ref.actionCreatorCheck, actionCreatorCheck = _ref_actionCreatorCheck === void 0 ? true : _ref_actionCreatorCheck;
        var middlewareArray = new $710a88b49044c621$export$1908877435b1d5e9();
        if (thunk) {
            if ($710a88b49044c621$var$isBoolean(thunk)) middlewareArray.push((0, $f9dc39e91a0a4a67$export$dd164f5517779f15));
            else middlewareArray.push((0, $f9dc39e91a0a4a67$export$16d06542a1949d9e)(thunk.extraArgument));
        }
        return middlewareArray;
    };
};
// src/autoBatchEnhancer.ts
var $710a88b49044c621$export$8fb31c0f05df007b = "RTK_autoBatch";
var $710a88b49044c621$export$39fcd5145ec5e4e2 = function() {
    return function(payload) {
        return {
            payload: payload,
            meta: (0, $73NPw._)({}, $710a88b49044c621$export$8fb31c0f05df007b, true)
        };
    };
};
var $710a88b49044c621$var$createQueueWithTimer = function(timeout) {
    return function(notify) {
        setTimeout(notify, timeout);
    };
};
var $710a88b49044c621$var$rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $710a88b49044c621$var$createQueueWithTimer(10);
var $710a88b49044c621$export$676277d7dca0f396 = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        type: "raf"
    };
    return function(next) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var store = next.apply(void 0, (0, $1SMDP._)(args));
            var notifying = true;
            var shouldNotifyAtEndOfTick = false;
            var notificationQueued = false;
            var listeners = /* @__PURE__ */ new Set();
            var queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? $710a88b49044c621$var$rAF : options.type === "callback" ? options.queueNotification : $710a88b49044c621$var$createQueueWithTimer(options.timeout);
            var notifyListeners = function() {
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach(function(l) {
                        return l();
                    });
                }
            };
            return Object.assign({}, store, {
                // Override the base `store.subscribe` method to keep original listeners
                // from running if we're delaying notifications
                subscribe: function(listener2) {
                    var wrappedListener = function() {
                        return notifying && listener2();
                    };
                    var unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return function() {
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                // Override the base `store.dispatch` method so that we can check actions
                // for the `shouldAutoBatch` flag and determine if batching is active
                dispatch: function(action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$710a88b49044c621$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
    };
};
// src/getDefaultEnhancers.ts
var $710a88b49044c621$var$buildGetDefaultEnhancers = function(middlewareEnhancer) {
    return function getDefaultEnhancers(options) {
        var _ref = options != null ? options : {}, _ref_autoBatch = _ref.autoBatch, autoBatch = _ref_autoBatch === void 0 ? true : _ref_autoBatch;
        var enhancerArray = new $710a88b49044c621$export$1908877435b1d5e9(middlewareEnhancer);
        if (autoBatch) enhancerArray.push($710a88b49044c621$export$676277d7dca0f396(typeof autoBatch === "object" ? autoBatch : void 0));
        return enhancerArray;
    };
};
// src/configureStore.ts
var $710a88b49044c621$var$IS_PRODUCTION = true;
function $710a88b49044c621$export$7d8a5b498da695ac(options) {
    var getDefaultMiddleware = $710a88b49044c621$var$buildGetDefaultMiddleware();
    var _ref = options || {}, reducer = _ref.reducer, middleware = _ref.middleware, _ref_devTools = _ref.devTools, devTools = _ref_devTools === void 0 ? true : _ref_devTools, preloadedState = _ref.preloadedState, enhancers = _ref.enhancers;
    var rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ((0, $c4195dcee631f3e8$export$53b83ca8eaab0383)(reducer)) rootReducer = (0, $c4195dcee631f3e8$export$66e4520cdb265d18)(reducer);
    else throw new Error($710a88b49044c621$export$378fa86b259c0280(1));
    if (!$710a88b49044c621$var$IS_PRODUCTION && middleware && typeof middleware !== "function") throw new Error($710a88b49044c621$export$378fa86b259c0280(2));
    var finalMiddleware;
    if (typeof middleware === "function") {
        finalMiddleware = middleware(getDefaultMiddleware);
        if (!$710a88b49044c621$var$IS_PRODUCTION && !Array.isArray(finalMiddleware)) throw new Error($710a88b49044c621$export$378fa86b259c0280(3));
    } else finalMiddleware = getDefaultMiddleware();
    if (!$710a88b49044c621$var$IS_PRODUCTION && finalMiddleware.some(function(item) {
        return typeof item !== "function";
    })) throw new Error($710a88b49044c621$export$378fa86b259c0280(4));
    var finalCompose = (0, $c4195dcee631f3e8$export$f672e0b6f7222cd7);
    if (devTools) finalCompose = $710a88b49044c621$var$composeWithDevTools($710a88b49044c621$var$__spreadValues({
        // Enable capture of stack traces for dispatched Redux actions
        trace: !$710a88b49044c621$var$IS_PRODUCTION
    }, typeof devTools === "object" && devTools));
    var middlewareEnhancer = (0, $c4195dcee631f3e8$export$9ff26e0402cc7b7).apply(void 0, (0, $1SMDP._)(finalMiddleware));
    var getDefaultEnhancers = $710a88b49044c621$var$buildGetDefaultEnhancers(middlewareEnhancer);
    if (!$710a88b49044c621$var$IS_PRODUCTION && enhancers && typeof enhancers !== "function") throw new Error($710a88b49044c621$export$378fa86b259c0280(5));
    var storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
    if (!$710a88b49044c621$var$IS_PRODUCTION && !Array.isArray(storeEnhancers)) throw new Error($710a88b49044c621$export$378fa86b259c0280(6));
    if (!$710a88b49044c621$var$IS_PRODUCTION && storeEnhancers.some(function(item) {
        return typeof item !== "function";
    })) throw new Error($710a88b49044c621$export$378fa86b259c0280(7));
    if (!$710a88b49044c621$var$IS_PRODUCTION && finalMiddleware.length && !storeEnhancers.includes(middlewareEnhancer)) console.error("middlewares were provided, but middleware enhancer was not included in final enhancers - make sure to call `getDefaultEnhancers`");
    var composedEnhancer = finalCompose.apply(void 0, (0, $1SMDP._)(storeEnhancers));
    return (0, $c4195dcee631f3e8$export$f51a9068ac82ea43)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $710a88b49044c621$var$executeReducerBuilderCallback(builderCallback) {
    var actionsMap = {};
    var actionMatchers = [];
    var defaultCaseReducer;
    var builder = {
        addCase: function(typeOrActionCreator, reducer) {
            var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error($710a88b49044c621$export$378fa86b259c0280(28));
            if (type in actionsMap) throw new Error($710a88b49044c621$export$378fa86b259c0280(29));
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher: function(matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase: function(reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $710a88b49044c621$var$isStateFunction(x) {
    return typeof x === "function";
}
function $710a88b49044c621$export$473eb76d322d0290(initialState, mapOrBuilderCallback) {
    var _executeReducerBuilderCallback = (0, $f9AIs._)($710a88b49044c621$var$executeReducerBuilderCallback(mapOrBuilderCallback), 3), actionsMap = _executeReducerBuilderCallback[0], finalActionMatchers = _executeReducerBuilderCallback[1], finalDefaultCaseReducer = _executeReducerBuilderCallback[2];
    var getInitialState;
    if ($710a88b49044c621$var$isStateFunction(initialState)) getInitialState = function() {
        return $710a88b49044c621$var$freezeDraftable(initialState());
    };
    else {
        var frozenInitialState = $710a88b49044c621$var$freezeDraftable(initialState);
        getInitialState = function() {
            return frozenInitialState;
        };
    }
    function reducer() {
        var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : getInitialState(), action = arguments.length > 1 ? arguments[1] : void 0;
        var caseReducers = [
            actionsMap[action.type]
        ].concat((0, $1SMDP._)(finalActionMatchers.filter(function(param) {
            var matcher = param.matcher;
            return matcher(action);
        }).map(function(param) {
            var reducer2 = param.reducer;
            return reducer2;
        })));
        if (caseReducers.filter(function(cr) {
            return !!cr;
        }).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce(function(previousState, caseReducer) {
            if (caseReducer) {
                if ((0, $64DyZ.isDraft)(previousState)) {
                    var draft = previousState;
                    var result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $64DyZ.isDraftable)(previousState)) {
                    var result1 = caseReducer(previousState, action);
                    if (result1 === void 0) {
                        if (previousState === null) return previousState;
                        throw new Error($710a88b49044c621$export$378fa86b259c0280(9));
                    }
                    return result1;
                } else return (0, $64DyZ.produce)(previousState, function(draft) {
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/nanoid.ts
var $710a88b49044c621$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $710a88b49044c621$export$ac4959f4f1338dfc = function() {
    var size = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 21;
    var id = "";
    var i = size;
    while(i--)id += $710a88b49044c621$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/matchers.ts
var $710a88b49044c621$var$matches = function(matcher, action) {
    if ($710a88b49044c621$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $710a88b49044c621$export$2c3435c7647f7b0d() {
    for(var _len = arguments.length, matchers = new Array(_len), _key = 0; _key < _len; _key++){
        matchers[_key] = arguments[_key];
    }
    return function(action) {
        return matchers.some(function(matcher) {
            return $710a88b49044c621$var$matches(matcher, action);
        });
    };
}
function $710a88b49044c621$export$9dd1fb32974da385() {
    for(var _len = arguments.length, matchers = new Array(_len), _key = 0; _key < _len; _key++){
        matchers[_key] = arguments[_key];
    }
    return function(action) {
        return matchers.every(function(matcher) {
            return $710a88b49044c621$var$matches(matcher, action);
        });
    };
}
function $710a88b49044c621$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    var hasValidRequestId = typeof action.meta.requestId === "string";
    var hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $710a88b49044c621$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $710a88b49044c621$export$872dec21e9a69476() {
    for(var _len = arguments.length, asyncThunks = new Array(_len), _key = 0; _key < _len; _key++){
        asyncThunks[_key] = arguments[_key];
    }
    if (asyncThunks.length === 0) return function(action) {
        return $710a88b49044c621$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    };
    if (!$710a88b49044c621$var$isAsyncThunkArray(asyncThunks)) return $710a88b49044c621$export$872dec21e9a69476()(asyncThunks[0]);
    return $710a88b49044c621$export$2c3435c7647f7b0d.apply(void 0, (0, $1SMDP._)(asyncThunks.map(function(asyncThunk) {
        return asyncThunk.pending;
    })));
}
function $710a88b49044c621$export$a5c5d27e3994c5be() {
    for(var _len = arguments.length, asyncThunks = new Array(_len), _key = 0; _key < _len; _key++){
        asyncThunks[_key] = arguments[_key];
    }
    if (asyncThunks.length === 0) return function(action) {
        return $710a88b49044c621$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    };
    if (!$710a88b49044c621$var$isAsyncThunkArray(asyncThunks)) return $710a88b49044c621$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return $710a88b49044c621$export$2c3435c7647f7b0d.apply(void 0, (0, $1SMDP._)(asyncThunks.map(function(asyncThunk) {
        return asyncThunk.rejected;
    })));
}
function $710a88b49044c621$export$fcc3388fb56de601() {
    for(var _len = arguments.length, asyncThunks = new Array(_len), _key = 0; _key < _len; _key++){
        asyncThunks[_key] = arguments[_key];
    }
    var hasFlag = function(action) {
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return $710a88b49044c621$export$9dd1fb32974da385($710a88b49044c621$export$a5c5d27e3994c5be.apply(void 0, (0, $1SMDP._)(asyncThunks)), hasFlag);
    if (!$710a88b49044c621$var$isAsyncThunkArray(asyncThunks)) return $710a88b49044c621$export$fcc3388fb56de601()(asyncThunks[0]);
    return $710a88b49044c621$export$9dd1fb32974da385($710a88b49044c621$export$a5c5d27e3994c5be.apply(void 0, (0, $1SMDP._)(asyncThunks)), hasFlag);
}
function $710a88b49044c621$export$1da80a6ef1307441() {
    for(var _len = arguments.length, asyncThunks = new Array(_len), _key = 0; _key < _len; _key++){
        asyncThunks[_key] = arguments[_key];
    }
    if (asyncThunks.length === 0) return function(action) {
        return $710a88b49044c621$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    };
    if (!$710a88b49044c621$var$isAsyncThunkArray(asyncThunks)) return $710a88b49044c621$export$1da80a6ef1307441()(asyncThunks[0]);
    return $710a88b49044c621$export$2c3435c7647f7b0d.apply(void 0, (0, $1SMDP._)(asyncThunks.map(function(asyncThunk) {
        return asyncThunk.fulfilled;
    })));
}
function $710a88b49044c621$export$6aa4142d99c1abce() {
    for(var _len = arguments.length, asyncThunks = new Array(_len), _key = 0; _key < _len; _key++){
        asyncThunks[_key] = arguments[_key];
    }
    if (asyncThunks.length === 0) return function(action) {
        return $710a88b49044c621$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    };
    if (!$710a88b49044c621$var$isAsyncThunkArray(asyncThunks)) return $710a88b49044c621$export$6aa4142d99c1abce()(asyncThunks[0]);
    return $710a88b49044c621$export$2c3435c7647f7b0d.apply(void 0, (0, $1SMDP._)(asyncThunks.flatMap(function(asyncThunk) {
        return [
            asyncThunk.pending,
            asyncThunk.rejected,
            asyncThunk.fulfilled
        ];
    })));
}
// src/createAsyncThunk.ts
var $710a88b49044c621$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $710a88b49044c621$var$RejectWithValue = function RejectWithValue(payload, meta) {
    "use strict";
    (0, $aliU1._)(this, RejectWithValue);
    this.payload = payload;
    this.meta = meta;
    /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $710a88b49044c621$var$__publicField(this, "_type");
};
var $710a88b49044c621$var$FulfillWithMeta = function FulfillWithMeta(payload, meta) {
    "use strict";
    (0, $aliU1._)(this, FulfillWithMeta);
    this.payload = payload;
    this.meta = meta;
    /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $710a88b49044c621$var$__publicField(this, "_type");
};
var $710a88b49044c621$export$c97c53d0b2d5d81e = function(value) {
    if (typeof value === "object" && value !== null) {
        var simpleError = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = $710a88b49044c621$var$commonProperties[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var property = _step.value;
                if (typeof value[property] === "string") simpleError[property] = value[property];
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $710a88b49044c621$export$6abd22dc03e5063f = /* @__PURE__ */ function() {
    var createAsyncThunk2 = function createAsyncThunk2(typePrefix, payloadCreator, options) {
        var fulfilled = $710a88b49044c621$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", function(payload, requestId, arg, meta) {
            return {
                payload: payload,
                meta: $710a88b49044c621$var$__spreadProps($710a88b49044c621$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            };
        });
        var pending = $710a88b49044c621$export$309c7a02b0b0bc62(typePrefix + "/pending", function(requestId, arg, meta) {
            return {
                payload: void 0,
                meta: $710a88b49044c621$var$__spreadProps($710a88b49044c621$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            };
        });
        var rejected = $710a88b49044c621$export$309c7a02b0b0bc62(typePrefix + "/rejected", function(error, requestId, arg, payload, meta) {
            return {
                payload: payload,
                error: (options && options.serializeError || $710a88b49044c621$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $710a88b49044c621$var$__spreadProps($710a88b49044c621$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            };
        });
        function actionCreator(arg) {
            return function(dispatch, getState, extra) {
                var abort = function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                };
                var requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $710a88b49044c621$export$ac4959f4f1338dfc();
                var abortController = new AbortController();
                var abortHandler;
                var abortReason;
                var promise = (0, $1d3fb01611386816$export$71511d61b312f219)(function() {
                    var _a, _b, finalAction, conditionResult, abortedPromise, err, skipDispatch;
                    return (0, $47055dab5b247348$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    4,
                                    5,
                                    6
                                ]);
                                conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                                    getState: getState,
                                    extra: extra
                                });
                                if (!$710a88b49044c621$var$isThenable(conditionResult)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    conditionResult
                                ];
                            case 1:
                                conditionResult = _state.sent();
                                _state.label = 2;
                            case 2:
                                if (conditionResult === false || abortController.signal.aborted) throw {
                                    name: "ConditionError",
                                    message: "Aborted due to condition callback returning false."
                                };
                                abortedPromise = new Promise(function(_, reject) {
                                    abortHandler = function() {
                                        reject({
                                            name: "AbortError",
                                            message: abortReason || "Aborted"
                                        });
                                    };
                                    abortController.signal.addEventListener("abort", abortHandler);
                                });
                                dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                                    requestId: requestId,
                                    arg: arg
                                }, {
                                    getState: getState,
                                    extra: extra
                                })));
                                return [
                                    4,
                                    Promise.race([
                                        abortedPromise,
                                        Promise.resolve(payloadCreator(arg, {
                                            dispatch: dispatch,
                                            getState: getState,
                                            extra: extra,
                                            requestId: requestId,
                                            signal: abortController.signal,
                                            abort: abort,
                                            rejectWithValue: function(value, meta) {
                                                return new $710a88b49044c621$var$RejectWithValue(value, meta);
                                            },
                                            fulfillWithValue: function(value, meta) {
                                                return new $710a88b49044c621$var$FulfillWithMeta(value, meta);
                                            }
                                        })).then(function(result) {
                                            if (result instanceof $710a88b49044c621$var$RejectWithValue) throw result;
                                            if (result instanceof $710a88b49044c621$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                            return fulfilled(result, requestId, arg);
                                        })
                                    ])
                                ];
                            case 3:
                                finalAction = _state.sent();
                                return [
                                    3,
                                    6
                                ];
                            case 4:
                                err = _state.sent();
                                finalAction = err instanceof $710a88b49044c621$var$RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                if (abortHandler) abortController.signal.removeEventListener("abort", abortHandler);
                                return [
                                    7
                                ];
                            case 6:
                                skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                                if (!skipDispatch) dispatch(finalAction);
                                return [
                                    2,
                                    finalAction
                                ];
                        }
                    });
                })();
                return Object.assign(promise, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap: function() {
                        return promise.then($710a88b49044c621$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            settled: $710a88b49044c621$export$2c3435c7647f7b0d(rejected, fulfilled),
            typePrefix: typePrefix
        });
    };
    createAsyncThunk2.withTypes = function() {
        return createAsyncThunk2;
    };
    return createAsyncThunk2;
}();
function $710a88b49044c621$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $710a88b49044c621$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/createSlice.ts
var $710a88b49044c621$var$asyncThunkSymbol = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
var $710a88b49044c621$export$343355ed40c51c46 = (0, $73NPw._)({}, $710a88b49044c621$var$asyncThunkSymbol, $710a88b49044c621$export$6abd22dc03e5063f);
var $710a88b49044c621$export$23a094319a4b586 = /* @__PURE__ */ function(ReducerType2) {
    ReducerType2["reducer"] = "reducer";
    ReducerType2["reducerWithPrepare"] = "reducerWithPrepare";
    ReducerType2["asyncThunk"] = "asyncThunk";
    return ReducerType2;
}($710a88b49044c621$export$23a094319a4b586 || {});
function $710a88b49044c621$var$getType(slice, actionKey) {
    return "".concat(slice, "/").concat(actionKey);
}
function $710a88b49044c621$export$affdea4146de9cf5() {
    var creators = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).creators;
    var _a;
    var cAT = (_a = creators == null ? void 0 : creators.asyncThunk) == null ? void 0 : _a[$710a88b49044c621$var$asyncThunkSymbol];
    return function createSlice2(options) {
        var name = options.name, _options_reducerPath = options.reducerPath, reducerPath = _options_reducerPath === void 0 ? name : _options_reducerPath;
        if (!name) throw new Error($710a88b49044c621$export$378fa86b259c0280(11));
        typeof $75c31d18d8204522$exports === "undefined" ? "undefined" : (0, $6zqIC._)($75c31d18d8204522$exports);
        var reducers = (typeof options.reducers === "function" ? options.reducers($710a88b49044c621$var$buildReducerCreators()) : options.reducers) || {};
        var reducerNames = Object.keys(reducers);
        var context = {
            sliceCaseReducersByName: {},
            sliceCaseReducersByType: {},
            actionCreators: {},
            sliceMatchers: []
        };
        var contextMethods = {
            addCase: function(typeOrActionCreator, reducer2) {
                var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
                if (!type) throw new Error($710a88b49044c621$export$378fa86b259c0280(12));
                if (type in context.sliceCaseReducersByType) throw new Error($710a88b49044c621$export$378fa86b259c0280(13));
                context.sliceCaseReducersByType[type] = reducer2;
                return contextMethods;
            },
            addMatcher: function(matcher, reducer2) {
                context.sliceMatchers.push({
                    matcher: matcher,
                    reducer: reducer2
                });
                return contextMethods;
            },
            exposeAction: function(name2, actionCreator) {
                context.actionCreators[name2] = actionCreator;
                return contextMethods;
            },
            exposeCaseReducer: function(name2, reducer2) {
                context.sliceCaseReducersByName[name2] = reducer2;
                return contextMethods;
            }
        };
        reducerNames.forEach(function(reducerName) {
            var reducerDefinition = reducers[reducerName];
            var reducerDetails = {
                reducerName: reducerName,
                type: $710a88b49044c621$var$getType(name, reducerName),
                createNotation: typeof options.reducers === "function"
            };
            if ($710a88b49044c621$var$isAsyncThunkSliceReducerDefinition(reducerDefinition)) $710a88b49044c621$var$handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
            else $710a88b49044c621$var$handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
        });
        function buildReducer() {
            var _ref = (0, $f9AIs._)(typeof options.extraReducers === "function" ? $710a88b49044c621$var$executeReducerBuilderCallback(options.extraReducers) : [
                options.extraReducers
            ], 3), tmp = _ref[0], extraReducers = tmp === void 0 ? {} : tmp, tmp1 = _ref[1], actionMatchers = tmp1 === void 0 ? [] : tmp1, defaultCaseReducer = _ref[2];
            var finalCaseReducers = $710a88b49044c621$var$__spreadValues($710a88b49044c621$var$__spreadValues({}, extraReducers), context.sliceCaseReducersByType);
            return $710a88b49044c621$export$473eb76d322d0290(options.initialState, function(builder) {
                for(var key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = context.sliceMatchers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var sM = _step.value;
                        builder.addMatcher(sM.matcher, sM.reducer);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = actionMatchers[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var m = _step1.value;
                        builder.addMatcher(m.matcher, m.reducer);
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
            });
        }
        var selectSelf = function(state) {
            return state;
        };
        var injectedSelectorCache = /* @__PURE__ */ new Map();
        var _reducer;
        function reducer(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        }
        function getInitialState() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
        function makeSelectorProps(reducerPath2) {
            var injected = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            function selectSlice(state) {
                var sliceState = state[reducerPath2];
                if (typeof sliceState === "undefined") {
                    if (injected) sliceState = getInitialState();
                }
                return sliceState;
            }
            function getSelectors() {
                var selectState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : selectSelf;
                var selectorCache = $710a88b49044c621$var$emplace(injectedSelectorCache, injected, {
                    insert: function() {
                        return /* @__PURE__ */ new WeakMap();
                    }
                });
                return $710a88b49044c621$var$emplace(selectorCache, selectState, {
                    insert: function() {
                        var _a2;
                        var map = {};
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = Object.entries((_a2 = options.selectors) != null ? _a2 : {})[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _step_value = (0, $f9AIs._)(_step.value, 2), name2 = _step_value[0], selector = _step_value[1];
                                map[name2] = $710a88b49044c621$var$wrapSelector(selector, selectState, getInitialState, injected);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return map;
                    }
                });
            }
            return {
                reducerPath: reducerPath2,
                getSelectors: getSelectors,
                get selectors () {
                    return getSelectors(selectSlice);
                },
                selectSlice: selectSlice
            };
        }
        var slice = $710a88b49044c621$var$__spreadProps($710a88b49044c621$var$__spreadValues({
            name: name,
            reducer: reducer,
            actions: context.actionCreators,
            caseReducers: context.sliceCaseReducersByName,
            getInitialState: getInitialState
        }, makeSelectorProps(reducerPath)), {
            injectInto: function(injectable) {
                var _a2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var _b = _a2, pathOpt = _b.reducerPath, config = $710a88b49044c621$var$__objRest(_b, [
                    "reducerPath"
                ]);
                var newReducerPath = pathOpt != null ? pathOpt : reducerPath;
                injectable.inject({
                    reducerPath: newReducerPath,
                    reducer: reducer
                }, config);
                return $710a88b49044c621$var$__spreadValues($710a88b49044c621$var$__spreadValues({}, slice), makeSelectorProps(newReducerPath, true));
            }
        });
        return slice;
    };
}
function $710a88b49044c621$var$wrapSelector(selector, selectState, getInitialState, injected) {
    function wrapper(rootState) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        var sliceState = selectState(rootState);
        if (typeof sliceState === "undefined") {
            if (injected) sliceState = getInitialState();
        }
        return selector.apply(void 0, [
            sliceState
        ].concat((0, $1SMDP._)(args)));
    }
    wrapper.unwrapped = selector;
    return wrapper;
}
var $710a88b49044c621$export$4d8d9bd83c24ae8b = /* @__PURE__ */ $710a88b49044c621$export$affdea4146de9cf5();
function $710a88b49044c621$var$buildReducerCreators() {
    function asyncThunk(payloadCreator, config) {
        return $710a88b49044c621$var$__spreadValues({
            _reducerDefinitionType: "asyncThunk" /* asyncThunk */ ,
            payloadCreator: payloadCreator
        }, config);
    }
    asyncThunk.withTypes = function() {
        return asyncThunk;
    };
    return {
        reducer: function(caseReducer) {
            return Object.assign(// hack so the wrapping function has the same name as the original
            // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
            (0, $73NPw._)({}, caseReducer.name, function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return caseReducer.apply(void 0, (0, $1SMDP._)(args));
            })[caseReducer.name], {
                _reducerDefinitionType: "reducer" /* reducer */ 
            });
        },
        preparedReducer: function(prepare, reducer) {
            return {
                _reducerDefinitionType: "reducerWithPrepare" /* reducerWithPrepare */ ,
                prepare: prepare,
                reducer: reducer
            };
        },
        asyncThunk: asyncThunk
    };
}
function $710a88b49044c621$var$handleNormalReducerDefinition(param, maybeReducerWithPrepare, context) {
    var type = param.type, reducerName = param.reducerName, createNotation = param.createNotation;
    var caseReducer;
    var prepareCallback;
    if ("reducer" in maybeReducerWithPrepare) {
        if (createNotation && !$710a88b49044c621$var$isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) throw new Error($710a88b49044c621$export$378fa86b259c0280(17));
        caseReducer = maybeReducerWithPrepare.reducer;
        prepareCallback = maybeReducerWithPrepare.prepare;
    } else caseReducer = maybeReducerWithPrepare;
    context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? $710a88b49044c621$export$309c7a02b0b0bc62(type, prepareCallback) : $710a88b49044c621$export$309c7a02b0b0bc62(type));
}
function $710a88b49044c621$var$isAsyncThunkSliceReducerDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "asyncThunk" /* asyncThunk */ ;
}
function $710a88b49044c621$var$isCaseReducerWithPrepareDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "reducerWithPrepare" /* reducerWithPrepare */ ;
}
function $710a88b49044c621$var$handleThunkCaseReducerDefinition(param, reducerDefinition, context, cAT) {
    var type = param.type, reducerName = param.reducerName;
    if (!cAT) throw new Error($710a88b49044c621$export$378fa86b259c0280(18));
    var payloadCreator = reducerDefinition.payloadCreator, fulfilled = reducerDefinition.fulfilled, pending = reducerDefinition.pending, rejected = reducerDefinition.rejected, settled = reducerDefinition.settled, options = reducerDefinition.options;
    var thunk = cAT(type, payloadCreator, options);
    context.exposeAction(reducerName, thunk);
    if (fulfilled) context.addCase(thunk.fulfilled, fulfilled);
    if (pending) context.addCase(thunk.pending, pending);
    if (rejected) context.addCase(thunk.rejected, rejected);
    if (settled) context.addMatcher(thunk.settled, settled);
    context.exposeCaseReducer(reducerName, {
        fulfilled: fulfilled || $710a88b49044c621$var$noop,
        pending: pending || $710a88b49044c621$var$noop,
        rejected: rejected || $710a88b49044c621$var$noop,
        settled: settled || $710a88b49044c621$var$noop
    });
}
function $710a88b49044c621$var$noop() {}
// src/entities/entity_state.ts
function $710a88b49044c621$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $710a88b49044c621$var$createInitialStateFactory(stateAdapter) {
    function getInitialState() {
        var additionalState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, entities = arguments.length > 1 ? arguments[1] : void 0;
        var state = Object.assign($710a88b49044c621$var$getInitialEntityState(), additionalState);
        return entities ? stateAdapter.setAll(state, entities) : state;
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $710a88b49044c621$var$createSelectorsFactory() {
    function getSelectors(selectState) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var tmp = options.createSelector, createSelector2 = tmp === void 0 ? $710a88b49044c621$export$a5d3c27355e35910 : tmp;
        var selectIds = function(state) {
            return state.ids;
        };
        var selectEntities = function(state) {
            return state.entities;
        };
        var selectAll = createSelector2(selectIds, selectEntities, function(ids, entities) {
            return ids.map(function(id) {
                return entities[id];
            });
        });
        var selectId = function(_, id) {
            return id;
        };
        var selectById = function(entities, id) {
            return entities[id];
        };
        var selectTotal = createSelector2(selectIds, function(ids) {
            return ids.length;
        });
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: createSelector2(selectEntities, selectId, selectById)
        };
        var selectGlobalizedEntities = createSelector2(selectState, selectEntities);
        return {
            selectIds: createSelector2(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createSelector2(selectState, selectAll),
            selectTotal: createSelector2(selectState, selectTotal),
            selectById: createSelector2(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
var $710a88b49044c621$var$isDraftTyped = (0, $64DyZ.isDraft);
function $710a88b49044c621$var$createSingleArgumentStateOperator(mutator) {
    var operator = $710a88b49044c621$var$createStateOperator(function(_, state) {
        return mutator(state);
    });
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $710a88b49044c621$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $710a88b49044c621$export$ebd532f9034651f3(arg2);
        }
        var runMutator = function(draft) {
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ($710a88b49044c621$var$isDraftTyped(state)) {
            runMutator(state);
            return state;
        }
        return (0, $64DyZ.produce)(state, runMutator);
    };
}
function $710a88b49044c621$var$selectIdValue(entity, selectId) {
    var key = selectId(entity);
    return key;
}
function $710a88b49044c621$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $710a88b49044c621$var$getCurrent(value) {
    return (0, $64DyZ.isDraft)(value) ? (0, $64DyZ.current)(value) : value;
}
function $710a88b49044c621$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $710a88b49044c621$var$ensureEntitiesArray(newEntities);
    var existingIdsArray = $710a88b49044c621$var$getCurrent(state.ids);
    var existingIds = new Set(existingIdsArray);
    var added = [];
    var updated = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = newEntities[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var entity = _step.value;
            var id = $710a88b49044c621$var$selectIdValue(entity, selectId);
            if (existingIds.has(id)) updated.push({
                id: id,
                changes: entity
            });
            else added.push(entity);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return [
        added,
        updated,
        existingIdsArray
    ];
}
// src/entities/unsorted_state_adapter.ts
function $710a88b49044c621$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        var key = $710a88b49044c621$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $710a88b49044c621$var$ensureEntitiesArray(newEntities);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = newEntities[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var entity = _step.value;
                addOneMutably(entity, state);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    function setOneMutably(entity, state) {
        var key = $710a88b49044c621$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $710a88b49044c621$var$ensureEntitiesArray(newEntities);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = newEntities[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var entity = _step.value;
                setOneMutably(entity, state);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $710a88b49044c621$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        var didMutate = false;
        keys.forEach(function(key) {
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter(function(id) {
            return id in state.entities;
        });
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        var original3 = state.entities[update.id];
        if (original3 === void 0) return false;
        var updated = Object.assign({}, original3, update.changes);
        var newKey = $710a88b49044c621$var$selectIdValue(updated, selectId);
        var hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var newKeys = {};
        var updatesPerEntity = {};
        updates.forEach(function(update) {
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                // Spreads ignore falsy values, so this works even if there isn't
                // an existing update already at this key
                changes: $710a88b49044c621$var$__spreadValues($710a88b49044c621$var$__spreadValues({}, updatesPerEntity[update.id] ? updatesPerEntity[update.id].changes : null), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        var didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            var didMutateIds = updates.filter(function(update) {
                return takeNewKey(newKeys, update, state);
            }).length > 0;
            if (didMutateIds) state.ids = Object.values(state.entities).map(function(e) {
                return $710a88b49044c621$var$selectIdValue(e, selectId);
            });
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _splitAddedUpdatedEntities = (0, $f9AIs._)($710a88b49044c621$var$splitAddedUpdatedEntities(newEntities, selectId, state), 2), added = _splitAddedUpdatedEntities[0], updated = _splitAddedUpdatedEntities[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $710a88b49044c621$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $710a88b49044c621$var$createStateOperator(addOneMutably),
        addMany: $710a88b49044c621$var$createStateOperator(addManyMutably),
        setOne: $710a88b49044c621$var$createStateOperator(setOneMutably),
        setMany: $710a88b49044c621$var$createStateOperator(setManyMutably),
        setAll: $710a88b49044c621$var$createStateOperator(setAllMutably),
        updateOne: $710a88b49044c621$var$createStateOperator(updateOneMutably),
        updateMany: $710a88b49044c621$var$createStateOperator(updateManyMutably),
        upsertOne: $710a88b49044c621$var$createStateOperator(upsertOneMutably),
        upsertMany: $710a88b49044c621$var$createStateOperator(upsertManyMutably),
        removeOne: $710a88b49044c621$var$createStateOperator(removeOneMutably),
        removeMany: $710a88b49044c621$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $710a88b49044c621$var$findInsertIndex(sortedItems, item, comparisonFunction) {
    var lowIndex = 0;
    var highIndex = sortedItems.length;
    while(lowIndex < highIndex){
        var middleIndex = lowIndex + highIndex >>> 1;
        var currentItem = sortedItems[middleIndex];
        var res = comparisonFunction(item, currentItem);
        if (res >= 0) lowIndex = middleIndex + 1;
        else highIndex = middleIndex;
    }
    return lowIndex;
}
function $710a88b49044c621$var$insert(sortedItems, item, comparisonFunction) {
    var insertAtIndex = $710a88b49044c621$var$findInsertIndex(sortedItems, item, comparisonFunction);
    sortedItems.splice(insertAtIndex, 0, item);
    return sortedItems;
}
function $710a88b49044c621$var$createSortedStateAdapter(selectId, comparer) {
    var _createUnsortedStateAdapter = $710a88b49044c621$var$createUnsortedStateAdapter(selectId), removeOne = _createUnsortedStateAdapter.removeOne, removeMany = _createUnsortedStateAdapter.removeMany, removeAll = _createUnsortedStateAdapter.removeAll;
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state, existingIds) {
        newEntities = $710a88b49044c621$var$ensureEntitiesArray(newEntities);
        var existingKeys = new Set(existingIds != null ? existingIds : (0, $64DyZ.current)(state.ids));
        var models = newEntities.filter(function(model) {
            return !existingKeys.has($710a88b49044c621$var$selectIdValue(model, selectId));
        });
        if (models.length !== 0) mergeFunction(state, models);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $710a88b49044c621$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = newEntities[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var item = _step.value;
                    delete state.entities[selectId(item)];
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            mergeFunction(state, newEntities);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $710a88b49044c621$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state, []);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var appliedUpdates = false;
        var replacedIds = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = updates[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var update = _step.value;
                var entity = state.entities[update.id];
                if (!entity) continue;
                appliedUpdates = true;
                Object.assign(entity, update.changes);
                var newId = selectId(entity);
                if (update.id !== newId) {
                    replacedIds = true;
                    delete state.entities[update.id];
                    var oldIndex = state.ids.indexOf(update.id);
                    state.ids[oldIndex] = newId;
                    state.entities[newId] = entity;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (appliedUpdates) mergeFunction(state, [], appliedUpdates, replacedIds);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _splitAddedUpdatedEntities = (0, $f9AIs._)($710a88b49044c621$var$splitAddedUpdatedEntities(newEntities, selectId, state), 3), added = _splitAddedUpdatedEntities[0], updated = _splitAddedUpdatedEntities[1], existingIdsArray = _splitAddedUpdatedEntities[2];
        if (updated.length) updateManyMutably(updated, state);
        if (added.length) addManyMutably(added, state, existingIdsArray);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(var i = 0; i < a.length && i < b.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    var mergeInsertion = function(state, addedItems, appliedUpdates, replacedIds) {
        var currentEntities = $710a88b49044c621$var$getCurrent(state.entities);
        var currentIds = $710a88b49044c621$var$getCurrent(state.ids);
        var stateEntities = state.entities;
        var ids = currentIds;
        if (replacedIds) ids = Array.from(new Set(currentIds));
        var sortedEntities = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = ids[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var id = _step.value;
                var entity = currentEntities[id];
                if (entity) sortedEntities.push(entity);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var wasPreviouslyEmpty = sortedEntities.length === 0;
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = addedItems[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var item = _step1.value;
                stateEntities[selectId(item)] = item;
                if (!wasPreviouslyEmpty) $710a88b49044c621$var$insert(sortedEntities, item, comparer);
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        if (wasPreviouslyEmpty) sortedEntities = addedItems.slice().sort(comparer);
        else if (appliedUpdates) sortedEntities.sort(comparer);
        var newSortedIds = sortedEntities.map(selectId);
        if (!areArraysEqual(currentIds, newSortedIds)) state.ids = newSortedIds;
    };
    var mergeFunction = mergeInsertion;
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $710a88b49044c621$var$createStateOperator(addOneMutably),
        updateOne: $710a88b49044c621$var$createStateOperator(updateOneMutably),
        upsertOne: $710a88b49044c621$var$createStateOperator(upsertOneMutably),
        setOne: $710a88b49044c621$var$createStateOperator(setOneMutably),
        setMany: $710a88b49044c621$var$createStateOperator(setManyMutably),
        setAll: $710a88b49044c621$var$createStateOperator(setAllMutably),
        addMany: $710a88b49044c621$var$createStateOperator(addManyMutably),
        updateMany: $710a88b49044c621$var$createStateOperator(updateManyMutably),
        upsertMany: $710a88b49044c621$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $710a88b49044c621$export$abcf4037b41e0df() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var __spreadValues1 = $710a88b49044c621$var$__spreadValues({
        sortComparer: false,
        selectId: function(instance) {
            return instance.id;
        }
    }, options), selectId = __spreadValues1.selectId, sortComparer = __spreadValues1.sortComparer;
    var stateAdapter = sortComparer ? $710a88b49044c621$var$createSortedStateAdapter(selectId, sortComparer) : $710a88b49044c621$var$createUnsortedStateAdapter(selectId);
    var stateFactory = $710a88b49044c621$var$createInitialStateFactory(stateAdapter);
    var selectorsFactory = $710a88b49044c621$var$createSelectorsFactory();
    return $710a88b49044c621$var$__spreadValues($710a88b49044c621$var$__spreadValues($710a88b49044c621$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/listenerMiddleware/exceptions.ts
var $710a88b49044c621$var$task = "task";
var $710a88b49044c621$var$listener = "listener";
var $710a88b49044c621$var$completed = "completed";
var $710a88b49044c621$var$cancelled = "cancelled";
var $710a88b49044c621$var$taskCancelled = "task-".concat($710a88b49044c621$var$cancelled);
var $710a88b49044c621$var$taskCompleted = "task-".concat($710a88b49044c621$var$completed);
var $710a88b49044c621$var$listenerCancelled = "".concat($710a88b49044c621$var$listener, "-").concat($710a88b49044c621$var$cancelled);
var $710a88b49044c621$var$listenerCompleted = "".concat($710a88b49044c621$var$listener, "-").concat($710a88b49044c621$var$completed);
var $710a88b49044c621$export$cb1bdac908fed7f = function TaskAbortError(code) {
    "use strict";
    (0, $aliU1._)(this, TaskAbortError);
    this.code = code;
    $710a88b49044c621$var$__publicField(this, "name", "TaskAbortError");
    $710a88b49044c621$var$__publicField(this, "message");
    this.message = "".concat($710a88b49044c621$var$task, " ").concat($710a88b49044c621$var$cancelled, " (reason: ").concat(code, ")");
};
// src/listenerMiddleware/utils.ts
var $710a88b49044c621$var$assertFunction = function(func, expected) {
    if (typeof func !== "function") throw new Error($710a88b49044c621$export$378fa86b259c0280(32));
};
var $710a88b49044c621$var$noop2 = function() {};
var $710a88b49044c621$var$catchRejection = function(promise) {
    var onError = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $710a88b49044c621$var$noop2;
    promise.catch(onError);
    return promise;
};
var $710a88b49044c621$var$addAbortSignalListener = function(abortSignal, callback) {
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return function() {
        return abortSignal.removeEventListener("abort", callback);
    };
};
var $710a88b49044c621$var$abortControllerWithReason = function(abortController, reason) {
    var signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/task.ts
var $710a88b49044c621$var$validateActive = function(signal) {
    if (signal.aborted) {
        var reason = signal.reason;
        throw new $710a88b49044c621$export$cb1bdac908fed7f(reason);
    }
};
function $710a88b49044c621$var$raceWithSignal(signal, promise) {
    var cleanup = $710a88b49044c621$var$noop2;
    return new Promise(function(resolve, reject) {
        var notifyRejection = function() {
            return reject(new $710a88b49044c621$export$cb1bdac908fed7f(signal.reason));
        };
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $710a88b49044c621$var$addAbortSignalListener(signal, notifyRejection);
        promise.finally(function() {
            return cleanup();
        }).then(resolve, reject);
    }).finally(function() {
        cleanup = $710a88b49044c621$var$noop2;
    });
}
var $710a88b49044c621$var$runTask = function() {
    var _ref = (0, $1d3fb01611386816$export$71511d61b312f219)(function(task2, cleanUp) {
        var value, error;
        return (0, $47055dab5b247348$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4,
                        Promise.resolve()
                    ];
                case 1:
                    _state.sent();
                    return [
                        4,
                        task2()
                    ];
                case 2:
                    value = _state.sent();
                    return [
                        2,
                        {
                            status: "ok",
                            value: value
                        }
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        2,
                        {
                            status: error instanceof $710a88b49044c621$export$cb1bdac908fed7f ? "cancelled" : "rejected",
                            error: error
                        }
                    ];
                case 4:
                    cleanUp == null || cleanUp();
                    return [
                        7
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function runTask(task2, cleanUp) {
        return _ref.apply(this, arguments);
    };
}();
var $710a88b49044c621$var$createPause = function(signal) {
    return function(promise) {
        return $710a88b49044c621$var$catchRejection($710a88b49044c621$var$raceWithSignal(signal, promise).then(function(output) {
            $710a88b49044c621$var$validateActive(signal);
            return output;
        }));
    };
};
var $710a88b49044c621$var$createDelay = function(signal) {
    var pause = $710a88b49044c621$var$createPause(signal);
    return function(timeoutMs) {
        return pause(new Promise(function(resolve) {
            return setTimeout(resolve, timeoutMs);
        }));
    };
};
// src/listenerMiddleware/index.ts
var $710a88b49044c621$var$assign = Object.assign;
var $710a88b49044c621$var$INTERNAL_NIL_TOKEN = {};
var $710a88b49044c621$var$alm = "listenerMiddleware";
var $710a88b49044c621$var$createFork = function(parentAbortSignal, parentBlockingPromises) {
    var linkControllers = function(controller) {
        return $710a88b49044c621$var$addAbortSignalListener(parentAbortSignal, function() {
            return $710a88b49044c621$var$abortControllerWithReason(controller, parentAbortSignal.reason);
        });
    };
    return function(taskExecutor, opts) {
        $710a88b49044c621$var$assertFunction(taskExecutor, "taskExecutor");
        var childAbortController = new AbortController();
        linkControllers(childAbortController);
        var result = $710a88b49044c621$var$runTask(/*#__PURE__*/ (0, $1d3fb01611386816$export$71511d61b312f219)(function() {
            var result2;
            return (0, $47055dab5b247348$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        $710a88b49044c621$var$validateActive(parentAbortSignal);
                        $710a88b49044c621$var$validateActive(childAbortController.signal);
                        return [
                            4,
                            taskExecutor({
                                pause: $710a88b49044c621$var$createPause(childAbortController.signal),
                                delay: $710a88b49044c621$var$createDelay(childAbortController.signal),
                                signal: childAbortController.signal
                            })
                        ];
                    case 1:
                        result2 = _state.sent();
                        $710a88b49044c621$var$validateActive(childAbortController.signal);
                        return [
                            2,
                            result2
                        ];
                }
            });
        }), function() {
            return $710a88b49044c621$var$abortControllerWithReason(childAbortController, $710a88b49044c621$var$taskCompleted);
        });
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result.catch($710a88b49044c621$var$noop2));
        return {
            result: $710a88b49044c621$var$createPause(parentAbortSignal)(result),
            cancel: function() {
                $710a88b49044c621$var$abortControllerWithReason(childAbortController, $710a88b49044c621$var$taskCancelled);
            }
        };
    };
};
var $710a88b49044c621$var$createTakePattern = function(startListening, signal) {
    var take = function() {
        var _ref = (0, $1d3fb01611386816$export$71511d61b312f219)(function(predicate, timeout) {
            var unsubscribe, tuplePromise, promises, output;
            return (0, $47055dab5b247348$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        $710a88b49044c621$var$validateActive(signal);
                        unsubscribe = function() {};
                        tuplePromise = new Promise(function(resolve, reject) {
                            var stopListening = startListening({
                                predicate: predicate,
                                effect: function(action, listenerApi) {
                                    listenerApi.unsubscribe();
                                    resolve([
                                        action,
                                        listenerApi.getState(),
                                        listenerApi.getOriginalState()
                                    ]);
                                }
                            });
                            unsubscribe = function() {
                                stopListening();
                                reject();
                            };
                        });
                        promises = [
                            tuplePromise
                        ];
                        if (timeout != null) promises.push(new Promise(function(resolve) {
                            return setTimeout(resolve, timeout, null);
                        }));
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4,
                            $710a88b49044c621$var$raceWithSignal(signal, Promise.race(promises))
                        ];
                    case 2:
                        output = _state.sent();
                        $710a88b49044c621$var$validateActive(signal);
                        return [
                            2,
                            output
                        ];
                    case 3:
                        unsubscribe();
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function take(predicate, timeout) {
            return _ref.apply(this, arguments);
        };
    }();
    return function(predicate, timeout) {
        return $710a88b49044c621$var$catchRejection(take(predicate, timeout));
    };
};
var $710a88b49044c621$var$getListenerEntryPropsFrom = function(options) {
    var type = options.type, actionCreator = options.actionCreator, matcher = options.matcher, predicate = options.predicate, effect = options.effect;
    if (type) predicate = $710a88b49044c621$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error($710a88b49044c621$export$378fa86b259c0280(21));
    $710a88b49044c621$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $710a88b49044c621$var$createListenerEntry = Object.assign(function(options) {
    var _getListenerEntryPropsFrom = $710a88b49044c621$var$getListenerEntryPropsFrom(options), type = _getListenerEntryPropsFrom.type, predicate = _getListenerEntryPropsFrom.predicate, effect = _getListenerEntryPropsFrom.effect;
    var id = $710a88b49044c621$export$ac4959f4f1338dfc();
    var entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: /* @__PURE__ */ new Set(),
        unsubscribe: function() {
            throw new Error($710a88b49044c621$export$378fa86b259c0280(22));
        }
    };
    return entry;
}, {
    withTypes: function() {
        return $710a88b49044c621$var$createListenerEntry;
    }
});
var $710a88b49044c621$var$cancelActiveListeners = function(entry) {
    entry.pending.forEach(function(controller) {
        $710a88b49044c621$var$abortControllerWithReason(controller, $710a88b49044c621$var$listenerCancelled);
    });
};
var $710a88b49044c621$var$createClearListenerMiddleware = function(listenerMap) {
    return function() {
        listenerMap.forEach($710a88b49044c621$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $710a88b49044c621$var$safelyNotifyError = function(errorHandler, errorToNotify, errorInfo) {
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(function() {
            throw errorHandlerError;
        }, 0);
    }
};
var $710a88b49044c621$export$f03a6b845d3fb58b = Object.assign($710a88b49044c621$export$309c7a02b0b0bc62("".concat($710a88b49044c621$var$alm, "/add")), {
    withTypes: function() {
        return $710a88b49044c621$export$f03a6b845d3fb58b;
    }
});
var $710a88b49044c621$export$b1b8022855fb2b71 = $710a88b49044c621$export$309c7a02b0b0bc62("".concat($710a88b49044c621$var$alm, "/removeAll"));
var $710a88b49044c621$export$b03e9483f936dccb = Object.assign($710a88b49044c621$export$309c7a02b0b0bc62("".concat($710a88b49044c621$var$alm, "/remove")), {
    withTypes: function() {
        return $710a88b49044c621$export$b03e9483f936dccb;
    }
});
var $710a88b49044c621$var$defaultErrorHandler = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _console;
    (_console = console).error.apply(_console, [
        "".concat($710a88b49044c621$var$alm, "/error")
    ].concat((0, $1SMDP._)(args)));
};
var $710a88b49044c621$export$1228acebbbcb485b = function() {
    var middlewareOptions = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var listenerMap = /* @__PURE__ */ new Map();
    var extra = middlewareOptions.extra, _middlewareOptions_onError = middlewareOptions.onError, onError = _middlewareOptions_onError === void 0 ? $710a88b49044c621$var$defaultErrorHandler : _middlewareOptions_onError;
    $710a88b49044c621$var$assertFunction(onError, "onError");
    var insertEntry = function(entry) {
        entry.unsubscribe = function() {
            return listenerMap.delete(entry.id);
        };
        listenerMap.set(entry.id, entry);
        return function(cancelOptions) {
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $710a88b49044c621$var$cancelActiveListeners(entry);
        };
    };
    var startListening = function(options) {
        var entry = $710a88b49044c621$var$find(Array.from(listenerMap.values()), function(existingEntry) {
            return existingEntry.effect === options.effect;
        });
        if (!entry) entry = $710a88b49044c621$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    Object.assign(startListening, {
        withTypes: function() {
            return startListening;
        }
    });
    var stopListening = function(options) {
        var _getListenerEntryPropsFrom = $710a88b49044c621$var$getListenerEntryPropsFrom(options), type = _getListenerEntryPropsFrom.type, effect = _getListenerEntryPropsFrom.effect, predicate = _getListenerEntryPropsFrom.predicate;
        var entry = $710a88b49044c621$var$find(Array.from(listenerMap.values()), function(entry2) {
            var matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $710a88b49044c621$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    Object.assign(stopListening, {
        withTypes: function() {
            return stopListening;
        }
    });
    var notifyListener = function() {
        var _ref = (0, $1d3fb01611386816$export$71511d61b312f219)(function(entry, action, api, getOriginalState) {
            var internalTaskController, take, autoJoinPromises, listenerError;
            return (0, $47055dab5b247348$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        internalTaskController = new AbortController();
                        take = $710a88b49044c621$var$createTakePattern(startListening, internalTaskController.signal);
                        autoJoinPromises = [];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            6
                        ]);
                        entry.pending.add(internalTaskController);
                        return [
                            4,
                            Promise.resolve(entry.effect(action, // Use assign() rather than ... to avoid extra helper functions added to bundle
                            $710a88b49044c621$var$assign({}, api, {
                                getOriginalState: getOriginalState,
                                condition: function(predicate, timeout) {
                                    return take(predicate, timeout).then(Boolean);
                                },
                                take: take,
                                delay: $710a88b49044c621$var$createDelay(internalTaskController.signal),
                                pause: $710a88b49044c621$var$createPause(internalTaskController.signal),
                                extra: extra,
                                signal: internalTaskController.signal,
                                fork: $710a88b49044c621$var$createFork(internalTaskController.signal, autoJoinPromises),
                                unsubscribe: entry.unsubscribe,
                                subscribe: function() {
                                    listenerMap.set(entry.id, entry);
                                },
                                cancelActiveListeners: function() {
                                    entry.pending.forEach(function(controller, _, set) {
                                        if (controller !== internalTaskController) {
                                            $710a88b49044c621$var$abortControllerWithReason(controller, $710a88b49044c621$var$listenerCancelled);
                                            set.delete(controller);
                                        }
                                    });
                                },
                                cancel: function() {
                                    $710a88b49044c621$var$abortControllerWithReason(internalTaskController, $710a88b49044c621$var$listenerCancelled);
                                    entry.pending.delete(internalTaskController);
                                },
                                throwIfCancelled: function() {
                                    $710a88b49044c621$var$validateActive(internalTaskController.signal);
                                }
                            })))
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 3:
                        listenerError = _state.sent();
                        if (!(listenerError instanceof $710a88b49044c621$export$cb1bdac908fed7f)) $710a88b49044c621$var$safelyNotifyError(onError, listenerError, {
                            raisedBy: "effect"
                        });
                        return [
                            3,
                            6
                        ];
                    case 4:
                        return [
                            4,
                            Promise.all(autoJoinPromises)
                        ];
                    case 5:
                        _state.sent();
                        $710a88b49044c621$var$abortControllerWithReason(internalTaskController, $710a88b49044c621$var$listenerCompleted);
                        entry.pending.delete(internalTaskController);
                        return [
                            7
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function notifyListener(entry, action, api, getOriginalState) {
            return _ref.apply(this, arguments);
        };
    }();
    var clearListenerMiddleware = $710a88b49044c621$var$createClearListenerMiddleware(listenerMap);
    var middleware = function(api) {
        return function(next) {
            return function(action) {
                if (!(0, $c4195dcee631f3e8$export$b956e38827fca970)(action)) return next(action);
                if ($710a88b49044c621$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($710a88b49044c621$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($710a88b49044c621$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                var originalState = api.getState();
                var getOriginalState = function() {
                    if (originalState === $710a88b49044c621$var$INTERNAL_NIL_TOKEN) throw new Error($710a88b49044c621$export$378fa86b259c0280(23));
                    return originalState;
                };
                var result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        var currentState = api.getState();
                        var listenerEntries = Array.from(listenerMap.values());
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = listenerEntries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var entry = _step.value;
                                var runListener = false;
                                try {
                                    runListener = entry.predicate(action, currentState, originalState);
                                } catch (predicateError) {
                                    runListener = false;
                                    $710a88b49044c621$var$safelyNotifyError(onError, predicateError, {
                                        raisedBy: "predicate"
                                    });
                                }
                                if (!runListener) continue;
                                notifyListener(entry, action, api, getOriginalState);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                } finally{
                    originalState = $710a88b49044c621$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
        };
    };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
};
var $710a88b49044c621$var$createMiddlewareEntry = function(middleware) {
    return {
        id: $710a88b49044c621$export$ac4959f4f1338dfc(),
        middleware: middleware,
        applied: /* @__PURE__ */ new Map()
    };
};
var $710a88b49044c621$var$matchInstance = function(instanceId) {
    return function(action) {
        var _a;
        return ((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a.instanceId) === instanceId;
    };
};
var $710a88b49044c621$export$4bb1606a79445586 = function() {
    var instanceId = $710a88b49044c621$export$ac4959f4f1338dfc();
    var middlewareMap = /* @__PURE__ */ new Map();
    var withMiddleware = Object.assign($710a88b49044c621$export$309c7a02b0b0bc62("dynamicMiddleware/add", function() {
        for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++){
            middlewares[_key] = arguments[_key];
        }
        return {
            payload: middlewares,
            meta: {
                instanceId: instanceId
            }
        };
    }), {
        withTypes: function() {
            return withMiddleware;
        }
    });
    var addMiddleware = Object.assign(function addMiddleware2() {
        for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++){
            middlewares[_key] = arguments[_key];
        }
        middlewares.forEach(function(middleware2) {
            var entry = $710a88b49044c621$var$find(Array.from(middlewareMap.values()), function(entry2) {
                return entry2.middleware === middleware2;
            });
            if (!entry) entry = $710a88b49044c621$var$createMiddlewareEntry(middleware2);
            middlewareMap.set(entry.id, entry);
        });
    }, {
        withTypes: function() {
            return addMiddleware;
        }
    });
    var getFinalMiddleware = function(api) {
        var appliedMiddleware = Array.from(middlewareMap.values()).map(function(entry) {
            return $710a88b49044c621$var$emplace(entry.applied, api, {
                insert: function() {
                    return entry.middleware(api);
                }
            });
        });
        return (0, $c4195dcee631f3e8$export$f672e0b6f7222cd7).apply(void 0, (0, $1SMDP._)(appliedMiddleware));
    };
    var isWithMiddleware = $710a88b49044c621$export$9dd1fb32974da385(withMiddleware, $710a88b49044c621$var$matchInstance(instanceId));
    var middleware = function(api) {
        return function(next) {
            return function(action) {
                if (isWithMiddleware(action)) {
                    addMiddleware.apply(void 0, (0, $1SMDP._)(action.payload));
                    return api.dispatch;
                }
                return getFinalMiddleware(api)(next)(action);
            };
        };
    };
    return {
        middleware: middleware,
        addMiddleware: addMiddleware,
        withMiddleware: withMiddleware,
        instanceId: instanceId
    };
};
var $710a88b49044c621$var$isSliceLike = function(maybeSliceLike) {
    return "reducerPath" in maybeSliceLike && typeof maybeSliceLike.reducerPath === "string";
};
var $710a88b49044c621$var$getReducers = function(slices) {
    return slices.flatMap(function(sliceOrMap) {
        return $710a88b49044c621$var$isSliceLike(sliceOrMap) ? [
            [
                sliceOrMap.reducerPath,
                sliceOrMap.reducer
            ]
        ] : Object.entries(sliceOrMap);
    });
};
var $710a88b49044c621$var$ORIGINAL_STATE = Symbol.for("rtk-state-proxy-original");
var $710a88b49044c621$var$isStateProxy = function(value) {
    return !!value && !!value[$710a88b49044c621$var$ORIGINAL_STATE];
};
var $710a88b49044c621$var$stateProxyMap = /* @__PURE__ */ new WeakMap();
var $710a88b49044c621$var$createStateProxy = function(state, reducerMap) {
    return $710a88b49044c621$var$emplace($710a88b49044c621$var$stateProxyMap, state, {
        insert: function() {
            return new Proxy(state, {
                get: function(target, prop, receiver) {
                    if (prop === $710a88b49044c621$var$ORIGINAL_STATE) return target;
                    var result = Reflect.get(target, prop, receiver);
                    if (typeof result === "undefined") {
                        var reducer = reducerMap[prop.toString()];
                        if (reducer) {
                            var reducerResult = reducer(void 0, {
                                type: $710a88b49044c621$export$ac4959f4f1338dfc()
                            });
                            if (typeof reducerResult === "undefined") throw new Error($710a88b49044c621$export$378fa86b259c0280(24));
                            return reducerResult;
                        }
                    }
                    return result;
                }
            });
        }
    });
};
var $710a88b49044c621$var$original = function(state) {
    if (!$710a88b49044c621$var$isStateProxy(state)) throw new Error($710a88b49044c621$export$378fa86b259c0280(25));
    return state[$710a88b49044c621$var$ORIGINAL_STATE];
};
var $710a88b49044c621$var$noopReducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return state;
};
function $710a88b49044c621$export$a3734c7614660b9() {
    for(var _len = arguments.length, slices = new Array(_len), _key = 0; _key < _len; _key++){
        slices[_key] = arguments[_key];
    }
    var reducerMap = Object.fromEntries($710a88b49044c621$var$getReducers(slices));
    var getReducer = function() {
        return Object.keys(reducerMap).length ? (0, $c4195dcee631f3e8$export$66e4520cdb265d18)(reducerMap) : $710a88b49044c621$var$noopReducer;
    };
    var reducer = getReducer();
    function combinedReducer(state, action) {
        return reducer(state, action);
    }
    combinedReducer.withLazyLoadedSlices = function() {
        return combinedReducer;
    };
    var inject = function(slice) {
        var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var reducerPath = slice.reducerPath, reducerToInject = slice.reducer;
        var currentReducer = reducerMap[reducerPath];
        if (!config.overrideExisting && currentReducer && currentReducer !== reducerToInject) {
            typeof $75c31d18d8204522$exports === "undefined" ? "undefined" : (0, $6zqIC._)($75c31d18d8204522$exports);
            return combinedReducer;
        }
        reducerMap[reducerPath] = reducerToInject;
        reducer = getReducer();
        return combinedReducer;
    };
    var selector = Object.assign(function makeSelector(selectorFn, selectState) {
        return function selector2(state) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                args[_key - 1] = arguments[_key];
            }
            return selectorFn.apply(void 0, [
                $710a88b49044c621$var$createStateProxy(selectState ? selectState.apply(void 0, [
                    state
                ].concat((0, $1SMDP._)(args))) : state, reducerMap)
            ].concat((0, $1SMDP._)(args)));
        };
    }, {
        original: $710a88b49044c621$var$original
    });
    return Object.assign(combinedReducer, {
        inject: inject,
        selector: selector
    });
}
// src/formatProdErrorMessage.ts
function $710a88b49044c621$export$378fa86b259c0280(code) {
    return "Minified Redux Toolkit error #".concat(code, "; visit https://redux-toolkit.js.org/Errors?code=").concat(code, " for the full message or use the non-minified dev environment for full errors. ");
}


var $2a41a5371824e9d4$var$cartSlice = (0, $710a88b49044c621$export$4d8d9bd83c24ae8b)({
    name: "cart ",
    initialState: {
        items: []
    },
    reducers: {
        addItem: function(state, action) {
            state.items.push(action.payload);
        },
        clearCart: function(state) {
            state.items = [];
        },
        removeItem: function(state, action) {
            state.items.pop();
        }
    }
});
var $2a41a5371824e9d4$var$_cartSlice_actions = $2a41a5371824e9d4$var$cartSlice.actions;
var $2a41a5371824e9d4$export$fb9705de59d96855 = $2a41a5371824e9d4$var$_cartSlice_actions.addItem, $2a41a5371824e9d4$export$810121176e3e3671 = $2a41a5371824e9d4$var$_cartSlice_actions.clearCart, $2a41a5371824e9d4$export$fe2d9b4e03920b4c = $2a41a5371824e9d4$var$_cartSlice_actions.removeItem;
var $2a41a5371824e9d4$export$2e2bcd8739ae039 = $2a41a5371824e9d4$var$cartSlice.reducer;



function $e1885ac3a1dc955d$var$RestaurantMenu() {
    var _res_cards__card_card_info, _res_cards__card_card, _res_cards__card, _res_cards_, _res_cards__card_card_info1, _res_cards__card_card1, _res_cards__card1, _res_cards_1, _res_cards__card_card_info2, _res_cards__card_card2, _res_cards__card2, _res_cards_2, _res_cards__card_card_info3, _res_cards__card_card3, _res_cards__card3, _res_cards_3, _res_cards__card_card_info4, _res_cards__card_card4, _res_cards__card4, _res_cards_4, _res_cards__groupedCard_cardGroupMap_REGULAR_cards__card_card, _res_cards__groupedCard_cardGroupMap_REGULAR_cards__card, _res_cards__groupedCard_cardGroupMap_REGULAR_cards_, _res_cards__groupedCard_cardGroupMap_REGULAR, _res_cards__groupedCard_cardGroupMap, _res_cards__groupedCard, _res_cards_5;
    var id = (0, $f0792a32d62fec93$export$99eaa27ddbbb95ef)().id;
    var res = (0, $e9b8049928d5875e$export$2e2bcd8739ae039)(id);
    var dispatch = (0, $d7493d97555cda1a$export$8ad76b76a4c905f8)();
    var addFoodItem = function(item) {
        dispatch((0, $2a41a5371824e9d4$export$fb9705de59d96855)(item));
    };
    return res.length === 0 ? /*#__PURE__*/ (0, $45FY7.jsx)((0, $881701763a680210$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $45FY7.jsxs)("div", {
        className: "flex",
        children: [
            /*#__PURE__*/ (0, $45FY7.jsxs)("div", {
                className: "",
                children: [
                    /*#__PURE__*/ (0, $45FY7.jsxs)("h1", {
                        children: [
                            "Restaurant ID ",
                            id
                        ]
                    }),
                    /*#__PURE__*/ (0, $45FY7.jsx)("h1", {
                        children: (_res_cards_ = res.cards[2]) === null || _res_cards_ === void 0 ? void 0 : (_res_cards__card = _res_cards_.card) === null || _res_cards__card === void 0 ? void 0 : (_res_cards__card_card = _res_cards__card.card) === null || _res_cards__card_card === void 0 ? void 0 : (_res_cards__card_card_info = _res_cards__card_card.info) === null || _res_cards__card_card_info === void 0 ? void 0 : _res_cards__card_card_info.name
                    }),
                    /*#__PURE__*/ (0, $45FY7.jsx)("h1", {
                        children: (_res_cards_1 = res.cards[2]) === null || _res_cards_1 === void 0 ? void 0 : (_res_cards__card1 = _res_cards_1.card) === null || _res_cards__card1 === void 0 ? void 0 : (_res_cards__card_card1 = _res_cards__card1.card) === null || _res_cards__card_card1 === void 0 ? void 0 : (_res_cards__card_card_info1 = _res_cards__card_card1.info) === null || _res_cards__card_card_info1 === void 0 ? void 0 : _res_cards__card_card_info1.city
                    }),
                    /*#__PURE__*/ (0, $45FY7.jsx)("img", {
                        className: "h-50 w-50",
                        src: (0, $4cda32079dcbcebc$export$63cce10c00d8eaa3) + ((_res_cards_2 = res.cards[2]) === null || _res_cards_2 === void 0 ? void 0 : (_res_cards__card2 = _res_cards_2.card) === null || _res_cards__card2 === void 0 ? void 0 : (_res_cards__card_card2 = _res_cards__card2.card) === null || _res_cards__card_card2 === void 0 ? void 0 : (_res_cards__card_card_info2 = _res_cards__card_card2.info) === null || _res_cards__card_card_info2 === void 0 ? void 0 : _res_cards__card_card_info2.cloudinaryImageId)
                    }),
                    /*#__PURE__*/ (0, $45FY7.jsxs)("h3", {
                        children: [
                            (_res_cards_3 = res.cards[2]) === null || _res_cards_3 === void 0 ? void 0 : (_res_cards__card3 = _res_cards_3.card) === null || _res_cards__card3 === void 0 ? void 0 : (_res_cards__card_card3 = _res_cards__card3.card) === null || _res_cards__card_card3 === void 0 ? void 0 : (_res_cards__card_card_info3 = _res_cards__card_card3.info) === null || _res_cards__card_card_info3 === void 0 ? void 0 : _res_cards__card_card_info3.avgRating,
                            "star"
                        ]
                    }),
                    /*#__PURE__*/ (0, $45FY7.jsx)("h3", {
                        children: (_res_cards_4 = res.cards[2]) === null || _res_cards_4 === void 0 ? void 0 : (_res_cards__card4 = _res_cards_4.card) === null || _res_cards__card4 === void 0 ? void 0 : (_res_cards__card_card4 = _res_cards__card4.card) === null || _res_cards__card_card4 === void 0 ? void 0 : (_res_cards__card_card_info4 = _res_cards__card_card4.info) === null || _res_cards__card_card_info4 === void 0 ? void 0 : _res_cards__card_card_info4.costForTwoMessage
                    })
                ]
            }),
            /*#__PURE__*/ (0, $45FY7.jsx)("h1", {
                children: "Menu"
            }),
            /*#__PURE__*/ (0, $45FY7.jsx)("div", {
                className: "flex m-2 p-2",
                children: /*#__PURE__*/ (0, $45FY7.jsxs)("ul", {
                    "data-testid": "menu1",
                    children: [
                        function() {
                            var _res_cards__groupedCard_cardGroupMap_REGULAR_cards__card_card, _res_cards__groupedCard_cardGroupMap_REGULAR_cards__card, _res_cards__groupedCard_cardGroupMap_REGULAR_cards_, _res_cards__groupedCard_cardGroupMap_REGULAR, _res_cards__groupedCard_cardGroupMap, _res_cards__groupedCard, _res_cards_;
                            var categories = (_res_cards_ = res.cards[5]) === null || _res_cards_ === void 0 ? void 0 : (_res_cards__groupedCard = _res_cards_.groupedCard) === null || _res_cards__groupedCard === void 0 ? void 0 : (_res_cards__groupedCard_cardGroupMap = _res_cards__groupedCard.cardGroupMap) === null || _res_cards__groupedCard_cardGroupMap === void 0 ? void 0 : (_res_cards__groupedCard_cardGroupMap_REGULAR = _res_cards__groupedCard_cardGroupMap.REGULAR) === null || _res_cards__groupedCard_cardGroupMap_REGULAR === void 0 ? void 0 : (_res_cards__groupedCard_cardGroupMap_REGULAR_cards_ = _res_cards__groupedCard_cardGroupMap_REGULAR.cards[2]) === null || _res_cards__groupedCard_cardGroupMap_REGULAR_cards_ === void 0 ? void 0 : (_res_cards__groupedCard_cardGroupMap_REGULAR_cards__card = _res_cards__groupedCard_cardGroupMap_REGULAR_cards_.card) === null || _res_cards__groupedCard_cardGroupMap_REGULAR_cards__card === void 0 ? void 0 : (_res_cards__groupedCard_cardGroupMap_REGULAR_cards__card_card = _res_cards__groupedCard_cardGroupMap_REGULAR_cards__card.card) === null || _res_cards__groupedCard_cardGroupMap_REGULAR_cards__card_card === void 0 ? void 0 : _res_cards__groupedCard_cardGroupMap_REGULAR_cards__card_card.categories;
                            if (categories) // If categories exist, use the original path
                            return Object.values(categories[0].itemCards || []).map(function(item) {
                                return /*#__PURE__*/ (0, $45FY7.jsxs)("li", {
                                    children: [
                                        item.card.info.name,
                                        " ",
                                        /*#__PURE__*/ (0, $45FY7.jsx)("button", {
                                            "data-testid": "addbtn",
                                            className: "p-2 bg-red-300",
                                            children: "- add "
                                        })
                                    ]
                                }, item.card.info.id);
                            });
                            else {
                                var _res_cards__groupedCard_cardGroupMap_REGULAR_cards__card_card1, _res_cards__groupedCard_cardGroupMap_REGULAR_cards__card1, _res_cards__groupedCard_cardGroupMap_REGULAR_cards_1, _res_cards__groupedCard_cardGroupMap_REGULAR1, _res_cards__groupedCard_cardGroupMap1, _res_cards__groupedCard1, _res_cards_1;
                                // If categories are missing, try a fallback path (assuming an alternative path exists)
                                var fallbackItemCards = ((_res_cards_1 = res.cards[5]) === null || _res_cards_1 === void 0 ? void 0 : (_res_cards__groupedCard1 = _res_cards_1.groupedCard) === null || _res_cards__groupedCard1 === void 0 ? void 0 : (_res_cards__groupedCard_cardGroupMap1 = _res_cards__groupedCard1.cardGroupMap) === null || _res_cards__groupedCard_cardGroupMap1 === void 0 ? void 0 : (_res_cards__groupedCard_cardGroupMap_REGULAR1 = _res_cards__groupedCard_cardGroupMap1.REGULAR) === null || _res_cards__groupedCard_cardGroupMap_REGULAR1 === void 0 ? void 0 : (_res_cards__groupedCard_cardGroupMap_REGULAR_cards_1 = _res_cards__groupedCard_cardGroupMap_REGULAR1.cards[2]) === null || _res_cards__groupedCard_cardGroupMap_REGULAR_cards_1 === void 0 ? void 0 : (_res_cards__groupedCard_cardGroupMap_REGULAR_cards__card1 = _res_cards__groupedCard_cardGroupMap_REGULAR_cards_1.card) === null || _res_cards__groupedCard_cardGroupMap_REGULAR_cards__card1 === void 0 ? void 0 : (_res_cards__groupedCard_cardGroupMap_REGULAR_cards__card_card1 = _res_cards__groupedCard_cardGroupMap_REGULAR_cards__card1.card) === null || _res_cards__groupedCard_cardGroupMap_REGULAR_cards__card_card1 === void 0 ? void 0 : _res_cards__groupedCard_cardGroupMap_REGULAR_cards__card_card1.itemCards) || [];
                                return Object.values(fallbackItemCards).map(function(item) {
                                    return /*#__PURE__*/ (0, $45FY7.jsxs)("li", {
                                        children: [
                                            item.card.info.name,
                                            " ",
                                            /*#__PURE__*/ (0, $45FY7.jsx)("button", {
                                                "data-testid": "addbtn",
                                                className: "p-2 bg-red-300",
                                                onClick: function() {
                                                    return addFoodItem(item);
                                                },
                                                children: "-add "
                                            })
                                        ]
                                    }, item.card.info.id);
                                });
                            }
                        }(),
                        Object.values(((_res_cards_5 = res.cards[5]) === null || _res_cards_5 === void 0 ? void 0 : (_res_cards__groupedCard = _res_cards_5.groupedCard) === null || _res_cards__groupedCard === void 0 ? void 0 : (_res_cards__groupedCard_cardGroupMap = _res_cards__groupedCard.cardGroupMap) === null || _res_cards__groupedCard_cardGroupMap === void 0 ? void 0 : (_res_cards__groupedCard_cardGroupMap_REGULAR = _res_cards__groupedCard_cardGroupMap.REGULAR) === null || _res_cards__groupedCard_cardGroupMap_REGULAR === void 0 ? void 0 : (_res_cards__groupedCard_cardGroupMap_REGULAR_cards_ = _res_cards__groupedCard_cardGroupMap_REGULAR.cards[2]) === null || _res_cards__groupedCard_cardGroupMap_REGULAR_cards_ === void 0 ? void 0 : (_res_cards__groupedCard_cardGroupMap_REGULAR_cards__card = _res_cards__groupedCard_cardGroupMap_REGULAR_cards_.card) === null || _res_cards__groupedCard_cardGroupMap_REGULAR_cards__card === void 0 ? void 0 : (_res_cards__groupedCard_cardGroupMap_REGULAR_cards__card_card = _res_cards__groupedCard_cardGroupMap_REGULAR_cards__card.card) === null || _res_cards__groupedCard_cardGroupMap_REGULAR_cards__card_card === void 0 ? void 0 : _res_cards__groupedCard_cardGroupMap_REGULAR_cards__card_card.itemCards) || []).length === 0 && /*#__PURE__*/ (0, $45FY7.jsx)("li", {
                            children: "There is no menu available for this restaurant."
                        }, "no-menu")
                    ]
                })
            })
        ]
    });
}
var //.cards[5]?.groupedcard?.cardGroupMap?.regular?.cards[2].card?.card?.categories[0].itemCards[0]
$e1885ac3a1dc955d$export$2e2bcd8739ae039 //{console.log(Object.values(res.cards[5]?.groupedCard?.cardGroupMap?.REGULAR.cards[2].card?.card?.categories[0]?.itemCards))}</h3>
 //<ul>
 //{Object.values (res.cards[5]?.groupedCard?.cardGroupMap?.REGULAR.cards[2].card?.card?.categories[0]?.itemCards).map((item)=>(
 //<li key={item.card.info.id} >{item.card.info.name} </li>
 //)) }
 //</ul>
 //button className="p-2 m-2 h-15 w-15 bg-green-800" onClick={()=>handleAddItem()}>Add items</button>
 = $e1885ac3a1dc955d$var$RestaurantMenu;



var $f9AIs = parcelRequire("f9AIs");

var $45FY7 = parcelRequire("45FY7");

var $4Bt61 = parcelRequire("4Bt61");
var $dd1ebd38c015bff9$var$Profile = function(props) {
    var _useState = (0, $f9AIs._)((0, $4Bt61.useState)(0), 2), count = _useState[0], setCount = _useState[1];
    (0, $4Bt61.useEffect)(function() {
        // API Call
        var timer = setInterval(function() {
            console.log("NAMASTE REACT OP ");
        }, 1000);
        console.log("useEffect");
        return function() {
            clearInterval(timer);
            console.log("useEffect Return");
        };
    }, []);
    console.log("render");
    return /*#__PURE__*/ (0, $45FY7.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $45FY7.jsx)("h2", {
                children: "Porofile Component"
            }),
            /*#__PURE__*/ (0, $45FY7.jsxs)("h3", {
                children: [
                    "Name: ",
                    props.name
                ]
            }),
            /*#__PURE__*/ (0, $45FY7.jsxs)("h3", {
                children: [
                    "Count: ",
                    count
                ]
            }),
            /*#__PURE__*/ (0, $45FY7.jsx)("button", {
                onClick: function() {
                    setCount(1);
                },
                children: "Count"
            })
        ]
    });
};
var $dd1ebd38c015bff9$export$2e2bcd8739ae039 = $dd1ebd38c015bff9$var$Profile;






var $7ea0b770f886b566$var$Store = (0, $710a88b49044c621$export$7d8a5b498da695ac)({
    reducer: {
        cart: (0, $2a41a5371824e9d4$export$2e2bcd8739ae039)
    }
});
var $7ea0b770f886b566$export$2e2bcd8739ae039 /**
 * 
 * create a store using 
 * 1.configure store from rtk
 * 2.Provider from react-redux
 * provider component to wrap all the app layout
 * 3.create cartSlice by create slice
 * added name,initialstate, reducers , actions
 * 4.exported cartSlice.reducer and const {addItem,...}=cartSlice.actions
 * 5.add the slice to the store
 *    {
 *     reducer:{
 *    "name of cart"(cart):cartSlice
 * }
 * }
 * 6.import  useSelector from react-redux to read the items in the slice and
 * update it in the store
 * 7.create a button for making an action
 * onclick {()=>handleAdditem}
 * handle add item include
 * dispatch 
 * addItem 
 * 
 * add dispatch from react-redux
 */  = $7ea0b770f886b566$var$Store;





var $45FY7 = parcelRequire("45FY7");


var $45FY7 = parcelRequire("45FY7");

var $1872d918ed2ffce0$export$8edcfd549a434daf = function(props) {
    console.log(props);
    return /*#__PURE__*/ (0, $45FY7.jsxs)("div", {
        className: "w-52 p-2 m-2 shadow-lg bg-pink-50 ",
        children: [
            /*#__PURE__*/ (0, $45FY7.jsx)("img", {
                className: " ",
                alt: "burger",
                src: (0, $4cda32079dcbcebc$export$63cce10c00d8eaa3) + props.card.info.imageId
            }),
            /*#__PURE__*/ (0, $45FY7.jsx)("h2", {
                className: "font-bold text-xl",
                children: props.card.info.name
            }),
            /*#__PURE__*/ (0, $45FY7.jsxs)("h2", {
                className: "font-bold text-xl",
                children: [
                    props.card.info.defaultPrice / 100,
                    "rs"
                ]
            })
        ]
    });
};
var $1872d918ed2ffce0$export$2e2bcd8739ae039 = $1872d918ed2ffce0$export$8edcfd549a434daf;



var $89460f626e7e6f6a$var$Cart = function() {
    var cartItems = (0, $d7493d97555cda1a$export$2105062e25df4afe)(function(store) {
        return store.cart.items;
    });
    console.log(cartItems);
    var dispatch = (0, $d7493d97555cda1a$export$8ad76b76a4c905f8)();
    var handleClearCart = function() {
        dispatch((0, $2a41a5371824e9d4$export$810121176e3e3671)());
    };
    return /*#__PURE__*/ (0, $45FY7.jsxs)("div", {
        className: "",
        children: [
            /*#__PURE__*/ (0, $45FY7.jsxs)("h1", {
                children: [
                    "  this is a cart containing ",
                    cartItems.length,
                    "items "
                ]
            }),
            /*#__PURE__*/ (0, $45FY7.jsx)("button", {
                className: "bg-red-300 p-2 m-12",
                onClick: function() {
                    return handleClearCart();
                },
                children: "Clear CART"
            }),
            /*#__PURE__*/ (0, $45FY7.jsx)("div", {
                className: "flex",
                children: cartItems.map(function(item) {
                    return /*#__PURE__*/ (0, $45FY7.jsx)((0, $1872d918ed2ffce0$export$2e2bcd8739ae039), (0, $5f1309c2fb31fc13$export$71511d61b312f219)({}, item), item.card.info.id);
                })
            })
        ]
    });
};
var $89460f626e7e6f6a$export$2e2bcd8739ae039 = $89460f626e7e6f6a$var$Cart;



//import Instamart from "./components/Instamart";
var $249f68bed56c8b00$var$Instamart = /*#__PURE__*/ (0, $4Bt61.lazy)(function() {
    return (parcelRequire("2LEdD"));
});
var $249f68bed56c8b00$var$AppLayout = function() {
    var _useState = (0, $f9AIs._)((0, $4Bt61.useState)({
        name: "The user name have changed",
        email: "username@gamil.com"
    }), 2), user = _useState[0], setUser = _useState[1];
    return /*#__PURE__*/ (0, $45FY7.jsx)((0, $d7493d97555cda1a$export$2881499e37b75b9a), {
        store: (0, $7ea0b770f886b566$export$2e2bcd8739ae039),
        children: /*#__PURE__*/ (0, $45FY7.jsxs)((0, $2819d30547b11aa2$export$2e2bcd8739ae039).Provider, {
            value: {
                user: user,
                setUser: setUser
            },
            children: [
                /*#__PURE__*/ (0, $45FY7.jsx)((0, $e780f7d3b9acb821$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $45FY7.jsx)((0, $f0792a32d62fec93$export$910ae8079b2c2852), {}),
                /*#__PURE__*/ (0, $45FY7.jsx)((0, $5ca1458fc886d126$export$2e2bcd8739ae039), {})
            ]
        })
    });
};
var $249f68bed56c8b00$var$Approuter = (0, $8f0ad21e84364a49$export$1f3f55432a00e06d)([
    {
        path: "/",
        element: /*#__PURE__*/ (0, $45FY7.jsx)($249f68bed56c8b00$var$AppLayout, {}),
        errorElement: /*#__PURE__*/ (0, $45FY7.jsx)((0, $72b17a93ab28127a$export$2e2bcd8739ae039), {}),
        children: [
            {
                path: "/",
                element: /*#__PURE__*/ (0, $45FY7.jsx)((0, $0d5eb0c0145439a3$export$2e2bcd8739ae039), {})
            },
            {
                path: "/About",
                element: /*#__PURE__*/ (0, $45FY7.jsx)((0, $8713b77ebe1ec3fa$export$2e2bcd8739ae039), {}),
                children: [
                    {
                        path: "profile",
                        element: /*#__PURE__*/ (0, $45FY7.jsx)((0, $dd1ebd38c015bff9$export$2e2bcd8739ae039), {})
                    }
                ]
            },
            {
                path: "/Contact",
                element: /*#__PURE__*/ (0, $45FY7.jsx)((0, $1f103d71b128a1d8$export$2e2bcd8739ae039), {})
            },
            {
                path: "/Restaurant/:id",
                element: /*#__PURE__*/ (0, $45FY7.jsx)((0, $e1885ac3a1dc955d$export$2e2bcd8739ae039), {})
            },
            {
                path: "/Instamart",
                element: /*#__PURE__*/ (0, $45FY7.jsx)((0, $4Bt61.Suspense), {
                    fallback: /*#__PURE__*/ (0, $45FY7.jsx)((0, $881701763a680210$export$2e2bcd8739ae039), {}),
                    children: /*#__PURE__*/ (0, $45FY7.jsx)($249f68bed56c8b00$var$Instamart, {})
                })
            },
            {
                path: "/Cart",
                element: /*#__PURE__*/ (0, $45FY7.jsx)((0, $89460f626e7e6f6a$export$2e2bcd8739ae039), {})
            }
        ]
    }
]);
//const heading2 = React.createElement('h2',{id:'titles',key:"2"},'Heading 2');
//const container = React.createElement('div',{id:'container',},[heading,heading2 ]);
var $249f68bed56c8b00$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($8949e5ebfdf38b70$exports))).createRoot(document.getElementById("root"));
$249f68bed56c8b00$var$root.render(/*#__PURE__*/ (0, $45FY7.jsx)((0, $8f0ad21e84364a49$export$323e4fc2fa4753fb), {
    router: $249f68bed56c8b00$var$Approuter
}));

})();
//# sourceMappingURL=index.7b391cca.js.map
